/* tslint:disable */
/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType } from 'graphql';
/**
 * This file is auto-generated by graphql-schema-typescript
 * Please note that any changes in this file may be overwritten
 */
 

/*******************************
 *                             *
 *          TYPE DEFS          *
 *                             *
 *******************************/
export interface Query {
  applicationContactDetails?: ApplicationContactDetails;
  applicationContactDetailsForBankPortal?: ApplicationContactDetails;
  bankAssetContent: BankAssetContent;
  
  /**
   * Operation to get a BG switch with the provided ID
   */
  bgSwitchByIdAndOrganisationId: DraftBGSwitch;
  
  /**
   * Operation to list BG Switch for an Organisation.
   */
  bgSwitchesByOrganisationId?: BgSwitchesByOrganisationIdConnection;
  
  /**
   * Indicative only
   */
  calculateAdvertisedFinance: FinanceRepaymentSummary;
  channelPartners?: ChannelPartnersConnection;
  channelPartnersForBankPortal?: ChannelPartnersForBankPortalConnection;
  cognitoGetAuthenticatedUser: CognitoUser;
  cognitoGetBankUsers?: CognitoGetBankUsersConnection;
  
  /**
   * Operation to get the link to download a Document Attachment.
   */
  documentAttachmentDownload?: DocumentAttachmentDownload;
  
  /**
   * Operation to get a document with the provided Draft ID
   */
  documentByDraftId?: Document;
  
  /**
   * Operation to get a document with the provided ID
   */
  documentById?: Document;
  
  /**
   * Operation to list Document Facilities for an Organisation.
   */
  documentFacilities?: DocumentFacilitiesConnection;
  
  /**
   * Operation to get facility by Id.
   */
  documentFacilityById?: DocumentFacility;
  documentReportDownloadUrl: string;
  documentReports?: DocumentReportsConnection;
  
  /**
   * Operation to list Documents for an Organisation.
   */
  documents?: DocumentsConnection;
  
  /**
   * Operation to list Documents accessible by the Banking Portal.
   */
  documentsForBankPortal?: DocumentsForBankPortalConnection;
  
  /**
   * Operation to get documents with the current user as a Collaborator.
   */
  documentsSharedWithMe?: DocumentsSharedWithMeConnection;
  
  /**
   * Operation to get remaining applicable requirements for a draft with the provided details.
   */
  draftApplicableRequirements?: Array<DraftApplicableRequirement | null>;
  
  /**
   * Operation to get the link to download a Draft Attachment.
   */
  draftAttachmentDownload?: DraftAttachmentDownload;
  
  /**
   * Operation to get the link to download a Draft Attachment for the supplier portal.
   */
  draftAttachmentDownloadForBankPortal?: DraftAttachmentDownload;
  
  /**
   * Operation to get a draft with the provided ID
   */
  draftByIdAndOrganisationId: Draft;
  
  /**
   * Operation to list Draft Originations accessible by the Banking Portal.
   */
  draftOriginationsForBankPortal?: DraftOriginationsForBankPortalConnection;
  
  /**
   * Operation to list Drafts for an Organisation.
   */
  draftsByOrganisationId?: DraftsByOrganisationIdConnection;
  
  /**
   * Operation to list Drafts accessible by the Banking Portal.
   */
  draftsForBankPortal?: DraftsForBankPortalConnection;
  
  /**
   * Operation to get Drafts with the current user as a Collaborator.
   */
  draftsSharedWithMe?: DraftsSharedWithMeConnection;
  
  /**
   * Gets the FSG content
   */
  fSGHtmlString: string;
  
  /**
   * Operation to get a list of facilities not scoped to an organisation.
   */
  facilitiesForBankPortal?: FacilitiesForBankPortalConnection;
  
  /**
   * Operation to get a Facility Application with the provided ID
   */
  facilityApplicationById?: FacilityApplication;
  
  /**
   * Operation to list Facility Applications for an Organisation.
   */
  facilityApplications?: FacilityApplicationsConnection;
  
  /**
   * Operation to get a list of facility applications not scoped to an organisation
   */
  facilityApplicationsForBankPortal?: FacilityApplicationsForBankPortalConnection;
  features: GatewayFeatures;
  financeRecordsForBankPortal?: FinanceRecordsForBankPortalConnection;
  
  /**
   * Generates the agency agreement content based on the template associated with the product for a given draft
   */
  generateAgencyAgreementHtmlStringForDraft: string;
  
  /**
   * Generates the agency agreement content based on the template associated with the product for a given draft
   * Only available to internal staff and suppliers
   */
  generateAgencyAgreementHtmlStringForDraftForBankPortal: string;
  
  /**
   * Generates the agency agreement content based on the template associated with the product for a given facility application
   */
  generateAgencyAgreementHtmlStringForFacilityApplication: string;
  
  /**
   * Generates the agency agreement content based on the template associated with the product for a given facility application
   * Only available to internal staff and suppliers
   */
  generateAgencyAgreementHtmlStringForFacilityApplicationForBankPortal: string;
  generateChannelPartnerReport: Array<ChannelPartnerReportMonth>;
  generateForecastChartReport: Array<ChartProjectionReportMonth>;
  
  /**
   * Generates the product preview content based on the template associated with the product for a given draft
   */
  generateProductPreviewTemplateHtmlStringForDraft: string;
  generateSummaryChartReport: Array<ChartReportMonth>;
  
  /**
   * Operation to get the link to download generated attachments for an organisation.
   */
  generatedAttachmentsForOrganisation?: GeneratedAttachmentsForOrganisationConnection;
  getFeeSummaries?: Array<FeeSummary | null>;
  
  /**
   * Returns notifications on the Bank Portal platform
   */
  getNotificationsForBankPortal?: GetNotificationsForBankPortalConnection;
  
  /**
   * List all organisation credit events with filtering
   */
  getOrganisationCreditEvents?: GetOrganisationCreditEventsConnection;
  
  /**
   * List all organisation credits with filtering
   */
  getOrganisationCredits?: GetOrganisationCreditsConnection;
  
  /**
   * Operation to list all Organisations.
   */
  getOrganisationsForBankPortal?: GetOrganisationsForBankPortalConnection;
  
  /**
   * Returns a secret that can be used to make payment against the designed invoice. If the invoice is not eligible to be paid, a null value is returned.
   */
  getPaymentIntentForInvoice?: InvoicePaymentIntentSecret;
  
  /**
   * Operation to list all the Simple Kys validation Flags for an Identification.
   */
  getSimpleKycDataFlagsByIdentificationId?: GetSimpleKycDataFlagsByIdentificationIdConnection;
  
  /**
   * Operation to list all the Simple Kys validation Urls by Identification.
   */
  getSimpleKycDataUrlByIdentificationId?: string;
  
  /**
   * Returns reactivation details from the Stripe subscription associated with a particular draft.
   */
  getStripeSubscriptionDetails?: StripeSubscriptionDetails;
  getSuppliersForBankPortal?: Array<Supplier | null>;
  
  /**
   * Returns users on the Bank Portal platform
   */
  getUsersForBankPortal?: GetUsersForBankPortalConnection;
  
  /**
   * Operation to list Identifications accessible by the Banking Portal.
   */
  identificationsForBankPortal?: IdentificationsForBankPortalConnection;
  
  /**
   * Operation to get import jobs for the current user
   */
  importJobs?: ImportJobsConnection;
  
  /**
   * Operation to get import jobs for the bank portal
   */
  importJobsForBankPortal?: ImportJobsForBankPortalConnection;
  
  /**
   * Operation to get a greenId Token with the provided ID
   */
  initializeGreenId?: IdentificationIndividual;
  
  /**
   * Operation to get a greenId Token with the provided ID BankPortal
   */
  initializeGreenIdBankPortal?: IdentificationIndividual;
  
  /**
   * Operation to list Invoices accessible by the Banking Portal.
   */
  invoicesForBankPortal?: InvoicesForBankPortalConnection;
  lifetimeProjectionValue: ChartLifetimeProjectedValueDetails;
  
  /**
   * Lists the assets available to use for dynamic content such as Assuro Agency Agreement Templates and Product Templates
   */
  listBankAssets: Array<BankAsset>;
  
  /**
   * Fetches details about the current user.
   */
  me?: Profile;
  
  /**
   * Operation to list the current users Organisations.
   */
  organisations?: OrganisationsConnection;
  productSelectionSummary: Array<ProductSummary>;
  referralConfiguration: ReferralConfiguration;
  referralPortalCommissionTiers: Array<ReferralCommissionTier>;
  referralPortalDeals?: ReferralPortalDealsConnection;
  referralPortalEntities?: ReferralPortalEntitiesConnection;
  referralPortalEntitiesForClientPortal?: ReferralPortalEntitiesForClientPortalConnection;
  referralPortalMembers?: ReferralPortalMembersConnection;
  referralPortalMyMember?: ReferralPortalMember;
  
  /**
   * Operation to search for Organisation members.
   */
  searchOrganisationMembers?: SearchOrganisationMembersConnection;
  
  /**
   * Operation to search organisations for specific members
   */
  searchOrganisationsForMembersForBankPortal?: SearchOrganisationsForMembersForBankPortalConnection;
  sourceOfFundsReferenceData_ByDraftId: Array<ReferenceDataType>;
  sourceOfFundsReferenceData_ForBankPortal: Array<ReferenceDataType>;
  totalBankGuaranteesSummary: ChartTotalActiveDetails;
  totalSuretyBondsSummary: ChartTotalActiveDetails;
  
  /**
   * Operation to get Total $ value of surety facilities
   */
  totalValueOfSuretyFacilities?: Decimal;
  validateSubmissionToGvp: Array<SubmissionValidationResult>;
  
  /**
   * Verify a facility application is complete and ready to submit
   */
  verifyFacilityApplication?: FacilityApplication;
  webhookResultsForBankPortal?: WebhookResultsForBankPortalConnection;
}

export interface ApplicationContactDetails {
  businessPhone?: string;
  dateLastModified: DateTime;
  draftId: string;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  mobilePhone: string;
  role: string;
}

/**
 * The `DateTime` scalar represents an ISO-8601 compliant date time type.
 */
export type DateTime = any;

export enum BankAssetType {
  ASSURO_AGENCY_AGREEMENT = 'ASSURO_AGENCY_AGREEMENT',
  ASSURO_FINANCIAL_SERVICES_GUIDE = 'ASSURO_FINANCIAL_SERVICES_GUIDE',
  SUPPLIER_PRODUCT_PREVIEW = 'SUPPLIER_PRODUCT_PREVIEW'
}

export interface BankAssetContent {
  content: string;
  contentType: string;
}

/**
 * Linked BG Switch
 */
export interface DraftBGSwitch {
  affirmationIrrevocability: boolean;
  beneficiaryApproval: boolean;
  
  /**
   * Full name of the bank which issued the current BG.
   */
  currentBankFullName?: string;
  
  /**
   * Expiry date (if any) of the current BG.
   */
  currentExpiryDate?: DateTime;
  currentGuaranteeNumber?: string;
  
  /**
   * Security type of the current BG.
   */
  currentSecurityType: BGSwitchSecurityType;
  
  /**
   * Value of current BG.
   */
  currentValue: Decimal;
  
  /**
   * The ID for the Draft BG Switch.
   */
  id: string;
  indemnityAgreement: boolean;
  irrevocableOrder: boolean;
  
  /**
   * If security type cash and cash is in term deposit.
   */
  isCashInTermDeposit?: boolean;
  
  /**
   * The ID of the Organisation who created this Draft. Required.
   */
  organisationId: string;
  securityInterestDeclaration: boolean;
  status: BGSwitchStatus;
  
  /**
   * The end date of the term deposit if security type is cash and cash is in term deposit.
   */
  termDepositEndDate?: DateTime;
  transactionUnwindingClause: boolean;
}

export enum BGSwitchSecurityType {
  CASH = 'CASH',
  PROPERTY = 'PROPERTY',
  OTHERS = 'OTHERS'
}

/**
 * The built-in `Decimal` scalar type.
 */
export type Decimal = any;

export enum BGSwitchStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED'
}

export type PaginationAmount = any;

/**
 * Sort options for the BG Switch type.
 */
export interface DraftBGSwitchSort {
  createdAt?: SortOperationKind;
  currentBankFullName?: SortOperationKind;
  currentExpiryDate?: SortOperationKind;
  currentSecurityType?: SortOperationKind;
  currentValue?: SortOperationKind;
  status?: SortOperationKind;
}

export enum SortOperationKind {
  ASC = 'ASC',
  DESC = 'DESC'
}

/**
 * Filters for the BG Switch type.
 */
export interface DraftBGSwitchFilter {
  AND?: Array<DraftBGSwitchFilter>;
  OR?: Array<DraftBGSwitchFilter>;
  id?: string;
  id_in?: Array<string>;
  currentValue_gte?: Decimal;
  currentValue_lte?: Decimal;
  currentExpiryDate_gte?: DateTime;
  currentExpiryDate_lte?: DateTime;
  status?: BGSwitchStatus;
  status_in?: Array<BGSwitchStatus>;
  currentSecurityType?: BGSwitchSecurityType;
  currentSecurityType_in?: Array<BGSwitchSecurityType>;
}

/**
 * A connection to a list of items.
 */
export interface BgSwitchesByOrganisationIdConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<BgSwitchesByOrganisationIdEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DraftBGSwitch | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface BgSwitchesByOrganisationIdEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DraftBGSwitch;
}

/**
 * Information about pagination in a connection.
 */
export interface PageInfo {
  
  /**
   * When paginating forwards, the cursor to continue.
   */
  endCursor?: string;
  
  /**
   * Indicates whether more edges exist following the set defined by the clients arguments.
   */
  hasNextPage: boolean;
  
  /**
   * Indicates whether more edges exist prior the set defined by the clients arguments.
   */
  hasPreviousPage: boolean;
  
  /**
   * When paginating backwards, the cursor to continue.
   */
  startCursor?: string;
}

export interface FinanceRepaymentSummary {
  availabilityPeriodMaxBusinessDays: number;
  availabilityPeriodMinBusinessDays: number;
  financeAmount: Decimal;
  repaymentOptions: Array<RepaymentOption>;
}

export interface RepaymentOption {
  advertisedFortnightlyRepayments: number;
  months: number;
}

export interface ChannelPartnerSortInput {
  id?: SortEnumType;
  name?: SortEnumType;
  establishmentFeeDiscountAmount?: SortEnumType;
  discountPercentage?: SortEnumType;
  referralPercentage?: SortEnumType;
  active?: SortEnumType;
  isPublic?: SortEnumType;
  webhookUrl?: SortEnumType;
  contactEmail?: SortEnumType;
  apiKey?: SortEnumType;
  createdAt?: SortEnumType;
}

export enum SortEnumType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface ChannelPartnerFilterInput {
  and?: Array<ChannelPartnerFilterInput>;
  or?: Array<ChannelPartnerFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  name?: StringOperationFilterInput;
  establishmentFeeDiscountAmount?: ComparableDecimalOperationFilterInput;
  discountPercentage?: ComparableDecimalOperationFilterInput;
  referralPercentage?: ComparableDecimalOperationFilterInput;
  active?: BooleanOperationFilterInput;
  isPublic?: BooleanOperationFilterInput;
  webhookUrl?: StringOperationFilterInput;
  contactEmail?: StringOperationFilterInput;
  apiKey?: StringOperationFilterInput;
  createdAt?: ComparableDateTimeOffsetOperationFilterInput;
}

export interface ComparableGuidOperationFilterInput {
  eq?: string;
  neq?: string;
  in?: Array<string>;
  nin?: Array<string>;
  gt?: string;
  ngt?: string;
  gte?: string;
  ngte?: string;
  lt?: string;
  nlt?: string;
  lte?: string;
  nlte?: string;
}

export interface StringOperationFilterInput {
  and?: Array<StringOperationFilterInput>;
  or?: Array<StringOperationFilterInput>;
  eq?: string;
  neq?: string;
  contains?: string;
  ncontains?: string;
  in?: Array<string | null>;
  nin?: Array<string | null>;
  startsWith?: string;
  nstartsWith?: string;
  endsWith?: string;
  nendsWith?: string;
}

export interface ComparableDecimalOperationFilterInput {
  eq?: Decimal;
  neq?: Decimal;
  in?: Array<Decimal>;
  nin?: Array<Decimal>;
  gt?: Decimal;
  ngt?: Decimal;
  gte?: Decimal;
  ngte?: Decimal;
  lt?: Decimal;
  nlt?: Decimal;
  lte?: Decimal;
  nlte?: Decimal;
}

export interface BooleanOperationFilterInput {
  eq?: boolean;
  neq?: boolean;
}

export interface ComparableDateTimeOffsetOperationFilterInput {
  eq?: DateTime;
  neq?: DateTime;
  in?: Array<DateTime>;
  nin?: Array<DateTime>;
  gt?: DateTime;
  ngt?: DateTime;
  gte?: DateTime;
  ngte?: DateTime;
  lt?: DateTime;
  nlt?: DateTime;
  lte?: DateTime;
  nlte?: DateTime;
}

/**
 * A connection to a list of items.
 */
export interface ChannelPartnersConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ChannelPartnersEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ChannelPartners>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ChannelPartnersEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: ChannelPartners;
}

export interface ChannelPartners {
  active: boolean;
  apiKey?: string;
  contactEmail?: string;
  createdAt: DateTime;
  discountPercentage: Decimal;
  establishmentFeeDiscountAmount: Decimal;
  id: string;
  isPublic: boolean;
  name?: string;
  referralPercentage: Decimal;
  webhookUrl?: string;
}

/**
 * A connection to a list of items.
 */
export interface ChannelPartnersForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ChannelPartnersForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ChannelPartners>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ChannelPartnersForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: ChannelPartners;
}

export interface CognitoUser {
  createdOn?: DateTime;
  emailAddress: string;
  firstName?: string;
  id: string;
  isEnabled: boolean;
  isSmsMfaRequired: boolean;
  lastName?: string;
  lastUpdatedAt?: DateTime;
  phoneNumber?: string;
  status: string;
  supplierId?: string;
  userName: string;
  userRoles: Array<BankUserRole>;
}

/**
 * Bitwise enum flag (1,2,4,8,16)
 */
export enum BankUserRole {
  ASSURO_RELATIONSHIP_MANAGER = 'ASSURO_RELATIONSHIP_MANAGER',
  ASSURO_GENERAL = 'ASSURO_GENERAL',
  EXTERNAL_SUPPLIER = 'EXTERNAL_SUPPLIER',
  EXTERNAL_REFERRALPORTAL_ADMIN = 'EXTERNAL_REFERRALPORTAL_ADMIN',
  EXTERNAL_REFERRALPORTAL_REFERRER = 'EXTERNAL_REFERRALPORTAL_REFERRER'
}

export interface CognitoUserSortInput {
  id?: SortEnumType;
  emailAddress?: SortEnumType;
  isEnabled?: SortEnumType;
  status?: SortEnumType;
  lastUpdatedAt?: SortEnumType;
  createdOn?: SortEnumType;
  userName?: SortEnumType;
  firstName?: SortEnumType;
  lastName?: SortEnumType;
  phoneNumber?: SortEnumType;
  isSmsMfaRequired?: SortEnumType;
  supplierId?: SortEnumType;
}

export interface CognitoUserFilterInput {
  and?: Array<CognitoUserFilterInput>;
  or?: Array<CognitoUserFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  emailAddress?: StringOperationFilterInput;
  isEnabled?: BooleanOperationFilterInput;
  status?: StringOperationFilterInput;
  lastUpdatedAt?: ComparableNullableOfDateTimeOffsetOperationFilterInput;
  createdOn?: ComparableNullableOfDateTimeOffsetOperationFilterInput;
  userName?: ComparableGuidOperationFilterInput;
  firstName?: StringOperationFilterInput;
  lastName?: StringOperationFilterInput;
  phoneNumber?: StringOperationFilterInput;
  isSmsMfaRequired?: BooleanOperationFilterInput;
  supplierId?: ComparableNullableOfGuidOperationFilterInput;
  userRoles?: ListBankUserRoleOperationFilterInput;
}

export interface ComparableNullableOfDateTimeOffsetOperationFilterInput {
  eq?: DateTime;
  neq?: DateTime;
  in?: Array<DateTime | null>;
  nin?: Array<DateTime | null>;
  gt?: DateTime;
  ngt?: DateTime;
  gte?: DateTime;
  ngte?: DateTime;
  lt?: DateTime;
  nlt?: DateTime;
  lte?: DateTime;
  nlte?: DateTime;
}

export interface ComparableNullableOfGuidOperationFilterInput {
  eq?: string;
  neq?: string;
  in?: Array<string | null>;
  nin?: Array<string | null>;
  gt?: string;
  ngt?: string;
  gte?: string;
  ngte?: string;
  lt?: string;
  nlt?: string;
  lte?: string;
  nlte?: string;
}

export interface ListBankUserRoleOperationFilterInput {
  all?: BankUserRoleOperationFilterInput;
  none?: BankUserRoleOperationFilterInput;
  some?: BankUserRoleOperationFilterInput;
  any?: boolean;
}

export interface BankUserRoleOperationFilterInput {
  eq?: BankUserRole;
  neq?: BankUserRole;
  in?: Array<BankUserRole>;
  nin?: Array<BankUserRole>;
}

/**
 * A connection to a list of items.
 */
export interface CognitoGetBankUsersConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<CognitoGetBankUsersEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<CognitoUser>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface CognitoGetBankUsersEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: CognitoUser;
}

/**
 * Details to download a Document Attachment
 */
export interface DocumentAttachmentDownload {
  
  /**
   * The link to download the Document Attachment
   */
  downloadPresignedUrl: string;
}

export interface Document {
  actionDate?: DateTime;
  amount: Decimal;
  
  /**
   * The Attachments for the Document. Not available for listed (>1 returned) Documents.
   */
  attachments?: Array<DocumentAttachment>;
  
  /**
   * Details the Financial Institution backing the Document.
   */
  bank?: Bank;
  
  /**
   * The context from which the current user (caller) can access this Document.
   */
  callerContext?: DocumentCallerContext;
  
  /**
   * The current users Capabilities to act on the Document.
   */
  capabilities: Array<DocumentCapability | null>;
  closedAt?: DateTime;
  
  /**
   * The Collaborators for the Document. Not available for listed (>1 returned) Documents.
   */
  collaborators?: CollaboratorsConnection;
  
  /**
   * The Comments for the Document. Not available for listed (>1 returned) Documents.
   */
  comments?: CommentsConnection;
  
  /**
   * The document costs (setup, fixed, percentage and frequency).
   */
  costs?: DocumentCosts;
  createdAt: DateTime;
  
  /**
   * The Custodian of the Document.
   */
  custodian: Custodian;
  description?: string;
  documentVariant?: DocumentVariant;
  establishedAt?: DateTime;
  expectedReturnDate?: Date;
  expiresAt?: Date;
  facilityId?: string;
  guaranteeNumber?: string;
  
  /**
   * The request for document handover.
   */
  handover?: DocumentHandover;
  
  /**
   * The History for the Document. Not available for listed (>1 returned) Documents.
   */
  history?: HistoryConnection;
  id: string;
  interestEndDate?: Date;
  interestStartDate?: Date;
  
  /**
   * The Document invoices.
   */
  invoices?: Array<IInvoice | null>;
  
  /**
   * Indicates whether or not the document was created and established by the system.
   */
  isSystemDocument: boolean;
  
  /**
   * The Metadata for the Document.
   */
  metadata?: MetadataConnection;
  organisationId: string;
  originalDraftId?: string;
  
  /**
   * The Parties relevant to the Document.
   */
  parties: Array<Party>;
  projectAddress?: string;
  purpose?: string;
  referenceNumber?: string;
  releventPartyNames?: string;
  
  /**
   * The request for return for document.
   */
  requestForReturn?: DocumentRequestForReturn;
  requestedAt?: DateTime;
  retentionType?: DocumentRetentionType;
  securityType?: SecurityType;
  specifiedOtherPurpose?: string;
  status?: DocumentStatus;
  
  /**
   * The members who are on the notification list for this Document.
   */
  subscribedMembers: Array<DocumentNotificationListMember | null>;
  
  /**
   * Full summary of the document,enriched with the reference number, guarantee number, relevant parties, amount
   */
  summary?: string;
  supplierName?: string;
}

export interface DocumentAttachment {
  contentType: string;
  fileName: string;
  id: string;
  infectedFileStatus: InfectedFileStatus;
  received: boolean;
  
  /**
   * The link to upload the Document Attachment file.
   */
  uploadPresignedUrl?: string;
}

export enum InfectedFileStatus {
  CLEAN = 'CLEAN',
  INFECTED = 'INFECTED',
  NOT_SCANNED = 'NOT_SCANNED'
}

/**
 * Details the Financial Institution backing the Document.
 */
export interface Bank {
  
  /**
   * The Address of the Financial Institution.
   */
  address?: string;
  
  /**
   * The BSB of the Bank backing the Document.
   */
  bsb?: string;
  
  /**
   * The name of the Financial Institution.
   */
  name: string;
}

/**
 * Context of user requesting access to Document
 */
export interface DocumentCallerContext {
  
  /**
   * Whether or not the user is a member of the organisation
   */
  isOrganisationMember: boolean;
  
  /**
   * The details of the Organisation in the context
   */
  organisation?: DocumentOrganisation;
}

/**
 * Details an Organisation
 */
export interface DocumentOrganisation {
  
  /**
   * The ID of the entity
   */
  id: string;
  
  /**
   * The name of the Organisation
   */
  name: string;
}

/**
 * The capabilities the current user has on a Document
 */
export enum DocumentCapability {
  
  /**
   * The document can be closed out (status update).
   */
  CAN_CLOSE_OUT = 'CAN_CLOSE_OUT',
  
  /**
   * The documents details can be edited, including metadata and custodian.
   */
  CAN_EDIT_DETAILS = 'CAN_EDIT_DETAILS',
  
  /**
   * The documents collaborators can be managed (added/removed).
   */
  CAN_MANAGE_COLLABORATORS = 'CAN_MANAGE_COLLABORATORS',
  
  /**
   * The documents attachments can be managed (added/removed).
   */
  CAN_MANAGE_ATTACHMENTS = 'CAN_MANAGE_ATTACHMENTS',
  
  /**
   * The documents notification list can be managed (members can be added/removed).
   */
  CAN_MANAGE_NOTIFICATION_LIST = 'CAN_MANAGE_NOTIFICATION_LIST',
  
  /**
   * Bank actions, such as Amend, Claim, Cancel and Return are able to be undertaken by the user. Only applicable on Documents where isSystemDocument is true.
   */
  CAN_REQUEST_BANK_ACTION = 'CAN_REQUEST_BANK_ACTION',
  
  /**
   * The documents original information can be edited, including content, parties, and expiry date.
   */
  CAN_AMEND = 'CAN_AMEND',
  
  /**
   * The documents costs and facility can be edited.
   */
  CAN_EDIT_COSTS = 'CAN_EDIT_COSTS',
  
  /**
   * The documents costs can be seen. CAN_EDIT_COSTS controls write access.
   */
  CAN_VIEW_COSTS = 'CAN_VIEW_COSTS',
  
  /**
   * The document can be set to awaiting return.
   */
  CAN_RETURN = 'CAN_RETURN'
}

/**
 * A connection to a list of items.
 */
export interface CollaboratorsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<CollaboratorsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DocumentCollaborator | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface CollaboratorsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DocumentCollaborator;
}

export interface DocumentCollaborator {
  
  /**
   * The capabilities of the current user to act on this Collaborator record.
   */
  capabilities: Array<DocumentCollaboratorRecordCapability | null>;
  emailAddress: string;
  id: string;
}

/**
 * Details the capabilities possible for an individual Collaborator Record
 */
export enum DocumentCollaboratorRecordCapability {
  
  /**
   * This record can be deleted by the current user
   */
  CAN_DELETE = 'CAN_DELETE'
}

/**
 * Sort options for the Comment type.
 */
export interface CommentSort {
  createdAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface CommentsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<CommentsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Comment | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface CommentsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Comment;
}

export interface Comment {
  
  /**
   * The Author of the Comment.
   */
  author?: Author;
  content: string;
  createdAt: DateTime;
  id: string;
}

/**
 * Details of an Author of data record.
 */
export interface Author {
  
  /**
   * The Family Name of the Author.
   */
  familyName: string;
  
  /**
   * The Given Name of the Author.
   */
  givenName: string;
  
  /**
   * Whether the Bank was the author or not
   */
  isBankAuthor: boolean;
}

/**
 * Details about the documents cost.
 */
export interface DocumentCosts {
  
  /**
   * Indication if the document costs are adjusted to prorata.
   */
  adjustedCost: boolean;
  
  /**
   * The recurring cost frequency. Range 1-360.
   */
  recurringCostFrequency: number;
  
  /**
   * Type of recurring fee.
   */
  recurringFeeType: RecurringFeeType;
  
  /**
   * The recurring fixed cost. Range 0-999999999.9999.
   */
  recurringFixedCost?: Decimal;
  
  /**
   * Recurring minimum fee (overwrites annual percentage cost if larger). Range 0-999999999.9999.
   */
  recurringMinimumAnnualCost?: Decimal;
  
  /**
   * The recurring percentage cost. Range 0-100.00.
   */
  recurringPercentageCost?: Decimal;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  setUpCost: Decimal;
}

export enum RecurringFeeType {
  ANNUAL_PERCENTAGE = 'ANNUAL_PERCENTAGE',
  FIXED_FEE = 'FIXED_FEE',
  LIFETIME_FEE = 'LIFETIME_FEE'
}

/**
 * Details the Custodian of a Document
 */
export interface Custodian {
  
  /**
   * The date the current Custodian received the Document.
   */
  dateReceived?: DateTime;
  
  /**
   * The email address of the current Custodian of the Document. Email format. Max length 255.
   */
  emailAddress?: string;
  
  /**
   * The name of the current Custodian of the Document. Max length 510.
   */
  name?: string;
  
  /**
   * User provided notes on the current Custodian of the Document. Max length 500.
   */
  notes?: string;
  
  /**
   * The storage address of the Document, under the current Custodian. Max length 500.
   */
  storageAddress?: string;
}

/**
 * The Document type.
 */
export enum DocumentVariant {
  
  /**
   * Bank Guarantee. The Document is backed by a Bank.
   */
  BANK_GUARANTEE = 'BANK_GUARANTEE',
  
  /**
   * Bond. The Document is backed by another Financial Institution.
   */
  SURETY_BOND = 'SURETY_BOND',
  
  /**
   * Cash Retention. The Document is backed by holding of Cash.
   */
  CASH = 'CASH',
  
  /**
   * Lease Bond. The Document is backed by another Financial Institution.
   */
  LEASE_BOND = 'LEASE_BOND'
}

/**
 * The `Date` scalar represents an ISO-8601 compliant date type.
 */
export type Date = any;

/**
 * Details the request for a Document handover
 */
export interface DocumentHandover {
  
  /**
   * The date of the document handover.
   */
  createdOn?: DateTime;
  
  /**
   * The email address to send the handover to . Email format. Max length 255.
   */
  emailAddress?: string;
  
  /**
   * The name of the person to send the handover to. Max length 510.
   */
  name?: string;
  
  /**
   * The organisation of the person receiving the document. Max length 510.
   */
  organisationName?: string;
  
  /**
   * The ID for the Document.
   */
  triggeredBy?: string;
}

/**
 * Sort options for the DocumentHistory type.
 */
export interface DocumentHistorySort {
  triggeredAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface HistoryConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<HistoryEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DocumentHistory | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface HistoryEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DocumentHistory;
}

export interface DocumentHistory {
  
  /**
   * The group of the changes, in case multiple happened at once.
   */
  changeSetId: string;
  changeType?: DocumentHistoryChangeType;
  
  /**
   * The field level changes that occured on this record.
   */
  changes?: Array<DocumentHistoryChange>;
  
  /**
   * The ID for the Document History record.
   */
  id: string;
  objectType: string;
  recordName?: string;
  triggeredAt: DateTime;
  
  /**
   * The Author of the change.
   */
  triggeredBy?: Author;
}

/**
 * Details the type of change that occurred
 */
export enum DocumentHistoryChangeType {
  
  /**
   * This change created a new record
   */
  INSERT = 'INSERT',
  
  /**
   * This change modified an existing record
   */
  UPDATE = 'UPDATE',
  
  /**
   * This change removed an existing record
   */
  DELETE = 'DELETE'
}

/**
 * Details on a field level change that has occurred in the system.
 */
export interface DocumentHistoryChange {
  
  /**
   * The name of the field that was changed.
   */
  field: string;
  
  /**
   * The label of the field that was changed.
   */
  label?: string;
  
  /**
   * The display value of this field after the change. In the case of DELETE events, this will be null.
   */
  newDisplayValue?: string;
  
  /**
   * The value of this field after the change. In the case of DELETE events, this will be null.
   */
  newValue?: string;
  
  /**
   * The display value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldDisplayValue?: string;
  
  /**
   * The value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldValue?: string;
}

export interface IInvoice {
  canGenerateHostedInvoice: boolean;
  createdAt: DateTime;
  createdBy: string;
  depositReferenceNumber: string;
  external_AmountDue: Decimal;
  external_CreatedDate?: DateTime;
  external_DueDate?: DateTime;
  external_PaidDate?: DateTime;
  external_ReceiptNumber?: string;
  hostedInvoiceAttachmentId?: string;
  hostedReceiptAttachmentId?: string;
  invoiceLineItems: Array<IInvoiceLineItem>;
  invoicePaymentIntents: Array<IInvoicePaymentIntent>;
  stripeInvoiceHostedUrl?: string;
  stripeInvoiceId?: string;
  stripeInvoicePdf?: string;
  stripeInvoiceStatus?: string;
  stripeReceiptUrl?: string;
  taxRate: TaxRateEnum;
  totalAmount: Decimal;
}

export interface IInvoiceLineItem {
  amount: Decimal;
  description: string;
  periodEnd?: DateTime;
  periodStart?: DateTime;
}

/** Use this to resolve interface type IInvoiceLineItem */
export type PossibleIInvoiceLineItemTypeNames = 'InvoiceLineItem';

export interface IInvoiceLineItemNameMap {
  IInvoiceLineItem: IInvoiceLineItem;
  InvoiceLineItem: InvoiceLineItem;
}

export interface IInvoicePaymentIntent {
  amount: Long;
  createdOn: DateTime;
  id: string;
  status: string;
  stripeInvoiceId: string;
  stripePaymentIntentId: string;
}

/** Use this to resolve interface type IInvoicePaymentIntent */
export type PossibleIInvoicePaymentIntentTypeNames = 'InvoicePaymentIntent';

export interface IInvoicePaymentIntentNameMap {
  IInvoicePaymentIntent: IInvoicePaymentIntent;
  InvoicePaymentIntent: InvoicePaymentIntent;
}

/**
 * The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1.
 */
export type Long = any;

export enum TaxRateEnum {
  
  /**
   * 
   * @deprecated Deprecated. Please use AU_GST_Inclusive for all NEW invoices/subscriptions
   */
  AU_GST_EXCLUSIVE = 'AU_GST_EXCLUSIVE',
  AU_GST_INCLUSIVE = 'AU_GST_INCLUSIVE'
}

/**
 * Sort options for the Metadata type.
 */
export interface MetadataSort {
  key?: SortOperationKind;
  value?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface MetadataConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<MetadataEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Metadata | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface MetadataEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Metadata;
}

export interface Metadata {
  id: string;
  key: string;
  value: string;
}

/**
 * Filters for the Party type.
 */
export interface PartyFilter {
  AND?: Array<PartyFilter>;
  OR?: Array<PartyFilter>;
  documentId_in?: Array<string>;
  documentId?: string;
  partyVariant?: PartyVariant;
  partyVariant_in?: Array<PartyVariant>;
  name_contains?: string;
}

export enum PartyVariant {
  BENEFICIARY = 'BENEFICIARY',
  ISSUER = 'ISSUER',
  OTHER = 'OTHER'
}

export interface Party {
  abn?: string;
  
  /**
   * 
   * @deprecated No longer supported
   */
  address?: string;
  addressV2?: Address;
  id: string;
  name: string;
  notes?: string;
  partyVariant?: PartyVariant;
}

export interface Address {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  country: string;
  postcode: string;
  state?: string;
}

/**
 * Details the request for return of a Document
 */
export interface DocumentRequestForReturn {
  
  /**
   * The email address to send the request for return to . Email format. Max length 255.
   */
  emailAddress?: string;
  
  /**
   * The name of the person to send the request for return to. Max length 510.
   */
  name?: string;
  
  /**
   * Indicates the request for return frequency.
   */
  recurringFrequency?: Short;
  
  /**
   * The date the request for return started.
   */
  startedOn?: DateTime;
}

/**
 * The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1.
 */
export type Short = any;

export enum DocumentRetentionType {
  PRACTICAL_COMPLETION = 'PRACTICAL_COMPLETION',
  DEFECT_LIABILITY_PERIOD = 'DEFECT_LIABILITY_PERIOD',
  LEASE_SECURITY = 'LEASE_SECURITY',
  OTHER = 'OTHER'
}

export enum SecurityType {
  CASH = 'CASH',
  FINANCE = 'FINANCE',
  PROPERTY = 'PROPERTY',
  OTHER = 'OTHER'
}

export enum DocumentStatus {
  PENDING = 'PENDING',
  ESTABLISHED = 'ESTABLISHED',
  AWAITING_RETURN = 'AWAITING_RETURN',
  CLOSED_RETURNED = 'CLOSED_RETURNED',
  CLOSED_CLAIMED = 'CLOSED_CLAIMED',
  CLOSED_CANCELLED = 'CLOSED_CANCELLED',
  CLOSED_EXPIRED = 'CLOSED_EXPIRED',
  PROJECTED = 'PROJECTED'
}

export interface DocumentNotificationListMember {
  familyName: string;
  givenName: string;
  memberId: string;
}

/**
 * Sort options for the DocumentFacility type.
 */
export interface DocumentFacilitySort {
  createdAt?: SortOperationKind;
  documentVariant?: SortOperationKind;
  endDate?: SortOperationKind;
  name?: SortOperationKind;
  securityType?: SortOperationKind;
  startDate?: SortOperationKind;
}

/**
 * Filters for the DocumentFacility type.
 */
export interface DocumentFacilityFilter {
  AND?: Array<DocumentFacilityFilter>;
  OR?: Array<DocumentFacilityFilter>;
  id?: string;
  id_in?: Array<string>;
  documentVariant?: DocumentVariant;
  documentVariant_in?: Array<DocumentVariant>;
  startDate_gte?: Date;
  startDate_gt?: Date;
  startDate_lt?: Date;
  startDate_lte?: Date;
  endDate_gte?: Date;
  endDate_gt?: Date;
  endDate_lt?: Date;
  endDate_lte?: Date;
  name_contains?: string;
  name_starts_with?: string;
  name_ends_with?: string;
  isAssuroFacility?: boolean;
  isAssuroFacility_not?: boolean;
  provider_contains?: string;
  provider_starts_with?: string;
  provider_ends_with?: string;
  securityType?: SecurityType;
  securityType_in?: Array<SecurityType | null>;
  limit?: Decimal;
  sharedFacilityWithOrganisations_some?: SharedFacilityWithOrganisationFilter;
}

/**
 * Filters for the SharedFacilityWithOrganisation type.
 */
export interface SharedFacilityWithOrganisationFilter {
  AND?: Array<SharedFacilityWithOrganisationFilter>;
  OR?: Array<SharedFacilityWithOrganisationFilter>;
  organisationId?: string;
  organisationId_in?: Array<string>;
}

/**
 * A connection to a list of items.
 */
export interface DocumentFacilitiesConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DocumentFacilitiesEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DocumentFacility | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DocumentFacilitiesEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DocumentFacility;
}

export interface DocumentFacility {
  annualCost?: Decimal;
  bankFrontedBondsRecurringPercentageCost?: Decimal;
  bankFrontedBondsSetUpCost?: Decimal;
  
  /**
   * The current users Capabilities to act on the Facility.
   */
  capabilities: Array<DocumentFacilityCapability | null>;
  documentAdjustedCost?: boolean;
  
  /**
   * The count of all documents in the facility
   */
  documentCount: Decimal;
  documentRecurringCostFrequency?: number;
  documentRecurringFeeType?: RecurringFeeType;
  documentRecurringFixedCost?: Decimal;
  documentRecurringMinimumAnnualCost?: Decimal;
  documentRecurringPercentageCost?: Decimal;
  documentSetUpCost?: Decimal;
  documentVariant: DocumentVariant;
  endDate: Date;
  entities?: Array<FacilityEntity | null>;
  
  /**
   * The History for the Facility.
   */
  facilityHistory?: FacilityHistoryConnection;
  id: string;
  
  /**
   * Indicates whether or not the facility is managed by Assuro
   */
  isAssuroFacility: boolean;
  limit: Decimal;
  name?: string;
  
  /**
   * The facility owner organisation.
   */
  organisation?: FacilityOrganisation;
  organisationId: string;
  premiumBankFrontedBondsRecurringPercentageCost?: Decimal;
  premiumDocumentRecurringPercentageCost?: Decimal;
  properties?: Array<FacilityProperty | null>;
  provider?: string;
  securityType?: SecurityType;
  setUpCost?: Decimal;
  sharedFacilityWithOrganisations?: Array<FacilitySharedFacilityWithOrganisation | null>;
  startDate: Date;
  supplierId?: string;
  
  /**
   * The total value of established documents in the facility
   */
  totalEstablished: Decimal;
  
  /**
   * The total value of projected documents in the facility
   */
  totalProjected: Decimal;
}

/**
 * The capabilities the current user has on a Facility
 */
export enum DocumentFacilityCapability {
  
  /**
   * The facility details can be edited.
   */
  CAN_EDIT_DETAILS = 'CAN_EDIT_DETAILS',
  
  /**
   * The only specific details, such as the nickname, can be edited.
   */
  CAN_EDIT_LIMITED_DETAILS = 'CAN_EDIT_LIMITED_DETAILS',
  
  /**
   * Can be attached to documents.
   */
  CAN_ATTACH_TO_DOCUMENTS = 'CAN_ATTACH_TO_DOCUMENTS',
  
  /**
   * Can be used to raise drafts.
   */
  CAN_RAISE_DRAFTS = 'CAN_RAISE_DRAFTS'
}

export interface FacilityEntity {
  abn?: string;
  facility: DocumentFacility;
  facilityId: string;
  id: string;
  name?: string;
}

/**
 * Sort options for the FacilityHistory type.
 */
export interface FacilityHistorySort {
  triggeredAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface FacilityHistoryConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<FacilityHistoryEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<FacilityHistory | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface FacilityHistoryEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: FacilityHistory;
}

export interface FacilityHistory {
  
  /**
   * The group of the changes, in case multiple happened at once.
   */
  changeSetId: string;
  changeType?: DocumentHistoryChangeType;
  
  /**
   * The field level changes that occured on this record.
   */
  changes?: Array<FacilityHistoryChange>;
  
  /**
   * The ID for the Facility History record.
   */
  id: string;
  objectType: string;
  recordName?: string;
  triggeredAt: DateTime;
  
  /**
   * The Author of the change.
   */
  triggeredBy?: string;
}

export interface FacilityHistoryChange {
  
  /**
   * The name of the field that was changed.
   */
  field: string;
  
  /**
   * The label of the field that was changed.
   */
  label?: string;
  
  /**
   * The display value of this field after the change. In the case of DELETE events, this will be null.
   */
  newDisplayValue?: string;
  
  /**
   * The value of this field after the change. In the case of DELETE events, this will be null.
   */
  newValue?: string;
  
  /**
   * The display value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldDisplayValue?: string;
  
  /**
   * The value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldValue?: string;
}

export interface FacilityOrganisation {
  id: string;
  name: string;
}

export interface FacilityProperty {
  address?: string;
  estimatedValue: Decimal;
  facility?: DocumentFacility;
  facilityId: string;
  id: string;
  isMortgaged: boolean;
  isPrimaryPlaceOfResidence?: boolean;
  lender?: string;
  outstandingMortgage?: Decimal;
  owners?: Array<FacilityPropertyOwner | null>;
  propertyType: PropertyType;
}

export interface FacilityPropertyOwner {
  applicantRelationship?: string;
  facilityPropertyId: string;
  id: string;
  name?: string;
  property: FacilityProperty;
}

export enum PropertyType {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL'
}

export interface FacilitySharedFacilityWithOrganisation {
  createdAt: DateTime;
  facilityId: string;
  id: string;
  organisationId: string;
  
  /**
   * The organisation.
   */
  sharedWithOrganisation?: FacilityOrganisation;
}

export interface ReportSortInput {
  id?: SortEnumType;
  supplierId?: SortEnumType;
  displayName?: SortEnumType;
  variant?: SortEnumType;
  status?: SortEnumType;
  filters?: SortEnumType;
  criteria?: SortEnumType;
  sortBy?: SortEnumType;
  sortOrder?: SortEnumType;
  createdBy?: SortEnumType;
  createdOn?: SortEnumType;
}

export interface ReportFilterInput {
  and?: Array<ReportFilterInput>;
  or?: Array<ReportFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  supplierId?: ComparableNullableOfGuidOperationFilterInput;
  displayName?: StringOperationFilterInput;
  variant?: NullableOfDocumentVariantOperationFilterInput;
  status?: ReportStatusOperationFilterInput;
  filters?: StringOperationFilterInput;
  criteria?: StringOperationFilterInput;
  sortBy?: StringOperationFilterInput;
  sortOrder?: NullableOfDocumentReportSortOrderOperationFilterInput;
  createdBy?: ComparableGuidOperationFilterInput;
  createdOn?: ComparableDateTimeOffsetOperationFilterInput;
}

export interface NullableOfDocumentVariantOperationFilterInput {
  eq?: DocumentVariant;
  neq?: DocumentVariant;
  in?: Array<DocumentVariant | null>;
  nin?: Array<DocumentVariant | null>;
}

export interface ReportStatusOperationFilterInput {
  eq?: ReportStatus;
  neq?: ReportStatus;
  in?: Array<ReportStatus>;
  nin?: Array<ReportStatus>;
}

export enum ReportStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface NullableOfDocumentReportSortOrderOperationFilterInput {
  eq?: DocumentReportSortOrder;
  neq?: DocumentReportSortOrder;
  in?: Array<DocumentReportSortOrder | null>;
  nin?: Array<DocumentReportSortOrder | null>;
}

export enum DocumentReportSortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

/**
 * A connection to a list of items.
 */
export interface DocumentReportsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DocumentReportsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Report>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DocumentReportsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: Report;
}

export interface Report {
  
  /**
   * The user who created the report.
   */
  createdBy?: CognitoUser;
  createdOn: DateTime;
  criteria: string;
  displayName: string;
  filters: string;
  id: string;
  sortBy?: string;
  sortOrder?: DocumentReportSortOrder;
  status: ReportStatus;
  supplierId?: string;
  variant?: DocumentVariant;
}

/**
 * Filter structure for Documents by their metadata
 */
export interface DocumentMetadataFilterInput {
  
  /**
   * The key of the metadata item to match
   */
  key: string;
  
  /**
   * The value of the metadata item to match
   */
  value: string;
}

/**
 * Sort options for the Document type.
 */
export interface DocumentSort {
  actionDate?: SortOperationKind;
  amount?: SortOperationKind;
  createdAt?: SortOperationKind;
  documentVariant?: SortOperationKind;
  establishedAt?: SortOperationKind;
  expectedReturnDate?: SortOperationKind;
  expiresAt?: SortOperationKind;
  projectAddress?: SortOperationKind;
  referenceNumber?: SortOperationKind;
}

/**
 * Filters for the Document type.
 */
export interface DocumentFilter {
  AND?: Array<DocumentFilter>;
  OR?: Array<DocumentFilter>;
  id?: string;
  id_in?: Array<string>;
  documentVariant?: DocumentVariant;
  documentVariant_in?: Array<DocumentVariant>;
  amount_gte?: Decimal;
  amount_lte?: Decimal;
  expiresAt_gte?: Date;
  expiresAt_lte?: Date;
  establishedAt_gte?: DateTime;
  establishedAt_lte?: DateTime;
  expectedReturnDate_gte?: Date;
  expectedReturnDate_lte?: Date;
  referenceNumber_contains?: string;
  referenceNumber_starts_with?: string;
  referenceNumber_ends_with?: string;
  description_contains?: string;
  description_starts_with?: string;
  description_ends_with?: string;
  status?: DocumentStatus;
  status_in?: Array<DocumentStatus>;
  actionDate_gte?: DateTime;
  actionDate_lte?: DateTime;
  facilityId?: string;
  facilityId_in?: Array<string | null>;
  originalDraftId?: string;
  originalDraftId_in?: Array<string | null>;
}

/**
 * A connection to a list of items.
 */
export interface DocumentsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DocumentsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Document | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DocumentsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Document;
}

/**
 * Sort options for the Bank Document type.
 */
export interface BankDocumentSort {
  actionDate?: SortOperationKind;
  amount?: SortOperationKind;
  createdAt?: SortOperationKind;
  documentVariant?: SortOperationKind;
  establishedAt?: SortOperationKind;
  expectedReturnDate?: SortOperationKind;
  expiresAt?: SortOperationKind;
  projectAddress?: SortOperationKind;
  referenceNumber?: SortOperationKind;
}

/**
 * Filters for the BankDocument type.
 */
export interface BankDocumentFilter {
  AND?: Array<BankDocumentFilter>;
  OR?: Array<BankDocumentFilter>;
  id?: string;
  id_in?: Array<string>;
  amount_gte?: Decimal;
  amount_lte?: Decimal;
  description_contains?: string;
  description_starts_with?: string;
  description_ends_with?: string;
  status?: DocumentStatus;
  status_in?: Array<DocumentStatus>;
  establishedAt_gte?: DateTime;
  establishedAt_lte?: DateTime;
  acceptedChannelPartnerId?: string;
  acceptedChannelPartnerId_in?: Array<string | null>;
  organisationId?: string;
  organisationId_in?: Array<string | null>;
  facilityId?: string;
  facilityId_in?: Array<string | null>;
  originalDraftId?: string;
  originalDraftId_not?: string;
  parties_some?: PartyFilter;
  expiresAt_gte?: Date;
  expiresAt_lte?: Date;
  expectedReturnDate_gte?: Date;
  expectedReturnDate_lte?: Date;
  referenceNumber_contains?: string;
  referenceNumber_starts_with?: string;
  referenceNumber_ends_with?: string;
  actionDate_gte?: DateTime;
  actionDate_lte?: DateTime;
  documentVariant?: DocumentVariant;
  documentVariant_in?: Array<DocumentVariant>;
  isParentDocument?: boolean;
  isParentDocument_in?: Array<boolean | null>;
}

/**
 * A connection to a list of items.
 */
export interface DocumentsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DocumentsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankDocument | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DocumentsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankDocument;
}

/**
 * Details on a Document, relevant to the Bank Portal.
 */
export interface BankDocument {
  actionDate?: DateTime;
  adjustedCost?: boolean;
  amount: Decimal;
  
  /**
   * 
   * @deprecated Replaced by the RecurringFixedCost and RecurringCostFrequency fields
   */
  annualCost?: Decimal;
  
  /**
   * The capabilities the current user has on a BankDocument
   */
  capabilities: Array<BankDocumentCapability | null>;
  
  /**
   * The name of the Channel Partner associated with this Document.
   */
  channelPartnerName?: string;
  closedAt?: DateTime;
  
  /**
   * The document costs (setup, fixed, percentage and frequency).
   */
  costs?: DocumentCosts;
  createdAt: DateTime;
  description?: string;
  documentVariant: DocumentVariant;
  establishedAt?: DateTime;
  
  /**
   * 
   * @deprecated Replaced by the SetUpCost field
   */
  establishmentFee?: Decimal;
  expectedReturnDate?: Date;
  expiresAt?: Date;
  guaranteeNumber?: string;
  
  /**
   * The Bank Document History record.
   */
  history?: HistoryConnection;
  id: string;
  
  /**
   * The Bank Document invoices.
   */
  invoices?: Array<IInvoice | null>;
  organisationId?: string;
  originalDraftId?: string;
  
  /**
   * The Parties relevant to the Document.
   */
  parties?: Array<Party>;
  projectAddress?: string;
  purpose?: string;
  recurringCostFrequency?: number;
  recurringFixedCost?: Decimal;
  recurringPercentageCost?: Decimal;
  referenceNumber?: string;
  requestedAt?: DateTime;
  retentionType?: DocumentRetentionType;
  securityType?: SecurityType;
  setUpCost?: Decimal;
  specifiedOtherPurpose?: string;
  status: DocumentStatus;
  
  /**
   * The name of the Supplier associated with this Document.
   */
  supplierName?: string;
}

/**
 * The possible actions that can be taken on a Bank Document
 */
export enum BankDocumentCapability {
  
  /**
   * The status can be changed
   */
  CAN_CHANGE_STATUS = 'CAN_CHANGE_STATUS',
  
  /**
   * The document can be edited
   */
  CAN_AMEND_DETAILS = 'CAN_AMEND_DETAILS'
}

/**
 * A connection to a list of items.
 */
export interface DocumentsSharedWithMeConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DocumentsSharedWithMeEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Document | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DocumentsSharedWithMeEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Document;
}

/**
 * Details required to determine remaining requirements for a draft
 */
export interface GetDraftApplicableRequirementsInput {
  amount?: Decimal;
  
  /**
   * The attachments currently on the Draft
   */
  attachments: Array<GetDraftApplicableRequirementsAttachmentInput>;
  
  /**
   * The associated Beneficiaries on the draft.
   */
  beneficiaries?: Array<GetDraftApplicableRequirementsPartyInput>;
  
  /**
   * The Contract Details relevant to confirming requirements
   */
  contract: GetDraftApplicableRequirementsContractDetailInput;
  description?: string;
  expectedReturnDate?: DateTime;
  expiresAt?: DateTime;
  facilityId?: string;
  
  /**
   * The associated issuer on the draft.
   */
  issuer?: GetDraftApplicableRequirementsPartyInput;
  organisationId?: string;
  
  /**
   * The process this draft is following
   */
  processType: DraftProcessType;
  purpose?: DraftPurpose;
  refundAccountName?: string;
  refundAccountNumber?: string;
  refundBSB?: string;
  
  /**
   * The requested documents on the Draft
   */
  requestedSuretyDocuments: Array<GetDraftApplicableRequirementsRequestedSuretyDocumentInput>;
  specifiedOtherPurpose?: string;
  
  /**
   * The status of the Draft.
   */
  status: DraftStatus;
}

/**
 * An attachment for the purpose of determining remaining requirements for a draft
 */
export interface GetDraftApplicableRequirementsAttachmentInput {
  
  /**
   * The variant of the attachment. Eg "Contract Deed".
   */
  variant?: DraftAttachmentVariant;
}

/**
 * The possible variants of Attachments for Drafts
 */
export enum DraftAttachmentVariant {
  
  /**
   * The supplier provided document preview for the bank guarantee application.
   */
  DOCUMENT_PREVIEW = 'DOCUMENT_PREVIEW',
  
  /**
   * An excerpt of the contract typically referred to as unfixed goods and materials, specifying the quantum of the offsite material
   */
  OFFSITE_MATERIALS_EXCERPT = 'OFFSITE_MATERIALS_EXCERPT',
  
  /**
   * If the Clause within the Contract is a generic clause and the Contract does not make a reference to quantum of the offsite material then a copy of the Billing Advice or Purchasing Order with exact description of materials, to be held off-site, and value of goods (inclusive of GST) is to be supplied
   */
  OFFSITE_MATERIALS_BILLING_ADVICE_OR_PURCHASE_ORDER = 'OFFSITE_MATERIALS_BILLING_ADVICE_OR_PURCHASE_ORDER',
  
  /**
   * The supplier provided "Original" of a document.
   */
  ORIGINAL_DOCUMENT = 'ORIGINAL_DOCUMENT',
  
  /**
   * The supplier provided Payment Invoice of the Surety Bond Application.
   */
  PAYMENT_INVOICE = 'PAYMENT_INVOICE',
  
  /**
   * The application submitted to the bank.
   */
  MEG_APPLICATION = 'MEG_APPLICATION',
  CONTRACT_DEED = 'CONTRACT_DEED',
  BANK_STATEMENT = 'BANK_STATEMENT',
  
  /**
   * A platform-generated invoice
   */
  GENERATED_INVOICE = 'GENERATED_INVOICE',
  
  /**
   * A platform-generated receipt
   */
  GENERATED_RECEIPT = 'GENERATED_RECEIPT',
  
  /**
   * A document associated with the "Required Document" feature
   */
  REQUIRED_DOCUMENT = 'REQUIRED_DOCUMENT'
}

/**
 * An attachment for the purpose of determining remaining requirements for a draft
 */
export interface GetDraftApplicableRequirementsPartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit).
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 255.
   */
  address?: string;
  addressV2?: AddressInput;
  
  /**
   * The name of Party, most likely the company name. Required. Max length 1000.
   */
  name: string;
  partyEntityType?: PartyEntityType;
  
  /**
   * The type of the Party, e.g. Issuer or Beneficiary
   */
  partyVariant?: DraftPartyVariant;
  
  /**
   * The main contact for the Party.
   */
  primaryContact?: DraftExtendedContactInput;
}

export interface AddressInput {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  country: string;
  postcode: string;
  state?: string;
}

export enum PartyEntityType {
  COMPANY = 'COMPANY',
  SOLE_TRADER = 'SOLE_TRADER',
  TRUST = 'TRUST'
}

/**
 * Details the type of a Party
 */
export enum DraftPartyVariant {
  
  /**
   * Beneficiary, the party that would receive the amount of the Draft if the Issuer defaulted.
   */
  BENEFICIARY = 'BENEFICIARY',
  
  /**
   * Issuer, the party who is responsible for funding (in most cases) the Draft.
   */
  ISSUER = 'ISSUER',
  
  /**
   * Any other type of party, e.g. a managing entity
   */
  OTHER = 'OTHER'
}

/**
 * A contact with address and phone number
 */
export interface DraftExtendedContactInput {
  
  /**
   * The email address of the Contact. Max length 255.
   */
  email?: string;
  
  /**
   * The Family Name of the Contact. Required. Max length 255.
   */
  familyName?: string;
  
  /**
   * The Given Name of the Contact. Required. Max length 255.
   */
  givenName?: string;
  
  /**
   * The Primary Phone Number of the Contact. Max length 255.
   */
  phoneNumber?: string;
}

/**
 * Relevant contract details for determining remaining requirements
 */
export interface GetDraftApplicableRequirementsContractDetailInput {
  bankFrontedBondsRequested?: boolean;
  bankFrontedBondsRequestedReason?: string;
  
  /**
   * Were there any defects and faults in materials, workmanship or design
   */
  defectsAndFaults?: DraftOptionWithDetailInput;
  
  /**
   * Has your Principal extended the defects liability Period?
   */
  defectsLiabilityPeriodExtended?: DraftOptionWithDetailInput;
  hasDelayEvents?: boolean;
  hasDesignObligationsLiability?: boolean;
  hasPreviousContracts?: boolean;
  hasSimilarContracts?: boolean;
  isExistingProject?: boolean;
  isSubcontractor?: boolean;
  
  /**
   * Are there any issues and / or disputes with respect to the underlying contract and for the defects liability period
   */
  issuesAndDisputes?: DraftOptionWithDetailInput;
  projectNotOnBudget?: boolean;
  
  /**
   * Are we replacing alternative security and if so specify type of security being replaced.
   * This field is required in two cases:
   * 1. A maintenance bond is requested and a performance bond is not being requested.
   * 2. Bond period start date differs to the Contract Start date
   */
  replacingExistingSecurity?: DraftOptionWithDetailInput;
  
  /**
   * The contracted start date.
   */
  startDate?: DateTime;
}

/**
 * Toggleable option with user supplied detail
 */
export interface DraftOptionWithDetailInput {
  
  /**
   * Whether the option is active/selected/checked or not.
   */
  active: boolean;
  
  /**
   * User supplied detail of the option. Max length 500.
   */
  detail?: string;
}

export enum DraftProcessType {
  
  /**
   * Bank Guarantee process. This is the default process.
   */
  BANK_GUARANTEE = 'BANK_GUARANTEE',
  
  /**
   * Surety Bond process.
   */
  SURETY_BOND = 'SURETY_BOND'
}

export enum DraftPurpose {
  RENTAL_BOND = 'RENTAL_BOND',
  SURETY_FOR_BUILDING = 'SURETY_FOR_BUILDING',
  SURETY_FOR_PERFORMANCE = 'SURETY_FOR_PERFORMANCE',
  SECURITY_DEPOSIT = 'SECURITY_DEPOSIT',
  CUSTOM_GUARANTEE = 'CUSTOM_GUARANTEE',
  OTHER = 'OTHER',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  DEPOSIT_BOND = 'DEPOSIT_BOND',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  SURETY_FOR_COSTS = 'SURETY_FOR_COSTS',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  ENVIRONMENTAL_PERFORMANCE = 'ENVIRONMENTAL_PERFORMANCE',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  FINANCIAL_ASSURANCE = 'FINANCIAL_ASSURANCE',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  LEASE_RENTAL_GUARANTEE = 'LEASE_RENTAL_GUARANTEE',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  DEPOSIT_GUARANTEE = 'DEPOSIT_GUARANTEE',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  SURETY_BOND_PERFORMANCE = 'SURETY_BOND_PERFORMANCE',
  
  /**
   * 
   * @deprecated Not exposed in current system
   */
  CONTRACT_PERFORMANCE_SECURITY = 'CONTRACT_PERFORMANCE_SECURITY'
}

/**
 * A requested document for the purpose of determining remaining requirements for a draft
 */
export interface GetDraftApplicableRequirementsRequestedSuretyDocumentInput {
  periodEndDate?: DateTime;
  periodStartDate?: DateTime;
  purpose: DraftRequestedDocumentPurpose;
}

/**
 * Options for the purpose of a requested document in a draft
 */
export enum DraftRequestedDocumentPurpose {
  
  /**
   * A bond to ensure performance of contracted duties
   */
  PERFORMANCE_BOND = 'PERFORMANCE_BOND',
  
  /**
   * A bond to ensure the maintenance period is completed and any defects fixed in the period
   */
  MAINTENANCE_BOND = 'MAINTENANCE_BOND',
  
  /**
   * A bond that is held in place of a cash retention, usually for performance guarantee reasons
   */
  RETENTION_RELEASE_BOND = 'RETENTION_RELEASE_BOND',
  
  /**
   * A bond for when advanced payment was made, usually held for performance guarantee reasons
   */
  ADVANCED_PAYMENT_BOND = 'ADVANCED_PAYMENT_BOND',
  
  /**
   * A bond held when works on utilities are required.
   */
  COUNCIL_OR_UTILITIES_BOND = 'COUNCIL_OR_UTILITIES_BOND',
  
  /**
   * A bond held to ensure materials will be available in the expected condition.
   */
  OFFSITE_OR_UNFIXED_MATERIALS_BOND = 'OFFSITE_OR_UNFIXED_MATERIALS_BOND',
  
  /**
   * A bond held for other reasons.
   */
  OTHER_BOND = 'OTHER_BOND',
  BID_OR_TENDER_BOND = 'BID_OR_TENDER_BOND',
  MINING_REHABILITATION_BOND = 'MINING_REHABILITATION_BOND'
}

/**
 * The possible Draft Statuses
 */
export enum DraftStatus {
  
  /**
   * Draft. Before the Bank Guarantee has been financially established/backed.
   */
  DRAFT = 'DRAFT',
  
  /**
   * Submitted. While the Draft is in review with the bank
   */
  SUBMITTED = 'SUBMITTED',
  
  /**
   * Established. The Bank Guarantee is financially established/backed and is current.
   */
  ESTABLISHED = 'ESTABLISHED',
  
  /**
   * Submission started. While the final details of the Draft for submission to the bank are being gathered.
   */
  SUBMISSION_STARTED = 'SUBMISSION_STARTED',
  
  /**
   * Pending Payment. While Draft is awaiting payment of fees from Issuer/Beneficiary to continue.
   */
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  
  /**
   * Rejected. The Draft was not acceptable to the Bank for the reason specified in RejectionReason.
   */
  REJECTED = 'REJECTED',
  
  /**
   * Changes Requested. The Draft was not acceptable to the Bank for the reason specified in RequestChangeReason.
   */
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  
  /**
   * Identifying. Performing AML/KYC on the client
   */
  IDENTIFYING = 'IDENTIFYING',
  
  /**
   * Processing. The Draft is being processed by the bank.
   */
  PROCESSING = 'PROCESSING',
  
  /**
   * Client has indicated the document has been returned, however we have yet to confirm this with the bank.
   */
  AWAITING_RETURN = 'AWAITING_RETURN',
  
  /**
   * Client has returned the document to the bank.
   */
  RETURNED = 'RETURNED',
  
  /**
   * Client has cancelled  the draft before draft submission.
   */
  CANCELLED = 'CANCELLED'
}

/**
 * Details a requirement that must be met by the current draft
 */
export interface DraftApplicableRequirement {
  
  /**
   * Field/part the requirement relates to (could refer to an attachment)
   */
  field: DraftRequirementField;
  
  /**
   * Message to be shown if requirement is not met
   */
  message: string;
  
  /**
   * Whether or not the requirement has been met
   */
  requirementMet: boolean;
}

/**
 * A field/part of a draft that is related to an applicable requirement.
 * This list is not complete.
 */
export enum DraftRequirementField {
  
  /**
   * The Defects and Faults field must be completed
   */
  DEFECTS_AND_FAULTS = 'DEFECTS_AND_FAULTS',
  DEFECTS_AND_FAULTS_DETAILS = 'DEFECTS_AND_FAULTS_DETAILS',
  
  /**
   * The Defects Liability Period Extended field must be completed
   */
  DEFECTS_LIABILITY_PERIOD_EXTENDED = 'DEFECTS_LIABILITY_PERIOD_EXTENDED',
  DEFECTS_LIABILITY_PERIOD_EXTENDED_DETAILS = 'DEFECTS_LIABILITY_PERIOD_EXTENDED_DETAILS',
  
  /**
   * The Issues and Disputes field must be completed
   */
  ISSUES_AND_DISPUTES = 'ISSUES_AND_DISPUTES',
  ISSUES_AND_DISPUTES_DETAILS = 'ISSUES_AND_DISPUTES_DETAILS',
  
  /**
   * The Project Not On Budget must be completed
   */
  PROJECT_NOT_ON_BUDGET = 'PROJECT_NOT_ON_BUDGET',
  
  /**
   * The Replacing Existing Security field must be completed
   */
  REPLACING_EXISTING_SECURITY = 'REPLACING_EXISTING_SECURITY',
  REPLACING_EXISTING_SECURITY_DETAILS = 'REPLACING_EXISTING_SECURITY_DETAILS',
  
  /**
   * An attachment is required with the excerpt of the contract typically referred to as unfixed goods and materials, specifying the quantum of the offsite material
   */
  OFFSITE_MATERIALS_EXCERPT_ATTACHMENT = 'OFFSITE_MATERIALS_EXCERPT_ATTACHMENT',
  
  /**
   * If the Clause within the Contract is a generic clause and the Contract does not make a reference to quantum of the offsite material then a copy of the Billing Advice or Purchasing Order with exact description of materials, to be held off-site, and value of goods (inclusive of GST) is to be supplied
   */
  OFFSITE_MATERIALS_BILLING_ADVICE_OR_PURCHASE_ORDER_ATTACHMENT = 'OFFSITE_MATERIALS_BILLING_ADVICE_OR_PURCHASE_ORDER_ATTACHMENT',
  
  /**
   * The Surety Bonds With Bank Fronted Bonds Requested Need a Reason
   */
  BANK_FRONTED_BONDS_REQUESTED_REASON = 'BANK_FRONTED_BONDS_REQUESTED_REASON',
  
  /**
   * need to answer this question "Has the company undertaken previous contracts for this client?"
   */
  HAS_PREVIOUS_CONTRACTS = 'HAS_PREVIOUS_CONTRACTS',
  
  /**
   * need to answer this question "Has the company undertaken a contract of this type before?"
   */
  HAS_SIMILAR_CONTRACTS = 'HAS_SIMILAR_CONTRACTS',
  
  /**
   * need to answer this question "Will the role be of Head or Subcontractor?"
   */
  IS_SUBCONTRACTOR = 'IS_SUBCONTRACTOR',
  
  /**
   * need to answer this question "Is this/these bonds for existing project?"
   */
  IS_EXISTING_PROJECT = 'IS_EXISTING_PROJECT',
  
  /**
   * need to answer this question "Does the contract include any Design obligations and/or liability?"
   */
  HAS_DESIGN_OBLIGATIONS_LIABILITY = 'HAS_DESIGN_OBLIGATIONS_LIABILITY',
  
  /**
   * need to answer this question "Does the contract identify delay events that give rise to Extensions of Time and Cost Recovery?"
   */
  HAS_DELAY_EVENTS = 'HAS_DELAY_EVENTS',
  
  /**
   * need to answer this question "Do you want this bond to provide a bank fronted guarantee?"
   */
  BANK_FRONTED_BONDS_REQUESTED = 'BANK_FRONTED_BONDS_REQUESTED',
  
  /**
   * A beneficiary address is required.
   */
  BENEFICIARY_ADDRESS = 'BENEFICIARY_ADDRESS',
  
  /**
   * A beneficiary ABN or ACN is required.
   */
  BENEFICIARY_ABN_OR_ACN = 'BENEFICIARY_ABN_OR_ACN',
  
  /**
   * A beneficiary Name is required.
   */
  BENEFICIARY_NAME = 'BENEFICIARY_NAME',
  
  /**
   * Recipient email addresses for invoice delivery are required.
   */
  INVOICE_RECIPIENT_ADDRESS = 'INVOICE_RECIPIENT_ADDRESS',
  
  /**
   * valid Facility Id.
   */
  FACILITY_ID = 'FACILITY_ID',
  PARTY_ENTITY_TYPE = 'PARTY_ENTITY_TYPE',
  
  /**
   * A account name is required
   */
  IDENTIFICATION_ACCOUNT_NAME = 'IDENTIFICATION_ACCOUNT_NAME',
  
  /**
   * A company name is required
   */
  IDENTIFICATION_COMPANY_NAME = 'IDENTIFICATION_COMPANY_NAME',
  
  /**
   * A company ABN or ACN is required.
   */
  IDENTIFICATION_COMPANY_ACN = 'IDENTIFICATION_COMPANY_ACN',
  
  /**
   * A company business activity is required.
   */
  IDENTIFICATION_COMPANY_BUSINESS_ACTIVITY = 'IDENTIFICATION_COMPANY_BUSINESS_ACTIVITY',
  
  /**
   * A company registered office address is required.
   */
  IDENTIFICATION_COMPANY_REGISTERED_OFFICE_ADDRESS = 'IDENTIFICATION_COMPANY_REGISTERED_OFFICE_ADDRESS',
  
  /**
   * A company principal place of business address is required.
   */
  IDENTIFICATION_COMPANY_PRINCIPAL_PLACE_OF_BUSINESS_ADDRESS = 'IDENTIFICATION_COMPANY_PRINCIPAL_PLACE_OF_BUSINESS_ADDRESS',
  
  /**
   * A company Director is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR = 'IDENTIFICATION_COMPANY_DIRECTOR',
  
  /**
   * A company Director title is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR_TITLE = 'IDENTIFICATION_COMPANY_DIRECTOR_TITLE',
  
  /**
   * A company Director first name is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR_FIRST_NAME = 'IDENTIFICATION_COMPANY_DIRECTOR_FIRST_NAME',
  
  /**
   * A company Director surname is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR_SURNAME = 'IDENTIFICATION_COMPANY_DIRECTOR_SURNAME',
  
  /**
   * A company beneficial owner who own 25% or more of the company is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER',
  
  /**
   * A company beneficial owner title is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_TITLE = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_TITLE',
  
  /**
   * A company beneficial owner first name is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_FIRST_NAME = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_FIRST_NAME',
  
  /**
   * A company beneficial owner surname is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_SURNAME = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_SURNAME',
  
  /**
   * A company beneficial owner email address is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_EMAIL_ADDRESS = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_EMAIL_ADDRESS',
  
  /**
   * A company's country of tax residency is required.
   */
  IDENTIFICATION_COMPANY_COUNTRY_OF_TAX_RESIDENCY = 'IDENTIFICATION_COMPANY_COUNTRY_OF_TAX_RESIDENCY',
  
  /**
   * A company's Global Intermediary Identification Number (GIIN) is required.
   */
  IDENTIFICATION_COMPANY_GIIN = 'IDENTIFICATION_COMPANY_GIIN',
  
  /**
   * A company's FATCA Status is required.
   */
  IDENTIFICATION_COMPANY_FATCA_STATUS = 'IDENTIFICATION_COMPANY_FATCA_STATUS',
  
  /**
   * A company's FATCA Status Description is required.
   */
  IDENTIFICATION_COMPANY_FATCA_STATUS_DESCRIPTION = 'IDENTIFICATION_COMPANY_FATCA_STATUS_DESCRIPTION',
  
  /**
   * A not australian tax resident company beneficial owner is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_NOT_AUSTRALIAN_TAX_RESIDENT = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_NOT_AUSTRALIAN_TAX_RESIDENT',
  
  /**
   * sole trader approver is required.
   */
  IDENTIFICATION_SOLE_TRADER_APPROVER = 'IDENTIFICATION_SOLE_TRADER_APPROVER',
  IDENTIFICATION_SOLE_TRADER_USER_ROLE = 'IDENTIFICATION_SOLE_TRADER_USER_ROLE',
  IDENTIFICATION_EMAIL_ADDRESS = 'IDENTIFICATION_EMAIL_ADDRESS',
  IDENTIFICATION_PHONE_MOBILE = 'IDENTIFICATION_PHONE_MOBILE',
  IDENTIFICATION_COMPANY_TYPE = 'IDENTIFICATION_COMPANY_TYPE',
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_USER_ROLE = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_USER_ROLE',
  IDENTIFICATION_COMPANY_DETAILS_REGULATOR_NAME = 'IDENTIFICATION_COMPANY_DETAILS_REGULATOR_NAME',
  IDENTIFICATION_COMPANY_DETAILS_REGULATOR_LICENSE_NUMBER = 'IDENTIFICATION_COMPANY_DETAILS_REGULATOR_LICENSE_NUMBER',
  IDENTIFICATION_COMPANY_DETAILS_LISTED_EXCHANGE_NAME = 'IDENTIFICATION_COMPANY_DETAILS_LISTED_EXCHANGE_NAME',
  IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_COMPANY_NAME = 'IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_COMPANY_NAME',
  IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_EXCHANGE_NAME = 'IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_EXCHANGE_NAME',
  IDENTIFICATION_TRADE_ORGANISATION = 'IDENTIFICATION_TRADE_ORGANISATION',
  IDENTIFICATION_POSTAL_ADDRESS = 'IDENTIFICATION_POSTAL_ADDRESS',
  IDENTIFICATION_TAX_EXEMPTION_DETAILS = 'IDENTIFICATION_TAX_EXEMPTION_DETAILS',
  IDENTIFICATION_TAX_EXEMPTION_TYPE = 'IDENTIFICATION_TAX_EXEMPTION_TYPE',
  IDENTIFICATION_TAX_STATUS = 'IDENTIFICATION_TAX_STATUS',
  IDENTIFICATION_COMPANY_USER_ROLE = 'IDENTIFICATION_COMPANY_USER_ROLE',
  IDENTIFICATION_COMPANY_SOLE_DIRECTOR_APPROVER = 'IDENTIFICATION_COMPANY_SOLE_DIRECTOR_APPROVER',
  IDENTIFICATION_COMPANY_MULTI_DIRECTOR_APPROVER = 'IDENTIFICATION_COMPANY_MULTI_DIRECTOR_APPROVER',
  ENTITY_TYPE = 'ENTITY_TYPE',
  HAS_MAC_ACCOUNT = 'HAS_MAC_ACCOUNT',
  REFUND_BSB = 'REFUND_BSB',
  REFUND_ACCOUNT_NAME = 'REFUND_ACCOUNT_NAME',
  REFUND_ACCOUNT_NUMBER = 'REFUND_ACCOUNT_NUMBER',
  PURPOSE = 'PURPOSE',
  SPECIFIED_OTHER_PURPOSE = 'SPECIFIED_OTHER_PURPOSE',
  DESCRIPTION = 'DESCRIPTION',
  AMOUNT = 'AMOUNT',
  EXPECTED_RETURN_DATE = 'EXPECTED_RETURN_DATE',
  ISSUER_ABN_OR_ACN = 'ISSUER_ABN_OR_ACN',
  ISSUER_NAME = 'ISSUER_NAME',
  ISSUER_ADDRESS = 'ISSUER_ADDRESS',
  CLIENT_APPROVAL = 'CLIENT_APPROVAL',
  BENEFICIARY_PRIMARYCONTACT_EMAIL = 'BENEFICIARY_PRIMARYCONTACT_EMAIL',
  DELIVERY_TYPE = 'DELIVERY_TYPE'
}

/**
 * Details to download a Draft Attachment
 */
export interface DraftAttachmentDownload {
  
  /**
   * The link to download the Draft Attachment
   */
  downloadPresignedUrl: string;
}

/**
 * Details on a Draft
 */
export interface Draft {
  
  /**
   * The channel partner ID that was used for the discount.
   */
  acceptedChannelPartnerId?: string;
  
  /**
   * Any additional supplier information relevant for the draft.
   */
  additionalSupplierDetail?: AdditionalSupplierDetail;
  
  /**
   * The monetary value of the Draft. Required. Range 0-999999999.99.
   */
  amount: Decimal;
  
  /**
   * List of FeeSummaryId for all ancestor drafts
   */
  ancestorFeeSummaryIds?: Array<string | null>;
  
  /**
   * Requirements specific to the Draft. All requirements must be met before submission can start.
   */
  applicableRequirements: Array<DraftApplicableRequirement>;
  
  /**
   * The Attachments for the Draft. Not available for listed (>1 returned) Drafts.
   */
  attachments: Array<DraftAttachment>;
  
  /**
   * The BG switch linked to the Draft.
   */
  bGSwitch?: DraftBGSwitch;
  
  /**
   * The context from which the current user (caller) can access this Draft.
   */
  callerContext?: DraftCallerContext;
  
  /**
   * The current users Capabilities to act on the Draft.
   */
  capabilities: Array<DraftCapability | null>;
  
  /**
   * Whether the associated draft has either submitted an enquiry to fund their BG via finance, or indicated they were not interested
   */
  completedFinanceJourney: boolean;
  
  /**
   * Details on the contract for this Draft
   */
  contract?: DraftContractDetail;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * End of the current period that the subscription has been invoiced for. At the end of this period, a new invoice will be created.
   */
  currentPeriodEnd?: DateTime;
  
  /**
   * Details for the delivery of the Document. Only available to users who can submit. Will be null if draft hasn't been submitted previously.
   */
  deliveryDetails?: DraftDeliveryDetails;
  
  /**
   * The selected delivery type
   * NOTE: can only be one of DIGITAL or PHYSICAL
   * TODO: need a migration script to set all historical values to PHYSICAL (apart from anything that hasn't had a feeSummary associated with it)
   */
  deliveryType?: DeliveryType;
  
  /**
   * The Description (usually the Agreement Content) of the Draft
   * This usually contains details on what the Draft is covering, e.g. Installing new windows at a property
   * Required
   */
  description: string;
  
  /**
   * The directors email address, if not the originating user.
   */
  directorEmailAddress?: string;
  
  /**
   * The directors first name, if not the originating user.
   */
  directorFirstName?: string;
  
  /**
   * The directors last name, if not the originating user.
   */
  directorLastName?: string;
  
  /**
   * The discount percentage applied.
   */
  discountPercentage?: Decimal;
  
  /**
   * The Collaborators for the Draft. Not available for listed (>1 returned) Drafts.
   */
  draftCollaborators?: DraftCollaboratorsConnection;
  
  /**
   * The Comments for the Draft. Not available for listed (>1 returned) Drafts.
   */
  draftComments?: DraftCommentsConnection;
  
  /**
   * The History for the Draft. Not available for listed (>1 returned) Drafts.
   */
  draftHistory?: DraftHistoryConnection;
  
  /**
   * The date stamp the draft was established
   */
  establishedAt?: DateTime;
  
  /**
   * The applicable establishment fee discount amount.
   */
  establishmentFeeDiscountAmount: Decimal;
  
  /**
   * The Expected Return Date.
   */
  expectedReturnDate?: Date;
  
  /**
   * The date the Draft expires.
   */
  expiresAt?: Date;
  
  /**
   * The ID of the Facility this Draft is attached to.
   */
  facilityId?: string;
  
  /**
   * The fee summary relevant to the Draft.
   */
  feeSummary?: FeeSummary;
  feeSummaryId?: string;
  
  /**
   * The funding of the Draft.
   */
  fundingMethod?: FundingMethod;
  
  /**
   * The ID for the Draft.
   */
  id: string;
  
  /**
   * Identification data relevant to the draft
   */
  identification?: Identification;
  identificationId?: string;
  
  /**
   * Whether the identification was submitted (the individual verification can be completed later)
   */
  identificationSubmitted: boolean;
  invoiceRecipientEmailAddresses?: string;
  
  /**
   * The Invoices relevant to the Draft.
   */
  invoices?: Array<DraftInvoice | null>;
  
  /**
   * Whether the organisation is eligible for finance.
   */
  isEligibleForFinance?: boolean;
  isVisibleToSupplier: boolean;
  
  /**
   * Further information on the source of funds for the security of the bank guarantee.
   */
  issuerDetailsOfSourceOfFunds?: string;
  
  /**
   * The source of the issuers funds for the security of the bank guarantee.
   */
  issuerSourceOfFunds?: DraftIssuerSourceOfFunds;
  
  /**
   * A Json string to store the Meg application details
   */
  megDetails?: string;
  
  /**
   * The ID of the Organisation who created this Draft. Required.
   */
  organisationId: string;
  
  /**
   * The Parties relevant to the Draft.
   */
  parties?: Array<DraftParty>;
  
  /**
   * The payment details for the Draft
   */
  paymentDetails?: DraftRequestedPaymentDetails;
  
  /**
   * The process the Draft will follow.
   */
  processType: DraftProcessType;
  
  /**
   * Timestamp of the product terms acceptance (not required for all products)
   */
  productTermsAcceptedDate?: DateTime;
  
  /**
   * The Project or Property Address. Max length 500.
   */
  projectAddress?: string;
  
  /**
   * The purpose of the Draft.
   */
  purpose?: DraftPurpose;
  
  /**
   * The Draft's Reference Number, such as a Contract Number. Max length 255.
   */
  referenceNumber?: string;
  
  /**
   * The referral percentage applied.
   */
  referralPercentage: Decimal;
  referralProgramDiscount?: ReferralDiscount;
  refundAccountName?: string;
  refundAccountNumber?: string;
  refundBSB?: string;
  
  /**
   * The reason the Draft was rejected from the Bank. Max length 255.
   */
  rejectionReason?: string;
  
  /**
   * The changes to the Draft requested from the Bank. Max length 255.
   */
  requestChangeReason?: string;
  
  /**
   * The Requested Documents related to the current Draft.
   */
  requestedSuretyDocuments?: Array<DraftRequestedSuretyDocuments | null>;
  
  /**
   * Any requested documents or documents sent to the client associated to the draft. Only populated for administrators of the organisation related to the draft
   */
  requiredDocuments?: Array<RequiredDocumentViewModel | null>;
  sourceDraftId?: string;
  
  /**
   * The other specified purpose.
   */
  specifiedOtherPurpose?: string;
  
  /**
   * The status of the Draft.
   */
  status: DraftStatus;
  stripeSubscriptionId?: string;
  stripeSubscriptionStatus?: string;
  
  /**
   * The date stamp the record was submitted to the Bank.
   */
  submittedAt?: DateTime;
  totalFees?: Decimal;
  visibleToSupplierDate?: DateTime;
}

/**
 * Additional supplier details.
 */
export interface AdditionalSupplierDetail {
  
  /**
   * The account BSB from which the security of a bank guarantee will be taken.
   */
  fundingAccountBsb: string;
  
  /**
   * The account name from which the security of a bank guarantee will be taken.
   */
  fundingAccountNumber: string;
  
  /**
   * Has the client provided authority to take funds from their nominated funding account?
   */
  hasFundingAccountAuthorisation: boolean;
  id: string;
}

/**
 * Details about a Draft Attachment
 */
export interface DraftAttachment {
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255.
   */
  contentType: string;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The ID of the Draft this Attachment is for. Required.
   */
  draftId: string;
  
  /**
   * The ID of the Draft this Attachment is for.
   */
  draftRequestedDocumentId?: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255.
   */
  fileName: string;
  
  /**
   * The ID of the Attachment
   */
  id: string;
  infectedFileStatus: InfectedFileStatus;
  
  /**
   * Stores whether the file has been received by S3 or not.
   */
  received: boolean;
  
  /**
   * The link to upload the Draft Attachment file.
   */
  uploadPresignedUrl?: string;
  
  /**
   * The variant of the attachment. Eg "Contract Deed".
   */
  variant?: DraftAttachmentVariant;
}

/**
 * Context of user requesting access to Draft
 */
export interface DraftCallerContext {
  
  /**
   * The details of the Collaborator in the context
   */
  collaborator?: DraftCollaborator;
  
  /**
   * Whether or not the user is a member of the organisation
   */
  isOrganisationMember: boolean;
  
  /**
   * The details of the Organisation in the context
   */
  organisation?: DraftOrganisation;
}

/**
 * Details on a Draft Collaborator
 */
export interface DraftCollaborator {
  
  /**
   * The capabilities of the current user to act on this Collaborator record.
   */
  capabilities: Array<DraftCollaboratorRecordCapability | null>;
  
  /**
   * The Email Address of the Collaborator, if this is an Individual Collaborator
   */
  emailAddress?: string;
  
  /**
   * The Family Name of the Collaborator, if this is an Individual Collaborator
   */
  familyName?: string;
  
  /**
   * The Given Name of the Collaborator, if this is an Individual Collaborator
   */
  givenName?: string;
  
  /**
   * Whether the Collaborator has approved the Draft.
   */
  hasApproved: boolean;
  
  /**
   * The ID for the Collaborator
   */
  id: string;
  
  /**
   * Invitation approval status.
   */
  invitationStatus: InvitationStatus;
  
  /**
   * The Name of the Organisation, if this is an Organisation Collaborator
   */
  organisationName?: string;
  
  /**
   * The roles the Collaborator has been granted.
   */
  roles: Array<CollaboratorRole>;
  
  /**
   * The members who are on the notification list for this draft.
   */
  subscribedMembers: Array<DraftNotificationListMember | null>;
}

/**
 * Details the capabilities possible for an individual Collaborator Record
 */
export enum DraftCollaboratorRecordCapability {
  
  /**
   * This record can be deleted by the current user
   */
  CAN_DELETE = 'CAN_DELETE',
  
  /**
   * This record can be used to extend the Collaborators scope to an Organisation
   */
  CAN_SHARE_TO_ORGANISATION = 'CAN_SHARE_TO_ORGANISATION',
  
  /**
   * This records notification list can be managed by the current user
   */
  CAN_MANAGE_NOTIFICATION_LIST = 'CAN_MANAGE_NOTIFICATION_LIST'
}

export enum InvitationStatus {
  INVITED = 'INVITED',
  EXPIRED = 'EXPIRED',
  ACCEPTED = 'ACCEPTED'
}

/**
 * The possible Roles a Draft Collaborator could have.
 */
export enum CollaboratorRole {
  
  /**
   * View and comment only on drafts.
   */
  LIMITED = 'LIMITED',
  
  /**
   * Take actions as the Beneficiary, such as amending and approving the draft.
   */
  BENEFICIARY = 'BENEFICIARY',
  
  /**
   * Take actions as the Beneficiary, such as amending, approving, and submitting the draft.
   */
  ISSUER = 'ISSUER',
  
  /**
   * Owner of the draft, can take actions such as adding further Collaborators.
   */
  OWNER = 'OWNER'
}

export interface DraftNotificationListMember {
  familyName: string;
  givenName: string;
  memberId: string;
}

/**
 * Details an Organisation
 */
export interface DraftOrganisation {
  
  /**
   * The Organisation's Fee Discount Percentage.
   */
  discountPercentage: Decimal;
  
  /**
   * The ID of the entity
   */
  id: string;
  
  /**
   * The name of the Organisation
   */
  name: string;
}

/**
 * The capabilities the current user has on a Draft
 */
export enum DraftCapability {
  
  /**
   * The drafts details can be edited.
   */
  CAN_EDIT_DETAILS = 'CAN_EDIT_DETAILS',
  
  /**
   * The draft can be approved.
   */
  CAN_APPROVE = 'CAN_APPROVE',
  
  /**
   * The draft can be canceled.
   */
  CAN_CANCEL = 'CAN_CANCEL',
  
  /**
   * The draft can be submitted to a financial institution.
   */
  CAN_SUBMIT = 'CAN_SUBMIT',
  
  /**
   * The draft can be progressed through the various statuses (not established or rejected).
   */
  CAN_PROGRESS = 'CAN_PROGRESS',
  
  /**
   * The drafts collaborators can be managed (added/removed).
   */
  CAN_MANAGE_COLLABORATORS = 'CAN_MANAGE_COLLABORATORS',
  
  /**
   * The payment details should be visible, if they are available
   */
  CAN_VIEW_PAYMENT_DETAILS = 'CAN_VIEW_PAYMENT_DETAILS',
  
  /**
   * The drafts attachments can be managed (added/removed).
   */
  CAN_MANAGE_ATTACHMENTS = 'CAN_MANAGE_ATTACHMENTS',
  
  /**
   * The draft can be paid for.
   */
  CAN_MAKE_PAYMENT = 'CAN_MAKE_PAYMENT',
  CAN_MANAGE_REQUIRED_DOCUMENTS = 'CAN_MANAGE_REQUIRED_DOCUMENTS'
}

/**
 * Contract details for a Draft
 */
export interface DraftContractDetail {
  
  /**
   * Bank fronted bonds have been requested.
   */
  bankFrontedBondsRequested: boolean;
  
  /**
   * Reason Bank Guarantee is required.
   */
  bankFrontedBondsRequestedReason?: string;
  
  /**
   * With respect to the contract, has your Principal made any claims to defects or faults in materials,
   * workmanship or design?
   */
  defectsAndFaults?: DraftOptionWithDetail;
  
  /**
   * Has your Principal extended the defects liability Period?
   */
  defectsLiabilityPeriodExtended?: DraftOptionWithDetail;
  
  /**
   * The date by which any defects found must be fixed by
   */
  finalCompletionDate?: Date;
  
  /**
   * Does the contract identify delay events that give rise to Extensions of Time and Cost Recovery?
   */
  hasDelayEvents?: boolean;
  
  /**
   * Does the contract include any "design" obligations and/or liability?
   */
  hasDesignObligationsLiability?: boolean;
  
  /**
   * Has the company undertaken previous contracts for this client?
   */
  hasPreviousContracts?: boolean;
  
  /**
   * Has the company undertaken a contract of this type before?
   */
  hasSimilarContracts?: boolean;
  
  /**
   * Is Existing Project?
   */
  isExistingProject?: boolean;
  
  /**
   * Will the role be Head Contractor or Subcontractor
   */
  isSubcontractor: boolean;
  
  /**
   * Has your Principal stated any issues/disputes about the contract works or defects with the project?
   */
  issuesAndDisputes?: DraftOptionWithDetail;
  
  /**
   * The date when contracted work should be completed
   */
  practicalCompletionDate?: Date;
  
  /**
   * Has either of the project program or contract sum been exceeded.
   */
  projectNotOnBudget?: boolean;
  
  /**
   * Are we replacing existing security?
   */
  replacingExistingSecurity?: DraftOptionWithDetail;
  
  /**
   * The contracted start date. Required.
   */
  startDate: Date;
  
  /**
   * The total value of the contract
   */
  totalValue: Decimal;
}

/**
 * Toggleable option with user supplied detail
 */
export interface DraftOptionWithDetail {
  
  /**
   * Whether the option is active/selected/checked or not.
   */
  active: boolean;
  
  /**
   * User supplied detail of the option. Max length 500.
   */
  detail?: string;
}

/**
 * Details for the delivery of the Document
 */
export interface DraftDeliveryDetails {
  
  /**
   * The Delivery Address for the physical copy of the Document. Max length 500.
   */
  address: string;
  
  /**
   * The Company Name who will receive the physical copy of the Document. Max length 255.
   */
  companyName?: string;
  
  /**
   * The phone number of the person who will receive the physical copy of the Document. Max length 255.
   */
  phoneNumber?: string;
  
  /**
   * The Family Name of the person who will receive the physical copy of the Document. Max length 255.
   */
  recipientFamilyName: string;
  
  /**
   * The Given Name of the person who will receive the physical copy of the Document. Max length 255.
   */
  recipientGivenName: string;
}

export enum DeliveryType {
  DIGITAL = 'DIGITAL',
  PHYSICAL = 'PHYSICAL',
  DIGITAL_OR_PHYSICAL = 'DIGITAL_OR_PHYSICAL'
}

/**
 * A connection to a list of items.
 */
export interface DraftCollaboratorsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftCollaboratorsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DraftCollaborator | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftCollaboratorsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DraftCollaborator;
}

/**
 * Sort options for the Comment type.
 */
export interface DraftCommentSort {
  createdAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface DraftCommentsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftCommentsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DraftComment | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftCommentsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DraftComment;
}

/**
 * Details of a Comment on a Draft
 */
export interface DraftComment {
  
  /**
   * The Author of the Comment.
   */
  author?: DraftAuthor;
  
  /**
   * The content of the comment. Required. Min length 1. Max length 500.
   */
  content: string;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The History related to the Comment.
   */
  history?: Array<DraftHistory>;
  
  /**
   * The ID for the Comment
   */
  id: string;
}

/**
 * Details of an Author of data record.
 */
export interface DraftAuthor {
  
  /**
   * The Family Name of the Author.
   */
  familyName: string;
  
  /**
   * The Given Name of the Author.
   */
  givenName: string;
  
  /**
   * Whether the Bank was the author or not
   */
  isBankAuthor: boolean;
}

/**
 * Details on a change that has occurred in the system.
 */
export interface DraftHistory {
  
  /**
   * The group of the changes, in case multiple happened at once.
   */
  changeSetId: string;
  
  /**
   * The type of change this record captures.
   */
  changeType?: DraftHistoryChangeType;
  
  /**
   * The field level changes that occured on this record.
   */
  changes?: Array<DraftHistoryChange>;
  
  /**
   * The ID for the Draft History record.
   */
  id: string;
  
  /**
   * The type of the record that was changed.
   */
  objectType: string;
  
  /**
   * The name identifier for the record. Optional.
   */
  recordName?: string;
  
  /**
   * When the change was made.
   */
  triggeredAt: DateTime;
  
  /**
   * The Author of the change.
   */
  triggeredBy?: DraftAuthor;
}

/**
 * Details the type of change that occurred
 */
export enum DraftHistoryChangeType {
  
  /**
   * This change created a new record
   */
  INSERT = 'INSERT',
  
  /**
   * This change modified an existing record
   */
  UPDATE = 'UPDATE',
  
  /**
   * This change removed an existing record
   */
  DELETE = 'DELETE'
}

/**
 * Details on a field level change that has occurred in the system.
 */
export interface DraftHistoryChange {
  
  /**
   * The name of the field that was changed.
   */
  field: string;
  
  /**
   * The label of the field that was changed.
   */
  label?: string;
  
  /**
   * The display value of this field after the change. In the case of DELETE events, this will be null.
   */
  newDisplayValue?: string;
  
  /**
   * The value of this field after the change. In the case of DELETE events, this will be null.
   */
  newValue?: string;
  
  /**
   * The display value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldDisplayValue?: string;
  
  /**
   * The value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldValue?: string;
}

/**
 * Sort options for the DraftHistory type.
 */
export interface DraftHistorySort {
  triggeredAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface DraftHistoryConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftHistoryEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DraftHistory | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftHistoryEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DraftHistory;
}

export interface FeeSummary {
  assuroAgencyAgreementTemplateName?: string;
  biannualFeeCoefficient: Decimal;
  createdAt: DateTime;
  createdBy: string;
  deliveryType: DeliveryType;
  details?: string;
  establishmentFee: Decimal;
  features?: Array<string>;
  feeSummaryStatus: FeeSummaryStatus;
  id: string;
  maxValue?: Decimal;
  minValue?: Decimal;
  name: string;
  productPreviewTemplateName?: string;
  productType: ProductType;
  recurringFeePercentage: Decimal;
  securityType: SecurityType;
  supplier?: Supplier;
  supplierId?: string;
}

export enum FeeSummaryStatus {
  LIMITED = 'LIMITED',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}

export enum ProductType {
  BANK_GUARANTEE = 'BANK_GUARANTEE',
  FACILITY_PROPERTY_BACKED = 'FACILITY_PROPERTY_BACKED'
}

export interface Supplier {
  createdAt: DateTime;
  createdBy: string;
  feeSummaries: Array<FeeSummary>;
  
  /**
   * The Id of the associated "Guarantor" record in GVP. (If null, it means either the supplier doesn't have an agreement to use ADS, or is not mapped yet)
   */
  gvpId?: string;
  id: string;
  name: string;
  notificationAddress: string;
}

/**
 * The possible Draft Funding Methods
 */
export enum FundingMethod {
  
  /**
   * Finance. The money used to fund this guarantee was sourced from a loan.
   */
  FINANCE = 'FINANCE',
  
  /**
   * Cash. The money used to fund this guarantee was sourced by cash.
   */
  CASH = 'CASH'
}

/**
 * Details on a Identification.
 */
export interface Identification {
  adminStatus?: IdentificationApprovalStatus;
  
  /**
   * Requirements specific to the Identification. All requirements must be met before submission can start.
   */
  applicableRequirements: Array<IdentificationApplicableRequirement>;
  clientStatus?: IdentificationApprovalStatus;
  
  /**
   * Client verification status for the Identification record.
   */
  clientVerificationStatus?: ClientVerificationStatus;
  companyDetailsACN?: string;
  companyDetailsHasBeneficialOwners?: boolean;
  companyDetailsIsListed?: boolean;
  companyDetailsIsNormalType?: boolean;
  companyDetailsIsRegulated?: boolean;
  companyDetailsIsSubsidiaryListed?: boolean;
  companyDetailsListedExchangeName?: string;
  companyDetailsName?: string;
  companyDetailsNatureOfBusiness?: string;
  companyDetailsOnlyOperatesInAustralia?: boolean;
  companyDetailsPrincipalPlaceOfBusiness?: string;
  companyDetailsRegisteredAddress?: string;
  companyDetailsRegulatorLicenseNumber?: string;
  companyDetailsRegulatorName?: string;
  companyDetailsSubsidiaryListedCompanyName?: string;
  companyDetailsSubsidiaryListedExchangeName?: string;
  companyDetailsTaxFatcaStatus?: IdentificationCompanyDetailsTaxFatcaStatus;
  companyDetailsTaxFatcaStatusOther?: string;
  companyDetailsTaxForeignResidentCountry?: string;
  companyDetailsTaxGIIN?: string;
  companyDetailsTaxHasBeneficialOwnerForeignResident?: boolean;
  companyDetailsTaxHasGIIN?: boolean;
  companyDetailsTaxIsForeignResident?: boolean;
  companyDetailsTaxType?: IdentificationCompanyDetailsTaxType;
  createdAt: DateTime;
  dataType?: IdentificationDataType;
  entityType?: IdentificationEntityType;
  entityWealthAccumulation?: EntityWealthAccumulation;
  hasDividendsIncome?: boolean;
  
  /**
   * 
   * @deprecated No longer supported
   */
  hasMacAccount?: boolean;
  id: string;
  identificationIndustry?: IdentificationIndustry;
  
  /**
   * The Individuals relevant to the Identification.
   */
  individuals?: Array<IdentificationIndividual | null>;
  industryAdditionalDetails?: string;
  
  /**
   * 
   * @deprecated No longer supported
   */
  macAccountName?: string;
  
  /**
   * 
   * @deprecated No longer supported
   */
  macAccountNumber?: string;
  
  /**
   * The Identification's organisation.
   */
  organisation?: IdentificationOrganisation;
  organisationId?: string;
  postalAddress?: string;
  simpleKycDataId?: string;
  
  /**
   * The SimpleKycData record.
   */
  simpleKycDataRecord?: ISimpleKycData;
  step?: IdentificationStep;
  taxExemptionDetails?: string;
  taxExemptionType?: IdentificationCompanyDetailsTaxTaxExemptionType;
  taxStatus?: IdentificationCompanyDetailsTaxStatus;
  userId: string;
}

export enum IdentificationApprovalStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED'
}

/**
 * Details a requirement that must be met by the current Identification
 */
export interface IdentificationApplicableRequirement {
  
  /**
   * Field/part the requirement relates to.
   */
  field: IdentificationRequirementField;
  
  /**
   * Message to be shown if requirement is not met
   */
  message: string;
  
  /**
   * Whether or not the requirement has been met
   */
  requirementMet: boolean;
}

/**
 * A field/part of a Identification that is related to an applicable requirement.
 * This list is not complete.
 */
export enum IdentificationRequirementField {
  
  /**
   * A account name is required
   */
  IDENTIFICATION_ACCOUNT_NAME = 'IDENTIFICATION_ACCOUNT_NAME',
  
  /**
   * A company name is required
   */
  IDENTIFICATION_COMPANY_NAME = 'IDENTIFICATION_COMPANY_NAME',
  
  /**
   * A company ABN or ACN is required.
   */
  IDENTIFICATION_COMPANY_ACN = 'IDENTIFICATION_COMPANY_ACN',
  
  /**
   * A company business activity is required.
   */
  IDENTIFICATION_COMPANY_BUSINESS_ACTIVITY = 'IDENTIFICATION_COMPANY_BUSINESS_ACTIVITY',
  
  /**
   * A company registered office address is required.
   */
  IDENTIFICATION_COMPANY_REGISTERED_OFFICE_ADDRESS = 'IDENTIFICATION_COMPANY_REGISTERED_OFFICE_ADDRESS',
  
  /**
   * A company principal place of business address is required.
   */
  IDENTIFICATION_COMPANY_PRINCIPAL_PLACE_OF_BUSINESS_ADDRESS = 'IDENTIFICATION_COMPANY_PRINCIPAL_PLACE_OF_BUSINESS_ADDRESS',
  
  /**
   * A company Director is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR = 'IDENTIFICATION_COMPANY_DIRECTOR',
  
  /**
   * A company Director title is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR_TITLE = 'IDENTIFICATION_COMPANY_DIRECTOR_TITLE',
  
  /**
   * A company Director first name is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR_FIRST_NAME = 'IDENTIFICATION_COMPANY_DIRECTOR_FIRST_NAME',
  
  /**
   * A company Director surname is required.
   */
  IDENTIFICATION_COMPANY_DIRECTOR_SURNAME = 'IDENTIFICATION_COMPANY_DIRECTOR_SURNAME',
  
  /**
   * A company beneficial owner who own 25% or more of the company is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER',
  
  /**
   * A company beneficial owner title is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_TITLE = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_TITLE',
  
  /**
   * A company beneficial owner first name is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_FIRST_NAME = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_FIRST_NAME',
  
  /**
   * A company beneficial owner surname is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_SURNAME = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_SURNAME',
  
  /**
   * A company beneficial owner email address is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_EMAIL_ADDRESS = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_EMAIL_ADDRESS',
  
  /**
   * A company's country of tax residency status - yes, no.
   */
  IDENTIFICATION_COMPANY_COUNTRY_OF_TAX_RESIDENCY_STATUS = 'IDENTIFICATION_COMPANY_COUNTRY_OF_TAX_RESIDENCY_STATUS',
  
  /**
   * A company's country of tax residency is required.
   */
  IDENTIFICATION_COMPANY_COUNTRY_OF_TAX_RESIDENCY = 'IDENTIFICATION_COMPANY_COUNTRY_OF_TAX_RESIDENCY',
  
  /**
   * A company's Global Intermediary Identification Number (GIIN) is required.
   */
  IDENTIFICATION_COMPANY_GIIN = 'IDENTIFICATION_COMPANY_GIIN',
  
  /**
   * A company's FATCA Status is required.
   */
  IDENTIFICATION_COMPANY_FATCA_STATUS = 'IDENTIFICATION_COMPANY_FATCA_STATUS',
  
  /**
   * A company's FATCA Status Description is required.
   */
  IDENTIFICATION_COMPANY_FATCA_STATUS_DESCRIPTION = 'IDENTIFICATION_COMPANY_FATCA_STATUS_DESCRIPTION',
  
  /**
   * A not australian tax resident company beneficial owner status - yes or no
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_NOT_AUSTRALIAN_TAX_RESIDENT_STATUS = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_NOT_AUSTRALIAN_TAX_RESIDENT_STATUS',
  
  /**
   * A not australian tax resident company beneficial owner is required.
   */
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_NOT_AUSTRALIAN_TAX_RESIDENT = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_NOT_AUSTRALIAN_TAX_RESIDENT',
  
  /**
   * sole trader approver is required.
   */
  IDENTIFICATION_SOLE_TRADER_APPROVER = 'IDENTIFICATION_SOLE_TRADER_APPROVER',
  IDENTIFICATION_SOLE_TRADER_USER_ROLE = 'IDENTIFICATION_SOLE_TRADER_USER_ROLE',
  IDENTIFICATION_EMAIL_ADDRESS = 'IDENTIFICATION_EMAIL_ADDRESS',
  IDENTIFICATION_PHONE_MOBILE = 'IDENTIFICATION_PHONE_MOBILE',
  IDENTIFICATION_COMPANY_TYPE = 'IDENTIFICATION_COMPANY_TYPE',
  IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_USER_ROLE = 'IDENTIFICATION_COMPANY_BENEFICIAL_OWNER_USER_ROLE',
  IDENTIFICATION_COMPANY_DETAILS_REGULATOR_NAME = 'IDENTIFICATION_COMPANY_DETAILS_REGULATOR_NAME',
  IDENTIFICATION_COMPANY_DETAILS_REGULATOR_LICENSE_NUMBER = 'IDENTIFICATION_COMPANY_DETAILS_REGULATOR_LICENSE_NUMBER',
  IDENTIFICATION_COMPANY_DETAILS_LISTED_EXCHANGE_NAME = 'IDENTIFICATION_COMPANY_DETAILS_LISTED_EXCHANGE_NAME',
  IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_COMPANY_NAME = 'IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_COMPANY_NAME',
  IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_EXCHANGE_NAME = 'IDENTIFICATION_COMPANY_DETAILS_SUBSIDIARY_LISTED_EXCHANGE_NAME',
  IDENTIFICATION_TRADE_ORGANISATION = 'IDENTIFICATION_TRADE_ORGANISATION',
  IDENTIFICATION_POSTAL_ADDRESS = 'IDENTIFICATION_POSTAL_ADDRESS',
  IDENTIFICATION_TAX_EXEMPTION_DETAILS = 'IDENTIFICATION_TAX_EXEMPTION_DETAILS',
  IDENTIFICATION_TAX_EXEMPTION_TYPE = 'IDENTIFICATION_TAX_EXEMPTION_TYPE',
  IDENTIFICATION_TAX_STATUS = 'IDENTIFICATION_TAX_STATUS',
  IDENTIFICATION_COMPANY_USER_ROLE = 'IDENTIFICATION_COMPANY_USER_ROLE',
  IDENTIFICATION_COMPANY_SOLE_DIRECTOR_APPROVER = 'IDENTIFICATION_COMPANY_SOLE_DIRECTOR_APPROVER',
  IDENTIFICATION_COMPANY_MULTI_DIRECTOR_APPROVER = 'IDENTIFICATION_COMPANY_MULTI_DIRECTOR_APPROVER',
  ENTITY_TYPE = 'ENTITY_TYPE',
  HAS_MAC_ACCOUNT = 'HAS_MAC_ACCOUNT',
  ACCOUNT_SIGNATORY = 'ACCOUNT_SIGNATORY',
  INDIVIDUAL_VERIFIED = 'INDIVIDUAL_VERIFIED',
  INDIVIDUAL_TAX_FOREIGN_RESIDENT_COUNTRY = 'INDIVIDUAL_TAX_FOREIGN_RESIDENT_COUNTRY',
  INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER = 'INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER',
  INDIVIDUAL_TAX_REASON_NO_TIN = 'INDIVIDUAL_TAX_REASON_NO_TIN',
  INDIVIDUAL_TAX_REASON_UNAVAILABLE_TIN = 'INDIVIDUAL_TAX_REASON_UNAVAILABLE_TIN',
  CLIENT_APPROVAL = 'CLIENT_APPROVAL',
  IDENTIFICATION_GREEN_ID_VERIFIED_STATUS = 'IDENTIFICATION_GREEN_ID_VERIFIED_STATUS',
  RISK_DETAILS = 'RISK_DETAILS',
  INDUSTRY = 'INDUSTRY',
  ENTITY_WEALTH_ACCUMULATION = 'ENTITY_WEALTH_ACCUMULATION',
  IDENTIFICATION_COMPANY_ONLYOPERATESINAUSTRALIA = 'IDENTIFICATION_COMPANY_ONLYOPERATESINAUSTRALIA',
  HAS_DIVIDENDS_INCOME = 'HAS_DIVIDENDS_INCOME'
}

/**
 * Aggregate verification status for an Identification's individuals.
 */
export enum ClientVerificationStatus {
  
  /**
   * At least one individual is a foreign resident.
   */
  HAS_FOREIGN_RESIDENT = 'HAS_FOREIGN_RESIDENT',
  
  /**
   * At least one individual is yet to be verified.
   */
  PENDING = 'PENDING',
  
  /**
   * All individuals have been verified.
   */
  COMPLETED = 'COMPLETED'
}

/**
 * The possible Tax Company Type for BG application
 */
export enum IdentificationCompanyDetailsTaxFatcaStatus {
  
  /**
   * Deemed Compliant Financial Institution
   */
  DEEMED_COMPLIANT_FINANCIAL_INSTITUTION = 'DEEMED_COMPLIANT_FINANCIAL_INSTITUTION',
  
  /**
   * Excepted Financial Institution
   */
  EXCEPTED_FINANCIAL_INSTITUTION = 'EXCEPTED_FINANCIAL_INSTITUTION',
  
  /**
   * Exempt Beneficial Owner
   */
  EXEMPT_BENEFICIAL_OWNER = 'EXEMPT_BENEFICIAL_OWNER',
  
  /**
   * Non Reporting IGA Financial Institution
   */
  NON_REPORTING_IGA_FINANCIAL_INSTITUTION = 'NON_REPORTING_IGA_FINANCIAL_INSTITUTION',
  
  /**
   * Nonparticipating Financial Institution
   */
  NONPARTICIPATING_FINANCIAL_INSTITUTION = 'NONPARTICIPATING_FINANCIAL_INSTITUTION',
  
  /**
   * Other, please specify.
   */
  OTHER = 'OTHER'
}

/**
 * The possible Tax Company Type for BG application
 */
export enum IdentificationCompanyDetailsTaxType {
  
  /**
   * Active Non-Financial Entity (NFE).
   */
  ACTIVE_NON_FINANCIAL_ENTITY = 'ACTIVE_NON_FINANCIAL_ENTITY',
  
  /**
   * Australian Public listed company , Majority owned subsidiary of an Australian Public listed company or Australian Registered Charity
   */
  AUSTRALIAN_PUBLIC_LISTED = 'AUSTRALIAN_PUBLIC_LISTED',
  
  /**
   * Financial Institution
   */
  FINANCIAL_INSTITUTION = 'FINANCIAL_INSTITUTION',
  
  /**
   * Other, please specify.
   */
  OTHER = 'OTHER'
}

export enum IdentificationDataType {
  MANUAL = 'MANUAL',
  PREFILL = 'PREFILL'
}

export enum IdentificationEntityType {
  COMPANY = 'COMPANY',
  SOLE_TRADER = 'SOLE_TRADER'
}

export enum EntityWealthAccumulation {
  BUSINESS_OPERATIONS = 'BUSINESS_OPERATIONS',
  SAVINGS_FROM_EMPLOYMENT = 'SAVINGS_FROM_EMPLOYMENT',
  SUPERANNUATION = 'SUPERANNUATION',
  INVESTMENTS = 'INVESTMENTS',
  INHERITANCE_GIFT = 'INHERITANCE_GIFT',
  SALE_OF_A_PROPERTY_OR_ASSET = 'SALE_OF_A_PROPERTY_OR_ASSET',
  LEGAL_SETTLEMENT = 'LEGAL_SETTLEMENT',
  FOREIGN_INCOME = 'FOREIGN_INCOME'
}

export enum IdentificationIndustry {
  ACCOMMODATION = 'ACCOMMODATION',
  ADMINISTRATIVE_SERVICES = 'ADMINISTRATIVE_SERVICES',
  ADULT_COMMUNITY_AND_OTHER_EDUCATION = 'ADULT_COMMUNITY_AND_OTHER_EDUCATION',
  AGRICULTURE = 'AGRICULTURE',
  AGRICULTURE_FORESTRY_AND_FISHING_SUPPORT_SERVICES = 'AGRICULTURE_FORESTRY_AND_FISHING_SUPPORT_SERVICES',
  AIR_AND_SPACE_TRANSPORT = 'AIR_AND_SPACE_TRANSPORT',
  AQUACULTURE = 'AQUACULTURE',
  AUXILIARY_FINANCE_AND_INSURANCE_SERVICES = 'AUXILIARY_FINANCE_AND_INSURANCE_SERVICES',
  BASIC_CHEMICAL_AND_CHEMICAL_PRODUCT_MANUFACTURING = 'BASIC_CHEMICAL_AND_CHEMICAL_PRODUCT_MANUFACTURING',
  BASIC_MATERIAL_WHOLESALING = 'BASIC_MATERIAL_WHOLESALING',
  BEVERAGE_AND_TOBACCO_PRODUCT_MANUFACTURING = 'BEVERAGE_AND_TOBACCO_PRODUCT_MANUFACTURING',
  BROADCASTING_EXCEPT_INTERNET = 'BROADCASTING_EXCEPT_INTERNET',
  BUILDING_CLEANING_PEST_CONTROL_AND_OTHER_SUPPORT_SERVICES = 'BUILDING_CLEANING_PEST_CONTROL_AND_OTHER_SUPPORT_SERVICES',
  BUILDING_CONSTRUCTION = 'BUILDING_CONSTRUCTION',
  CIVIC_PROFESSIONAL_AND_OTHER_INTEREST_GROUP_SERVICES = 'CIVIC_PROFESSIONAL_AND_OTHER_INTEREST_GROUP_SERVICES',
  COAL_MINING = 'COAL_MINING',
  COMMISSION_BASED_WHOLESALING = 'COMMISSION_BASED_WHOLESALING',
  COMPUTER_SYSTEM_DESIGN_AND_RELATED_SERVICES = 'COMPUTER_SYSTEM_DESIGN_AND_RELATED_SERVICES',
  CONSTRUCTION_SERVICES = 'CONSTRUCTION_SERVICES',
  CREATIVE_AND_PERFORMING_ARTS_ACTIVITIES = 'CREATIVE_AND_PERFORMING_ARTS_ACTIVITIES',
  DEFENCE = 'DEFENCE',
  ELECTRICITY_SUPPLY = 'ELECTRICITY_SUPPLY',
  EXPLORATION_AND_OTHER_MINING_SUPPORT_SERVICES = 'EXPLORATION_AND_OTHER_MINING_SUPPORT_SERVICES',
  FABRICATED_METAL_PRODUCT_MANUFACTURING = 'FABRICATED_METAL_PRODUCT_MANUFACTURING',
  FINANCE = 'FINANCE',
  FISHING_HUNTING_AND_TRAPPING = 'FISHING_HUNTING_AND_TRAPPING',
  FOOD_AND_BEVERAGE_SERVICES = 'FOOD_AND_BEVERAGE_SERVICES',
  FOOD_PRODUCT_MANUFACTURING = 'FOOD_PRODUCT_MANUFACTURING',
  FOOD_RETAILING = 'FOOD_RETAILING',
  FORESTRY_AND_LOGGING = 'FORESTRY_AND_LOGGING',
  FUEL_RETAILING = 'FUEL_RETAILING',
  FURNITURE_AND_OTHER_MANUFACTURING = 'FURNITURE_AND_OTHER_MANUFACTURING',
  GAMBLING_ACTIVITIES = 'GAMBLING_ACTIVITIES',
  GAS_SUPPLY = 'GAS_SUPPLY',
  GROCERY_LIQUOR_AND_TOBACCO_PRODUCT_WHOLESALING = 'GROCERY_LIQUOR_AND_TOBACCO_PRODUCT_WHOLESALING',
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION = 'HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION',
  HERITAGE_ACTIVITIES = 'HERITAGE_ACTIVITIES',
  HOSPITALS = 'HOSPITALS',
  INSURANCE_AND_SUPERANNUATION_FUNDS = 'INSURANCE_AND_SUPERANNUATION_FUNDS',
  INTERNET_PUBLISHING_AND_BROADCASTING = 'INTERNET_PUBLISHING_AND_BROADCASTING',
  INTERNET_SERVICE_PROVIDERS_WEB_SEARCH_PORTALS_AND_DATA_PROCESSING_SERVICES = 'INTERNET_SERVICE_PROVIDERS_WEB_SEARCH_PORTALS_AND_DATA_PROCESSING_SERVICES',
  LIBRARY_AND_OTHER_INFORMATION_SERVICES = 'LIBRARY_AND_OTHER_INFORMATION_SERVICES',
  MACHINERY_AND_EQUIPMENT_MANUFACTURING = 'MACHINERY_AND_EQUIPMENT_MANUFACTURING',
  MACHINERY_AND_EQUIPMENT_WHOLESALING = 'MACHINERY_AND_EQUIPMENT_WHOLESALING',
  MEDICAL_AND_OTHER_HEALTH_CARE_SERVICES_ = 'MEDICAL_AND_OTHER_HEALTH_CARE_SERVICES_',
  METAL_ORE_MINING = 'METAL_ORE_MINING',
  MOTION_PICTURE_AND_SOUND_RECORDING_ACTIVITIES = 'MOTION_PICTURE_AND_SOUND_RECORDING_ACTIVITIES',
  MOTOR_VEHICLE_AND_MOTOR_VEHICLE_PARTS_RETAILING = 'MOTOR_VEHICLE_AND_MOTOR_VEHICLE_PARTS_RETAILING',
  MOTOR_VEHICLE_AND_MOTOR_VEHICLE_PARTS_WHOLESALING = 'MOTOR_VEHICLE_AND_MOTOR_VEHICLE_PARTS_WHOLESALING',
  NON_METALLIC_MINERAL_MINING_AND_QUARRYING = 'NON_METALLIC_MINERAL_MINING_AND_QUARRYING',
  NON_METALLIC_MINERAL_PRODUCT_MANUFACTURING = 'NON_METALLIC_MINERAL_PRODUCT_MANUFACTURING',
  NON_STORE_RETAILING_AND_RETAIL_COMMISSION_BASED_BUYING_ = 'NON_STORE_RETAILING_AND_RETAIL_COMMISSION_BASED_BUYING_',
  OIL_AND_GAS_EXTRACTION = 'OIL_AND_GAS_EXTRACTION',
  OTHER_STORE_BASED_RETAILING = 'OTHER_STORE_BASED_RETAILING',
  OTHER_TRANSPORT = 'OTHER_TRANSPORT',
  PETROLEUM_AND_COAL_PRODUCT_MANUFACTURING = 'PETROLEUM_AND_COAL_PRODUCT_MANUFACTURING',
  POLYMER_PRODUCT_AND_RUBBER_PRODUCT_MANUFACTURING = 'POLYMER_PRODUCT_AND_RUBBER_PRODUCT_MANUFACTURING',
  POSTAL_AND_COURIER_PICK_UP_AND_DELIVERY_SERVICES = 'POSTAL_AND_COURIER_PICK_UP_AND_DELIVERY_SERVICES',
  PRESCHOOL_AND_SCHOOL_EDUCATION = 'PRESCHOOL_AND_SCHOOL_EDUCATION',
  PRIMARY_METAL_AND_METAL_PRODUCT_MANUFACTURING = 'PRIMARY_METAL_AND_METAL_PRODUCT_MANUFACTURING',
  PRINTING_INCLUDING_THE_REPRODUCTION_OF_RECORDED_MEDIA = 'PRINTING_INCLUDING_THE_REPRODUCTION_OF_RECORDED_MEDIA',
  PRIVATE_HOUSEHOLDS_EMPLOYING_STAFF_AND_UNDIFFERENTIATED_GOODS_AND_SERVICE_PRODUCING_ACTIVITIES_OF_HOUSEHOLDS_FOR_OWN_USE = 'PRIVATE_HOUSEHOLDS_EMPLOYING_STAFF_AND_UNDIFFERENTIATED_GOODS_AND_SERVICE_PRODUCING_ACTIVITIES_OF_HOUSEHOLDS_FOR_OWN_USE',
  PROFESSIONAL_SCIENTIFIC_AND_TECHNICAL_SERVICES_EXCEPT_COMPUTER_SYSTEM_DESIGN_AND_RELATED_SERVICES_ = 'PROFESSIONAL_SCIENTIFIC_AND_TECHNICAL_SERVICES_EXCEPT_COMPUTER_SYSTEM_DESIGN_AND_RELATED_SERVICES_',
  PROPERTY_OPERATORS_AND_REAL_ESTATE_SERVICES = 'PROPERTY_OPERATORS_AND_REAL_ESTATE_SERVICES',
  PUBLIC_ADMINISTRATION = 'PUBLIC_ADMINISTRATION',
  PUBLIC_ORDER_SAFETY_AND_REGULATORY_SERVICES = 'PUBLIC_ORDER_SAFETY_AND_REGULATORY_SERVICES',
  PUBLISHING_EXCEPT_INTERNET_AND_MUSIC_PUBLISHING = 'PUBLISHING_EXCEPT_INTERNET_AND_MUSIC_PUBLISHING',
  PULP_PAPER_AND_CONVERTED_PAPER_PRODUCT_MANUFACTURING = 'PULP_PAPER_AND_CONVERTED_PAPER_PRODUCT_MANUFACTURING',
  RAIL_TRANSPORT = 'RAIL_TRANSPORT',
  RENTAL_AND_HIRING_SERVICES_EXCEPT_REAL_ESTATE = 'RENTAL_AND_HIRING_SERVICES_EXCEPT_REAL_ESTATE',
  REPAIR_AND_MAINTENANCE = 'REPAIR_AND_MAINTENANCE',
  RESIDENTIAL_CARE_SERVICES = 'RESIDENTIAL_CARE_SERVICES',
  ROAD_TRANSPORT = 'ROAD_TRANSPORT',
  SOCIAL_ASSISTANCE_SERVICES = 'SOCIAL_ASSISTANCE_SERVICES',
  SPORTS_AND_RECREATION_ACTIVITIES = 'SPORTS_AND_RECREATION_ACTIVITIES',
  TELECOMMUNICATIONS_SERVICES = 'TELECOMMUNICATIONS_SERVICES',
  TERTIARY_EDUCATION = 'TERTIARY_EDUCATION',
  TEXTILE_CLOTHING_AND_FOOTWEAR_WHOLESALING = 'TEXTILE_CLOTHING_AND_FOOTWEAR_WHOLESALING',
  TEXTILE_LEATHER_CLOTHING_AND_FOOTWEAR_MANUFACTURING = 'TEXTILE_LEATHER_CLOTHING_AND_FOOTWEAR_MANUFACTURING',
  TRANSPORT_EQUIPMENT_MANUFACTURING = 'TRANSPORT_EQUIPMENT_MANUFACTURING',
  TRANSPORT_SUPPORT_SERVICES = 'TRANSPORT_SUPPORT_SERVICES',
  WAREHOUSING_AND_STORAGE_SERVICES = 'WAREHOUSING_AND_STORAGE_SERVICES',
  WASTE_COLLECTION_TREATMENT_AND_DISPOSAL_SERVICES = 'WASTE_COLLECTION_TREATMENT_AND_DISPOSAL_SERVICES',
  WATER_SUPPLY_SEWERAGE_AND_DRAINAGE_SERVICES = 'WATER_SUPPLY_SEWERAGE_AND_DRAINAGE_SERVICES',
  WATER_TRANSPORT = 'WATER_TRANSPORT',
  WOOD_PRODUCT_MANUFACTURING = 'WOOD_PRODUCT_MANUFACTURING'
}

/**
 * Filters for the IdentificationIndividual type.
 */
export interface IdentificationIndividualFilter {
  AND?: Array<IdentificationIndividualFilter>;
  OR?: Array<IdentificationIndividualFilter>;
  id?: string;
  id_in?: Array<string>;
}

export interface IdentificationIndividual {
  emailAddress?: string;
  firstName?: string;
  
  /**
   * The GreenId Verification Result.
   */
  greenIdResult?: GreenIdVerificationResult;
  greenIdToken?: string;
  greenIdVerificationId?: string;
  greenIdVerificationStatus?: GreenIdVerificationStatus;
  id: string;
  identificationId: string;
  isAccountSignatory?: boolean;
  isApprover?: boolean;
  
  /**
   * The individual owns 25% or more of the company.
   */
  isBeneficialOwner?: boolean;
  isDirectorOrSecretary?: boolean;
  isForeignResident?: boolean;
  isMacVerified?: boolean;
  isValidated: boolean;
  lastVerificationSmsSentAt?: DateTime;
  macVerifiedNumber?: string;
  middleNames?: string;
  phoneMobile?: string;
  simpleKycDataIndividualId?: string;
  
  /**
   * The SimpleKycDataIndividual record.
   */
  simpleKycDataIndividualRecord?: ISimpleKycDataIndividual;
  surname?: string;
  taxForeignResidentCountry?: string;
  taxReasonNoTIN?: TaxReasonNoTIN;
  taxReasonUnavailableTIN?: string;
  taxpayerIdentificationNumber?: string;
  title?: string;
  userRole?: IdentificationUserRole;
  verificationUrl?: string;
  verificationUrlExpiresAt?: DateTime;
}

export interface GreenIdVerificationResult {
  address?: GreenIdAddress;
  dateOfBirth?: Date;
  email?: string;
  firstName?: string;
  greenIdVerificationStatus?: GreenIdVerificationStatus;
  lastName?: string;
  middleName?: string;
  watchlistStatusCollection?: Array<GreenIdWatchlistStatus | null>;
}

export interface GreenIdAddress {
  country?: string;
  number?: string;
  postalCode?: string;
  state?: string;
  street?: string;
  streetType?: string;
  suburb?: string;
  unit?: string;
}

export enum GreenIdVerificationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  VERIFIED = 'VERIFIED',
  VERIFIED_ADMIN = 'VERIFIED_ADMIN',
  VERIFIED_WITH_CHANGES = 'VERIFIED_WITH_CHANGES',
  PENDING = 'PENDING',
  LOCKED_OUT = 'LOCKED_OUT',
  MANUAL = 'MANUAL'
}

export interface GreenIdWatchlistStatus {
  result?: GreenIdWatchlistResult;
  resultDescription?: string;
  resultLabel?: string;
  watchlistType: string;
}

export enum GreenIdWatchlistResult {
  
  /**
   * The person was NOT found on the given watchlist
   */
  NOT_FOUND_ON_LIST = 'NOT_FOUND_ON_LIST',
  
  /**
   * The person was found on the given watchlist
   */
  FOUND_ON_LIST = 'FOUND_ON_LIST',
  
  /**
   * The person was found on the given watchlist, but needs administrator review
   */
  MATCH_REVIEW_REQUIRED = 'MATCH_REVIEW_REQUIRED',
  
  /**
   * The person was found on the given watchlist, and the administrator flagged it as confirmed
   */
  MATCH_CONFIRMED = 'MATCH_CONFIRMED',
  
  /**
   * The person was found on the given watchlist, but the administrator flagged it as false positive
   */
  MATCH_FALSE_POSITIVE = 'MATCH_FALSE_POSITIVE'
}

export interface ISimpleKycDataIndividual {
  address?: ISimpleKycAddress;
  dateOfBirth?: Date;
  firstName?: string;
  
  /**
   * The ID of the entity
   */
  id: string;
  isBeneficialOwner?: boolean;
  isDirector?: boolean;
  lastName?: string;
  middleNames?: string;
  roles?: string;
}

export interface ISimpleKycAddress {
  country?: string;
  country_name?: string;
  number?: string;
  postalCode?: string;
  state?: string;
  street?: string;
  suburb?: string;
  type?: string;
  unformattedAddress?: string;
  unit?: string;
}

export enum TaxReasonNoTIN {
  NOT_ISSUED = 'NOT_ISSUED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  APPLIED_FOR = 'APPLIED_FOR',
  UNOBTAINABLE = 'UNOBTAINABLE'
}

export enum IdentificationUserRole {
  DIRECTOR = 'DIRECTOR',
  COMPANY_SECRETARY = 'COMPANY_SECRETARY',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  ACCOUNTANT = 'ACCOUNTANT',
  APPOINTER = 'APPOINTER',
  AUTHORISED_SIGNATORY = 'AUTHORISED_SIGNATORY',
  BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
  BENEFICIARY = 'BENEFICIARY',
  BUSINESS_PARTNER = 'BUSINESS_PARTNER',
  CEO = 'CEO',
  CFO = 'CFO',
  CHAIRMAN = 'CHAIRMAN',
  COBORROWER = 'COBORROWER',
  COO = 'COO',
  GUARANTOR = 'GUARANTOR',
  GUARDIAN = 'GUARDIAN',
  PARTNER = 'PARTNER',
  PRESIDENT = 'PRESIDENT',
  SECRETARY = 'SECRETARY',
  SETTLOR = 'SETTLOR',
  SUPPORT_STAFF = 'SUPPORT_STAFF',
  THIRD_PARTY_AUTHORITY = 'THIRD_PARTY_AUTHORITY',
  TREASURER = 'TREASURER',
  TRUSTEE = 'TRUSTEE',
  INDIVIDUAL = 'INDIVIDUAL',
  SOLE_TRADER = 'SOLE_TRADER',
  OTHER = 'OTHER'
}

export interface IdentificationOrganisation {
  abn?: string;
  address?: string;
  channelPartners?: Array<IdentificationOrganisationChannelPartner>;
  discountPercentage: Decimal;
  id?: string;
  industryType?: string;
  isOngoingClient?: boolean;
  leadSource?: string;
  name: string;
  relationshipManager?: ICognitoUser;
}

export interface IdentificationOrganisationChannelPartner {
  active: boolean;
  id: string;
  isPublic: boolean;
  name?: string;
}

export interface ICognitoUser {
  emailAddress: string;
  firstName: string;
  isEnabled: boolean;
  isSmsMfaRequired: boolean;
  lastName: string;
  phoneNumber?: string;
  roles?: BankUserRole;
  status: string;
  supplierId?: string;
  userName: string;
  userRoles: Array<BankUserRole>;
}

export interface ISimpleKycData {
  applicationStatus?: ApplicationStatus;
  businessNames?: string;
  companyABN: string;
  createdAt: DateTime;
  entityClassification?: string;
  
  /**
   * The ID of the entity
   */
  id: string;
  legalBusinessName?: string;
  principalPlaceOfBusinessAddress?: string;
  registeredOfficeAddress?: string;
  simpleKycApplicationId: string;
  
  /**
   * The SimpleKycDataIndividual record.
   */
  simpleKycDataIndividualRecord?: Array<ISimpleKycDataIndividual | null>;
}

export enum ApplicationStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE',
  INITIALIZED = 'INITIALIZED'
}

export enum IdentificationStep {
  APPLICATION_DETAILS = 'APPLICATION_DETAILS',
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  DIRECTORS_APPROVAL = 'DIRECTORS_APPROVAL',
  ACCOUNT_DETAILS = 'ACCOUNT_DETAILS',
  DELIVERY_DETAILS = 'DELIVERY_DETAILS',
  PAYMENT_DETAILS = 'PAYMENT_DETAILS',
  TERMS_ACCEPTANCE = 'TERMS_ACCEPTANCE',
  REVIEW = 'REVIEW',
  SUBMITTED = 'SUBMITTED'
}

export enum IdentificationCompanyDetailsTaxTaxExemptionType {
  TYPE_A_PENSION_OR_OTHER_SOCIAL_SECURITY_BENEFIT = 'TYPE_A_PENSION_OR_OTHER_SOCIAL_SECURITY_BENEFIT',
  TYPE_B_CHILD_UNDER_16 = 'TYPE_B_CHILD_UNDER_16',
  TYPE_C_ORGANISATIONS_NOT_REQUIRED_TO_LODGE_A_TAX_RETURN = 'TYPE_C_ORGANISATIONS_NOT_REQUIRED_TO_LODGE_A_TAX_RETURN',
  TYPE_D_NON_RESIDENT = 'TYPE_D_NON_RESIDENT',
  TYPE_E_OTHER = 'TYPE_E_OTHER'
}

export enum IdentificationCompanyDetailsTaxStatus {
  USE_ABN = 'USE_ABN',
  DO_NOT_WISH_TO_PROVIDE = 'DO_NOT_WISH_TO_PROVIDE',
  EXEMPT_FROM_PROVIDING_A_TFN = 'EXEMPT_FROM_PROVIDING_A_TFN'
}

export interface DraftInvoice {
  canGenerateHostedInvoice: boolean;
  createdAt: DateTime;
  depositReferenceNumber: string;
  hostedInvoiceAttachmentId?: string;
  hostedReceiptAttachmentId?: string;
  id: string;
  invoiceLineItems: Array<InvoiceLineItem>;
  invoicePaymentIntents?: Array<InvoicePaymentIntent | null>;
  stripeInvoiceHostedUrl?: string;
  
  /**
   * 
   * @deprecated This should now be deprecated by HostedInvoiceAttachmentId (if null)
   */
  stripeInvoicePdf?: string;
  stripeInvoiceStatus?: string;
  stripeReceiptUrl?: string;
  
  /**
   * The amount that will be charged per subscription, exclusive of any once-off fees in the initial invoice; Will be 0 for once-off invoices; NOTE: for historical records (created prior to ~December 2025), this will be 0
   */
  sumSubscriptionAmount?: Decimal;
  total?: Decimal;
}

export interface InvoiceLineItem extends IInvoiceLineItem {
  amount: Decimal;
  description: string;
  id: string;
  invoice: DraftInvoice;
  invoiceId: string;
  
  /**
   * Null for historical records that were created prior to this associated PR being merged in
   */
  isRecurring?: boolean;
  periodEnd?: DateTime;
  periodStart?: DateTime;
}

export interface InvoicePaymentIntent extends IInvoicePaymentIntent {
  amount: Long;
  createdOn: DateTime;
  id: string;
  status: string;
  stripeInvoiceId: string;
  stripePaymentIntentId: string;
}

/**
 * Details the different accepted Sources of Funds for the security of a Bank Guarantee
 */
export enum DraftIssuerSourceOfFunds {
  EMPLOYMENT_BUSINESS_INCOME = 'EMPLOYMENT_BUSINESS_INCOME',
  THIRD_PARTY_MONEY = 'THIRD_PARTY_MONEY',
  INVESTMENTS_AND_DIVIDENDS_ASSET_SALE = 'INVESTMENTS_AND_DIVIDENDS_ASSET_SALE',
  SUPERANNUATION_PENSION = 'SUPERANNUATION_PENSION',
  SAVINGS = 'SAVINGS',
  INHERITANCE_GIFT = 'INHERITANCE_GIFT',
  GOVERNMENT_BENEFITS_SOCIAL_SECURITY = 'GOVERNMENT_BENEFITS_SOCIAL_SECURITY',
  FOREIGN_INCOME = 'FOREIGN_INCOME',
  OTHER = 'OTHER',
  DONATIONS_GIFTS = 'DONATIONS_GIFTS',
  GRANT_SUBSIDY = 'GRANT_SUBSIDY',
  INVESTMENT_INCOME = 'INVESTMENT_INCOME',
  INSURANCE_SETTLEMENT_PROCEEDS = 'INSURANCE_SETTLEMENT_PROCEEDS',
  ROYALTIES = 'ROYALTIES',
  TEST = 'TEST'
}

/**
 * Filters for the Party type.
 */
export interface DraftPartyFilter {
  AND?: Array<DraftPartyFilter>;
  OR?: Array<DraftPartyFilter>;
  name_contains?: string;
  name?: string;
  name_not?: string;
  name_not_contains?: string;
  name_starts_with?: string;
  name_not_starts_with?: string;
  name_ends_with?: string;
  name_not_ends_with?: string;
  name_in?: Array<string>;
  name_not_in?: Array<string>;
  partyVariant?: DraftPartyVariant;
  partyVariant_in?: Array<DraftPartyVariant>;
}

/**
 * Details a Draft Party, such as an Issuer or Beneficiary.
 */
export interface DraftParty {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit).
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 255.
   * @deprecated No longer supported
   */
  address?: string;
  addressV2?: Address;
  
  /**
   * The ID for the Draft Party.
   */
  id: string;
  
  /**
   * The name of Party, most likely the company name. Required. Max length 1000.
   */
  name: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500.
   */
  notes?: string;
  partyEntityType?: PartyEntityType;
  
  /**
   * The type of the Party, e.g. Issuer or Beneficiary
   */
  partyVariant: DraftPartyVariant;
  
  /**
   * The main contact for the Party.
   */
  primaryContact?: DraftExtendedContact;
}

/**
 * A contact with address and phone number
 */
export interface DraftExtendedContact {
  
  /**
   * The email address of the Contact. Max length 255.
   */
  email?: string;
  
  /**
   * The Family Name of the Contact. Required. Max length 255.
   */
  familyName?: string;
  
  /**
   * The Given Name of the Contact. Required. Max length 255.
   */
  givenName?: string;
  
  /**
   * The Primary Phone Number of the Contact. Max length 255.
   */
  phoneNumber?: string;
}

/**
 * Details for the payment of the security and fees for the Document
 */
export interface DraftRequestedPaymentDetails {
  
  /**
   * The BSB of the account that funds should be transferred to for establishment of the Document.
   */
  bankAccountBsb: string;
  
  /**
   * The Name of the account that funds should be transferred to for establishment of the Document.
   */
  bankAccountName: string;
  
  /**
   * The Account Number of the account that funds should be transferred to for establishment of the Document.
   */
  bankAccountNumber: string;
  
  /**
   * The establishment fee for the Document
   */
  establishmentFee?: Decimal;
  lineItems?: Array<DraftRequestedPaymentLineItemDetails>;
  
  /**
   * The description that should be used when making the payment
   */
  paymentDescription: string;
  
  /**
   * The date stamp the request for payment was submitted
   */
  requestedAt: DateTime;
  
  /**
   * The amount payable for the security of the Document
   */
  securityAmount?: Decimal;
}

/**
 * Details for the payment of the security and fees for the Document
 */
export interface DraftRequestedPaymentLineItemDetails {
  
  /**
   * The amount payable for this line item
   */
  amount: Decimal;
  
  /**
   * The description of this line item
   */
  description: string;
}

export interface ReferralDiscount {
  discountAmountInDollars: Decimal;
  discountType: ReferralDiscountType;
  organisationReferralId: string;
}

export enum ReferralDiscountType {
  REFERRER = 'REFERRER',
  REFEREE = 'REFEREE'
}

/**
 * A requested Bond/BG under the draft
 */
export interface DraftRequestedSuretyDocuments {
  
  /**
   * The amount the requested document needs to cover. Required. Range 0-999999999.99.
   */
  amount: Decimal;
  
  /**
   * The document wording (legal content) to be used
   */
  documentWording?: string;
  
  /**
   * The template used for the document wording (legal content). Specify "OTHER" if not directly from template.
   */
  documentWordingTemplate?: DraftContractForm;
  
  /**
   * The expiry date for the requested document. Optional.
   */
  expiryDate?: Date;
  
  /**
   * The ID for the Draft Requested Document.
   */
  id: string;
  
  /**
   * The amount payable each year for maintainance of the Document
   */
  paymentAnnualCost?: Decimal;
  
  /**
   * The establishment fee for the Document
   */
  paymentEstablishmentFee?: Decimal;
  
  /**
   * The end of the period the requested document is active. Required.
   */
  periodEndDate: Date;
  
  /**
   * The start of the period the requested document is active. Required.
   */
  periodStartDate: Date;
  
  /**
   * The purpose of the Requested Document. Required.
   */
  purpose: DraftRequestedDocumentPurpose;
}

/**
 * The base form of the legal content for the draft
 */
export enum DraftContractForm {
  
  /**
   * AS 2124
   */
  AS2124 = 'AS2124',
  
  /**
   * AS 2124 (with expiry date)
   */
  AS2124_WITH_EXPIRY = 'AS2124_WITH_EXPIRY',
  
  /**
   * AS 4000
   */
  AS4000 = 'AS4000',
  
  /**
   * AS 4000 (with expiry date)
   */
  AS4000_WITH_EXPIRY = 'AS4000_WITH_EXPIRY',
  
  /**
   * Other type
   */
  OTHER = 'OTHER'
}

/**
 * Sort options for the RequiredDocument type
 */
export interface RequiredDocumentViewModelSort {
  createdByAdminUserId?: SortOperationKind;
  dateCreated?: SortOperationKind;
  draftId?: SortOperationKind;
  id?: SortOperationKind;
  requiredDocumentType?: SortOperationKind;
}

export interface RequiredDocumentViewModel {
  createdByAdminUserId: string;
  dateCreated: DateTime;
  draftId: string;
  id: string;
  overallStatus: RequiredDocumentStatus;
  requiredDocumentFlow: RequiredDocumentFlow;
  
  /**
   * The messages (including any approvals/rejections) related to the parent record
   */
  requiredDocumentMessages?: Array<RequiredDocumentMessageViewModel | null>;
  requiredDocumentType: RequiredDocumentType;
}

export enum RequiredDocumentStatus {
  SENT = 'SENT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  NOT_APPROVED = 'NOT_APPROVED',
  APPROVED = 'APPROVED'
}

/**
 * NOTE: Even though a document can be Sent/Uploaded to the client, it can still mean a copy of the document still needs to be returned by the client (e.g. ApplicationForm)
 * This is just derived/exposed to reflect the UI if required. Can be deleted if not required
 */
export enum RequiredDocumentFlow {
  SENT_TO_CLIENT = 'SENT_TO_CLIENT',
  REQUESTED_FROM_CLIENT = 'REQUESTED_FROM_CLIENT'
}

/**
 * Sort options for the RequiredDocumentMessage type
 */
export interface RequiredDocumentMessageViewModelSort {
  attachmentId?: SortOperationKind;
  createdByUserId?: SortOperationKind;
  dateCreated?: SortOperationKind;
  fromParty?: SortOperationKind;
  hasApproval?: SortOperationKind;
  id?: SortOperationKind;
  isAutomatedMessage?: SortOperationKind;
  message?: SortOperationKind;
  messageType?: SortOperationKind;
  requiredDocumentId?: SortOperationKind;
}

export interface RequiredDocumentMessageViewModel {
  
  /**
   * The domain attachment record associated with the message (if the attachmentId is not null)
   */
  attachment?: DraftAttachment;
  attachmentId?: string;
  
  /**
   * If false, do not render the buttons for accept/reject as it either means the user is not authorized to do so, or the messages are not actionable for various reasons
   */
  canAuthorizedUserAcceptOrReject: boolean;
  
  /**
   * The User details of who created the message. ONLY POPULATED IF THE FromParty PROPERTY HAS A VALUE OF CLIENT
   */
  createdByUser?: IUser;
  createdByUserId?: string;
  dateCreated: DateTime;
  fromParty: RequiredDocumentMessageParty;
  hasApproval?: boolean;
  id: string;
  
  /**
   * 
   * @deprecated Please refer to the MessageType
   */
  isAutomatedMessage: boolean;
  message?: string;
  messageType: RequiredDocumentMessageType;
  
  /**
   * this link exists for 2 purposes:
   * 1. For approval/rejection MESSAGES to link back to the original MESSAGE/attachment that it is approved against
   * 2. For the front-end to be able to "group" MESSAGES within a requiredDocument together (based on product's designs)
   * if null, it means it is a root-level record
   */
  parentMessageId?: string;
  requiredDocumentId: string;
}

export interface IUser {
  email: string;
  familyName: string;
  givenName: string;
}

export enum RequiredDocumentMessageParty {
  ADMIN_ASSURO = 'ADMIN_ASSURO',
  ADMIN_SUPPLIER = 'ADMIN_SUPPLIER',
  DOCUSIGN_AUTOMATED = 'DOCUSIGN_AUTOMATED',
  CLIENT = 'CLIENT'
}

export enum RequiredDocumentMessageType {
  
  /**
   * a standard message, not relating to an approval or a rejection
   */
  STANDARD = 'STANDARD',
  
  /**
   * an approval
   */
  APPROVAL = 'APPROVAL',
  
  /**
   * a rejection
   */
  REJECTION = 'REJECTION',
  
  /**
   * An attachment as part of an approval or rejection (partial message)
   */
  OUTCOME_ATTACHMENT = 'OUTCOME_ATTACHMENT',
  
  /**
   * An automated message
   */
  AUTOMATED = 'AUTOMATED'
}

export enum RequiredDocumentType {
  DRAFT_BG_FORM = 'DRAFT_BG_FORM',
  APPLICATION_FORM = 'APPLICATION_FORM',
  CUSTOMER_IDENTIFICATION = 'CUSTOMER_IDENTIFICATION',
  FOR_CLIENT_RECORD = 'FOR_CLIENT_RECORD',
  CERTIFIED_TRUST_DOCUMENT = 'CERTIFIED_TRUST_DOCUMENT',
  SHARE_CERTIFICATE = 'SHARE_CERTIFICATE',
  OTHER_DOCUMENT = 'OTHER_DOCUMENT'
}

/**
 * Sort options for the ApiDraftOrigination type.
 */
export interface ApiDraftOriginationSort {
  amount?: SortOperationKind;
  createdAt?: SortOperationKind;
}

/**
 * Filters for the ApiDraftOrigination type.
 */
export interface ApiDraftOriginationFilter {
  AND?: Array<ApiDraftOriginationFilter>;
  OR?: Array<ApiDraftOriginationFilter>;
  id?: string;
  id_in?: Array<string>;
  organisationId?: string;
  organisationId_in?: Array<string | null>;
  channelPartnerId?: string;
  channelPartnerId_in?: Array<string>;
  draftReferenceId_contains?: string;
  draftReferenceId_starts_with?: string;
  draftReferenceId_ends_with?: string;
}

/**
 * A connection to a list of items.
 */
export interface DraftOriginationsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftOriginationsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ApiDraftOrigination | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftOriginationsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: ApiDraftOrigination;
}

export interface ApiDraftOrigination {
  agreementContent?: string;
  amount?: Decimal;
  channelPartner?: IChannelPartner;
  channelPartnerId: string;
  channelPartnerOrganisationAbnOrAcn?: string;
  channelPartnerOrganisationBusinessAddress?: string;
  channelPartnerOrganisationIndustry?: ChannelPartnerOrganisationIndustry;
  channelPartnerOrganisationName?: string;
  channelPartnerOrganisationPostalAddress?: string;
  channelPartnerOrganisationReferenceId?: string;
  createdAt: DateTime;
  draftId?: string;
  draftOriginationStatus: DraftOriginationStatus;
  draftReferenceId?: string;
  draftType: DraftProcessType;
  expectedReturnDate?: Date;
  expiryDate?: Date;
  id: string;
  organisationId?: string;
  
  /**
   * The Parties relevant to the ApiDraftOrigination.
   */
  parties?: Array<ApiDraftOriginationParty>;
  purpose?: DraftPurpose;
  purposeSpecificOther?: string;
  userId?: string;
}

export interface IChannelPartner {
  active: boolean;
  createdAt: DateTime;
  discountPercentage: Decimal;
  id: string;
  name?: string;
}

export enum ChannelPartnerOrganisationIndustry {
  CONSTRUCTION = 'CONSTRUCTION',
  MINING = 'MINING',
  PROPERTY = 'PROPERTY',
  OTHER = 'OTHER'
}

export enum DraftOriginationStatus {
  RECEIVED = 'RECEIVED',
  CREATED = 'CREATED',
  CANCELLED = 'CANCELLED'
}

export interface ApiDraftOriginationParty {
  abnOrAcn?: string;
  
  /**
   * 
   * @deprecated No longer supported
   */
  address?: string;
  addressV2?: Address;
  apiDraftOriginationId: string;
  id: string;
  name?: string;
  
  /**
   * The Parties relevant to the Draft.
   */
  representatives?: Array<ApiDraftOriginationPartRepresentative | null>;
  type: DraftPartyVariant;
}

export interface ApiDraftOriginationPartRepresentative {
  apiDraftOriginationPartyId: string;
  email: string;
  familyName?: string;
  givenName?: string;
  id: string;
  isOwner: boolean;
}

/**
 * Sort options for the Draft type.
 */
export interface DraftSort {
  amount?: SortOperationKind;
  createdAt?: SortOperationKind;
  deliveryType?: SortOperationKind;
  expectedReturnDate?: SortOperationKind;
  expiresAt?: SortOperationKind;
  purpose?: SortOperationKind;
  status?: SortOperationKind;
  visibleToSupplierDate?: SortOperationKind;
}

/**
 * Filters for the Draft type.
 */
export interface DraftFilter {
  AND?: Array<DraftFilter>;
  OR?: Array<DraftFilter>;
  id?: string;
  id_in?: Array<string>;
  amount_gte?: Decimal;
  amount_lte?: Decimal;
  expiresAt_gte?: Date;
  expiresAt_lte?: Date;
  expectedReturnDate_gte?: Date;
  expectedReturnDate_lte?: Date;
  description_contains?: string;
  description_starts_with?: string;
  description_ends_with?: string;
  status?: DraftStatus;
  status_in?: Array<DraftStatus>;
  facilityId?: string;
  visibleToSupplierDate_gt?: DateTime;
  visibleToSupplierDate_lt?: DateTime;
  visibleToSupplierDate_in?: Array<DateTime | null>;
}

/**
 * A connection to a list of items.
 */
export interface DraftsByOrganisationIdConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftsByOrganisationIdEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Draft | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftsByOrganisationIdEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Draft;
}

/**
 * Sort options for the Bank Draft type.
 */
export interface BankDraftSort {
  amount?: SortOperationKind;
  createdAt?: SortOperationKind;
  deliveryType?: SortOperationKind;
  description?: SortOperationKind;
  establishedAt?: SortOperationKind;
  expectedReturnDate?: SortOperationKind;
  feeSummary?: FeeSummarySort;
  megAppId?: SortOperationKind;
  megAppNo?: SortOperationKind;
  status?: SortOperationKind;
  submittedAt?: SortOperationKind;
  visibleToSupplierDate?: SortOperationKind;
}

/**
 * Sort options for the Fee Summary type.
 */
export interface FeeSummarySort {
  createdAt?: SortOperationKind;
  feeSummaryStatus?: SortOperationKind;
  name?: SortOperationKind;
  supplier?: SupplierSort;
}

/**
 * Sort options for the Supplier type.
 */
export interface SupplierSort {
  createdAt?: SortOperationKind;
  name?: SortOperationKind;
}

/**
 * Filters for the BankDraft type.
 */
export interface BankDraftFilter {
  AND?: Array<BankDraftFilter>;
  OR?: Array<BankDraftFilter>;
  id?: string;
  id_in?: Array<string>;
  organisationId?: string;
  organisationId_in?: Array<string>;
  identificationId?: string;
  identificationId_in?: Array<string | null>;
  facilityId?: string;
  facilityId_in?: Array<string | null>;
  acceptedChannelPartnerId?: string;
  acceptedChannelPartnerId_in?: Array<string | null>;
  amount_gte?: Decimal;
  amount_lte?: Decimal;
  description_contains?: string;
  description_starts_with?: string;
  description_ends_with?: string;
  status?: DraftStatus;
  status_in?: Array<DraftStatus>;
  processType?: DraftProcessType;
  processType_in?: Array<DraftProcessType>;
  projectAddress_contains?: string;
  projectAddress_starts_with?: string;
  projectAddress_ends_with?: string;
  parties_some?: DraftPartyFilter;
  invoices_some?: InvoiceFilter;
  megAppId_contains?: string;
  megAppId_starts_with?: string;
  megAppId_ends_with?: string;
  megAppNo_contains?: string;
  megAppNo_starts_with?: string;
  megAppNo_ends_with?: string;
  stripeSubscriptionStatus_contains?: string;
  establishedAt_gt?: DateTime;
  establishedAt_lt?: DateTime;
  establishedAt_in?: Array<DateTime | null>;
  submittedAt_gt?: DateTime;
  submittedAt_lt?: DateTime;
  submittedAt_in?: Array<DateTime | null>;
  visibleToSupplierDate_gt?: DateTime;
  visibleToSupplierDate_lt?: DateTime;
  visibleToSupplierDate_in?: Array<DateTime | null>;
}

/**
 * Filters for the Invoice type.
 */
export interface InvoiceFilter {
  AND?: Array<InvoiceFilter>;
  OR?: Array<InvoiceFilter>;
  stripeInvoiceStatus_contains?: string;
  stripeInvoiceStatus_not_contains?: string;
  stripeInvoiceStatus_starts_with?: string;
  stripeInvoiceStatus_ends_with?: string;
  stripeInvoiceStatus?: string;
  stripeInvoiceStatus_in?: Array<string | null>;
}

/**
 * A connection to a list of items.
 */
export interface DraftsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankDraft | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankDraft;
}

/**
 * Details on a Draft, relevant to the Bank Portal.
 */
export interface BankDraft {
  
  /**
   * The channel partner ID that was used for the discount.
   */
  acceptedChannelPartnerId?: string;
  
  /**
   * Any additional supplier information relevant for the draft.
   */
  additionalSupplierDetail?: AdditionalSupplierDetail;
  
  /**
   * The monetary value of the Draft. Required. Range 0-999999999.99.
   */
  amount: Decimal;
  
  /**
   * The Attachments for the Draft. Not available for listed (>1 returned) Drafts.
   */
  attachments: Array<DraftAttachment>;
  
  /**
   * The BG switch linked to the Draft.
   */
  bGSwitch?: DraftBGSwitch;
  canResubmitToGvp: boolean;
  
  /**
   * The capabilities the current user has on a BankDraft
   */
  capabilities: Array<BankDraftCapability | null>;
  
  /**
   * The Channel Partner relevant to the Draft.
   */
  channelPartner?: DraftChannelPartners;
  
  /**
   * Details on the contract for this Draft
   */
  contract?: DraftContractDetail;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The Creator of the Draft
   */
  creator?: IUser;
  
  /**
   * End of the current period that the subscription has been invoiced for. At the end of this period, a new invoice will be created.
   */
  currentPeriodEnd?: DateTime;
  
  /**
   * Details for the delivery of the Document.
   */
  deliveryDetails?: DraftDeliveryDetails;
  
  /**
   * The selected delivery type
   * NOTE: can only be one of DIGITAL or PHYSICAL
   * TODO: need a migration script to set all historical values to PHYSICAL (apart from anything that hasn't had a feeSummary associated with it)
   */
  deliveryType?: DeliveryType;
  
  /**
   * The Description (usually the Agreement Content) of the Draft
   * This usually contains details on what the Draft is covering, e.g. Installing new windows at a property
   * Required
   */
  description: string;
  
  /**
   * The directors email address, if not the originating user.
   */
  directorEmailAddress?: string;
  
  /**
   * The directors first name, if not the originating user.
   */
  directorFirstName?: string;
  
  /**
   * The directors last name, if not the originating user.
   */
  directorLastName?: string;
  
  /**
   * The applicable discount percentage.
   */
  discountPercentage: Decimal;
  
  /**
   * The document id of the established Draft.
   */
  documentId?: string;
  
  /**
   * The Document Number. This is provided by the financial institution that is backing the document upon establishment. Max length 255.
   */
  documentNumber?: string;
  
  /**
   * The History for the Draft. Not available for listed (>1 returned) Drafts.
   */
  draftHistory?: DraftHistoryConnection;
  
  /**
   * The estimated fees for the Draft
   */
  estimatedFees: Decimal;
  
  /**
   * The Expected Return Date.
   */
  expectedReturnDate?: Date;
  
  /**
   * The date the Draft expires.
   */
  expiresAt?: Date;
  
  /**
   * Facility related to the draft.
   */
  facility?: BankFacility;
  
  /**
   * The fee summary relevant to the Draft.
   */
  feeSummary?: FeeSummary;
  feeSummaryId?: string;
  gvpId?: string;
  
  /**
   * The ID for the Draft.
   */
  id: string;
  
  /**
   * Identification data relevant to the draft
   */
  identification?: Identification;
  
  /**
   * Whether the identification was submitted (the individual verification can be completed later)
   */
  identificationSubmitted: boolean;
  invoiceRecipientEmailAddresses?: string;
  
  /**
   * The Invoices relevant to the Draft.
   */
  invoices?: Array<DraftInvoice | null>;
  isVisibleToSupplier: boolean;
  
  /**
   * Further information on the source of funds for the security of the bank guarantee.
   */
  issuerDetailsOfSourceOfFunds?: string;
  
  /**
   * The source of the issuers funds for the security of the bank guarantee.
   */
  issuerSourceOfFunds?: DraftIssuerSourceOfFunds;
  megAppId?: string;
  megAppNo?: string;
  
  /**
   * A Json string to store the Meg application details
   */
  megDetails?: string;
  
  /**
   * The ID of the Organisation who created this Draft. Required.
   */
  organisationId: string;
  
  /**
   * The Parties relevant to the Draft.
   */
  parties?: Array<DraftParty>;
  
  /**
   * The payment details for the Draft
   */
  paymentDetails?: DraftRequestedPaymentDetails;
  
  /**
   * The process the Draft will follow.
   */
  processType: DraftProcessType;
  
  /**
   * Timestamp of the product terms acceptance (not required for all products)
   */
  productTermsAcceptedDate?: DateTime;
  
  /**
   * The Project or Property Address. Max length 500.
   */
  projectAddress?: string;
  
  /**
   * The purpose of the Draft.
   */
  purpose?: DraftPurpose;
  
  /**
   * The Draft's Reference Number, such as a Contract Number. Max length 255.
   */
  referenceNumber?: string;
  
  /**
   * The referral percentage applied.
   */
  referralPercentage: Decimal;
  referralPortalDeal?: Deal;
  refundAccountName?: string;
  refundAccountNumber?: string;
  refundBSB?: string;
  
  /**
   * The reason the Draft was rejected from the Bank. Max length 255.
   */
  rejectionReason?: string;
  
  /**
   * The relationship manager associated to the draft
   */
  relationshipManager?: ICognitoUser;
  
  /**
   * The changes to the Draft requested from the Bank. Max length 255.
   */
  requestChangeReason?: string;
  
  /**
   * The Requested Documents related to the current Draft.
   */
  requestedSuretyDocuments?: Array<DraftRequestedSuretyDocuments | null>;
  
  /**
   * Any requested documents or documents sent to the client associated to the draft
   */
  requiredDocuments?: Array<RequiredDocumentViewModel | null>;
  sourceDraftId?: string;
  
  /**
   * The other specified purpose.
   */
  specifiedOtherPurpose?: string;
  
  /**
   * The status of the Draft.
   */
  status: DraftStatus;
  stripeSubscriptionCanceledAt?: DateTime;
  stripeSubscriptionId?: string;
  stripeSubscriptionStatus?: string;
  
  /**
   * The date stamp the record was submitted to the Bank.
   */
  submittedAt?: DateTime;
  totalFees?: Decimal;
  
  /**
   * Total credit that have been used on this draft
   */
  totalOrganisationCreditUsed?: Decimal;
  visibleToSupplierDate?: DateTime;
}

/**
 * The possible actions that can be taken on a Bank Draft
 */
export enum BankDraftCapability {
  
  /**
   * Payment can be requested.
   */
  CAN_REQUEST_PAYMENT = 'CAN_REQUEST_PAYMENT',
  
  /**
   * The draft can be rejected.
   */
  CAN_REJECT = 'CAN_REJECT',
  
  /**
   * Changes can be requested.
   */
  CAN_REQUEST_CHANGES = 'CAN_REQUEST_CHANGES',
  
  /**
   * The draft can be established
   */
  CAN_ESTABLISH = 'CAN_ESTABLISH',
  
  /**
   * The entity can be Identified
   */
  CAN_IDENTIFY = 'CAN_IDENTIFY',
  
  /**
   * The draft can be processed by the bank
   */
  CAN_PROCESS = 'CAN_PROCESS',
  
  /**
   * The draft can be edited by the admins
   */
  CAN_EDIT = 'CAN_EDIT'
}

export interface DraftChannelPartners {
  id: string;
  name?: string;
}

export interface BankFacility {
  annualCost?: Decimal;
  bankFrontedBondsRecurringPercentageCost?: Decimal;
  bankFrontedBondsSetUpCost?: Decimal;
  
  /**
   * The current users Capabilities to act on the Facility.
   */
  capabilities: Array<DocumentFacilityCapability | null>;
  documentAdjustedCost?: boolean;
  
  /**
   * The count of all documents in the facility
   */
  documentCount: Decimal;
  documentRecurringCostFrequency?: number;
  documentRecurringFeeType?: RecurringFeeType;
  documentRecurringFixedCost?: Decimal;
  documentRecurringMinimumAnnualCost?: Decimal;
  documentRecurringPercentageCost?: Decimal;
  documentSetUpCost?: Decimal;
  documentVariant: DocumentVariant;
  endDate: Date;
  entities?: Array<FacilityEntity | null>;
  facilityApplicationId?: string;
  
  /**
   * The History for the Facility.
   */
  facilityHistory?: FacilityHistoryConnection;
  id: string;
  invoiceNumber?: string;
  
  /**
   * Indicates whether or not the facility is managed by Assuro
   */
  isAssuroFacility: boolean;
  limit: Decimal;
  name?: string;
  
  /**
   * The facility owner organisation.
   */
  organisation?: FacilityOrganisation;
  organisationId: string;
  premiumBankFrontedBondsRecurringPercentageCost?: Decimal;
  premiumDocumentRecurringPercentageCost?: Decimal;
  properties?: Array<FacilityProperty | null>;
  provider?: string;
  securityType?: SecurityType;
  setUpCost?: Decimal;
  sharedFacilityWithOrganisations?: Array<FacilitySharedFacilityWithOrganisation | null>;
  startDate: Date;
  supplierId?: string;
  
  /**
   * The total value of established documents in the facility
   */
  totalEstablished: Decimal;
  
  /**
   * The total value of projected documents in the facility
   */
  totalProjected: Decimal;
}

/**
 * Sort options for the Bank Document party.
 */
export interface BankPartySort {
  name?: SortOperationKind;
}

export interface Deal {
  commissionAmount: Decimal;
  createdAt: DateTime;
  draftAmount?: Decimal;
  draftDateEstablished?: DateTime;
  draftDateSubmitted?: DateTime;
  
  /**
   * The full description, including the purpose name and agreement content
   */
  draftDescription?: string;
  draftId: string;
  draftIssuer?: string;
  draftProduct?: DealProduct;
  draftPurpose?: string;
  draftStatus?: DealStatus;
  draftSupplier?: string;
  entityContactPerson?: string;
  entityEmail?: string;
  entityId: string;
  entityName?: string;
  id: string;
  memberEmail?: string;
  memberFullName?: string;
  memberPhone?: string;
  referralPortalMemberId?: string;
}

export enum DealProduct {
  BANK_GUARANTEE = 'BANK_GUARANTEE',
  SURETY_BOND = 'SURETY_BOND'
}

export enum DealStatus {
  STARTED = 'STARTED',
  PROCESSING = 'PROCESSING',
  ESTABLISHED = 'ESTABLISHED',
  WITHDRAWN = 'WITHDRAWN',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED'
}

/**
 * A connection to a list of items.
 */
export interface DraftsSharedWithMeConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<DraftsSharedWithMeEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Draft | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface DraftsSharedWithMeEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Draft;
}

/**
 * A connection to a list of items.
 */
export interface FacilitiesForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<FacilitiesForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankFacility | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface FacilitiesForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankFacility;
}

/**
 * Details of a facility application
 */
export interface FacilityApplication {
  
  /**
   * The Applicant details.
   */
  applicant?: Applicant;
  
  /**
   * Further application information
   */
  applicationInformation?: ApplicationInformation;
  
  /**
   * The Attachments for the FacilityApplication
   */
  attachments?: Array<FacilityApplicationAttachment>;
  
  /**
   * The capabilities the current user has on the facility application
   */
  capabilities?: Array<FacilityApplicationCapability>;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  entities: Array<FacilityApplicationEntity>;
  
  /**
   * The establishment records.
   */
  establishmentRecord?: EstablishmentRecord;
  
  /**
   * The History for the FacilityApplication.
   */
  facilityApplicationHistory?: FacilityApplicationHistoryConnection;
  
  /**
   * Type of facility
   */
  facilityType: FacilityType;
  
  /**
   * The product associated with the facility application. NOTE: Currently only populated for PROPERTY-BACKED facility applications
   */
  feeSummaryId?: string;
  hasBankApproval?: boolean;
  
  /**
   * The ID for the Comment
   */
  id: string;
  invoiceNumber?: string;
  
  /**
   * Invoice number is only applicable to PropertyBacked facility.
   */
  isInvoicePaid?: boolean;
  isVisibleToSupplier: boolean;
  
  /**
   * The date stamp the record was last updated.
   */
  lastUpdatedAt?: DateTime;
  
  /**
   * The applications associated organisation.
   */
  organisation?: FacilityApplicationOrganisation;
  
  /**
   * The ID of the Organisation this Facility Application is on behalf of.
   * @deprecated No longer supported
   */
  organisationId: string;
  properties: Array<FacilityApplicationProperty>;
  
  /**
   * The organisations this facility application is shared with.
   */
  sharedFacilityWithOrganisations?: Array<FacilityApplicationSharedFacilityWithOrganisation | null>;
  
  /**
   * The status of the application
   */
  status: FacilityApplicationStatus;
  
  /**
   * The submission details.
   */
  submission?: SubmissionRecord;
  
  /**
   * The supplier associated with the facility application. NOTE: Currently only populated for PROPERTY-BACKED facility applications
   */
  supplierId?: string;
  totalFees?: Decimal;
  visibleToSupplierDate?: DateTime;
}

export interface Applicant {
  abn?: string;
  address?: string;
  companyName?: string;
  contactName?: string;
  contactTitle?: string;
  emailAddress?: string;
  entityType?: ApplicantEntityType;
  industry?: string;
  phoneNumber?: string;
  role?: string;
  website?: string;
}

export enum ApplicantEntityType {
  COMPANY = 'COMPANY',
  SOLE_TRADER = 'SOLE_TRADER',
  TRUST = 'TRUST'
}

export interface ApplicationInformation {
  facilityLimit?: Decimal;
}

/**
 * Details about a FacilityApplication Attachment
 */
export interface FacilityApplicationAttachment {
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255.
   */
  contentType: string;
  
  /**
   * The link to download the Facility Application Attachment file.
   */
  downloadPresignedUrl?: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255.
   */
  fileName: string;
  
  /**
   * The ID of the Attachment
   */
  id: string;
  infectedFileStatus: InfectedFileStatus;
  
  /**
   * Stores whether the file has been received by S3 or not.
   */
  received: boolean;
  
  /**
   * The link to upload the Facility Application Attachment file.
   */
  uploadPresignedUrl?: string;
  
  /**
   * The variant of the attachment. Eg "Financial Statements". Required.
   */
  variant: AttachmentVariant;
}

/**
 * The possible variants of Attachments for Facility Applications
 */
export enum AttachmentVariant {
  FINANCIAL_STATEMENTS = 'FINANCIAL_STATEMENTS',
  MANAGEMENT_ACCOUNTS = 'MANAGEMENT_ACCOUNTS',
  GROUP_STRUCTURE = 'GROUP_STRUCTURE',
  BANKING_FACILITIES = 'BANKING_FACILITIES',
  CASHFLOW_FORECASTS = 'CASHFLOW_FORECASTS',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS'
}

/**
 * The capabilities the current user has on a Facility Application
 */
export enum FacilityApplicationCapability {
  
  /**
   * Details on the application can be edited
   */
  CAN_EDIT_DETAILS = 'CAN_EDIT_DETAILS',
  
  /**
   * The application can be approved
   */
  CAN_APPROVE = 'CAN_APPROVE',
  
  /**
   * The application can be established, creating a facility
   */
  CAN_ESTABLISH = 'CAN_ESTABLISH',
  
  /**
   * The application can be closed
   */
  CAN_CLOSE = 'CAN_CLOSE',
  
  /**
   * The application can be rejected
   */
  CAN_REJECT = 'CAN_REJECT',
  CAN_SEND_TO_SUPPLIER = 'CAN_SEND_TO_SUPPLIER',
  CAN_RECORD_BANK_OUTCOME = 'CAN_RECORD_BANK_OUTCOME',
  CAN_RECORD_PAYMENT = 'CAN_RECORD_PAYMENT'
}

export interface FacilityApplicationEntity {
  abn?: string;
  facilityApplication: FacilityApplication;
  facilityApplicationId: string;
  id: string;
  name?: string;
}

/**
 * Establishment details for a Facility Application
 */
export interface EstablishmentRecord {
  
  /**
   * The recurring annual cost. Range 0-999999999.99.
   */
  annualCost?: Decimal;
  
  /**
   * The default recurring percentage cost for the bank fronted document. Range 0-100.00
   */
  bankFrontedBondsRecurringPercentageCost?: Decimal;
  
  /**
   * The default cost value required for setup for the bank fronted document. Range 0-999999999.99.
   */
  bankFrontedBondsSetUpCost?: Decimal;
  
  /**
   * The default recurring percentage cost for the document. Range 0-100.00
   */
  documentRecurringPercentageCost?: Decimal;
  
  /**
   * The default cost value required for setup for the document. Range 0-999999999.99.
   */
  documentSetUpCost?: Decimal;
  
  /**
   * The end date of the Facility. Required.
   */
  endDate: Date;
  
  /**
   * The name for the Facility. Max length 255.
   */
  facilityName: string;
  
  /**
   * The financial limit of the Facility. Required. Range 0-999999999.99.
   */
  limit: Decimal;
  
  /**
   * The premium recurring percentage cost for the bank fronted document. Range 0-100.00
   */
  premiumBankFrontedBondsRecurringPercentageCost?: Decimal;
  
  /**
   * The premium recurring percentage cost for the document. Range 0-100.00
   */
  premiumDocumentRecurringPercentageCost?: Decimal;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  setUpCost?: Decimal;
  
  /**
   * The start date of the Facility. Required.
   */
  startDate: Date;
}

/**
 * Sort options for the FacilityApplicationHistory type.
 */
export interface FacilityApplicationHistorySort {
  triggeredAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface FacilityApplicationHistoryConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<FacilityApplicationHistoryEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<FacilityApplicationHistory | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface FacilityApplicationHistoryEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: FacilityApplicationHistory;
}

/**
 * Details on a change that has occurred in the system.
 */
export interface FacilityApplicationHistory {
  
  /**
   * The group of the changes, in case multiple happened at once.
   */
  changeSetId: string;
  
  /**
   * The type of change this record captures.
   */
  changeType?: DocumentHistoryChangeType;
  
  /**
   * The field level changes that occured on this record.
   */
  changes?: Array<FacilityApplicationHistoryChange>;
  
  /**
   * The ID for the Draft History record.
   */
  id: string;
  
  /**
   * The type of the record that was changed.
   */
  objectType: string;
  
  /**
   * The name identifier for the record. Optional.
   */
  recordName?: string;
  
  /**
   * When the change was made.
   */
  triggeredAt: DateTime;
  
  /**
   * The Author of the change.
   */
  triggeredBy?: string;
}

export interface FacilityApplicationHistoryChange {
  
  /**
   * The name of the field that was changed.
   */
  field: string;
  
  /**
   * The label of the field that was changed.
   */
  label?: string;
  
  /**
   * The display value of this field after the change. In the case of DELETE events, this will be null.
   */
  newDisplayValue?: string;
  
  /**
   * The value of this field after the change. In the case of DELETE events, this will be null.
   */
  newValue?: string;
  
  /**
   * The display value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldDisplayValue?: string;
  
  /**
   * The value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldValue?: string;
}

export enum FacilityType {
  SURETY_BOND = 'SURETY_BOND',
  PROPERTY_BACKED = 'PROPERTY_BACKED'
}

export interface FacilityApplicationOrganisation {
  id: string;
  name: string;
}

export interface FacilityApplicationProperty {
  address?: string;
  estimatedValue: Decimal;
  facilityApplication: FacilityApplication;
  facilityApplicationId: string;
  
  /**
   * The ID for the property backed facility
   */
  id: string;
  isMortgaged: boolean;
  isPrimaryPlaceOfResidence?: boolean;
  
  /**
   * Mortgage lender.
   */
  lender?: string;
  
  /**
   * Amount left in mortgage
   */
  outstandingMortgage?: Decimal;
  owners: Array<FacilityApplicationPropertyOwner>;
  
  /**
   * Type of facility
   */
  propertyType: PropertyType;
}

export interface FacilityApplicationPropertyOwner {
  applicantRelationship?: string;
  facilityPropertyId: string;
  id: string;
  name?: string;
  property: FacilityApplicationProperty;
}

/**
 * Details of a facility application
 */
export interface FacilityApplicationSharedFacilityWithOrganisation {
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The ID of the Facility Application this Organisation is shared with.
   */
  facilityApplicationId: string;
  
  /**
   * The ID for the Comment
   */
  id: string;
  
  /**
   * The ID of the Organisation this Facility Application is shared with.
   */
  organisationId: string;
  
  /**
   * The organisation.
   */
  sharedWithOrganisation?: FacilityApplicationOrganisation;
}

/**
 * The possible Facility Application Statuses
 */
export enum FacilityApplicationStatus {
  
  /**
   * Draft. While the Application is still being completed.
   */
  DRAFT = 'DRAFT',
  
  /**
   * Submitted. While the Application is awaiting review.
   */
  SUBMITTED = 'SUBMITTED',
  
  /**
   * Processing. While the Application is being reviewed/processed by the bank
   * NOTE: At the time of development, currently only used for property-backed applications
   */
  PROCESSING = 'PROCESSING',
  
  /**
   * Pending Payment. After the application has been reviewed by the bank
   * NOTE: At the time of development, currently only used for property-backed applications
   */
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  
  /**
   * Approved. The Application has been approved and is awaiting signature and payment
   */
  APPROVED = 'APPROVED',
  
  /**
   * Established. The Application has been established as a Facility
   */
  ESTABLISHED = 'ESTABLISHED',
  
  /**
   * Rejected. The Application was rejected by the Supplier
   */
  REJECTED = 'REJECTED',
  
  /**
   * Closed. The Application was not completed in time.
   */
  CLOSED = 'CLOSED'
}

export interface SubmissionRecord {
  submittedAt: DateTime;
}

/**
 * Sort options for the Facility Application type.
 */
export interface FacilityApplicationSort {
  createdAt?: SortOperationKind;
  facilityType?: SortOperationKind;
  lastUpdatedAt?: SortOperationKind;
  submissionRecord?: SubmissionRecordSort;
  visibleToSupplierDate?: SortOperationKind;
}

export interface SubmissionRecordSort {
  submittedAt?: SortOperationKind;
  userId?: SortOperationKind;
}

/**
 * Filters for the FacilityApplication type.
 */
export interface FacilityApplicationFilter {
  AND?: Array<FacilityApplicationFilter>;
  OR?: Array<FacilityApplicationFilter>;
  id?: string;
  id_in?: Array<string>;
  status?: FacilityApplicationStatus;
  status_in?: Array<FacilityApplicationStatus>;
  status_not_in?: Array<FacilityApplicationStatus>;
  facilityType?: FacilityType;
  facilityType_in?: Array<FacilityType>;
  facilityType_not_in?: Array<FacilityType>;
  applicant?: ApplicantFilter;
  visibleToSupplierDate_gt?: DateTime;
  visibleToSupplierDate_lt?: DateTime;
  visibleToSupplierDate_in?: Array<DateTime | null>;
}

export interface ApplicantFilter {
  AND?: Array<ApplicantFilter>;
  OR?: Array<ApplicantFilter>;
  abn_contains?: string;
  abn?: string;
  abn_not?: string;
  abn_not_contains?: string;
  abn_starts_with?: string;
  abn_not_starts_with?: string;
  abn_ends_with?: string;
  abn_not_ends_with?: string;
  abn_in?: Array<string | null>;
  abn_not_in?: Array<string | null>;
  companyName_contains?: string;
  companyName?: string;
  companyName_not?: string;
  companyName_not_contains?: string;
  companyName_starts_with?: string;
  companyName_not_starts_with?: string;
  companyName_ends_with?: string;
  companyName_not_ends_with?: string;
  companyName_in?: Array<string | null>;
  companyName_not_in?: Array<string | null>;
  emailAddress_contains?: string;
  emailAddress?: string;
  emailAddress_not?: string;
  emailAddress_not_contains?: string;
  emailAddress_starts_with?: string;
  emailAddress_not_starts_with?: string;
  emailAddress_ends_with?: string;
  emailAddress_not_ends_with?: string;
  emailAddress_in?: Array<string | null>;
  emailAddress_not_in?: Array<string | null>;
  contactName_contains?: string;
  contactName?: string;
  contactName_not?: string;
  contactName_not_contains?: string;
  contactName_starts_with?: string;
  contactName_not_starts_with?: string;
  contactName_ends_with?: string;
  contactName_not_ends_with?: string;
  contactName_in?: Array<string | null>;
  contactName_not_in?: Array<string | null>;
}

/**
 * A connection to a list of items.
 */
export interface FacilityApplicationsConnection {
  
  /**
   * List capabilities available to the current user around facility applications
   */
  capabilities?: Array<FacilityApplicationListCapability>;
  
  /**
   * A list of edges.
   */
  edges?: Array<FacilityApplicationsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<FacilityApplication | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * The capabilities the current user has generally on Facility Applications
 */
export enum FacilityApplicationListCapability {
  
  /**
   * User can apply for a surety bond facility application for their organisation
   */
  CAN_APPLY_FOR_SURETYBOND_FACILITY = 'CAN_APPLY_FOR_SURETYBOND_FACILITY',
  
  /**
   * User can apply for a property-backed facility application for their organisation
   */
  CAN_APPLY_FOR_PROPERTYBACKED_FACILITY = 'CAN_APPLY_FOR_PROPERTYBACKED_FACILITY'
}

/**
 * An edge in a connection.
 */
export interface FacilityApplicationsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: FacilityApplication;
}

/**
 * A connection to a list of items.
 */
export interface FacilityApplicationsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<FacilityApplicationsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<FacilityApplication | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface FacilityApplicationsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: FacilityApplication;
}

export interface GatewayFeatures {
  docuSignIntegration: boolean;
  emailAuditing: boolean;
  googleAuth: boolean;
  gvpIntegration: boolean;
  organisationCredit: boolean;
  referralPortal: boolean;
  referrals: boolean;
  requiredDocuments_BlockCreation_IfSubmittedToGvpAndNotRecalled: boolean;
  suretyBonds: boolean;
}

export interface FinanceRecordSortInput {
  id?: SortEnumType;
  organisationId?: SortEnumType;
  dateTime?: SortEnumType;
  amount?: SortEnumType;
  
  /**
   * The id of the Bank Portal user that performed the change
   */
  performedBy?: SortEnumType;
  financeType?: SortEnumType;
  financier?: SortEnumType;
}

export interface FinanceRecordFilterInput {
  and?: Array<FinanceRecordFilterInput>;
  or?: Array<FinanceRecordFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  organisationId?: ComparableGuidOperationFilterInput;
  dateTime?: ComparableDateTimeOperationFilterInput;
  amount?: ComparableDecimalOperationFilterInput;
  
  /**
   * The id of the Bank Portal user that performed the change
   */
  performedBy?: ComparableGuidOperationFilterInput;
  financeType?: NullableOfFinanceTypeOperationFilterInput;
  financier?: NullableOfFinancierOperationFilterInput;
}

export interface ComparableDateTimeOperationFilterInput {
  eq?: DateTime;
  neq?: DateTime;
  in?: Array<DateTime>;
  nin?: Array<DateTime>;
  gt?: DateTime;
  ngt?: DateTime;
  gte?: DateTime;
  ngte?: DateTime;
  lt?: DateTime;
  nlt?: DateTime;
  lte?: DateTime;
  nlte?: DateTime;
}

export interface NullableOfFinanceTypeOperationFilterInput {
  eq?: FinanceType;
  neq?: FinanceType;
  in?: Array<FinanceType | null>;
  nin?: Array<FinanceType | null>;
}

export enum FinanceType {
  WORKING_CAPITAL = 'WORKING_CAPITAL',
  EQUIPMENT_OR_ASSET_FINANCE = 'EQUIPMENT_OR_ASSET_FINANCE',
  LINE_OF_CREDIT = 'LINE_OF_CREDIT',
  OTHER = 'OTHER'
}

export interface NullableOfFinancierOperationFilterInput {
  eq?: Financier;
  neq?: Financier;
  in?: Array<Financier | null>;
  nin?: Array<Financier | null>;
}

export enum Financier {
  VALIANT = 'VALIANT',
  PROSPA = 'PROSPA'
}

/**
 * A connection to a list of items.
 */
export interface FinanceRecordsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<FinanceRecordsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<FinanceRecord>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface FinanceRecordsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: FinanceRecord;
}

export interface FinanceRecord {
  amount: Decimal;
  dateTime: DateTime;
  financeType?: FinanceType;
  financier?: Financier;
  id: string;
  organisationId: string;
  
  /**
   * The id of the Bank Portal user that performed the change
   */
  performedBy: string;
  
  /**
   * The bank user who last modified the finance record
   */
  performedByUser?: ICognitoUser;
}

export interface ChannelPartnerReportMonth {
  amount: Decimal;
  existingClients: number;
  monthYear?: string;
  newClients: number;
  numberOfDocuments: number;
  savings: Decimal;
}

export interface ChartProjectionReportMonth {
  monthYear?: string;
  totalAmount: Decimal;
}

export interface ChartReportMonth {
  bankguaranteeAmount: Decimal;
  monthYear?: string;
  numberOfBankguaranteeClients: number;
  numberOfBankguaranteeDocuments: number;
  numberOfClients: number;
  numberOfDocuments: number;
  numberOfSuretyBondsClients: number;
  numberOfSuretyBondsDocuments: number;
  suretyBondsAmount: Decimal;
  totalAmount: Decimal;
}

/**
 * Details about a Draft Attachment
 */
export interface DraftAttachmentSort {
  createdAt?: SortOperationKind;
}

/**
 * Details about a Draft Attachment
 */
export interface DraftAttachmentFilter {
  AND?: Array<DraftAttachmentFilter>;
  OR?: Array<DraftAttachmentFilter>;
  id?: string;
  id_in?: Array<string>;
}

/**
 * A connection to a list of items.
 */
export interface GeneratedAttachmentsForOrganisationConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GeneratedAttachmentsForOrganisationEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<DraftAttachment | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GeneratedAttachmentsForOrganisationEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: DraftAttachment;
}

/**
 * Filters for the FeeSummary
 */
export interface FeeSummaryFilter {
  AND?: Array<FeeSummaryFilter>;
  OR?: Array<FeeSummaryFilter>;
  productType?: ProductType;
  productType_in?: Array<ProductType>;
}

/**
 * Details on a notification email that was dispatched to a user (or non-user).
 */
export interface NotificationSortInput {
  id?: SortEnumType;
  userId?: SortEnumType;
  event?: SortEnumType;
  emailAddress?: SortEnumType;
  externalId?: SortEnumType;
  template?: SortEnumType;
  metadata?: SortEnumType;
  subject?: SortEnumType;
  sentOn?: SortEnumType;
  createdOn?: SortEnumType;
  user?: UserSortInput;
}

/**
 * A User Profile record, capturing details of someone who has registered to use the system.
 */
export interface UserSortInput {
  
  /**
   * The ID for the User
   */
  id?: SortEnumType;
  
  /**
   * The Given (First) name of the user. Required. Max Length 255.
   */
  givenName?: SortEnumType;
  
  /**
   * The Family name (surname) of the user. Required. Max Length 255.
   */
  familyName?: SortEnumType;
  
  /**
   * The email address of the user. Required. Max Length 255.
   */
  email?: SortEnumType;
  
  /**
   * The physical address of the user. Max Length 255.
   */
  address?: SortEnumType;
  
  /**
   * The locale (which assists in language detection) of the user. Max Length 255.
   */
  locale?: SortEnumType;
  
  /**
   * The phone number of the user. Max Length 255.
   */
  phoneNumber?: SortEnumType;
  
  /**
   * The timezone (which assists in clock/date correction) of the user. Max Length 255.
   */
  timezone?: SortEnumType;
  
  /**
   * The job title of the user. Max Length 255.
   */
  jobTitle?: SortEnumType;
  
  /**
   * The industry of the user. Max Length 255.
   */
  industry?: SortEnumType;
  
  /**
   * The identifier for who or what created this record. Required.
   */
  createdBy?: SortEnumType;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt?: SortEnumType;
  
  /**
   * The identifier for who or what last updated this record.
   */
  lastUpdatedBy?: SortEnumType;
  
  /**
   * The date stamp the record was last updated.
   */
  lastUpdatedAt?: SortEnumType;
  
  /**
   * The datetime when the user last viewed the platform updates notification
   */
  updatesNotifiedAt?: SortEnumType;
  
  /**
   * Whether Terms will need to be manually accepted after the next login
   */
  requireTermsAcceptance?: SortEnumType;
  
  /**
   * The referralCode of the organisation that referred this user (via the organisation-to-organisation referral feature)
   */
  referrerCode?: SortEnumType;
  
  /**
   * The referralCode of the Member that referred this user (via the referral portal feature)
   */
  referralPortalReferrerMemberCode?: SortEnumType;
}

/**
 * Details on a notification email that was dispatched to a user (or non-user).
 */
export interface NotificationFilterInput {
  and?: Array<NotificationFilterInput>;
  or?: Array<NotificationFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  userId?: ComparableNullableOfGuidOperationFilterInput;
  event?: StringOperationFilterInput;
  emailAddress?: StringOperationFilterInput;
  externalId?: StringOperationFilterInput;
  template?: StringOperationFilterInput;
  metadata?: StringOperationFilterInput;
  subject?: StringOperationFilterInput;
  sentOn?: ComparableNullableOfDateTimeOffsetOperationFilterInput;
  createdOn?: ComparableDateTimeOffsetOperationFilterInput;
  user?: UserFilterInput;
}

/**
 * A User Profile record, capturing details of someone who has registered to use the system.
 */
export interface UserFilterInput {
  and?: Array<UserFilterInput>;
  or?: Array<UserFilterInput>;
  
  /**
   * The ID for the User
   */
  id?: ComparableGuidOperationFilterInput;
  
  /**
   * The Given (First) name of the user. Required. Max Length 255.
   */
  givenName?: StringOperationFilterInput;
  
  /**
   * The Family name (surname) of the user. Required. Max Length 255.
   */
  familyName?: StringOperationFilterInput;
  
  /**
   * The email address of the user. Required. Max Length 255.
   */
  email?: StringOperationFilterInput;
  
  /**
   * The physical address of the user. Max Length 255.
   */
  address?: StringOperationFilterInput;
  
  /**
   * The locale (which assists in language detection) of the user. Max Length 255.
   */
  locale?: StringOperationFilterInput;
  
  /**
   * The phone number of the user. Max Length 255.
   */
  phoneNumber?: StringOperationFilterInput;
  
  /**
   * The timezone (which assists in clock/date correction) of the user. Max Length 255.
   */
  timezone?: StringOperationFilterInput;
  
  /**
   * The job title of the user. Max Length 255.
   */
  jobTitle?: StringOperationFilterInput;
  
  /**
   * The industry of the user. Max Length 255.
   */
  industry?: StringOperationFilterInput;
  
  /**
   * The identifier for who or what created this record. Required.
   */
  createdBy?: StringOperationFilterInput;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt?: ComparableDateTimeOffsetOperationFilterInput;
  
  /**
   * The identifier for who or what last updated this record.
   */
  lastUpdatedBy?: StringOperationFilterInput;
  
  /**
   * The date stamp the record was last updated.
   */
  lastUpdatedAt?: ComparableNullableOfDateTimeOffsetOperationFilterInput;
  
  /**
   * The datetime when the user last viewed the platform updates notification
   */
  updatesNotifiedAt?: ComparableNullableOfDateTimeOffsetOperationFilterInput;
  
  /**
   * Whether Terms will need to be manually accepted after the next login
   */
  requireTermsAcceptance?: BooleanOperationFilterInput;
  notifications?: ListFilterInputTypeOfNotificationFilterInput;
  
  /**
   * The referralCode of the organisation that referred this user (via the organisation-to-organisation referral feature)
   */
  referrerCode?: StringOperationFilterInput;
  
  /**
   * The referralCode of the Member that referred this user (via the referral portal feature)
   */
  referralPortalReferrerMemberCode?: StringOperationFilterInput;
}

export interface ListFilterInputTypeOfNotificationFilterInput {
  all?: NotificationFilterInput;
  none?: NotificationFilterInput;
  some?: NotificationFilterInput;
  any?: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GetNotificationsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GetNotificationsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Notification | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GetNotificationsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Notification;
}

/**
 * Details on a notification email that was dispatched to a user (or non-user).
 */
export interface Notification {
  createdOn: DateTime;
  emailAddress?: string;
  event?: string;
  externalId?: string;
  id: string;
  metadata?: string;
  sentOn?: DateTime;
  subject?: string;
  template?: string;
  userId?: string;
}

/**
 * Sort options for the Organisation Credit Event type.
 */
export interface OrganisationCreditEventSort {
  actionedRole?: SortOperationKind;
  amountChanged?: SortOperationKind;
  dateCreated?: SortOperationKind;
  eventType?: SortOperationKind;
  remainingBalance?: SortOperationKind;
}

/**
 * Filters for the Organisation Credit Event type.
 */
export interface OrganisationCreditEventFilter {
  AND?: Array<OrganisationCreditEventFilter>;
  OR?: Array<OrganisationCreditEventFilter>;
  organisationCreditId?: string;
  organisationCreditId_in?: Array<string>;
}

/**
 * A connection to a list of items.
 */
export interface GetOrganisationCreditEventsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GetOrganisationCreditEventsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<OrganisationCreditEvent | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GetOrganisationCreditEventsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: OrganisationCreditEvent;
}

export interface OrganisationCreditEvent {
  
  /**
   * Can be from client or admin user pool
   * NOTE: A value of null indicates it came from an automated process
   */
  actionedBy?: string;
  actionedByName: string;
  actionedRole: ActionedRole;
  
  /**
   * Amount changed: 0 or more (+ve only)
   * Use EventType to determine if this is an increase or decrease
   */
  amountChanged: Decimal;
  
  /**
   * credit event note or comment.
   */
  comment: string;
  dateCreated: DateTime;
  eventType: CreditEventType;
  id: string;
  organisationCreditId: string;
  
  /**
   * Balance after this event. 0 or more (+ve only)
   */
  remainingBalance: Decimal;
  usedByDraftId?: string;
}

export enum ActionedRole {
  ASSURO_CLIENT_USER = 'ASSURO_CLIENT_USER',
  ASSURO_RELATIONSHIP_MANAGER = 'ASSURO_RELATIONSHIP_MANAGER',
  ASSURO_SYSTEM = 'ASSURO_SYSTEM'
}

export enum CreditEventType {
  
  /**
   * Credit issued to organisation
   * AmountChanged is +ve
   */
  ISSUED = 'ISSUED',
  
  /**
   * Credit used by organisation against a draft
   * AmountChanged is -ve
   */
  USED = 'USED',
  
  /**
   * Credit voided by admin
   * AmountChanged is -ve
   */
  VOIDED = 'VOIDED',
  
  /**
   * Credit reissued (reverted) to organisation against a draft e.g. the draft was rejected and admin reissued the credit
   * AmountChanged is +ve
   */
  REISSUED = 'REISSUED'
}

/**
 * Sort options for the Organisation Credit type.
 */
export interface OrganisationCreditSort {
  creditType?: SortOperationKind;
  dateCreated?: SortOperationKind;
  issuedAmount?: SortOperationKind;
  remainingAmount?: SortOperationKind;
  status?: SortOperationKind;
}

/**
 * Filters for the Organisation Credit type.
 */
export interface OrganisationCreditFilter {
  AND?: Array<OrganisationCreditFilter>;
  OR?: Array<OrganisationCreditFilter>;
  organisationId?: string;
  organisationId_in?: Array<string>;
}

/**
 * A connection to a list of items.
 */
export interface GetOrganisationCreditsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GetOrganisationCreditsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<OrganisationCredit | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GetOrganisationCreditsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: OrganisationCredit;
}

export interface OrganisationCredit {
  createdByAdminId: string;
  createdByName: string;
  creditType: CreditType;
  dateCreated: DateTime;
  
  /**
   * The draft application description for which this credit was created.
   */
  draftDescription?: string;
  id: string;
  issuedAmount: Decimal;
  
  /**
   * The events associated with this credit.
   */
  organisationCreditEvents?: Array<OrganisationCreditEvent>;
  organisationId: string;
  remainingAmount: Decimal;
  sourceDraftId?: string;
  status: CreditStatus;
}

export enum CreditType {
  
  /**
   * Issued to application that does not move forward e.g. declined
   */
  APPLICATION = 'APPLICATION'
}

export enum CreditStatus {
  
  /**
   * Credit is available to be used against a new application
   */
  AVAILABLE = 'AVAILABLE',
  
  /**
   * All credit has been used (over one or more applications)
   */
  CLAIMED = 'CLAIMED',
  
  /**
   * Credit has been voided (e.g. RM decision)
   */
  VOID = 'VOID'
}

/**
 * Sort options for the Organisation type.
 */
export interface OrganisationSort {
  abn?: SortOperationKind;
  createdAt?: SortOperationKind;
  discountPercentage?: SortOperationKind;
  name?: SortOperationKind;
  nickname?: SortOperationKind;
}

/**
 * Filters for the Organisation type.
 */
export interface OrganisationFilter {
  AND?: Array<OrganisationFilter>;
  OR?: Array<OrganisationFilter>;
  id?: string;
  id_in?: Array<string>;
  name?: string;
  name_contains?: string;
  name_starts_with?: string;
  name_ends_with?: string;
  abn?: string;
  abn_contains?: string;
  abn_starts_with?: string;
  abn_ends_with?: string;
  address_contains?: string;
  address_not_contains?: string;
  nickname?: string;
  nickname_contains?: string;
  nickname_starts_with?: string;
  nickname_ends_with?: string;
}

/**
 * A connection to a list of items.
 */
export interface GetOrganisationsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GetOrganisationsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankOrganisation | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GetOrganisationsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankOrganisation;
}

/**
 * Details of an Organisation
 */
export interface BankOrganisation {
  
  /**
   * The ABN of the Organisation. ABN format.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   */
  address?: string;
  
  /**
   * The current users Capabilities to act on the Organisation.
   */
  capabilities: Array<OrganisationCapability | null>;
  
  /**
   * ChannelPartners of the organisation
   */
  channelPartnerOrganisations?: ChannelPartnerOrganisationsConnection;
  
  /**
   * The collection of ESTABLISHED/CONFIRMED connections between an Organisation record in Assuro (Business Unit in GVP) to Guarantors in GVP. (via the "connection" functionality in GVP)
   */
  connectedGvpGuarantorIds?: Array<string | null>;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The Organisation's Fee Discount Percentage.
   */
  discountPercentage: Decimal;
  entityType?: PartyEntityType;
  
  /**
   * The Id of the associated "Applicant" record in GVP. (If null, it means either the organisation hasn't applied for any products related to suppliers who are using GVP, or is not mapped yet)
   */
  gvpId?: string;
  
  /**
   * The ID for the Organisation.
   */
  id: string;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   */
  industryType?: string;
  isOngoingClient?: boolean;
  leadSource?: string;
  
  /**
   * Pending invitations to the organisation
   */
  memberInvitations?: MemberInvitationsConnection;
  
  /**
   * Members of the organisation
   */
  members?: MembersConnection;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Max length 255.
   */
  name: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Max length 255.
   */
  nickname?: string;
  
  /**
   * Fee summaries associated with the organisation
   */
  organisationFeeSummaries?: Array<OrganisationFeeSummary>;
  
  /**
   * The Organisation Type.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * The Postal Address of the Organisation. Max length 500.
   */
  postalAddress?: string;
  
  /**
   * Whether the Postal Address of the Organisation is the same as the Business Address.
   */
  postalAddressSameAsBusinessAddress?: boolean;
  
  /**
   * A short, unique string that is used to attribute referrals back to the organisation that sent out the original invite. Readonly
   */
  referralCode?: string;
  referralPortalAssociation?: OrganisationAssociation;
  
  /**
   * The relationship manager associated to the organisation
   */
  relationshipManager?: ICognitoUser;
  relationshipManagerId?: string;
  sumAvailableOrganisationCredits?: Decimal;
}

/**
 * The capabilities the current user has on a Organisation
 */
export enum OrganisationCapability {
  
  /**
   * Organisation Invitations can be created and removed.
   */
  MANAGE_INVITATIONS = 'MANAGE_INVITATIONS',
  
  /**
   * Organisation Members can be modified and removed.
   */
  MANAGE_MEMBERS = 'MANAGE_MEMBERS',
  
  /**
   * Organisation details can be modified.
   */
  UPDATE_DETAILS = 'UPDATE_DETAILS',
  
  /**
   * Organisation Alert Configurations can be created, modified and removed.
   */
  MANAGE_ORGANISATION_ALERT_CONFIGURATIONS = 'MANAGE_ORGANISATION_ALERT_CONFIGURATIONS',
  
  /**
   * Documents can be added to this Organisation
   */
  ADD_DOCUMENTS = 'ADD_DOCUMENTS',
  
  /**
   * Billing information can be viewed.
   */
  VIEW_BILLING = 'VIEW_BILLING'
}

/**
 * A connection to a list of items.
 */
export interface ChannelPartnerOrganisationsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ChannelPartnerOrganisationsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ChannelPartnerOrganisation | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ChannelPartnerOrganisationsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: ChannelPartnerOrganisation;
}

export interface ChannelPartnerOrganisation {
  channelPartner?: ChannelPartners;
  id: string;
}

/**
 * A connection to a list of items.
 */
export interface MemberInvitationsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<MemberInvitationsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<MemberInvitation | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface MemberInvitationsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: MemberInvitation;
}

/**
 * Details on an Invitation to an Organisation
 */
export interface MemberInvitation {
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The Email adddress of the Member to invite.
   */
  email: string;
  
  /**
   * The ID for the Organisation Invitation.
   */
  id: string;
  
  /**
   * Whether or not the invitation has expired.
   */
  isExpired?: boolean;
  
  /**
   * The Role the Member will have if they accept the invite.
   */
  role?: MemberRole;
}

/**
 * Details the different Member Roles
 */
export enum MemberRole {
  
  /**
   * Limited user. Can view data and comment and documents.
   */
  LIMITED_USER = 'LIMITED_USER',
  
  /**
   * Regular user. Can create and modify documents, but cannot invite organisation members or change organisation details.
   */
  USER = 'USER',
  
  /**
   * Admin user. Can change organisation details, invite members as well create and modify documents.
   */
  ADMIN = 'ADMIN'
}

/**
 * Filters for the Member type.
 */
export interface MemberFilter {
  AND?: Array<MemberFilter>;
  OR?: Array<MemberFilter>;
  userId?: string;
  role?: MemberRole;
  givenName?: string;
  givenName_contains?: string;
  givenName_starts_with?: string;
  givenName_ends_with?: string;
  familyName?: string;
  familyName_contains?: string;
  familyName_starts_with?: string;
  familyName_ends_with?: string;
  fullName?: string;
  fullName_contains?: string;
  fullName_starts_with?: string;
  fullName_ends_with?: string;
}

/**
 * A connection to a list of items.
 */
export interface MembersConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<MembersEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Member | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface MembersEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Member;
}

/**
 * Details on an Organisation Member
 */
export interface Member {
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The current users email.
   */
  email?: string;
  
  /**
   * The Family name (surname) of the user. Max Length 255.
   */
  familyName?: string;
  
  /**
   * The Given (First) name of the user. Max Length 255.
   */
  givenName?: string;
  
  /**
   * The ID for the Organisation Member.
   */
  memberId: string;
  
  /**
   * The Role of the Member. Determines level of access to Organisation and Documents.
   */
  role?: MemberRole;
  
  /**
   * The User details of the Member
   * @deprecated Member.GivenName, Member.FamilyName and Member.UserId replace this type.
   */
  user?: User;
  
  /**
   * The User ID of the Member. Required. GUID.
   */
  userId: string;
}

/**
 * A User Profile record, capturing details of someone who has registered to use the system.
 */
export interface User {
  
  /**
   * The physical address of the user. Max Length 255.
   */
  address?: string;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The email address of the user. Required. Max Length 255.
   */
  email: string;
  
  /**
   * The Family name (surname) of the user. Required. Max Length 255.
   */
  familyName: string;
  
  /**
   * The Given (First) name of the user. Required. Max Length 255.
   */
  givenName: string;
  
  /**
   * The ID for the User
   */
  id: string;
  
  /**
   * The industry of the user. Max Length 255.
   */
  industry?: string;
  
  /**
   * The job title of the user. Max Length 255.
   */
  jobTitle?: string;
  
  /**
   * The locale (which assists in language detection) of the user. Max Length 255.
   */
  locale?: string;
  
  /**
   * The phone number of the user. Max Length 255.
   */
  phoneNumber?: string;
}

export interface OrganisationFeeSummary {
  feeSummaryId: string;
  id: string;
  organisation: Organisation;
  organisationId: string;
}

/**
 * Details of an Organisation
 */
export interface Organisation {
  
  /**
   * The ABN of the Organisation. ABN format.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   */
  address?: string;
  
  /**
   * The document alert configurations for the organisation
   */
  alertConfigurations?: Array<AlertConfiguration>;
  
  /**
   * The current users Capabilities to act on the Organisation.
   */
  capabilities: Array<OrganisationCapability | null>;
  
  /**
   * ChannelPartners of the organisation
   */
  channelPartnerOrganisations?: ChannelPartnerOrganisationsConnection;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The Organisation's Fee Discount Percentage.
   */
  discountPercentage: Decimal;
  
  /**
   * Whether the organisation is opted in to facilities or not.
   */
  documentFacilitiesOptIn: boolean;
  
  /**
   * The Document Metadata configured for this Organisation.
   */
  documentMetadata: Array<OrganisationDocumentMetadata | null>;
  
  /**
   * The current users Capabilities to act on Documents for the Organisation.
   */
  documentsCapabilities: Array<OrganisationDocumentsCapability | null>;
  entityType?: PartyEntityType;
  
  /**
   * The ID for the Organisation.
   */
  id: string;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   */
  industryType?: string;
  isOngoingClient?: boolean;
  leadSource?: string;
  
  /**
   * Pending invitations to the organisation
   */
  memberInvitations?: MemberInvitationsConnection;
  
  /**
   * Members of the organisation
   */
  members?: MembersConnection;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Max length 255.
   */
  name: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Max length 255.
   */
  nickname?: string;
  
  /**
   * Fee summaries associated with the organisation
   */
  organisationFeeSummaries?: Array<OrganisationFeeSummary>;
  
  /**
   * The Organisation Type.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * The Postal Address of the Organisation. Max length 500.
   */
  postalAddress?: string;
  
  /**
   * Whether the Postal Address of the Organisation is the same as the Business Address.
   */
  postalAddressSameAsBusinessAddress?: boolean;
  
  /**
   * A short, unique string that is used to attribute referrals back to the organisation that sent out the original invite. Readonly
   */
  referralCode?: string;
  referralPortalAssociation?: OrganisationAssociation;
  
  /**
   * The relationship manager associated to the organisation
   */
  relationshipManager?: ICognitoUser;
  relationshipManagerId?: string;
  sumAvailableOrganisationCredits?: Decimal;
}

export interface AlertConfiguration {
  
  /**
   * The email addresses that will be notified when the Alert triggers.
   */
  emailAddresses?: Array<string>;
  facilityId?: string;
  facilityLimit?: Decimal;
  facilityLimitIncludeProjectedDocs?: boolean;
  id: string;
  triggerLeadTime?: Seconds;
  triggerProperty?: AlertTriggerProperty;
}

export type Seconds = any;

export enum AlertTriggerProperty {
  EXPIRY_DATE = 'EXPIRY_DATE',
  EXPECTED_RETURN_DATE = 'EXPECTED_RETURN_DATE',
  FACILITY_EXPIRY_DATE = 'FACILITY_EXPIRY_DATE',
  FACILITY_LIMIT = 'FACILITY_LIMIT'
}

/**
 * Sort options for the OrganisationDocumentMetadata type.
 */
export interface OrganisationDocumentMetadataSort {
  key?: SortOperationKind;
}

export interface OrganisationDocumentMetadata {
  id: string;
  key: string;
}

/**
 * The capabilities the current user has to manage documents for an Organisation
 */
export enum OrganisationDocumentsCapability {
  
  /**
   * Documents can be added to this Organisation
   */
  CAN_ADD_DOCUMENTS = 'CAN_ADD_DOCUMENTS',
  
  /**
   * Organisation Document Metadata can be managed
   */
  CAN_MANAGE_ORGANISATION_METADATA = 'CAN_MANAGE_ORGANISATION_METADATA',
  
  /**
   * Organisation Document Facilities can be managed
   */
  CAN_MANAGE_FACILITIES = 'CAN_MANAGE_FACILITIES'
}

/**
 * Details the different types of an Organisation
 */
export enum OrganisationVariant {
  
  /**
   * Beneficiary, the party that would receive the amount of the Document if the Issuer defaulted.
   */
  BENEFICIARY = 'BENEFICIARY',
  
  /**
   * Issuer, the party who is responsible for funding (in most cases) the Document.
   */
  ISSUER = 'ISSUER',
  
  /**
   * Other party(eg-real estate agent) who creates the draft behalf of the issuer or beneficiary.This party must invite issuer and beneficiary representatives.
   */
  OTHER = 'OTHER'
}

export interface OrganisationAssociation {
  createdAt: DateTime;
  entity: Entity;
  entityId: string;
  id: string;
  organisationId: string;
  referralPortalMember?: ReferralPortalMember;
  referralPortalMemberId?: string;
}

export interface Entity {
  abn: string;
  addressLine1?: string;
  addressLine2?: string;
  addressPostcode?: string;
  addressState?: EntityAddressState;
  addressSuburb?: string;
  bankingAccountNumber?: string;
  bankingBsbNumber?: string;
  contactPerson: string;
  createdAt: DateTime;
  email: string;
  entityType: EntityType;
  id: string;
  name: string;
  parentEntityId?: string;
  phone: string;
  relationshipManagerEmail?: string;
  relationshipManagerFirstName?: string;
  relationshipManagerId?: string;
  relationshipManagerLastName?: string;
  relationshipManagerPhone?: string;
}

export enum EntityAddressState {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  QLD = 'QLD',
  SA = 'SA',
  TAS = 'TAS',
  VIC = 'VIC',
  WA = 'WA'
}

export enum EntityType {
  CORPORATE_PARTNER = 'CORPORATE_PARTNER',
  REFERRAL_PARTNER = 'REFERRAL_PARTNER'
}

export interface ReferralPortalMember {
  cognitoUser_Username?: string;
  email: string;
  entity: Entity;
  entityId: string;
  
  /**
   * 
   * @deprecated Obsolete: Please query the nested Entity model instead
   */
  entityName?: string;
  id: string;
  isSmsMfaRequired?: boolean;
  mobilePhone?: string;
  name: string;
  position?: string;
  referClientCode: string;
  role?: BankUserRole;
  status: MemberStatus;
  surname: string;
}

export enum MemberStatus {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export interface InvoicePaymentIntentSecret {
  amountInCents: Long;
  clientSecret?: string;
  paymentMethodId?: string;
}

/**
 * Sort options for the Simple Kys validation Flags type.
 */
export interface IFlagsDataSort {
  flagGrade?: SortOperationKind;
  nodeName?: SortOperationKind;
}

/**
 * Filters for the Simple Kys validation Flags type.
 */
export interface IFlagsDataFilter {
  AND?: Array<IFlagsDataFilter>;
  OR?: Array<IFlagsDataFilter>;
  flagGrade?: number;
  flagGrade_in?: Array<number>;
}

/**
 * A connection to a list of items.
 */
export interface GetSimpleKycDataFlagsByIdentificationIdConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GetSimpleKycDataFlagsByIdentificationIdEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<IFlagsData | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GetSimpleKycDataFlagsByIdentificationIdEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: IFlagsData;
}

export interface IFlagsData {
  bo: number;
  descriptor: string;
  flagGrade: number;
  msg: string;
  nodeName: string;
  relevance: number;
}

export enum KycUrlType {
  URL = 'URL',
  URL_GUEST = 'URL_GUEST',
  HTML_REPORT = 'HTML_REPORT',
  PDF_REPORT = 'PDF_REPORT'
}

export interface StripeSubscriptionDetails {
  isLastInvoicePaid: boolean;
  lastInvoiceDueDate?: DateTime;
  subscriptionCancelledAt?: DateTime;
  subscriptionEndedAt?: DateTime;
}

export interface SupplierFilter {
  AND?: Array<SupplierFilter>;
  OR?: Array<SupplierFilter>;
  id?: string;
  id_in?: Array<string>;
}

/**
 * A connection to a list of items.
 */
export interface GetUsersForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<GetUsersForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<User | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface GetUsersForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: User;
}

/**
 * Sort options for the BankIdentification type.
 */
export interface BankIdentificationSort {
  adminStatus?: SortOperationKind;
  clientStatus?: SortOperationKind;
  companyDetailsACN?: SortOperationKind;
  companyDetailsName?: SortOperationKind;
  createdAt?: SortOperationKind;
  entityType?: SortOperationKind;
}

/**
 * Filters for the BankIdentification type.
 */
export interface BankIdentificationFilter {
  AND?: Array<BankIdentificationFilter>;
  OR?: Array<BankIdentificationFilter>;
  id?: string;
  id_in?: Array<string>;
  companyDetailsACN?: string;
  companyDetailsACN_contains?: string;
  companyDetailsName?: string;
  companyDetailsName_contains?: string;
  organisationId?: string;
  userId?: string;
}

/**
 * A connection to a list of items.
 */
export interface IdentificationsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<IdentificationsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankIdentification | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface IdentificationsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankIdentification;
}

/**
 * Details on a Identification, relevant to the Bank Portal.
 */
export interface BankIdentification {
  adminStatus?: IdentificationApprovalStatus;
  clientStatus?: IdentificationApprovalStatus;
  
  /**
   * Client verification status for the Identification record.
   */
  clientVerificationStatus?: ClientVerificationStatus;
  comments?: string;
  companyDetailsACN?: string;
  companyDetailsHasBeneficialOwners?: boolean;
  companyDetailsIsListed?: boolean;
  companyDetailsIsNormalType?: boolean;
  companyDetailsIsRegulated?: boolean;
  companyDetailsIsSubsidiaryListed?: boolean;
  companyDetailsListedExchangeName?: string;
  companyDetailsName?: string;
  companyDetailsNatureOfBusiness?: string;
  companyDetailsOnlyOperatesInAustralia?: boolean;
  companyDetailsPrincipalPlaceOfBusiness?: string;
  companyDetailsRegisteredAddress?: string;
  companyDetailsRegulatorLicenseNumber?: string;
  companyDetailsRegulatorName?: string;
  companyDetailsSubsidiaryListedCompanyName?: string;
  companyDetailsSubsidiaryListedExchangeName?: string;
  companyDetailsTaxFatcaStatus?: IdentificationCompanyDetailsTaxFatcaStatus;
  companyDetailsTaxFatcaStatusOther?: string;
  companyDetailsTaxForeignResidentCountry?: string;
  companyDetailsTaxGIIN?: string;
  companyDetailsTaxHasBeneficialOwnerForeignResident?: boolean;
  companyDetailsTaxHasGIIN?: boolean;
  companyDetailsTaxIsForeignResident?: boolean;
  companyDetailsTaxType?: IdentificationCompanyDetailsTaxType;
  createdAt: DateTime;
  dataType?: IdentificationDataType;
  entityType?: IdentificationEntityType;
  entityWealthAccumulation?: EntityWealthAccumulation;
  hasDividendsIncome?: boolean;
  
  /**
   * 
   * @deprecated No longer supported
   */
  hasMacAccount?: boolean;
  id: string;
  
  /**
   * The History for the Identification. Not available for listed (>1 returned) Identifications.
   */
  identificationHistory?: IdentificationHistoryConnection;
  identificationIndustry?: IdentificationIndustry;
  
  /**
   * The Individuals relevant to the Identification.
   */
  individuals?: Array<IdentificationIndividual | null>;
  industryAdditionalDetails?: string;
  
  /**
   * 
   * @deprecated No longer supported
   */
  macAccountName?: string;
  
  /**
   * 
   * @deprecated No longer supported
   */
  macAccountNumber?: string;
  
  /**
   * The Identification's organisation.
   */
  organisation?: IdentificationOrganisation;
  organisationId?: string;
  postalAddress?: string;
  
  /**
   * A Json string to store the Risk Details
   */
  riskDetails?: string;
  riskDetailsCreatedAt?: DateTime;
  riskDetailsCreatedBy?: string;
  riskStatus?: RiskStatus;
  simpleKycDataId?: string;
  
  /**
   * The SimpleKycData record.
   */
  simpleKycDataRecord?: ISimpleKycData;
  step?: IdentificationStep;
  taxExemptionDetails?: string;
  taxExemptionType?: IdentificationCompanyDetailsTaxTaxExemptionType;
  taxStatus?: IdentificationCompanyDetailsTaxStatus;
  userId: string;
}

/**
 * Sort options for the IdentificationHistory type.
 */
export interface IdentificationHistorySort {
  triggeredAt?: SortOperationKind;
}

/**
 * A connection to a list of items.
 */
export interface IdentificationHistoryConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<IdentificationHistoryEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<IdentificationHistory | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface IdentificationHistoryEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: IdentificationHistory;
}

/**
 * Details on a change that has occurred in the system.
 */
export interface IdentificationHistory {
  
  /**
   * The group of the changes, in case multiple happened at once.
   */
  changeSetId: string;
  
  /**
   * The type of change this record captures.
   */
  changeType?: IdentificationHistoryChangeType;
  
  /**
   * The field level changes that occured on this record.
   */
  changes?: Array<IdentificationHistoryChange>;
  
  /**
   * The ID for the Identification History record.
   */
  id: string;
  
  /**
   * The type of the record that was changed.
   */
  objectType: string;
  
  /**
   * The name identifier for the record. Optional.
   */
  recordName?: string;
  
  /**
   * When the change was made.
   */
  triggeredAt: DateTime;
  
  /**
   * The Author of the change.
   */
  triggeredBy?: IdentificationAuthor;
}

/**
 * Details the type of change that occurred
 */
export enum IdentificationHistoryChangeType {
  
  /**
   * This change created a new record
   */
  INSERT = 'INSERT',
  
  /**
   * This change modified an existing record
   */
  UPDATE = 'UPDATE',
  
  /**
   * This change removed an existing record
   */
  DELETE = 'DELETE'
}

/**
 * Details on a field level change that has occurred in the system.
 */
export interface IdentificationHistoryChange {
  
  /**
   * The name of the field that was changed.
   */
  field: string;
  
  /**
   * The label of the field that was changed.
   */
  label?: string;
  
  /**
   * The display value of this field after the change. In the case of DELETE events, this will be null.
   */
  newDisplayValue?: string;
  
  /**
   * The value of this field after the change. In the case of DELETE events, this will be null.
   */
  newValue?: string;
  
  /**
   * The display value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldDisplayValue?: string;
  
  /**
   * The value of this field before the change. In the case of INSERT events, this will be null.
   */
  oldValue?: string;
}

/**
 * Details of an Author of data record.
 */
export interface IdentificationAuthor {
  
  /**
   * The Family Name of the Author.
   */
  familyName: string;
  
  /**
   * The Given Name of the Author.
   */
  givenName: string;
  
  /**
   * Whether the Bank was the author or not
   */
  isBankAuthor: boolean;
}

export enum RiskStatus {
  LOW = 'LOW',
  MID = 'MID',
  HIGH = 'HIGH'
}

/**
 * Sort options for the Import Job type.
 */
export interface ImportJobSort {
  createdAt?: SortOperationKind;
}

export interface ImportJobFilter {
  AND?: Array<ImportJobFilter>;
  OR?: Array<ImportJobFilter>;
  id?: string;
  id_not?: string;
  id_in?: Array<string>;
  id_not_in?: Array<string>;
  id_gt?: string;
  id_not_gt?: string;
  id_gte?: string;
  id_not_gte?: string;
  id_lt?: string;
  id_not_lt?: string;
  id_lte?: string;
  id_not_lte?: string;
  organisationId?: string;
  organisationId_not?: string;
  organisationId_in?: Array<string>;
  organisationId_not_in?: Array<string>;
  organisationId_gt?: string;
  organisationId_not_gt?: string;
  organisationId_gte?: string;
  organisationId_not_gte?: string;
  organisationId_lt?: string;
  organisationId_not_lt?: string;
  organisationId_lte?: string;
  organisationId_not_lte?: string;
  status?: ImportJobStatus;
  status_not?: ImportJobStatus;
  status_in?: Array<ImportJobStatus>;
  status_not_in?: Array<ImportJobStatus>;
  status_gt?: ImportJobStatus;
  status_not_gt?: ImportJobStatus;
  status_gte?: ImportJobStatus;
  status_not_gte?: ImportJobStatus;
  status_lt?: ImportJobStatus;
  status_not_lt?: ImportJobStatus;
  status_lte?: ImportJobStatus;
  status_not_lte?: ImportJobStatus;
  variant?: ImportJobVariant;
  variant_not?: ImportJobVariant;
  variant_in?: Array<ImportJobVariant>;
  variant_not_in?: Array<ImportJobVariant>;
  variant_gt?: ImportJobVariant;
  variant_not_gt?: ImportJobVariant;
  variant_gte?: ImportJobVariant;
  variant_not_gte?: ImportJobVariant;
  variant_lt?: ImportJobVariant;
  variant_not_lt?: ImportJobVariant;
  variant_lte?: ImportJobVariant;
  variant_not_lte?: ImportJobVariant;
  errors?: string;
  errors_not?: string;
  errors_contains?: string;
  errors_not_contains?: string;
  errors_starts_with?: string;
  errors_not_starts_with?: string;
  errors_ends_with?: string;
  errors_not_ends_with?: string;
  errors_in?: Array<string | null>;
  errors_not_in?: Array<string | null>;
  recordsRead?: number;
  recordsRead_not?: number;
  recordsRead_in?: Array<number>;
  recordsRead_not_in?: Array<number>;
  recordsRead_gt?: number;
  recordsRead_not_gt?: number;
  recordsRead_gte?: number;
  recordsRead_not_gte?: number;
  recordsRead_lt?: number;
  recordsRead_not_lt?: number;
  recordsRead_lte?: number;
  recordsRead_not_lte?: number;
  recordsProcessed?: number;
  recordsProcessed_not?: number;
  recordsProcessed_in?: Array<number>;
  recordsProcessed_not_in?: Array<number>;
  recordsProcessed_gt?: number;
  recordsProcessed_not_gt?: number;
  recordsProcessed_gte?: number;
  recordsProcessed_not_gte?: number;
  recordsProcessed_lt?: number;
  recordsProcessed_not_lt?: number;
  recordsProcessed_lte?: number;
  recordsProcessed_not_lte?: number;
  recordsFailed?: number;
  recordsFailed_not?: number;
  recordsFailed_in?: Array<number>;
  recordsFailed_not_in?: Array<number>;
  recordsFailed_gt?: number;
  recordsFailed_not_gt?: number;
  recordsFailed_gte?: number;
  recordsFailed_not_gte?: number;
  recordsFailed_lt?: number;
  recordsFailed_not_lt?: number;
  recordsFailed_lte?: number;
  recordsFailed_not_lte?: number;
  createdBy?: string;
  createdBy_not?: string;
  createdBy_contains?: string;
  createdBy_not_contains?: string;
  createdBy_starts_with?: string;
  createdBy_not_starts_with?: string;
  createdBy_ends_with?: string;
  createdBy_not_ends_with?: string;
  createdBy_in?: Array<string>;
  createdBy_not_in?: Array<string>;
  createdAt?: DateTime;
  createdAt_not?: DateTime;
  createdAt_in?: Array<DateTime>;
  createdAt_not_in?: Array<DateTime>;
  createdAt_gt?: DateTime;
  createdAt_not_gt?: DateTime;
  createdAt_gte?: DateTime;
  createdAt_not_gte?: DateTime;
  createdAt_lt?: DateTime;
  createdAt_not_lt?: DateTime;
  createdAt_lte?: DateTime;
  createdAt_not_lte?: DateTime;
  items_some?: ImportItemFilter;
  items_none?: ImportItemFilter;
  items_all?: ImportItemFilter;
  items_any?: boolean;
  files_some?: ImportFileFilter;
  files_none?: ImportFileFilter;
  files_all?: ImportFileFilter;
  files_any?: boolean;
}

export enum ImportJobStatus {
  AWAITING_FILES = 'AWAITING_FILES',
  CREATING_ITEMS = 'CREATING_ITEMS',
  PROCESSING_ITEMS = 'PROCESSING_ITEMS',
  FAILED = 'FAILED',
  COMPLETE = 'COMPLETE'
}

export enum ImportJobVariant {
  CSV = 'CSV'
}

export interface ImportItemFilter {
  AND?: Array<ImportItemFilter>;
  OR?: Array<ImportItemFilter>;
  id?: string;
  id_not?: string;
  id_in?: Array<string>;
  id_not_in?: Array<string>;
  id_gt?: string;
  id_not_gt?: string;
  id_gte?: string;
  id_not_gte?: string;
  id_lt?: string;
  id_not_lt?: string;
  id_lte?: string;
  id_not_lte?: string;
  sourceFileId?: string;
  sourceFileId_not?: string;
  sourceFileId_in?: Array<string>;
  sourceFileId_not_in?: Array<string>;
  sourceFileId_gt?: string;
  sourceFileId_not_gt?: string;
  sourceFileId_gte?: string;
  sourceFileId_not_gte?: string;
  sourceFileId_lt?: string;
  sourceFileId_not_lt?: string;
  sourceFileId_lte?: string;
  sourceFileId_not_lte?: string;
  rowNumber?: number;
  rowNumber_not?: number;
  rowNumber_in?: Array<number | null>;
  rowNumber_not_in?: Array<number | null>;
  rowNumber_gt?: number;
  rowNumber_not_gt?: number;
  rowNumber_gte?: number;
  rowNumber_not_gte?: number;
  rowNumber_lt?: number;
  rowNumber_not_lt?: number;
  rowNumber_lte?: number;
  rowNumber_not_lte?: number;
  rowData?: string;
  rowData_not?: string;
  rowData_contains?: string;
  rowData_not_contains?: string;
  rowData_starts_with?: string;
  rowData_not_starts_with?: string;
  rowData_ends_with?: string;
  rowData_not_ends_with?: string;
  rowData_in?: Array<string | null>;
  rowData_not_in?: Array<string | null>;
  objectData?: string;
  objectData_not?: string;
  objectData_contains?: string;
  objectData_not_contains?: string;
  objectData_starts_with?: string;
  objectData_not_starts_with?: string;
  objectData_ends_with?: string;
  objectData_not_ends_with?: string;
  objectData_in?: Array<string | null>;
  objectData_not_in?: Array<string | null>;
  errors?: string;
  errors_not?: string;
  errors_contains?: string;
  errors_not_contains?: string;
  errors_starts_with?: string;
  errors_not_starts_with?: string;
  errors_ends_with?: string;
  errors_not_ends_with?: string;
  errors_in?: Array<string | null>;
  errors_not_in?: Array<string | null>;
  status?: ImportItemStatus;
  status_not?: ImportItemStatus;
  status_in?: Array<ImportItemStatus>;
  status_not_in?: Array<ImportItemStatus>;
  status_gt?: ImportItemStatus;
  status_not_gt?: ImportItemStatus;
  status_gte?: ImportItemStatus;
  status_not_gte?: ImportItemStatus;
  status_lt?: ImportItemStatus;
  status_not_lt?: ImportItemStatus;
  status_lte?: ImportItemStatus;
  status_not_lte?: ImportItemStatus;
  createdBy?: string;
  createdBy_not?: string;
  createdBy_contains?: string;
  createdBy_not_contains?: string;
  createdBy_starts_with?: string;
  createdBy_not_starts_with?: string;
  createdBy_ends_with?: string;
  createdBy_not_ends_with?: string;
  createdBy_in?: Array<string>;
  createdBy_not_in?: Array<string>;
  createdAt?: DateTime;
  createdAt_not?: DateTime;
  createdAt_in?: Array<DateTime>;
  createdAt_not_in?: Array<DateTime>;
  createdAt_gt?: DateTime;
  createdAt_not_gt?: DateTime;
  createdAt_gte?: DateTime;
  createdAt_not_gte?: DateTime;
  createdAt_lt?: DateTime;
  createdAt_not_lt?: DateTime;
  createdAt_lte?: DateTime;
  createdAt_not_lte?: DateTime;
  importJobId?: string;
  importJobId_not?: string;
  importJobId_in?: Array<string>;
  importJobId_not_in?: Array<string>;
  importJobId_gt?: string;
  importJobId_not_gt?: string;
  importJobId_gte?: string;
  importJobId_not_gte?: string;
  importJobId_lt?: string;
  importJobId_not_lt?: string;
  importJobId_lte?: string;
  importJobId_not_lte?: string;
  importJob?: ImportJobFilter;
}

export enum ImportItemStatus {
  AWAITING_PROCESSING = 'AWAITING_PROCESSING',
  AWAITING_USER_ACTION = 'AWAITING_USER_ACTION',
  IMPORTED = 'IMPORTED',
  DISCARDED = 'DISCARDED'
}

export interface ImportFileFilter {
  AND?: Array<ImportFileFilter>;
  OR?: Array<ImportFileFilter>;
  id?: string;
  id_not?: string;
  id_in?: Array<string>;
  id_not_in?: Array<string>;
  id_gt?: string;
  id_not_gt?: string;
  id_gte?: string;
  id_not_gte?: string;
  id_lt?: string;
  id_not_lt?: string;
  id_lte?: string;
  id_not_lte?: string;
  fileName?: string;
  fileName_not?: string;
  fileName_contains?: string;
  fileName_not_contains?: string;
  fileName_starts_with?: string;
  fileName_not_starts_with?: string;
  fileName_ends_with?: string;
  fileName_not_ends_with?: string;
  fileName_in?: Array<string>;
  fileName_not_in?: Array<string>;
  contentType?: string;
  contentType_not?: string;
  contentType_contains?: string;
  contentType_not_contains?: string;
  contentType_starts_with?: string;
  contentType_not_starts_with?: string;
  contentType_ends_with?: string;
  contentType_not_ends_with?: string;
  contentType_in?: Array<string>;
  contentType_not_in?: Array<string>;
  contentMd5Checksum?: string;
  contentMd5Checksum_not?: string;
  contentMd5Checksum_contains?: string;
  contentMd5Checksum_not_contains?: string;
  contentMd5Checksum_starts_with?: string;
  contentMd5Checksum_not_starts_with?: string;
  contentMd5Checksum_ends_with?: string;
  contentMd5Checksum_not_ends_with?: string;
  contentMd5Checksum_in?: Array<string>;
  contentMd5Checksum_not_in?: Array<string>;
  contentLength?: number;
  contentLength_not?: number;
  contentLength_in?: Array<number | null>;
  contentLength_not_in?: Array<number | null>;
  contentLength_gt?: number;
  contentLength_not_gt?: number;
  contentLength_gte?: number;
  contentLength_not_gte?: number;
  contentLength_lt?: number;
  contentLength_not_lt?: number;
  contentLength_lte?: number;
  contentLength_not_lte?: number;
  received?: boolean;
  received_not?: boolean;
  createdBy?: string;
  createdBy_not?: string;
  createdBy_contains?: string;
  createdBy_not_contains?: string;
  createdBy_starts_with?: string;
  createdBy_not_starts_with?: string;
  createdBy_ends_with?: string;
  createdBy_not_ends_with?: string;
  createdBy_in?: Array<string>;
  createdBy_not_in?: Array<string>;
  createdAt?: DateTime;
  createdAt_not?: DateTime;
  createdAt_in?: Array<DateTime>;
  createdAt_not_in?: Array<DateTime>;
  createdAt_gt?: DateTime;
  createdAt_not_gt?: DateTime;
  createdAt_gte?: DateTime;
  createdAt_not_gte?: DateTime;
  createdAt_lt?: DateTime;
  createdAt_not_lt?: DateTime;
  createdAt_lte?: DateTime;
  createdAt_not_lte?: DateTime;
  importJobId?: string;
  importJobId_not?: string;
  importJobId_in?: Array<string>;
  importJobId_not_in?: Array<string>;
  importJobId_gt?: string;
  importJobId_not_gt?: string;
  importJobId_gte?: string;
  importJobId_not_gte?: string;
  importJobId_lt?: string;
  importJobId_not_lt?: string;
  importJobId_lte?: string;
  importJobId_not_lte?: string;
  importJob?: ImportJobFilter;
  infectedFileStatus?: InfectedFileStatus;
  infectedFileStatus_not?: InfectedFileStatus;
  infectedFileStatus_in?: Array<InfectedFileStatus>;
  infectedFileStatus_not_in?: Array<InfectedFileStatus>;
  infectedFileStatus_gt?: InfectedFileStatus;
  infectedFileStatus_not_gt?: InfectedFileStatus;
  infectedFileStatus_gte?: InfectedFileStatus;
  infectedFileStatus_not_gte?: InfectedFileStatus;
  infectedFileStatus_lt?: InfectedFileStatus;
  infectedFileStatus_not_lt?: InfectedFileStatus;
  infectedFileStatus_lte?: InfectedFileStatus;
  infectedFileStatus_not_lte?: InfectedFileStatus;
  excludeFilenameFromMetadata?: boolean;
  excludeFilenameFromMetadata_not?: boolean;
}

/**
 * A connection to a list of items.
 */
export interface ImportJobsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ImportJobsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ImportJob | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ImportJobsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: ImportJob;
}

export interface ImportJob {
  createdAt: DateTime;
  errors?: Array<string | null>;
  files: Array<ImportFile | null>;
  id: string;
  items?: Array<ImportItem>;
  recordsFailed?: number;
  recordsProcessed?: number;
  status?: ImportJobStatus;
}

export interface ImportFile {
  contentMd5Checksum: string;
  contentType: string;
  
  /**
   * The download link for the Import File
   */
  downloadPresignedUrl?: string;
  fileName: string;
  id: string;
  received: boolean;
  
  /**
   * The link to upload the Import File.
   */
  uploadPresignedUrl?: string;
}

export interface ImportItem {
  errors?: Array<string | null>;
  rowNumber?: number;
}

/**
 * A connection to a list of items.
 */
export interface ImportJobsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ImportJobsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ImportJob | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ImportJobsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: ImportJob;
}

/**
 * Sort options for the Bank Invoice type.
 */
export interface BankInvoiceSort {
  createdAt?: SortOperationKind;
  depositReferenceNumber?: SortOperationKind;
  stripeInvoiceStatus?: SortOperationKind;
}

/**
 * Filters for the BankInvoice type.
 */
export interface BankInvoiceFilter {
  AND?: Array<BankInvoiceFilter>;
  OR?: Array<BankInvoiceFilter>;
  id?: string;
  id_in?: Array<string>;
  depositReferenceNumber_contains?: string;
  depositReferenceNumber_starts_with?: string;
  depositReferenceNumber_ends_with?: string;
  stripeInvoiceStatus_contains?: string;
  stripeInvoiceStatus_starts_with?: string;
  stripeInvoiceStatus_ends_with?: string;
  stripeInvoiceStatus_not_contains?: string;
  draft?: BankDraftFilter;
}

/**
 * A connection to a list of items.
 */
export interface InvoicesForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<InvoicesForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankInvoice | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface InvoicesForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankInvoice;
}

/**
 * Details on a Invoice, relevant to the Bank Portal.
 */
export interface BankInvoice {
  canGenerateHostedInvoice: boolean;
  createdAt: DateTime;
  depositReferenceNumber: string;
  
  /**
   * Draft relevant to the invoice
   */
  draft: Draft;
  draftId: string;
  hostedInvoiceAttachmentId?: string;
  hostedReceiptAttachmentId?: string;
  id: string;
  invoicePaymentIntents?: Array<InvoicePaymentIntent | null>;
  stripeInvoiceHostedUrl?: string;
  stripeInvoiceId: string;
  stripeInvoicePdf?: string;
  stripeInvoiceStatus?: string;
  stripeReceiptUrl?: string;
  
  /**
   * The amount that will be charged per subscription, exclusive of any once-off fees in the initial invoice; Will be 0 for once-off invoices; NOTE: for historical records (created prior to ~December 2025), this will be 0
   */
  sumSubscriptionAmount?: Decimal;
  total?: Decimal;
}

export interface ChartLifetimeProjectedValueDetails {
  lifetimeAmount: Decimal;
}

export interface BankAsset {
  assetType: BankAssetType;
  name: string;
}

/**
 * A User Profile record, capturing details of someone who has registered to use the system.
 */
export interface Profile {
  
  /**
   * The physical address of the user. Max Length 255.
   */
  address?: string;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The email address of the user. Required. Max Length 255.
   */
  email: string;
  
  /**
   * The Family name (surname) of the user. Required. Max Length 255.
   */
  familyName: string;
  
  /**
   * The Given (First) name of the user. Required. Max Length 255.
   */
  givenName: string;
  
  /**
   * The ID for the User
   */
  id: string;
  
  /**
   * The industry of the user. Max Length 255.
   */
  industry?: string;
  
  /**
   * The hash of the users email address for Intercom identity verification.
   */
  intercomIdentityEmailHash: string;
  
  /**
   * The current users pending Invitations.
   */
  invitations?: InvitationsConnection;
  
  /**
   * The job title of the user. Max Length 255.
   */
  jobTitle?: string;
  
  /**
   * The locale (which assists in language detection) of the user. Max Length 255.
   */
  locale?: string;
  
  /**
   * The phone number of the user. Max Length 255.
   */
  phoneNumber?: string;
  
  /**
   * The referralCode of the Member that referred this user (via the referral portal feature)
   */
  referralPortalReferrerMemberCode?: string;
  
  /**
   * The referralCode of the organisation that referred this user (via the organisation-to-organisation referral feature)
   */
  referrerCode?: string;
  
  /**
   * Whether Terms will need to be manually accepted after the next login
   */
  requireTermsAcceptance: boolean;
  
  /**
   * The timezone (which assists in clock/date correction) of the user. Max Length 255.
   */
  timezone?: string;
  
  /**
   * The datetime when the user last viewed the platform updates notification
   */
  updatesNotifiedAt?: DateTime;
}

/**
 * Filters for the Invitation type.
 */
export interface InvitationFilter {
  AND?: Array<InvitationFilter>;
  OR?: Array<InvitationFilter>;
  code?: string;
  code_in?: Array<string>;
}

/**
 * A connection to a list of items.
 */
export interface InvitationsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<InvitationsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<OrganisationInvitation | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface InvitationsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: OrganisationInvitation;
}

/**
 * Details on an Invitation to an Organisation
 */
export interface OrganisationInvitation {
  
  /**
   * The Invitation Code, used to accept the invitation.
   */
  code: string;
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The name of the person who sent the invite.
   */
  invitedBy: string;
  
  /**
   * The name of the Organisation the user was invited to.
   */
  invitedTo?: string;
  
  /**
   * The ID of the Organisation that the Invitation belongs to. Required.
   */
  organisationId: string;
  
  /**
   * The Role the Member will have if they accept the invite.
   */
  role?: MemberRole;
}

/**
 * A connection to a list of items.
 */
export interface OrganisationsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<OrganisationsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Organisation | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface OrganisationsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: Organisation;
}

export interface ProductSummary {
  feeSummary: FeeSummary;
  productDiscount?: ProductDiscount;
  referralDiscount?: ReferralDiscount;
}

export interface ProductDiscount {
  channelPartnerId?: string;
  discountLabel: string;
  discountProviderType: DiscountProviderType;
  discountType: DiscountType;
  providerName: string;
  value: Decimal;
}

export enum DiscountProviderType {
  ASSURO = 'ASSURO',
  CHANNEL_PARTNER = 'CHANNEL_PARTNER'
}

export enum DiscountType {
  ESTABLISHMENT_FEE_AMOUNT = 'ESTABLISHMENT_FEE_AMOUNT',
  ONGOING_PERCENTAGE = 'ONGOING_PERCENTAGE'
}

export interface ReferralConfiguration {
  refereeDiscountAmountInDollars: number;
  referrerDiscountAmountInDollars: number;
}

export interface ReferralCommissionTier {
  commissionAmount: Decimal;
  minValue: number;
}

export interface DealSortInput {
  id?: SortEnumType;
  createdAt?: SortEnumType;
  draftId?: SortEnumType;
  entityId?: SortEnumType;
  referralPortalMemberId?: SortEnumType;
  commissionAmount?: SortEnumType;
}

export interface DealFilterInput {
  and?: Array<DealFilterInput>;
  or?: Array<DealFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  createdAt?: ComparableDateTimeOffsetOperationFilterInput;
  draftId?: ComparableGuidOperationFilterInput;
  entityId?: ComparableGuidOperationFilterInput;
  referralPortalMemberId?: ComparableNullableOfGuidOperationFilterInput;
  commissionAmount?: ComparableDecimalOperationFilterInput;
}

/**
 * A connection to a list of items.
 */
export interface ReferralPortalDealsConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ReferralPortalDealsEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Deal>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ReferralPortalDealsEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: Deal;
}

export interface EntitySortInput {
  id?: SortEnumType;
  entityType?: SortEnumType;
  createdAt?: SortEnumType;
  parentEntityId?: SortEnumType;
  name?: SortEnumType;
  email?: SortEnumType;
  abn?: SortEnumType;
  contactPerson?: SortEnumType;
  bankingBsbNumber?: SortEnumType;
  bankingAccountNumber?: SortEnumType;
  phone?: SortEnumType;
  relationshipManagerId?: SortEnumType;
}

export interface EntityFilterInput {
  and?: Array<EntityFilterInput>;
  or?: Array<EntityFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  entityType?: EntityTypeOperationFilterInput;
  createdAt?: ComparableDateTimeOffsetOperationFilterInput;
  parentEntityId?: ComparableNullableOfGuidOperationFilterInput;
  name?: StringOperationFilterInput;
  email?: StringOperationFilterInput;
  abn?: StringOperationFilterInput;
  contactPerson?: StringOperationFilterInput;
  bankingBsbNumber?: StringOperationFilterInput;
  bankingAccountNumber?: StringOperationFilterInput;
  phone?: StringOperationFilterInput;
  relationshipManagerId?: ComparableNullableOfGuidOperationFilterInput;
}

export interface EntityTypeOperationFilterInput {
  eq?: EntityType;
  neq?: EntityType;
  in?: Array<EntityType>;
  nin?: Array<EntityType>;
}

/**
 * A connection to a list of items.
 */
export interface ReferralPortalEntitiesConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ReferralPortalEntitiesEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Entity>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ReferralPortalEntitiesEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: Entity;
}

/**
 * A connection to a list of items.
 */
export interface ReferralPortalEntitiesForClientPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ReferralPortalEntitiesForClientPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<Entity>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ReferralPortalEntitiesForClientPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: Entity;
}

export interface ReferralPortalMemberSortInput {
  id?: SortEnumType;
  cognitoUser_Username?: SortEnumType;
  entityId?: SortEnumType;
  name?: SortEnumType;
  surname?: SortEnumType;
  mobilePhone?: SortEnumType;
  email?: SortEnumType;
  position?: SortEnumType;
  referClientCode?: SortEnumType;
  status?: SortEnumType;
  entity?: EntitySortInput;
}

export interface ReferralPortalMemberFilterInput {
  and?: Array<ReferralPortalMemberFilterInput>;
  or?: Array<ReferralPortalMemberFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  cognitoUser_Username?: ComparableNullableOfGuidOperationFilterInput;
  entityId?: ComparableGuidOperationFilterInput;
  name?: StringOperationFilterInput;
  surname?: StringOperationFilterInput;
  mobilePhone?: StringOperationFilterInput;
  email?: StringOperationFilterInput;
  position?: StringOperationFilterInput;
  referClientCode?: StringOperationFilterInput;
  status?: MemberStatusOperationFilterInput;
  entity?: EntityFilterInput;
}

export interface MemberStatusOperationFilterInput {
  eq?: MemberStatus;
  neq?: MemberStatus;
  in?: Array<MemberStatus>;
  nin?: Array<MemberStatus>;
}

/**
 * A connection to a list of items.
 */
export interface ReferralPortalMembersConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<ReferralPortalMembersEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ReferralPortalMember>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface ReferralPortalMembersEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: ReferralPortalMember;
}

/**
 * A connection to a list of items.
 */
export interface SearchOrganisationMembersConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<SearchOrganisationMembersEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<OrganisationMember | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface SearchOrganisationMembersEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: OrganisationMember;
}

/**
 * Details on an Organisation Member
 */
export interface OrganisationMember {
  
  /**
   * The date stamp the record was created. Required.
   */
  createdAt: DateTime;
  
  /**
   * The Family name (surname) of the user. Max Length 255.
   */
  familyName?: string;
  
  /**
   * The Given (First) name of the user. Max Length 255.
   */
  givenName?: string;
  
  /**
   * The ID for the Organisation Member.
   */
  memberId: string;
  
  /**
   * The Role of the Member. Determines level of access to Organisation and Documents.
   */
  role?: MemberRole;
  
  /**
   * The User ID of the Member. Required. GUID.
   */
  userId: string;
}

/**
 * A connection to a list of items.
 */
export interface SearchOrganisationsForMembersForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<SearchOrganisationsForMembersForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<BankOrganisation | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface SearchOrganisationsForMembersForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node?: BankOrganisation;
}

export interface ReferenceDataType {
  description: string;
  id: number;
  key: string;
}

export interface ChartTotalActiveDetails {
  activeAmount: Decimal;
  activeClientsNumber: number;
  activeDocumentsNumber: number;
  totalAmount: Decimal;
  totalClientsNumber: number;
  totalDocumentsNumber: number;
}

export interface SubmissionValidationResult {
  errorLevel: ErrorLevel;
  message: string;
}

export enum ErrorLevel {
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

export interface ApiWebhookResultSortInput {
  id?: SortEnumType;
  requestType?: SortEnumType;
  originationId?: SortEnumType;
  responseCode?: SortEnumType;
  responseData?: SortEnumType;
  requestData?: SortEnumType;
  createdAt?: SortEnumType;
}

export interface ApiWebhookResultFilterInput {
  and?: Array<ApiWebhookResultFilterInput>;
  or?: Array<ApiWebhookResultFilterInput>;
  id?: ComparableGuidOperationFilterInput;
  requestType?: StringOperationFilterInput;
  originationId?: ComparableGuidOperationFilterInput;
  responseCode?: ComparableInt32OperationFilterInput;
  responseData?: StringOperationFilterInput;
  requestData?: StringOperationFilterInput;
  createdAt?: ComparableDateTimeOffsetOperationFilterInput;
}

export interface ComparableInt32OperationFilterInput {
  eq?: number;
  neq?: number;
  in?: Array<number>;
  nin?: Array<number>;
  gt?: number;
  ngt?: number;
  gte?: number;
  ngte?: number;
  lt?: number;
  nlt?: number;
  lte?: number;
  nlte?: number;
}

/**
 * A connection to a list of items.
 */
export interface WebhookResultsForBankPortalConnection {
  
  /**
   * A list of edges.
   */
  edges?: Array<WebhookResultsForBankPortalEdge>;
  
  /**
   * A flattened list of the nodes.
   */
  nodes?: Array<ApiWebhookResult>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: PageInfo;
  totalCount: number;
}

/**
 * An edge in a connection.
 */
export interface WebhookResultsForBankPortalEdge {
  
  /**
   * A cursor for use in pagination.
   */
  cursor: string;
  
  /**
   * The item at the end of the edge.
   */
  node: ApiWebhookResult;
}

export interface ApiWebhookResult {
  createdAt: DateTime;
  id: string;
  originationId: string;
  requestData: string;
  requestType: string;
  responseCode: number;
  responseData?: string;
}

export interface Mutation {
  
  /**
   * Operation to accept an Invitation to an Organisation.
   */
  acceptInvitation?: AcceptInvitationPayload;
  
  /**
   * Endpoint for a Client to either Approve/Reject a RequiredDocument (based on a message version linked to an attachmentId)
   * Must meet the relative rules to be able to perform this action succesfully
   */
  actionRequiredDocumentMessage: RequiredDocumentMessage;
  
  /**
   * Endpoint for an Admin to either Approve/Reject a RequiredDocument (based on a message version linked to an attachmentId)
   * Must meet the relative rules to be able to perform this action succesfully
   */
  actionRequiredDocumentMessageForBankPortal: RequiredDocumentMessage;
  addChannelPartnerForBankPortal: MutateChannelPartnerPayload;
  
  /**
   * Operation to amend an existing Document.
   */
  amendDocument?: AmendDocumentPayload;
  
  /**
   * Operation to mark a Draft as SUBMISSION_STARTED.
   */
  beginDraftSubmission?: BeginDraftSubmissionPayload;
  
  /**
   * Operation to cancel a Draft.
   */
  cancelDraft?: CancelDraftPayload;
  
  /**
   * Operation to mark a Draft as DRAFT from SUBMISSION_STARTED.
   */
  cancelDraftSubmission?: CancelDraftSubmissionPayload;
  
  /**
   * Operation to change the status of a facility application.
   */
  changeFacilityApplicationStatus: ChangeFacilityApplicationStatusPayload;
  
  /**
   * Operation to change the role of the Member of an Organisation.
   */
  changeMemberRole?: ChangeMemberRolePayload;
  clientNotInterestedInFinance: boolean;
  cognitoAddBankUser: CognitoPayload;
  cognitoDeleteBankUser: CognitoPayload;
  cognitoResyncBankUser: CognitoPayload;
  cognitoUpdateAuthenticatedBankUser: CognitoPayload;
  cognitoUpdateBankUser: CognitoPayload;
  
  /**
   * Operation to complete a Bank Guarantee Draft's submission.
   */
  completeDraftSubmission?: CompleteDraftSubmissionPayload;
  
  /**
   * Operation for the client to submit/complete an existing Identification.
   */
  completeIdentification?: UpdateIdentificationPayload;
  
  /**
   * Operation to complete a Surety Bond Draft's submission, and send it to the supplier.
   */
  completeSuretyBondDraftSubmission?: CompleteDraftSubmissionPayload;
  
  /**
   * Operation to confirm the receipt of a Document handover
   */
  confirmDocumentHandover?: ConfirmDocumentHandoverPayload;
  
  /**
   * Operation to update an existing Document Facility.
   */
  convertDocumentFacilityForBankPortal?: ConvertDocumentFacilityForBankPortalPayload;
  
  /**
   * Copy and create a new draft
   */
  copyDraftForBankPortal?: Draft;
  
  /**
   * Operation to add a comment to a Document.
   */
  createComment?: CreateCommentPayload;
  
  /**
   * Operation to create a new Document.
   */
  createDocument?: CreateDocumentPayload;
  
  /**
   * Operation to create a new Document Attachment.
   */
  createDocumentAttachment?: CreateDocumentAttachmentPayload;
  
  /**
   * Operation to create a new Document Collaborator.
   */
  createDocumentCollaborator?: CreateDocumentCollaboratorPayload;
  
  /**
   * Operation to create a new Document Facility.
   */
  createDocumentFacility?: CreateDocumentFacilityPayload;
  
  /**
   * Operation to create a request for Document handover.
   */
  createDocumentHandover?: CreateDocumentHandoverPayload;
  
  /**
   * Operation to add an item of Metadata to a Document.
   */
  createDocumentMetadata?: CreateDocumentMetadataPayload;
  
  /**
   * Operation to create a request for return for Document.
   */
  createDocumentRequestForReturn?: CreateDocumentRequestForReturnPayload;
  
  /**
   * Operation to create a new Draft.
   */
  createDraft?: CreateDraftPayload;
  
  /**
   * Operation to create a new Draft Attachment.
   */
  createDraftAttachment?: CreateDraftAttachmentPayload;
  
  /**
   * Operation to create a new Draft Attachment.
   */
  createDraftAttachmentForBankPortal?: CreateDraftAttachmentPayload;
  
  /**
   * Operation to create a new BG Switch Draft.
   */
  createDraftBGSwitch?: CreateDraftBGSwitchPayload;
  
  /**
   * Operation to create a new Draft Collaborator.
   */
  createDraftCollaborator?: CreateDraftCollaboratorPayload;
  
  /**
   * Operation to add a comment to a Document.
   */
  createDraftComment?: CreateDraftCommentPayload;
  
  /**
   * Operation to create a new Draft from Origination.
   */
  createDraftFromOrigination?: CreateDraftFromOriginationPayload;
  
  /**
   * Operation to add a facility application
   */
  createFacilityApplication?: CreateFacilityApplicationPayload;
  
  /**
   * Operation to add an attachment to an existing facility application
   */
  createFacilityApplicationAttachment?: CreateFacilityApplicationAttachmentPayload;
  createFinanceEnquiry: FinanceEnquiry;
  createFinanceRecordForBankPortal: FinanceRecord;
  
  /**
   * Operation to create a Document Import Job.
   */
  createImportJob?: CreateImportJobPayload;
  
  /**
   * Operation to create a bank asset (e.g. Assuro Agency Agreement/Product Template/etc)
   */
  createOrReplaceBankAsset: string;
  
  /**
   * Operation to create or update a Fee Summary
   */
  createOrUpdateFeeSummary?: CreateOrUpdateFeeSummaryPayload;
  
  /**
   * Operation to create or update a Supplier
   */
  createOrUpdateSupplier?: CreateOrUpdateSupplierPayload;
  
  /**
   * Operation to create a new Organisation.
   */
  createOrganisation?: CreateOrganisationPayload;
  
  /**
   * Operation to add an Organisation level Alert Configuration.
   */
  createOrganisationAlertConfiguration?: CreateOrganisationAlertConfigurationPayload;
  
  /**
   * Operation to add an item of Document Metadata to an Organisation.
   */
  createOrganisationDocumentMetadata?: CreateOrganisationDocumentMetadataPayload;
  
  /**
   * Responsible to create a new "required document" flow, with an initial message to the client
   */
  createRequiredDocumentForBankPortal: RequiredDocument;
  createRequiredDocumentMessage: RequiredDocumentMessage;
  
  /**
   * Responsible to create a new message as part of an existing "required document" flow
   * Can contain a message and attachmentId
   */
  createRequiredDocumentMessageForBankPortal: RequiredDocumentMessage;
  
  /**
   * Operation to create a new simple Kyc application based on existing Identification.
   */
  createSimpleKycDataByIdentificationIdForBankPortal?: CreateSimpleKycDataPayload;
  
  /**
   * Operation to delete a bank asset (e.g. Assuro Agency Agreement/Product Template/etc)
   */
  deleteBankAsset: string;
  deleteFinanceRecordFromBankPortal: FinanceRecord;
  editFinanceRecordForBankPortal: FinanceRecord;
  
  /**
   * Operation to establish a draft.
   */
  establishDraft?: DraftEstablishPayload;
  
  /**
   * Operation to establish a Surety Bond draft.
   */
  establishSuretyBondDraft?: DraftEstablishPayload;
  
  /**
   * Operation to update overlooked AddressV2 in Documents. Draft -&gt; Document only copied the string address, resulting in no address for beneficiaries.
   */
  fixAddressV2: Array<string>;
  generateDocumentReport?: Report;
  
  /**
   * Operation to create a new verification link and SMS to an indidual being identified
   */
  generateNewIndividualVerificationUrl?: IdentificationIndividual;
  
  /**
   * Operation to re-generate stripe Subscription with a new invoice for a Bank Guarantee Draft.
   */
  generateNewStripeSubscription?: GenerateNewStripeSubscriptionPayload;
  
  /**
   * Bank Portal - Operation to re-generate stripe Subscription with a new invoice for a Bank Guarantee Draft.
   */
  generateNewStripeSubscriptionForBankPortal?: BankGenerateNewStripeSubscriptionPayload;
  
  /**
   * Operation to import all existing simple kyc from Api.
   */
  importAllExistingSimpleKycApplications?: ImportExistingSimpleKycDataPayload;
  
  /**
   * Invalidates the cache for all dynamic content maintained by the AssetService
   * 
   * 
   * **Returns:**
   * The list of keys that were deleted from the cache
   */
  invalidateAssetCache: Array<string>;
  onceOffDocumentDescriptionMigration: Array<MigrateAllDescriptionsResult>;
  
  /**
   * Just-in-time migration of the description property
   */
  onceOffDraftDescriptionMigration?: Array<MigrateAllDescriptionsResult | null>;
  
  /**
   * Operation to opt in an organisation to Document Facilities.
   */
  optInOrganisationToDocumentFacilities?: OptInOrganisationToDocumentFacilitiesPayload;
  
  /**
   * Operation to prefill Identification data from SimpleKyc.
   */
  prefillIdentification?: PrefillIdentificationPayload;
  
  /**
   * Specifies that terms have been explicitly accepted for the current user.
   */
  profileTermsAccepted?: ProfileTermsAcceptedPayload;
  
  /**
   * Operation to reactivate a cancelled subscription
   */
  reactivateSubscription?: string;
  reestablishBankDocument: BankDocumentUpdatePayload;
  referralPortalCreateEntity: Entity;
  referralPortalCreateMember: ReferralPortalMember;
  referralPortalDeleteMember: ReferralPortalMember;
  referralPortalResendInvitation: boolean;
  referralPortalSetOrganisationAssociation: OrganisationAssociation;
  referralPortalUpdateEntity: Entity;
  referralPortalUpdateMember: ReferralPortalMember;
  
  /**
   * Operation to reject a draft.
   */
  rejectDraft?: DraftRejectPayload;
  
  /**
   * Operation to remove an existing Document Attachment.
   */
  removeDocumentAttachment?: RemoveDocumentAttachmentPayload;
  
  /**
   * Operation to remove an existing Document Collaborator.
   */
  removeDocumentCollaborator?: RemoveDocumentCollaboratorPayload;
  
  /**
   * Operation to remove an existing request for Document handover.
   */
  removeDocumentHandover?: RemoveDocumentHandoverPayload;
  
  /**
   * Operation to remove an item of Metadata from a Document.
   */
  removeDocumentMetadata?: RemoveDocumentMetadataPayload;
  
  /**
   * Operation to remove an existing request for return for Document.
   */
  removeDocumentRequestForReturn?: RemoveDocumentRequestForReturnPayload;
  
  /**
   * Operation to remove an existing Draft Attachment.
   */
  removeDraftAttachment?: RemoveDraftAttachmentPayload;
  
  /**
   * Operation to remove an existing Draft Attachment from within the bank portal.
   */
  removeDraftAttachmentForBankPortal?: RemoveDraftAttachmentPayload;
  
  /**
   * Operation to remove an existing Draft Collaborator.
   */
  removeDraftCollaborator?: RemoveDraftCollaboratorPayload;
  
  /**
   * Operation to remove an attachment from an existing facility application
   */
  removeFacilityApplicationAttachment?: MutateFacilityApplicationPayload;
  
  /**
   * Operation to remove an Invitation to an Organisation.
   */
  removeInvitation?: RemoveInvitationPayload;
  
  /**
   * Operation to remove a Member from an Organisation.
   */
  removeMember?: RemoveMemberPayload;
  
  /**
   * Operation to remove a Member from an Organisation.
   */
  removeMemberForBankPortal?: RemoveMemberPayload;
  
  /**
   * Operation to remove an Invitation to an Organisation.
   */
  removeOrgMemberInvitationForBankPortal?: RemoveInvitationPayload;
  
  /**
   * Operation to remove an Organisation level Alert Configuration.
   */
  removeOrganisationAlertConfiguration?: RemoveOrganisationAlertConfigurationPayload;
  
  /**
   * Operation to remove an item of Document Metadata from an Organisation.
   */
  removeOrganisationDocumentMetadata?: RemoveOrganisationDocumentMetadataPayload;
  
  /**
   * Operation to request changes to a draft.
   */
  requestDraftChanges?: DraftRequestChangePayload;
  
  /**
   * Operation to request the payment for a draft.
   */
  requestDraftPayment?: DraftRequestPaymentPayload;
  
  /**
   * Resend invoices to additional recipients.
   */
  resendInvoices?: ResendAdditionalInvoicesPayload;
  resubmitReturnedGvpApplication: Array<SubmissionValidationResult>;
  
  /**
   * Operation to send an Invitation to an Organisation.
   */
  sendOrgMemberInvitation?: SendInvitationPayload;
  
  /**
   * Operation to send an Invitation to an Organisation.
   */
  sendOrgMemberInvitationForBankPortal?: SendInvitationPayload;
  setApplicationContactDetails?: ApplicationContactDetails;
  setApplicationContactDetailsForBankPortal?: ApplicationContactDetails;
  
  /**
   * Operation to set the Notification List for a Document.
   */
  setDocumentNotificationList?: SetDocumentNotificationListPayload;
  
  /**
   * Operation to Approve a Draft.
   */
  setDraftApprovalStatusForCollaborator?: SetDraftApprovalStatusForCollaboratorPayload;
  
  /**
   * Allows the draft to be made available to the supplier of the selected bank guarantee product.
   */
  setDraftAvailableToSupplier?: string;
  
  /**
   * Prevalidation of setDraftAvailableToSupplier
   */
  setDraftAvailableToSupplier_preValidation?: Array<SubmissionValidationResult | null>;
  
  /**
   * Operation to set the Notification List of a Collaborator for a Draft.
   */
  setDraftNotificationListForCollaborator?: SetDraftNotificationListForCollaboratorPayload;
  
  /**
   * Operation to set the state of a realtime author. State is only valid for 30 seconds.
   */
  setDraftRealtimeAuthorState?: SetDraftRealtimeAuthorStatePayload;
  
  /**
   * Allows the facility application to be made available to the supplier.
   */
  setFacilityApplicationAvailableToSupplier?: string;
  
  /**
   * Operation for suppliers to set their approval outcome of the application
   */
  setFacilityApplicationBankOutcome: FacilityApplication;
  setOrganisationGvpMetadata: OrganisationGvpMetadata;
  
  /**
   * Operation to extend an existing individual Draft Collaborator's access to an Organisation.
   */
  shareDraftToOrganisationFromCollaborator?: ShareDraftToOrganisationFromCollaboratorPayload;
  submitApplicationToGvp: Array<SubmissionValidationResult>;
  
  /**
   * Submit a facility application
   */
  submitFacilityApplication?: MutateFacilityApplicationPayload;
  updateBankDocument: BankDocumentUpdatePayload;
  updateChannelPartnerForBankPortal: MutateChannelPartnerPayload;
  
  /**
   * Operation to update an existing Document.
   */
  updateDocument?: UpdateDocumentPayload;
  
  /**
   * Operation to update an existing Document Facility.
   */
  updateDocumentFacility?: UpdateDocumentFacilityPayload;
  
  /**
   * Operation to update an existing Document Facility for Bank Portal.
   */
  updateDocumentFacilityForBankPortal?: UpdateDocumentFacilityPayload;
  
  /**
   * Operation to update an item of Metadata on a Document.
   */
  updateDocumentMetadata?: UpdateDocumentMetadataPayload;
  
  /**
   * Operation to update an existing Draft.
   */
  updateDraft?: UpdateDraftPayload;
  
  /**
   * Operation to update a BG Switch Draft.
   */
  updateDraftBGSwitch?: UpdateDraftBGSwitchPayload;
  
  /**
   * Operation to update a BG Switch Draft
   */
  updateDraftBGSwitchForBankPortal?: UpdateDraftBGSwitchPayload;
  
  /**
   * Operation to update an existing Draft Collaborator.
   */
  updateDraftCollaborator?: UpdateDraftCollaboratorPayload;
  
  /**
   * Updates the existing draft
   */
  updateDraftForBankPortal?: UpdateBankDraftPayload;
  updateDraftMegDetails?: string;
  
  /**
   * Operation to preview results of an update to an existing Draft.
   */
  updateDraftPreview?: UpdateDraftPreviewPayload;
  
  /**
   * Update a facility application
   */
  updateFacilityApplication?: MutateFacilityApplicationPayload;
  
  /**
   * Update a facility application
   */
  updateFacilityApplicationForBankPortal?: MutateFacilityApplicationPayload;
  
  /**
   * Update facility application payment status. Only applicable to PropertyBacked facility application.
   */
  updateFacilityApplicationPaymentStatus?: string;
  
  /**
   * Updates the existing Identification individual Green Id data
   */
  updateGreenId?: UpdateGreenIdPayload;
  
  /**
   * Updates the existing Identification individual Green Id data
   */
  updateGreenIdForBankPortal?: UpdateBankGreenIdPayload;
  
  /**
   * Operation to update an existing Identification.
   */
  updateIdentification?: UpdateIdentificationPayload;
  
  /**
   * Updates the existing Identification
   */
  updateIdentificationForBankPortal?: UpdateBankIdentificationPayload;
  
  /**
   * Updates the existing Identification RiskDetails
   */
  updateIdentificationRiskDetailsForBankPortal?: UpdateBankIdentificationRiskDetailsPayload;
  
  /**
   * Updates the timestamp when the user last saw the platform updates.
   */
  updateNotifiedAt?: UpdateNotifiedPayload;
  
  /**
   * Operation to update an existing Organisation.
   */
  updateOrganisation?: UpdateOrganisationPayload;
  
  /**
   * Operation to update an Organisation level Alert Configuration.
   */
  updateOrganisationAlertConfiguration?: UpdateOrganisationAlertConfigurationPayload;
  
  /**
   * Operation to update an existing Organisation.
   */
  updateOrganisationBankPortal?: UpdateBankOrganisationPayload;
  
  /**
   * Allows a user to change their profile details.
   */
  updateProfile?: UpdateProfilePayload;
  
  /**
   * Operation to update the new simple Kyc data from Api.
   */
  updateSimpleKycDataFromApi?: UpdateSimpleKycDataPayload;
  
  /**
   * Operation to update the new simple Kyc data from Api using Identification Id.
   */
  updateSimpleKycDataFromApiByIdentificationId?: UpdateSimpleKycDataAppPayload;
  
  /**
   * Operation to void organisation credit
   */
  voidOrganisationCredit?: OrganisationCredit;
}

/**
 * Details about an invitation to accept
 */
export interface AcceptInvitationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The code of the invitation to accept. Required. GUID format.
   */
  code: string;
}

/**
 * Details the result of the Accept Invitation operation.
 */
export interface AcceptInvitationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface ActionRequiredDocumentMessageInput {
  
  /**
   * An optional attachment associated with the approval/rejection 
   * NOTE: if specified, will be recorded in its own seperate message
   */
  attachmentId?: string;
  
  /**
   * An optional message/content associated with the approval/rejection
   */
  message?: string;
  outcome: RequiredDocumentApprovalInput;
  requiredDocumentId: string;
  
  /**
   * Passed in to provide the specific version/message that is being accepted
   * Referenced message must contain an attachmentId
   */
  requiredDocumentMessageId: string;
}

export enum RequiredDocumentApprovalInput {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export interface RequiredDocumentMessage {
  attachment: DraftAttachment;
  attachmentId?: string;
  createdByUserId?: string;
  dateCreated: DateTime;
  fromParty: RequiredDocumentMessageParty;
  hasApproval?: boolean;
  id: string;
  
  /**
   * 
   * @deprecated Please refer to the MessageType
   */
  isAutomatedMessage: boolean;
  message?: string;
  messageType: RequiredDocumentMessageType;
  
  /**
   * this link exists for 2 purposes:
   * 1. For approval/rejection MESSAGES to link back to the original MESSAGE/attachment that it is approved against
   * 2. For the front-end to be able to "group" MESSAGES within a requiredDocument together (based on product's designs)
   * if null, it means it is a root-level record
   */
  parentMessageId?: string;
  requiredDocument: RequiredDocument;
  requiredDocumentId: string;
}

export interface RequiredDocument {
  createdByAdminUserId: string;
  dateCreated: DateTime;
  draft: Draft;
  draftId: string;
  id: string;
  requiredDocumentMessages: Array<RequiredDocumentMessage>;
  requiredDocumentType: RequiredDocumentType;
}

export interface MutateChannelPartnerInput {
  active: boolean;
  apiKey?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  contactEmail?: string;
  discountPercentage: Decimal;
  establishmentFeeDiscountAmount: Decimal;
  isPublic: boolean;
  name: string;
  referralPercentage: Decimal;
  webhookUrl?: string;
}

export interface MutateChannelPartnerPayload {
  channelPartner: ChannelPartners;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about the Document to amend
 */
export interface AmendDocumentInput {
  
  /**
   * The new monetary value of the Document. Range 0-999999999.99. Do not provide this if it should not be changed
   */
  amount?: Decimal;
  
  /**
   * The name of the Financial Institution backing the Document. Max length 255. Do not provide this if it should not be changed.
   */
  bankName?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The new Agreement Content of the Document
   * This usually contains details on what the Document is covering, e.g. Installing new windows at a property. 
   * Max Length 1000
   * Do not provide this if it should not be changed
   */
  description?: string;
  
  /**
   * The date the Document was Established on. Do not provide this if it should not be changed
   */
  establishedAt?: DateTime;
  
  /**
   * The new date the Document expires. Do not provide this if it should not be changed
   */
  expiresAt?: Date;
  
  /**
   * The Document Number. This is provided by the financial institution that is backing the document. Max length 255. Do not provide this if it should not be changed
   */
  guaranteeNumber?: string;
  
  /**
   * The ID for the Document. Required.
   */
  id: string;
  
  /**
   * The parties to be created. Do not provide this if it should not be changed.
   */
  partyCreates?: Array<AmendDocumentCreatePartyInput>;
  
  /**
   * The parties to be deleted. Do not provide this if it should not be changed.
   */
  partyDeletes?: Array<AmendDocumentDeletePartyInput>;
  
  /**
   * The updated parties for the Document. Do not provide this if it should not be changed.
   */
  partyUpdates?: Array<AmendDocumentUpdatePartyInput>;
  
  /**
   * The Document's Reference Number. This is usually provided by the party raising the Document, as a Reference Number from their own system. Max length 255. Do not provide this if it should not be changed
   */
  referenceNumber?: string;
  
  /**
   * The type of the retention, only applicable to Cash Retention documents. Do not provide this if it should not be changed.
   */
  retentionType?: DocumentRetentionType;
  
  /**
   * The type of security. Max length 100. Do not provide this if it should not be changed.
   */
  securityType?: SecurityType;
}

/**
 * Details a Document Party to create, such as an Issuer or Beneficiary.
 */
export interface AmendDocumentCreatePartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit).
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 500.
   */
  address?: string;
  addressV2?: AddressInput;
  
  /**
   * The name of Party, most likely the company name. Required. Max length 1000.
   */
  name: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500.
   */
  notes?: string;
  
  /**
   * The type of the Party, e.g. Issuer or Beneficiary. Required.
   */
  partyVariant: PartyVariant;
}

/**
 * Details a Document Party to be deleted.
 */
export interface AmendDocumentDeletePartyInput {
  
  /**
   * The ID for the Party. Required.
   */
  id: string;
}

/**
 * Details updates to a Document Party, such as an Issuer or Beneficiary.
 */
export interface AmendDocumentUpdatePartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit). Do not provide this if it should not be changed.
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 500. Do not provide this if it should not be changed.
   */
  address?: string;
  addressV2?: AddressInput;
  
  /**
   * The ID for the Party. Required.
   */
  id: string;
  
  /**
   * The name of Party, most likely the company name. Max length 1000. Do not provide this if it should not be changed.
   */
  name: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500. Do not provide this if it should not be changed.
   */
  notes?: string;
}

/**
 * Details of the updated Document
 */
export interface AmendDocumentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Document
   */
  document?: Document;
}

/**
 * Details about the Draft to mark as starting submission
 */
export interface BeginDraftSubmissionInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation who is starting the submission.
   */
  organisationId: string;
}

/**
 * Details about the result of the operation to start the submission of a Draft
 */
export interface BeginDraftSubmissionPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  draft: Draft;
}

/**
 * Details about the Draft to update
 */
export interface CancelDraftInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID for the Draft. Required.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation that is executing the cancel. Required.
   */
  organisationId: string;
}

export interface CancelDraftPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft created
   */
  draft: Draft;
}

/**
 * Details about the Draft to cancel the submission, so it can be edited again
 */
export interface CancelDraftSubmissionInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation who is cancelling the submission.
   */
  organisationId: string;
}

/**
 * Details about the result of the operation to cancel the submission of a Draft
 */
export interface CancelDraftSubmissionPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details required to update a Facility Applications status.
 */
export interface ChangeFacilityApplicationStatusInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * Establishment details for the facility application, only used when status is being set to "ESTABLISHED".
   */
  establishmentDetails?: EstablishmentDetailsInput;
  
  /**
   * The ID of the facility application to update the status of
   */
  facilityApplicationId: string;
  
  /**
   * Send a notification email to the client.
   */
  shouldSendEmail?: boolean;
  
  /**
   * The new status for the facility application
   */
  status: FacilityApplicationStatus;
}

/**
 * Establishment details for a Facility Application
 */
export interface EstablishmentDetailsInput {
  
  /**
   * The recurring annual cost. Range 0-999999999.99.
   */
  annualCost?: Decimal;
  
  /**
   * The default recurring percentage cost for the bank fronted document. Range 0-100.00
   */
  bankFrontedBondsRecurringPercentageCost?: Decimal;
  
  /**
   * The default cost value required for setup for the bank fronted document. Range 0-999999999.99.
   */
  bankFrontedBondsSetUpCost?: Decimal;
  
  /**
   * The default recurring percentage cost for the document. Range 0-100.00
   */
  documentRecurringPercentageCost?: Decimal;
  
  /**
   * The default cost value required for setup for the document. Range 0-999999999.99.
   */
  documentSetUpCost?: Decimal;
  
  /**
   * The end date of the Facility. Required.
   */
  endDate: Date;
  
  /**
   * The name for the Facility. Max length 255.
   */
  facilityName: string;
  
  /**
   * The financial limit of the Facility. Required. Range 0-999999999.99.
   */
  limit: Decimal;
  
  /**
   * The premium recurring percentage cost for the bank fronted document. Range 0-100.00
   */
  premiumBankFrontedBondsRecurringPercentageCost?: Decimal;
  
  /**
   * The premium recurring percentage cost for the document. Range 0-100.00
   */
  premiumDocumentRecurringPercentageCost?: Decimal;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  setUpCost?: Decimal;
  
  /**
   * The start date of the Facility. Required.
   */
  startDate: Date;
}

/**
 * Result of a status change to a Facility Application
 */
export interface ChangeFacilityApplicationStatusPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated facility application
   */
  facilityApplication: FacilityApplication;
}

/**
 * Details about a Change Member Role operation
 */
export interface ChangeMemberRoleInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The new Role for the member. Required.
   */
  newRole: MemberRole;
  
  /**
   * The ID of the Organisation that the Member belongs to. Required.
   */
  organisationId: string;
  
  /**
   * The User ID of the Member. Required. GUID.
   */
  userId: string;
}

/**
 * Details the result of the Change Member Role operation.
 */
export interface ChangeMemberRolePayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Member with the changed Role
   */
  member?: Member;
}

export interface CognitoUserInput {
  clientMutationId: string;
  emailAddress: string;
  firstName: string;
  isSmsMfaRequired: boolean;
  lastName: string;
  phoneNumber: string;
  supplierId?: string;
  userName?: string;
  
  /**
   * NOTE: each account can be tied to multiple roles (e.g. Alec is C.O.O, but can also be added to the list of relationship managers)
   *       if a record has no "specialized" role, the value should just be set to null
   */
  userRoles: Array<string>;
}

export interface CognitoPayload {
  clientMutationId: string;
  user?: CognitoUser;
}

export interface AuthenticatedCognitoUserModificationRequestInput {
  clientMutationId: string;
  emailAddress: string;
  firstName: string;
  isSmsMfaRequired: boolean;
  lastName: string;
  phoneNumber: string;
}

/**
 * Details of the draft and submission to send to the bank to establish the document
 */
export interface CompleteDraftSubmissionInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation who is starting the submission.
   */
  organisationId: string;
}

/**
 * Details about the result of the operation to complete the submission of a Draft to a bank
 */
export interface CompleteDraftSubmissionPayload {
  applicableRequirements: Array<DraftApplicableRequirement>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface UpdateIdentificationPayload {
  applicableRequirements: Array<IdentificationApplicableRequirement>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identification?: Identification;
}

/**
 * Details of the draft and submission to send to the bank to establish the document
 */
export interface CompleteSuretyBondDraftSubmissionInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Delivery Address for the physical copy of the Document. Max length 500.
   */
  deliveryAddress: string;
  
  /**
   * The Family Name of the person who will receive the physical copy of the Document. Max length 255.
   */
  deliveryRecipientFamilyName: string;
  
  /**
   * The Given Name of the person who will receive the physical copy of the Document. Max length 255.
   */
  deliveryRecipientGivenName: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation who is starting the submission.
   */
  organisationId: string;
}

/**
 * Details about the Document handover to remove
 */
export interface ConfirmDocumentHandoverInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The code for the Document handover confirmation. Required
   */
  confirmationCode: string;
  
  /**
   * The ID of the Document this request for handover is for. Required.
   */
  documentId: string;
}

/**
 * Details the result of an operation to confirm the Document handover.
 */
export interface ConfirmDocumentHandoverPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about the Document Facility to update
 */
export interface ConvertDocumentFacilityForBankPortalInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID for the Document Facility. Required.
   */
  id: string;
  
  /**
   * Indicates whether or not the facility is managed by Assuro.
   */
  isAssuroFacility: boolean;
}

/**
 * Details of the updated Document Facility
 */
export interface ConvertDocumentFacilityForBankPortalPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Document Facility
   */
  documentFacility?: DocumentFacility;
}

export interface CopyDraftInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  sourceDraftId: string;
}

/**
 * Details about a Document Comment to create
 */
export interface CreateCommentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The content of the comment. Required. Min length 1. Max length 500.
   */
  content: string;
  
  /**
   * The ID of the Document this Comment is for. Required.
   */
  documentId: string;
}

/**
 * Details of the Document Comment created
 */
export interface CreateCommentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Comment created
   */
  comment?: Comment;
}

/**
 * Details about a Document to create
 */
export interface CreateDocumentInput {
  
  /**
   * The monetary value of the Document. Required. Range 0-999999999.99.
   */
  amount: Decimal;
  
  /**
   * The Address of the Financial Institution backing the Document. Max length 500. Should be null if BankName is not provided.
   */
  bankAddress?: string;
  
  /**
   * The BSB of the Bank backing the Document. Max length 255. Should be null if BankName is not provided.
   */
  bankBsb?: string;
  
  /**
   * The name of the Financial Institution backing the Document. Max length 255.
   */
  bankName?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The document costs (setup, fixed, percentage and frequency).
   */
  costs?: DocumentCostsInput;
  
  /**
   * The Agreement Content of the Document. This usually contains details on what the Document is covering, e.g. Installing new windows at a property.
   */
  description?: string;
  
  /**
   * The type of the Document.
   */
  documentVariant: DocumentVariant;
  
  /**
   * The date the Document was Established on.
   */
  establishedAt?: DateTime;
  
  /**
   * The Expected Return date of the Document.
   */
  expectedReturnDate?: Date;
  
  /**
   * The date the Document expires.
   */
  expiresAt?: Date;
  
  /**
   * The facility to link the document to.
   */
  facilityId?: string;
  
  /**
   * The Document Number. This is provided by the financial institution that is backing the document. Max length 255.
   */
  guaranteeNumber?: string;
  
  /**
   * The Metadata of the Document.
   */
  metadata?: Array<CreateDocumentMetadataItemInput | null>;
  
  /**
   * The ID of the Organisation that this Document is for. Required.
   */
  organisationId: string;
  
  /**
   * The Party type that the creating Organisation should be saved as against the document.
   */
  organisationPartyVariant: PartyVariant;
  
  /**
   * The Parties (Issuers, Beneficiaries) related to the current Document, that are NOT the current Organisation.
   */
  otherParties: Array<CreateDocumentPartyInput | null>;
  
  /**
   * The Project or Property Address. Max length 500.
   */
  projectAddress?: string;
  
  /**
   * The Document's Reference Number. This is usually provided by the party raising the Document, as a Reference Number from their own system. Max length 255.
   */
  referenceNumber?: string;
  
  /**
   * The type of the retention.
   */
  retentionType?: DocumentRetentionType;
  
  /**
   * The type of security.
   */
  securityType?: SecurityType;
  
  /**
   * The status of the Document.
   */
  status?: CreateDocumentStatus;
}

/**
 * Details about the documents cost.
 */
export interface DocumentCostsInput {
  
  /**
   * Indication if the document costs are adjusted to prorata.
   */
  adjustedCost: boolean;
  
  /**
   * The recurring cost frequency. Range 1-360.
   */
  recurringCostFrequency: number;
  
  /**
   * Type of recurring fee.
   */
  recurringFeeType: RecurringFeeType;
  
  /**
   * The recurring fixed cost. Range 0-999999999.9999.
   */
  recurringFixedCost?: Decimal;
  
  /**
   * Recurring minimum fee (overwrites annual percentage cost if larger). Range 0-999999999.9999.
   */
  recurringMinimumAnnualCost?: Decimal;
  
  /**
   * The recurring percentage cost. Range 0-100.00.
   */
  recurringPercentageCost?: Decimal;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  setUpCost: Decimal;
}

/**
 * Details an item of Document Metadata
 */
export interface CreateDocumentMetadataItemInput {
  
  /**
   * The key for the Metadata. Required. Must be between 1 and 255 characters.
   */
  key: string;
  
  /**
   * The value for the Metadata. Required. Must be between 1 and 255 characters.
   */
  value: string;
}

/**
 * Details a Document Party, such as an Issuer or Beneficiary.
 */
export interface CreateDocumentPartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit).
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 500.
   */
  address?: string;
  
  /**
   * The name of Party, most likely the company name. Required. Max length 1000.
   */
  name: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500.
   */
  notes?: string;
  
  /**
   * The type of the Party, e.g. Issuer or Beneficiary. Required.
   */
  partyVariant: PartyVariant;
}

/**
 * Status' that a document can be added with.
 */
export enum CreateDocumentStatus {
  
  /**
   * Projected. The Document is added to help forecast costs.
   */
  PROJECTED = 'PROJECTED',
  
  /**
   * Established. The Document is financially established/backed and is current.
   */
  ESTABLISHED = 'ESTABLISHED'
}

/**
 * Details of the Document created
 */
export interface CreateDocumentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document created
   */
  document?: Document;
}

/**
 * Details about a Document Attachment to create
 */
export interface CreateDocumentAttachmentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Required. Range 0-30000000.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255. Can only be one of "application/pdf", "image/jpeg", "image/png".
   */
  contentType: string;
  
  /**
   * The ID of the Document this Attachment is for. Required.
   */
  documentId: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
}

/**
 * Details of the Document Attachment created
 */
export interface CreateDocumentAttachmentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Attachment created
   */
  documentAttachment: DocumentAttachment;
}

/**
 * Details about a Document Collaborator to create
 */
export interface CreateDocumentCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this Collaborator is for.
   */
  documentId: string;
  
  /**
   * The email address of the Collaborator. Required. Email Format. Max Length 255.
   */
  emailAddress: string;
}

/**
 * Details of the Document Collaborator created
 */
export interface CreateDocumentCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Collaborator created
   */
  documentCollaborator: DocumentCollaborator;
}

/**
 * Details about a Document Facility to create
 */
export interface CreateDocumentFacilityInput {
  
  /**
   * The recurring annual cost. Range 0-999999999.99.
   */
  annualCost?: Decimal;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The type of the Documents this Facility is for.
   */
  documentVariant: DocumentFacilityVariant;
  
  /**
   * The end date of the Facility. Required.
   */
  endDate: Date;
  
  /**
   * The document costs (setup, fixed, percentage and frequency).
   */
  facilityDocumentCosts?: FacilityDocumentCostsInput;
  
  /**
   * Indicates whether or not the facility is managed by Assuro.
   */
  isAssuroFacility?: boolean;
  
  /**
   * The financial limit of the Facility. Required. Range 0-999999999.99.
   */
  limit: Decimal;
  
  /**
   * The name of the Facility. Max length 255.
   */
  name: string;
  
  /**
   * The ID of the Organisation that this Document Facility is for. Required.
   */
  organisationId: string;
  
  /**
   * The name of the Financial Institution backing the Facility. Max length 255.
   */
  provider?: string;
  
  /**
   * The type of Security backing the Facility.
   */
  securityType?: SecurityType;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  setUpCost?: Decimal;
  
  /**
   * Indicates whether or not the facility is shared by other organisations.
   */
  sharedFacilityWithOrganisations?: Array<string>;
  
  /**
   * The start date of the Facility. Required.
   */
  startDate: Date;
}

/**
 * The Facility's Document type.
 */
export enum DocumentFacilityVariant {
  
  /**
   * Bank Guarantee. The Document is backed by a Bank.
   */
  BANK_GUARANTEE = 'BANK_GUARANTEE',
  
  /**
   * Bond. The Document is backed by another Financial Institution.
   */
  SURETY_BOND = 'SURETY_BOND'
}

/**
 * Details about the documents cost.
 */
export interface FacilityDocumentCostsInput {
  
  /**
   * The default recurring percentage cost for the bank fronted document. Range 0-100.00
   */
  bankFrontedBondsRecurringPercentageCost?: Decimal;
  
  /**
   * The default cost value required for setup for the bank fronted document. Range 0-999999999.99.
   */
  bankFrontedBondsSetUpCost?: Decimal;
  
  /**
   * Indication if the document costs are adjusted to prorata.
   */
  documentAdjustedCost?: boolean;
  
  /**
   * The recurring cost frequency. Range 0-360.
   */
  documentRecurringCostFrequency?: number;
  
  /**
   * Type of recurring fee.
   */
  documentRecurringFeeType?: RecurringFeeType;
  
  /**
   * The recurring fixed cost. Range 0-999999999.9999.
   */
  documentRecurringFixedCost?: Decimal;
  
  /**
   * Recurring minimum fee (overwrites annual percentage cost if larger). Range 0-999999999.9999.
   */
  documentRecurringMinimumAnnualCost?: Decimal;
  
  /**
   * The recurring percentage cost. Range 0-100.00.
   */
  documentRecurringPercentageCost?: Decimal;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  documentSetUpCost: Decimal;
  
  /**
   * The premium recurring percentage cost for the bank fronted document. Range 0-100.00
   */
  premiumBankFrontedBondsRecurringPercentageCost?: Decimal;
  
  /**
   * The premium recurring percentage cost for the document. Range 0-100.00
   */
  premiumDocumentRecurringPercentageCost?: Decimal;
}

/**
 * Details of the Document Facility created
 */
export interface CreateDocumentFacilityPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Facility created
   */
  documentFacility?: DocumentFacility;
}

/**
 * Details about a Request to handover a Document
 */
export interface CreateDocumentHandoverInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this request for handover is for. Required.
   */
  documentId: string;
  
  /**
   * The email address to send the request for handover to . Email format. Max length 255. Required.
   */
  emailAddress: string;
  
  /**
   * The name of the person to send the request for handover to. Max length 510. Required.
   */
  name: string;
  
  /**
   * The name of the person to send the request for handover to. Max length 510. Required.
   */
  organisationName: string;
}

/**
 * Details of the Document request for handover created
 */
export interface CreateDocumentHandoverPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Document Metadata item to create
 */
export interface CreateDocumentMetadataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this Metadata is for.
   */
  documentId: string;
  
  /**
   * The key for the Metadata. Required. Must be between 1 and 255 characters.
   */
  key: string;
  
  /**
   * The value for the Metadata. Required. Must be between 1 and 255 characters.
   */
  value: string;
}

/**
 * Details of the Document Metadata item created
 */
export interface CreateDocumentMetadataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Metadata item created
   */
  metadata?: Metadata;
}

/**
 * Details about a Request to Return a Document
 */
export interface CreateDocumentRequestForReturnInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this request for return is for. Required.
   */
  documentId: string;
  
  /**
   * The email address to send the request for return to . Email format. Max length 255. Required.
   */
  emailAddress: string;
  
  /**
   * The name of the person to send the request for return to. Max length 510. Required.
   */
  name: string;
  
  /**
   * Indicates the request for return frequency. Required.
   */
  recurringFrequency: Short;
}

/**
 * Details of the Document request for return created
 */
export interface CreateDocumentRequestForReturnPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Draft to create
 */
export interface CreateDraftInput {
  
  /**
   * The monetary value of the Draft. Required. Range 0-999999999.99.
   */
  amount?: Decimal;
  
  /**
   * The attachments to create with the draft
   */
  attachments?: Array<CreateDraftCreateAttachmentInput>;
  bGSwitchId?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The contract details related to this draft
   */
  contract?: CreateDraftContractDetailInput;
  
  /**
   * The Description of the Draft. 
   * This usually contains details on what the Draft is covering, e.g. Installing new windows at a property
   * Required. 
   * Max Length 1000.
   */
  description: string;
  
  /**
   * The Expected Return Date.
   */
  expectedReturnDate?: Date;
  
  /**
   * The date the Draft expires.
   */
  expiresAt?: Date;
  
  /**
   * The facility ID under which a bond should be established.
   */
  facilityId?: string;
  
  /**
   * The funding of the Draft.
   */
  fundingMethod?: FundingMethod;
  
  /**
   * The ID of the Organisation that this Draft is for. Required.
   */
  organisationId: string;
  
  /**
   * The Parties (Issuers, Beneficiaries) related to the current Draft.
   */
  parties: Array<CreateDraftPartyInput | null>;
  
  /**
   * The process this draft will follow
   */
  processType?: DraftProcessType;
  
  /**
   * The Project or Property Address. Max length 500.
   */
  projectAddress?: string;
  
  /**
   * The purpose of the Draft.
   */
  purpose?: DraftPurpose;
  
  /**
   * The Draft's Reference Number, such as a Contract Number. Max length 255.
   */
  referenceNumber?: string;
  
  /**
   * The requested documents under this draft
   */
  requestedSuretyDocuments?: Array<CreateDraftRequestedSuretyDocumentInput>;
  
  /**
   * The other specified purpose.
   */
  specifiedOtherPurpose?: string;
}

/**
 * Specifies an attachment to be created with the draft
 */
export interface CreateDraftCreateAttachmentInput {
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Required. Range 0-30000000.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255. Can only be one of "application/pdf", "image/jpeg", "image/png".
   */
  contentType: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
  
  /**
   * The variant of the attachment. Eg "Contract Deed".
   */
  variant?: DraftAttachmentVariant;
}

/**
 * Details of the contract to attach to the draft
 */
export interface CreateDraftContractDetailInput {
  
  /**
   * Bank fronted bonds have been requested.
   */
  bankFrontedBondsRequested: boolean;
  
  /**
   * Reason Bank Guarantee is required.
   */
  bankFrontedBondsRequestedReason?: string;
  
  /**
   * Were there any defects and faults in materials, workmanship or design
   */
  defectsAndFaults?: DraftOptionWithDetailInput;
  
  /**
   * Has you Principal extended the defects liability Period?
   */
  defectsLiabilityPeriodExtended?: DraftOptionWithDetailInput;
  
  /**
   * The date by which any defects found must be fixed by
   */
  finalCompletionDate?: Date;
  
  /**
   * Does the contract identify delay events that give raise to Extension of Time and Cost Recovery?
   */
  hasDelayEvents?: boolean;
  
  /**
   * Does the contract include any "design" obligations and/or liability?
   */
  hasDesignObligationsLiability?: boolean;
  
  /**
   * Has the company undertaken previous contracts for this client?
   */
  hasPreviousContracts?: boolean;
  
  /**
   * Has the company undertaken a contract of this type before?
   */
  hasSimilarContracts?: boolean;
  
  /**
   * Is Existing Project?
   */
  isExistingProject: boolean;
  
  /**
   * Whether the Issuer is acting as a Subcontractor to the Beneficiary
   */
  isSubcontractor: boolean;
  
  /**
   * Are there any issues and / or disputes with respect to the underlying contract and for the defects liability period
   */
  issuesAndDisputes?: DraftOptionWithDetailInput;
  
  /**
   * The date when contracted work should be completed
   */
  practicalCompletionDate?: Date;
  
  /**
   * Has either of the project program or contract sum been exceeded.
   */
  projectNotOnBudget?: boolean;
  
  /**
   * Are we replacing alternative security and if so specify type of security being replaced.
   * This field is required in two cases:
   * 1. A maintenance bond is requested and a performance bond is not being requested.
   * 2. Bond period start date differs to the Contract Start date
   */
  replacingExistingSecurity?: DraftOptionWithDetailInput;
  
  /**
   * The contracted start date. Required.
   */
  startDate: Date;
  
  /**
   * The total value of the contract
   */
  totalValue: Decimal;
}

/**
 * Details a Draft Party, such as an Issuer or Beneficiary.
 */
export interface CreateDraftPartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit).
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 500.
   */
  address?: string;
  addressV2?: AddressInput;
  
  /**
   * Whether or not this Party represents the Organisation creating the Draft. Required..
   */
  isCurrentOrganisation: boolean;
  
  /**
   * The name of Party, most likely the company name. Required. Max length 1000.
   */
  name: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500.
   */
  notes?: string;
  partyEntityType?: PartyEntityType;
  
  /**
   * The type of the Party, e.g. Issuer or Beneficiary. Required.
   */
  partyVariant: DraftPartyVariant;
  
  /**
   * The main contact for the Party.
   */
  primaryContact?: DraftExtendedContactInput;
}

/**
 * Details of a Requested Document to create
 */
export interface CreateDraftRequestedSuretyDocumentInput {
  
  /**
   * The amount the requested document needs to cover. Required. Range 0-999999999.99.
   */
  amount: Decimal;
  
  /**
   * The document wording (legal content) to be used
   */
  documentWording?: string;
  
  /**
   * The template used for the document wording (legal content). Specify "OTHER" if not directly from template.
   */
  documentWordingTemplate?: DraftContractForm;
  
  /**
   * The expiry date for the requested document. Optional.
   */
  expiryDate?: Date;
  
  /**
   * The end of the period the requested document is active. Required.
   */
  periodEndDate: Date;
  
  /**
   * The start of the period the requested document is active. Required.
   */
  periodStartDate: Date;
  
  /**
   * The purpose of the Requested Document. Required.
   */
  purpose: DraftRequestedDocumentPurpose;
}

/**
 * Details of the Draft created
 */
export interface CreateDraftPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft created
   */
  draft: Draft;
}

/**
 * Details about a Draft Attachment to create
 */
export interface CreateDraftAttachmentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Required. Range 0-30000000.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255. Can only be one of "application/pdf", "image/jpeg", "image/png".
   */
  contentType: string;
  
  /**
   * The ID of the Draft this Attachment is for. Required.
   */
  draftId: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
  
  /**
   * The ID of the Organisation the User is working on behalf of. Required.
   */
  organisationId: string;
  
  /**
   * The variant of the attachment. Eg "Contract Deed".
   */
  variant?: DraftAttachmentVariant;
}

/**
 * Details of the Draft Attachment created
 */
export interface CreateDraftAttachmentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft Attachment created
   */
  draftAttachment: DraftAttachment;
}

/**
 * Details about a Draft Attachment to create
 */
export interface CreateDraftAttachmentForBankPortalInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Required. Range 0-30000000.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255. Can only be one of "application/pdf", "image/jpeg", "image/png".
   */
  contentType: string;
  
  /**
   * The ID of the Draft this Attachment is for. Required.
   */
  draftId: string;
  
  /**
   * The ID of the Draft Requested Document this Attachment is for.
   */
  draftRequestedDocumentId?: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
  
  /**
   * The variant of the attachment. Eg "Contract Deed".
   */
  variant?: DraftAttachmentVariantSupplier;
}

/**
 * The possible variants of Attachments for Drafts
 */
export enum DraftAttachmentVariantSupplier {
  
  /**
   * The supplier provided "Original" of a document.
   */
  ORIGINAL_DOCUMENT = 'ORIGINAL_DOCUMENT',
  
  /**
   * The supplier provided Payment Invoice of the Surety Bond Application.
   */
  PAYMENT_INVOICE = 'PAYMENT_INVOICE',
  
  /**
   * The supplier provided document preview for the bank guarantee application.
   */
  DOCUMENT_PREVIEW = 'DOCUMENT_PREVIEW',
  
  /**
   * The application submitted to the bank.
   */
  MEG_APPLICATION = 'MEG_APPLICATION',
  
  /**
   * A document associated with the "Required Document" feature
   */
  REQUIRED_DOCUMENT = 'REQUIRED_DOCUMENT'
}

/**
 * Details about a BG Switch Draft to create.
 */
export interface CreateDraftBGSwitchInput {
  affirmationIrrevocability: boolean;
  beneficiaryApproval: boolean;
  
  /**
   * Full name of the bank which issued the current BG.
   */
  currentBankFullName?: string;
  
  /**
   * Expiry date (if any) of the current BG.
   */
  currentExpiryDate?: Date;
  currentGuaranteeNumber?: string;
  
  /**
   * Security type of the current BG.
   */
  currentSecurityType: BGSwitchSecurityType;
  
  /**
   * Value of current BG.
   */
  currentValue: Decimal;
  indemnityAgreement: boolean;
  irrevocableOrder: boolean;
  
  /**
   * If security type cash and cash is in term deposit.
   */
  isCashInTermDeposit?: boolean;
  
  /**
   * The ID of the Organisation that this Draft is for. Required.
   */
  organisationId: string;
  securityInterestDeclaration: boolean;
  
  /**
   * The end date of the term deposit if security type is cash and cash is in term deposit.
   */
  termDepositEndDate?: Date;
  transactionUnwindingClause: boolean;
}

/**
 * Details of the created BG Switch Draft
 */
export interface CreateDraftBGSwitchPayload {
  
  /**
   * The Draft created
   */
  draftBGSwitch: DraftBGSwitch;
}

/**
 * Details about a Draft Collaborator to create
 */
export interface CreateDraftCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Collaborator is for.
   */
  draftId: string;
  
  /**
   * The email address of the Draft Collaborator. Required. Email Format. Max Length 255.
   */
  emailAddress: string;
  
  /**
   * The Family Name of the Draft Collaborator. Required. Max length 255.
   */
  familyName: string;
  
  /**
   * The Given Name of the Draft Collaborator. Required. Max length 255.
   */
  givenName: string;
  
  /**
   * The ID of the Organisation who is inviting this Collaborator.
   */
  organisationId: string;
  
  /**
   * The Role to grant the Draft Collaborator. Required.
   */
  role: CreateDraftCollaboratorRole;
}

/**
 * Roles that can be assigned to a new Collaborator
 */
export enum CreateDraftCollaboratorRole {
  
  /**
   * View and comment only on drafts.
   */
  LIMITED = 'LIMITED',
  
  /**
   * Take actions as the Beneficiary, such as amending and approving the draft.
   */
  BENEFICIARY = 'BENEFICIARY',
  
  /**
   * Take actions as the Beneficiary, such as amending, approving, and submitting the draft.
   */
  ISSUER = 'ISSUER'
}

/**
 * Details of the Draft Collaborator created
 */
export interface CreateDraftCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft Collaborator created
   */
  draftCollaborator: DraftCollaborator;
}

/**
 * Details about a Draft Comment to create
 */
export interface CreateDraftCommentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The content of the comment. Required. Min length 1. Max length 500. Required.
   */
  content: string;
  
  /**
   * The ID of the Draft this Comment is for. Required.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation this Comment is for. Required.
   */
  organisationId: string;
}

/**
 * Details of the Draft Comment created
 */
export interface CreateDraftCommentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft Comment created
   */
  comment?: DraftComment;
}

export interface CreateDraftFromOriginationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  originationId: string;
}

/**
 * Details of the Draft created
 */
export interface CreateDraftFromOriginationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  draftId: string;
  organisationId: string;
}

/**
 * Details about an Organisation level Alert Configuration to create
 */
export interface CreateFacilityApplicationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  facilityType: FacilityType;
  
  /**
   * The ID of the Organisation that is applying for a bond facility. Required.
   */
  organisationId: string;
}

/**
 * Details of the Facility Application created
 */
export interface CreateFacilityApplicationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Facility Application created
   */
  facilityApplication: FacilityApplication;
}

/**
 * Details about a FacilityApplication Attachment to create
 */
export interface CreateFacilityApplicationAttachmentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Required. Range 0-30000000.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255. Can only be one of "application/pdf", "image/jpeg", "image/png".
   */
  contentType: string;
  
  /**
   * The ID of the FacilityApplication this Attachment is for. Required.
   */
  facilityApplicationId: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
  
  /**
   * The variant of this attachment. Describes the context of the attachment e.g. FINANCIAL_STATEMENTS, GROUP_STRUCTURE
   */
  variant: AttachmentVariant;
}

/**
 * Details of the Facility Application created
 */
export interface CreateFacilityApplicationAttachmentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Facility Application created
   */
  facilityApplicationAttachment: FacilityApplicationAttachment;
}

export interface FinanceEnquiryInput {
  contactEmail: string;
  contactFirstName: string;
  contactLastName: string;
  contactPhoneNumber: string;
  draftId?: string;
  financeEnquiryDetail?: FinanceEnquiryDetailInput;
  organisationId: string;
  reasonForFinance: FinanceReason;
}

export interface FinanceEnquiryDetailInput {
  averageMonthlySales: Decimal;
  creditStatus: FinanceCreditStatus;
  loanAmount: Decimal;
  monthsTrading: number;
  recentPerformance: FinanceRecentPerformance;
  requestedLoanTermInMonths: number;
  residencyStatus: FinanceResidency;
  yearsTrading: number;
}

export enum FinanceCreditStatus {
  UNPAID_DEFAULT = 'UNPAID_DEFAULT',
  FULLY_PAID_DEFAULT = 'FULLY_PAID_DEFAULT',
  ALL_GREAT = 'ALL_GREAT'
}

export enum FinanceRecentPerformance {
  POOR = 'POOR',
  MODERATE = 'MODERATE',
  STRONG = 'STRONG'
}

export enum FinanceResidency {
  AUSTRALIAN_CITIZEN_AND_RESIDENT = 'AUSTRALIAN_CITIZEN_AND_RESIDENT',
  AUSTRALIAN_CITIZEN_BUT_NON_RESIDENT = 'AUSTRALIAN_CITIZEN_BUT_NON_RESIDENT',
  PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
  NEW_ZEALAND_RESIDENT = 'NEW_ZEALAND_RESIDENT',
  VISA_HOLDER = 'VISA_HOLDER',
  NON_RESIDENT_NON_CITIZEN_NO_VISA = 'NON_RESIDENT_NON_CITIZEN_NO_VISA'
}

export enum FinanceReason {
  CASH_SECURITY_FOR_BANK_GUARANTEE = 'CASH_SECURITY_FOR_BANK_GUARANTEE',
  WORKING_CAPITAL_FOR_BUSINESS = 'WORKING_CAPITAL_FOR_BUSINESS'
}

export interface FinanceEnquiry {
  contactEmail: string;
  contactFirstName: string;
  contactLastName: string;
  contactPhoneNumber: string;
  dateTimeEnquired: DateTime;
  draftId?: string;
  financeEnquiryDetail?: FinanceEnquiryDetail;
  id: string;
  organisationId: string;
  reasonForFinance: FinanceReason;
}

export interface FinanceEnquiryDetail {
  averageMonthlySales: Decimal;
  creditStatus: FinanceCreditStatus;
  financeEnquiry: FinanceEnquiry;
  financeEnquiryId: string;
  id: string;
  loanAmount: Decimal;
  monthsTrading: number;
  recentPerformance: FinanceRecentPerformance;
  requestedLoanTermInMonths: number;
  residencyStatus: FinanceResidency;
  yearsTrading: number;
}

export interface FinanceRecordInput {
  amount: Decimal;
  dateTime: DateTime;
  financeType?: FinanceType;
  financier: Financier;
  organisationId: string;
}

/**
 * Details about a Document Import Job to create
 */
export interface CreateImportJobInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The files used/to be used in this ImportJob. Required. Must contain a single element.
   */
  files: Array<CreateImportJobFileInput | null>;
  
  /**
   * The ID of the Organisation that this Import Job is for. Required.
   */
  organisationId: string;
  
  /**
   * The Type of Import Job, e.g. CSV. Required.
   */
  variant: ImportJobVariant;
}

/**
 * Details on a File that is part of an Import Job
 */
export interface CreateImportJobFileInput {
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Range 0-30000000. Required.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the file, so systems can identify how to open the file. Required. Max Length 255.
   */
  contentType: string;
  
  /**
   * Whether or not to skip adding the file name to the upload request as metadata. Deprecated, will always be treated as true.
   */
  excludeFilenameFromMetadata?: boolean;
  
  /**
   * The filename for identification. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
}

/**
 * Details of the Document Import Job created
 */
export interface CreateImportJobPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Import Job created
   */
  importJob?: ImportJob;
}

export interface CreateOrReplaceBankAssetInput {
  assetType: BankAssetType;
  content: string;
  contentType: string;
  name: string;
}

export interface CreateOrUpdateFeeSummaryInput {
  
  /**
   * Name of the asset relating to Assuro's agency agreement TEMPLATE for the given product
   * Asset name must exist (Can be created via the CreateOrReplaceBankAsset; and checked via the ListBankAssets endpoint)
   * Required
   */
  assuroAgencyAgreementTemplateName: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  deliveryType: DeliveryType;
  details: string;
  establishmentFee: Decimal;
  features: Array<string>;
  feeSummaryStatus: FeeSummaryStatus;
  id?: string;
  maxValue?: Decimal;
  minValue?: Decimal;
  name: string;
  
  /**
   * Name of the asset relating to the BG Preview TEMPLATE for the given product
   * Asset name must exist (Can be created via the CreateOrReplaceBankAsset; and checked via the ListBankAssets endpoint)
   * Required
   */
  productPreviewTemplateName: string;
  productType: ProductType;
  recurringFeePercentage: Decimal;
  securityType: SecurityType;
  supplierId: string;
}

export interface CreateOrUpdateFeeSummaryPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  feeSummary: FeeSummary;
}

export interface CreateOrUpdateSupplierInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * Nullable. The Id of the associated "Guarantor" record in GVP
   * 
   * If a non-null value is provided, a mapping between the supplier and the GVP "Guarantor" will be recorded in the SupplierGvpMapping
   * Otherwise, the transaction will ensure that there is no mapping record
   */
  gvpId?: string;
  id?: string;
  name: string;
  notificationAddress?: string;
}

export interface CreateOrUpdateSupplierPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  supplier: EnrichedSupplier;
}

export interface EnrichedSupplier {
  createdAt: DateTime;
  createdBy: string;
  feeSummaries: Array<FeeSummary>;
  gvpId?: string;
  id: string;
  name: string;
  notificationAddress: string;
}

/**
 * Details of an Organisation to create.
 */
export interface CreateOrganisationInput {
  
  /**
   * The ABN of the Organisation. ABN format.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   */
  address?: string;
  channelPartnerIds?: Array<string>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  entityType: PartyEntityType;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   */
  industryType?: string;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Min length 3. Max length 255.
   */
  name: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Min length 3. Max length 255.
   */
  nickname?: string;
  
  /**
   * The Organisation Type.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * The Postal Address of the Organisation. Max length 500.
   */
  postalAddress?: string;
  
  /**
   * Whether the Postal Address of the Organisation is the same as the Business Address.
   */
  postalAddressSameAsBusinessAddress?: boolean;
  
  /**
   * Only to be used if the client MANUALLY specifies they came in from a referral from an entity in the referral portal
   * CANNOT be specified if the creating user is already part of an organisation (not the first organisation being created)
   * CANNOT be specified if the creating user has EITHER a ReferrerCode or ReferralPortalReferrerMemberCode, as it means we have already captured this information
   */
  referralPortalReferralEntityId?: string;
  
  /**
   * The Stripe CustomerId of the Organisation. Max length 500.
   */
  stripeCustomerId?: string;
}

/**
 * The result of the Create Organisation operation.
 */
export interface CreateOrganisationPayload {
  
  /**
   * The ABN of the Organisation. ABN format.
   * @deprecated Please use the organisation property to access this detail.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   * @deprecated Please use the organisation property to access this detail.
   */
  address?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The date stamp the record was created. Required.
   * @deprecated Please use the organisation property to access this detail.
   */
  createdAt: DateTime;
  
  /**
   * The identifier for who or what created this record. Required.
   * @deprecated Please use the organisation property to access this detail.
   */
  createdBy: string;
  
  /**
   * The ID for the Organisation.
   * @deprecated Please use the organisation property to access this detail.
   */
  id: string;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  industryType?: string;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Min length 3. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  name: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Min length 3. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  nickname?: string;
  
  /**
   * The Organisation created
   */
  organisation: Organisation;
  
  /**
   * The Organisation Type.
   * @deprecated Please use the organisation property to access this detail.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  stripeCustomerId?: string;
}

/**
 * Details about an Organisation level Alert Configuration to create
 */
export interface CreateOrganisationAlertConfigurationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The email addresses that should be notified for an Alert. Min length 1, max length 25. Each element must be in email format.
   */
  emailAddresses: Array<string>;
  
  /**
   * The facility linked to the alert.
   */
  facilityId?: string;
  
  /**
   * The percentage that triggers the facility limit alert
   */
  facilityLimit?: Decimal;
  
  /**
   * Indicates if request facility limit should include projected docs.
   */
  facilityLimitIncludeProjectedDocs?: boolean;
  
  /**
   * The ID of the Organisation that this Alert Configuration should apply to. Required.
   */
  organisationId: string;
  
  /**
   * The number of seconds before the event the Alert should be triggered.
   */
  triggerLeadTime?: Seconds;
  
  /**
   * The property that will trigger the Alert. Required.
   */
  triggerProperty?: AlertTriggerProperty;
}

/**
 * Details of the Organisation level Alert Configuration created
 */
export interface CreateOrganisationAlertConfigurationPayload {
  
  /**
   * The Alert Configuration created
   */
  alertConfiguration: AlertConfiguration;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details an item of Organisation Document Metadata to create
 */
export interface CreateOrganisationDocumentMetadataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The key for the Metadata. Required. Must be between 1 and 255 characters.
   */
  key: string;
  
  /**
   * The ID of the Organisation this Metadata is for.
   */
  organisationId: string;
}

/**
 * Details an item of Organisation Document Metadata created
 */
export interface CreateOrganisationDocumentMetadataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Organisation Document Metadata item created
   */
  organisationDocumentMetadata: OrganisationDocumentMetadata;
}

export interface CreateRequiredDocumentForBankPortalInput {
  attachmentId?: string;
  draftId: string;
  message: string;
  requiredDocumentType: RequiredDocumentType;
}

export interface CreateRequiredDocumentMessageInput {
  attachmentId?: string;
  message?: string;
  parentMessageId?: string;
  requiredDocumentId: string;
}

export interface CreateSimpleKycDataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identificationId: string;
}

export interface CreateSimpleKycDataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface DeleteBankAssetInput {
  assetType: BankAssetType;
  name: string;
}

export interface EditFinanceRecordInput {
  amount: Decimal;
  dateTime: DateTime;
  financeType?: FinanceType;
  financier: Financier;
  id: string;
  organisationId: string;
}

/**
 * Details for establishing a Draft (Bank Portal action)
 */
export interface DraftEstablishInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Document Number. This is provided by the financial institution that is backing the document upon establishment. Max length 255.
   */
  documentNumber: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  megDetails?: string;
}

/**
 * Details about the result of the operation to establish a Draft
 */
export interface DraftEstablishPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The established draft
   */
  draft: BankDraft;
}

/**
 * Details for establishing a Surety Bond Draft (Bank Portal action)
 */
export interface DraftEstablishSuretyBondInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The establishment details for each requested document in this draft.
   */
  draftRequestedSuretyDocumentEstablishmentDetails: Array<DraftEstablishSuretyBondRequestedDocumentInput>;
}

export interface DraftEstablishSuretyBondRequestedDocumentInput {
  
  /**
   * The Document Number. This is provided by the financial institution that is backing the document upon establishment. Max length 255.
   */
  documentNumber: string;
  
  /**
   * The ID of the Requested Document.
   */
  draftRequestedDocumentId: string;
}

export interface DocumentReportInput {
  criteria?: string;
  displayName?: string;
  filters?: DocumentReportFiltersInput;
  sortBy?: string;
  sortOrder?: DocumentReportSortOrder;
  supplierId?: string;
}

export interface DocumentReportFiltersInput {
  acceptedChannelPartnerId?: string;
  acceptedChannelPartnerIdIn?: Array<string>;
  actionDateGte?: DateTime;
  actionDateLte?: DateTime;
  amountGte?: Decimal;
  amountLte?: Decimal;
  dateDraftSubmittedGte?: DateTime;
  dateDraftSubmittedLte?: DateTime;
  dateDraftVisibleToSupplierGte?: DateTime;
  dateDraftVisibleToSupplierLte?: DateTime;
  descriptionContains?: string;
  descriptionEndsWith?: string;
  descriptionStartsWith?: string;
  documentVariant?: DocumentVariant;
  documentVariantIn?: Array<DocumentVariant>;
  establishedAtGte?: DateTime;
  establishedAtLte?: DateTime;
  expectedReturnDateGte?: DateTime;
  expectedReturnDateLte?: DateTime;
  expiresAtGte?: DateTime;
  expiresAtLte?: DateTime;
  facilityId?: string;
  facilityIdIn?: Array<string>;
  id?: string;
  idIn?: Array<string>;
  isParentDocument?: boolean;
  organisationId?: string;
  organisationIdIn?: Array<string>;
  originalDraftId?: string;
  originalDraftIdNot?: string;
  partyVariant?: PartyVariant;
  referenceNumberContains?: string;
  referenceNumberEndsWith?: string;
  referenceNumberStartsWith?: string;
  status?: DocumentStatus;
  statusIn?: Array<DocumentStatus>;
  supplierId?: string;
}

/**
 * Details of the draft needs a new stripe subscription
 */
export interface GenerateNewStripeSubscriptionInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation.
   */
  organisationId: string;
}

/**
 * Details about the result of the operation to create a new stripe subscription
 */
export interface GenerateNewStripeSubscriptionPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  draft: Draft;
}

/**
 * Details of the draft needs a new stripe subscription
 */
export interface BankPortalGenerateNewStripeSubscriptionInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
}

/**
 * Details about the result of the operation to create a new stripe subscription
 */
export interface BankGenerateNewStripeSubscriptionPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  draft: Draft;
}

export interface ImportExistingSimpleKycDataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface ImportExistingSimpleKycDataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface MigrateAllDescriptionsResult {
  defaultedReason: DescriptionDefaultedReason;
  entityId: string;
  exception?: string;
  generatedDescription?: string;
  originalAgreementContent?: string;
  purpose?: string;
  successful: boolean;
  variant: string;
}

export enum DescriptionDefaultedReason {
  NON_BG = 'NON_BG',
  NO_PURPOSE = 'NO_PURPOSE',
  MAPPING_RULES = 'MAPPING_RULES',
  RECORD_OF_A_DOCUMENT = 'RECORD_OF_A_DOCUMENT'
}

/**
 * Details to Opt In an Organisation to Facilities
 */
export interface OptInOrganisationToDocumentFacilitiesInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Organisation to opt in to facilities. Required.
   */
  organisationId: string;
}

/**
 * Details of the Opt In operation
 */
export interface OptInOrganisationToDocumentFacilitiesPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface PrefillIdentificationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identificationId: string;
}

export interface PrefillIdentificationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identification: Identification;
}

/**
 * Records that the current platform terms have been accepted by the user
 */
export interface ProfileTermsAcceptedInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * The response when the terms acceptance has been recorded successfully.
 */
export interface ProfileTermsAcceptedPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated User Profile record.
   */
  profile?: Profile;
}

/**
 * Details about the result of the operation to update the status of a Document
 */
export interface BankDocumentUpdatePayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Document
   */
  document: BankDocument;
}

export interface CreateEntityRequestInput {
  abn: string;
  addressLine1: string;
  addressLine2?: string;
  addressPostcode: string;
  addressState: EntityAddressState;
  addressSuburb: string;
  bankingAccountNumber?: string;
  bankingBsbNumber?: string;
  contactPerson: string;
  email: string;
  entityType: EntityType;
  name: string;
  parentEntityId?: string;
  phone: string;
  relationshipManagerId?: string;
}

export interface ReferralPortalMemberCreateInput {
  cognitoUser_Username?: string;
  email: string;
  entityId: string;
  isSmsMfaRequired: boolean;
  mobilePhone?: string;
  name: string;
  position?: string;
  role: BankUserRole;
  surname: string;
}

export interface ResendInvitationRequestInput {
  referralPortalMemberId: string;
}

export interface SetOrganisationAssociationInput {
  entityId?: string;
  organisationId: string;
  referralPortalMemberId?: string;
}

export interface UpdateEntityRequestInput {
  abn: string;
  addressLine1: string;
  addressLine2?: string;
  addressPostcode: string;
  addressState: EntityAddressState;
  addressSuburb: string;
  bankingAccountNumber?: string;
  bankingBsbNumber?: string;
  contactPerson: string;
  email: string;
  id: string;
  name: string;
  phone: string;
  relationshipManagerId?: string;
}

export interface ReferralPortalMemberUpdateInput {
  isSmsMfaRequired: boolean;
  mobilePhone: string;
  name: string;
  position?: string;
  referralPortalMemberId: string;
  role: BankUserRole;
  surname: string;
}

/**
 * Details for rejecting a Draft (Bank Portal action)
 */
export interface DraftRejectInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * Copy the Bank Guarantee draft to create a new one.
   */
  copyBGDraft: boolean;
  
  /**
   * The credit amount to be issued to the organisation upon rejection.
   */
  creditAmount?: Decimal;
  
  /**
   * Optional comments to be added to the credit event record.
   */
  creditComment?: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The reason the Draft was rejected from the Bank. Required. Max length 255.
   */
  rejectionReason: string;
  
  /**
   * Send a notification email to the client.
   */
  shouldSendEmail?: boolean;
}

/**
 * Details about the result of the operation to reject a Draft
 */
export interface DraftRejectPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The rejected draft
   */
  draft: BankDraft;
}

/**
 * Details about a Document Attachment to remove
 */
export interface RemoveDocumentAttachmentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this Attachment is for. Required.
   */
  documentId: string;
  
  /**
   * The ID for the Document Attachment. Required.
   */
  id: string;
}

/**
 * Details the result of an operation to remove a Document Attachment.
 */
export interface RemoveDocumentAttachmentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Document Collaborator to remove
 */
export interface RemoveDocumentCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this Collaborator is for.
   */
  documentId: string;
  
  /**
   * The ID for the Document Collaborator
   */
  id: string;
}

/**
 * Details the result of an operation to remove a Document Collaborator.
 */
export interface RemoveDocumentCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about the Document handover cancellation
 */
export interface RemoveDocumentHandoverInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this request for handover is for. Required.
   */
  documentId: string;
}

/**
 * Details the result of an operation to remove the Document handover.
 */
export interface RemoveDocumentHandoverPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Document Metadata Item to remove
 */
export interface RemoveDocumentMetadataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this Metadata is for. Required.
   */
  documentId: string;
  
  /**
   * The ID for the Document Metadata. Required.
   */
  id: string;
}

/**
 * Details the result of an operation to remove an item of Document Metadata.
 */
export interface RemoveDocumentMetadataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about the Document request for return to remove
 */
export interface RemoveDocumentRequestForReturnInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this request for return is for. Required.
   */
  documentId: string;
}

/**
 * Details the result of an operation to remove the Document request for return.
 */
export interface RemoveDocumentRequestForReturnPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Draft Attachment to remove
 */
export interface RemoveDraftAttachmentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Attachment is for. Required.
   */
  draftId: string;
  
  /**
   * The ID for the Draft Attachment. Required.
   */
  id: string;
  
  /**
   * The ID of the Organisation the User is working on behalf of. Required.
   */
  organisationId: string;
}

/**
 * Details the result of an operation to remove a Draft Attachment.
 */
export interface RemoveDraftAttachmentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Draft Attachment to remove
 */
export interface RemoveDraftAttachmentForBankPortalInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Attachment is for. Required.
   */
  draftId: string;
  
  /**
   * The ID for the Draft Attachment. Required.
   */
  id: string;
}

/**
 * Details about a Draft Collaborator to remove
 */
export interface RemoveDraftCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Collaborator is for.
   */
  draftId: string;
  
  /**
   * The ID for the Draft Collaborator
   */
  id: string;
  
  /**
   * The ID of the Organisation who is removing this Collaborator.
   */
  organisationId: string;
}

/**
 * Details the result of an operation to remove a Draft Collaborator.
 */
export interface RemoveDraftCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface RemoveFacilityApplicationAttachmentInput {
  attachmentId: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  facilityApplicationId: string;
}

/**
 * Details of the Facility Application created
 */
export interface MutateFacilityApplicationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Facility Application created
   */
  facilityApplication: FacilityApplication;
}

/**
 * Details about an Invitation to remove
 */
export interface RemoveInvitationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID for the Organisation Invitation.
   */
  invitationId: string;
  
  /**
   * The ID of the Organisation that the Invitation belongs to. Required.
   */
  organisationId: string;
}

/**
 * Details the result of an operation to remove an Organisation Invitation.
 */
export interface RemoveInvitationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about a Member to remove
 */
export interface RemoveMemberInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Organisation that the Member belongs to. Required.
   */
  organisationId: string;
  
  /**
   * The User ID of the Member. Required. GUID.
   */
  userId: string;
}

/**
 * Details the result of an operation to remove an Organisation Member.
 */
export interface RemoveMemberPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about an Organisation level Alert Configuration to remove
 */
export interface RemoveOrganisationAlertConfigurationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID for the Alert Configuration. Required.
   */
  id: string;
  
  /**
   * The ID for the Organisation this Alert Configuration applies to. Required.
   */
  organisationId: string;
}

/**
 * Details the result of an operation to remove an Organisation level Alert Configuration.
 */
export interface RemoveOrganisationAlertConfigurationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details an item of Organisation Document Metadata to remove
 */
export interface RemoveOrganisationDocumentMetadataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID for the Organisation Document Metadata. Required.
   */
  id: string;
  
  /**
   * The ID of the Organisation this Document Metadata is for.
   */
  organisationId: string;
}

/**
 * Details the result of an operation to remove an item of Organisation Document Metadata
 */
export interface RemoveOrganisationDocumentMetadataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details for changes requested on a Draft (Bank Portal action)
 */
export interface DraftRequestChangeInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The changes requested from the Bank. Required. Max length 255.
   */
  requestChangeReason: string;
}

/**
 * Details about the result of the operation to request changes on a Draft
 */
export interface DraftRequestChangePayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated draft
   */
  draft: BankDraft;
}

/**
 * Details for requesting payment from the Issuer
 */
export interface DraftRequestPaymentInput {
  
  /**
   * The BSB of the account that funds should be transferred to for establishment of the Document.
   */
  bankAccountBsb: string;
  
  /**
   * The Name of the account that funds should be transferred to for establishment of the Document. Required. Max length 255.
   */
  bankAccountName: string;
  
  /**
   * The Account Number of the account that funds should be transferred to for establishment of the Document.
   */
  bankAccountNumber: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft.
   */
  draftId: string;
  
  /**
   * The description that should be used when making the payment
   */
  paymentDescription: string;
  
  /**
   * A list of payment details for requested surety documents attached to the draft
   */
  requestedSuretyDocuments?: Array<RequestDraftPaymentRequestedDocumentInput>;
  
  /**
   * The amount payable for the security of the Document
   */
  securityAmount?: Decimal;
}

/**
 * Details for requesting payment from the Issuer
 */
export interface RequestDraftPaymentRequestedDocumentInput {
  
  /**
   * The amount payable each year for maintainance of the Document
   */
  paymentAnnualCost: Decimal;
  
  /**
   * The establishment fee for the Document
   */
  paymentEstablishmentFee: Decimal;
  
  /**
   * The ID of the DraftRequestedDocument.
   */
  requestedDocumentId: string;
}

/**
 * Details about the result of the operation to complete the submission of a Draft to a bank
 */
export interface DraftRequestPaymentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated draft
   */
  draft: BankDraft;
}

export interface ResendAdditionalInvoicesPayload {
  allRecipients: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details of the invitation to send.
 */
export interface SendInvitationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Email adddress of the Member to invite. Required. Email format. Max length 255.
   */
  email: string;
  
  /**
   * The ID of the Organisation that the Invitation belongs to. Required.
   */
  organisationId: string;
  
  /**
   * The Role the Member will have if they accept the invite. Required.
   */
  role: MemberRole;
}

/**
 * The result of the Send Organisation Invitation operation.
 */
export interface SendInvitationPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The invitation sent
   */
  invitation?: MemberInvitation;
}

export interface ClientPortalApplicationContactDetailsInput {
  businessPhone?: string;
  draftId: string;
  email: string;
  firstName: string;
  lastName: string;
  mobilePhone: string;
  organisationId: string;
  role: string;
}

export interface ApplicationContactDetailsInput {
  businessPhone?: string;
  draftId: string;
  email: string;
  firstName: string;
  lastName: string;
  mobilePhone: string;
  role: string;
}

/**
 * The notification list to set for a Document
 */
export interface SetDocumentNotificationListInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this notification list is for
   */
  documentId: string;
  
  /**
   * The members that should be notified about this Document
   */
  notificationListMembers: Array<DocumentNotificationListMemberInput>;
}

/**
 * Details of a Member of the Notification List
 */
export interface DocumentNotificationListMemberInput {
  
  /**
   * The Organisation Member Id
   */
  organisationMemberId: string;
}

/**
 * Details the result of an operation to set the notification list.
 */
export interface SetDocumentNotificationListPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about Approval Status of a Draft by Collaborator
 */
export interface SetDraftApprovalStatusForCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Collaborator who is Approving this Draft.
   */
  collaboratorId: string;
  
  /**
   * The ID of the Draft this Approval is for.
   */
  draftId: string;
  
  /**
   * The boolean for IsApproved or not. Required.
   */
  isApproved: boolean;
}

/**
 * Details the result of an operation to Approve a Draft.
 */
export interface SetDraftApprovalStatusForCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * The notification list to set for an Organisation Draft Collaborator
 */
export interface SetDraftNotificationListForCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Collaborator who this notification list is for
   */
  collaboratorId: string;
  
  /**
   * The ID of the Draft this notification list is for
   */
  draftId: string;
  
  /**
   * The members that should be notified about this draft
   */
  notificationListMembers: Array<DraftNotificationListMemberInput>;
}

/**
 * Details of a Member of the Notification List
 */
export interface DraftNotificationListMemberInput {
  
  /**
   * The Organisation Member Id
   */
  organisationMemberId: string;
}

/**
 * Details the result of an operation to set the notification list.
 */
export interface SetDraftNotificationListForCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Details about the current state of a realtime author
 */
export interface SetDraftRealtimeAuthorStateInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Author is viewing. Required.
   */
  draftId: string;
  
  /**
   * The ID of the Organisation this Author is viewing the Draft as. Required.
   */
  organisationId: string;
  
  /**
   * The Authors current status
   */
  status: DraftRealtimeAuthorStatus;
}

/**
 * The realtime status of an author
 */
export enum DraftRealtimeAuthorStatus {
  
  /**
   * Clear the status for an Author, when they are no longer Viewing or Editing.
   */
  NONE = 'NONE',
  
  /**
   * Viewing the draft, and not editing.
   */
  VIEWING = 'VIEWING',
  
  /**
   * Editing the draft
   */
  EDITING = 'EDITING'
}

/**
 * Details of all the current realtime authors for a draft
 */
export interface SetDraftRealtimeAuthorStatePayload {
  authors: Array<DraftRealtimeAuthor>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

/**
 * Represents a realtime author of a draft
 */
export interface DraftRealtimeAuthor {
  
  /**
   * The details of the realtime author
   */
  author: DraftAuthor;
  
  /**
   * Whether this is the current user or not
   */
  isCurrentUser: boolean;
  
  /**
   * The status of the realtime author
   */
  status: DraftRealtimeAuthorStatus;
}

export interface SetFacilityApplicationBankOutcomeInput {
  
  /**
   * Approval outcome.
   * True for Approved (will transition the status to PENDING_PAYMENT)
   * False for Rejected (will transition the status to REJECTED)
   */
  approved: boolean;
  
  /**
   * The ID of the facility application to update the status of
   */
  facilityApplicationId: string;
}

export interface OrganisationGvpMetadataInput {
  gvpGuarantorIds: Array<string>;
  gvpId?: string;
  organisationId: string;
}

export interface OrganisationGvpMetadata {
  gvpGuarantorIds: Array<string>;
  gvpId?: string;
  organisationId: string;
}

/**
 * Details about a Draft Collaborator to extend to being Organisation scoped
 */
export interface ShareDraftToOrganisationFromCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Collaborator is for.
   */
  draftId: string;
  
  /**
   * The ID for the Draft Collaborator
   */
  id: string;
  
  /**
   * The ID of the Organisation to extend this Collaborator to include.
   */
  organisationId: string;
}

/**
 * Details of the Draft Collaborator updated
 */
export interface ShareDraftToOrganisationFromCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft Collaborator updated
   */
  draftCollaborator: DraftCollaborator;
}

export interface SubmitApplicationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  id: string;
}

/**
 * Details for updating the status of a Document (Bank Portal action)
 */
export interface BankDocumentUpdateInput {
  
  /**
   * The new amount for the document. Note that changing this may update the customers ongoing fees.
   */
  amount?: Decimal;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document.
   */
  documentId: string;
  
  /**
   * The new status for the document.
   */
  status?: UpdateDocumentStatus;
}

/**
 * Available statuses a Document can be updated to
 */
export enum UpdateDocumentStatus {
  
  /**
   * Client has indicated the document has been returned, however we have yet to confirm this with the bank.
   */
  AWAITING_RETURN = 'AWAITING_RETURN',
  
  /**
   * Returned. The funds have been returned to the Issuer and the Document is no longer active.
   */
  CLOSED_RETURNED = 'CLOSED_RETURNED',
  
  /**
   * Claimed. The funds have been claimed by the Beneficiary and the Document is no longer active.
   */
  CLOSED_CLAIMED = 'CLOSED_CLAIMED',
  
  /**
   * Cancelled. The Document is no longer active for some other reason.
   */
  CLOSED_CANCELLED = 'CLOSED_CANCELLED',
  
  /**
   * Expired. The Document passed its expiry date and is no longer active.
   */
  CLOSED_EXPIRED = 'CLOSED_EXPIRED'
}

/**
 * Details about the Document to update
 */
export interface UpdateDocumentInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The document costs (setup, fixed, percentage and frequency).
   */
  costs?: DocumentCostsInput;
  
  /**
   * The new custodian for the document. Do not provide this if it should not be changed.
   */
  custodian?: UpdateCustodianInput;
  
  /**
   * The new expected return date for the document. Do not provide this if it should not be changed.
   */
  expectedReturnDate?: Date;
  
  /**
   * The facility to link the document to.
   */
  facilityId?: string;
  
  /**
   * The ID for the Document. Required.
   */
  id: string;
  
  /**
   * The new expected maturity of the interest rate accrual.
   */
  interestEndDate?: Date;
  
  /**
   * The new expected start of the interest rate accrual.
   */
  interestStartDate?: Date;
  
  /**
   * The new status for the document. Do not provide this if it should not be changed.
   */
  status?: UpdateDocumentStatus;
}

/**
 * Details about a Document Custodian to update
 */
export interface UpdateCustodianInput {
  
  /**
   * The date the current Custodian received the Document.
   */
  dateReceived?: DateTime;
  
  /**
   * The email address of the current Custodian of the Document. Email format. Max length 255.
   */
  emailAddress?: string;
  
  /**
   * The name of the current Custodian of the Document. Max length 510.
   */
  name?: string;
  
  /**
   * User provided notes on the current Custodian of the Document. Max length 500.
   */
  notes?: string;
  
  /**
   * The storage address of the Document, under the current Custodian. Max length 500.
   */
  storageAddress?: string;
}

/**
 * Details of the updated Document
 */
export interface UpdateDocumentPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Document
   */
  document?: Document;
}

/**
 * Details about the Document Facility to update
 */
export interface UpdateDocumentFacilityInput {
  
  /**
   * The recurring annual cost. Range 0-999999999.99.
   */
  annualCost?: Decimal;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The type of the Documents this Facility is for.
   */
  documentVariant?: DocumentFacilityVariant;
  
  /**
   * The end date of the Facility. Required.
   */
  endDate?: Date;
  entities?: Array<UpsertFacilityEntityInput>;
  
  /**
   * The document costs (setup, fixed, percentage and frequency).
   */
  facilityDocumentCosts?: FacilityDocumentCostsInput;
  
  /**
   * The ID for the Document Facility. Required.
   */
  id: string;
  
  /**
   * The financial limit of the Facility. Range 0-999999999.99.
   */
  limit?: Decimal;
  
  /**
   * The name of the Facility. Max length 255.
   */
  name?: string;
  properties?: Array<UpsertFacilityPropertyInput>;
  
  /**
   * The name of the Financial Institution backing the Facility. Max length 255.
   */
  provider?: string;
  
  /**
   * The type of Security backing the Facility.
   */
  securityType?: SecurityType;
  
  /**
   * The cost value required for setup. Range 0-999999999.99.
   */
  setUpCost?: Decimal;
  
  /**
   * Indicates whether or not the facility is shared by other organisations.
   */
  sharedFacilityWithOrganisations?: Array<string>;
  
  /**
   * The start date of the Facility. Required.
   */
  startDate?: Date;
}

export interface UpsertFacilityEntityInput {
  abn: string;
  name: string;
}

export interface UpsertFacilityPropertyInput {
  address: string;
  estimatedValue: Decimal;
  isMortgaged: boolean;
  isPrimaryPlaceOfResidence?: boolean;
  
  /**
   * Mortgage lender.
   */
  lender?: string;
  
  /**
   * Amount left in mortgage
   */
  outstandingMortgage?: Decimal;
  owners: Array<UpsertFacilityPropertyOwnerInput>;
  
  /**
   * Type of facility
   */
  propertyType: PropertyType;
}

export interface UpsertFacilityPropertyOwnerInput {
  applicantRelationship?: string;
  name: string;
}

/**
 * Details of the updated Document Facility
 */
export interface UpdateDocumentFacilityPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Document Facility
   */
  documentFacility?: DocumentFacility;
}

/**
 * Details about an item of Document Metadata to update
 */
export interface UpdateDocumentMetadataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Document this Metadata is for. Required.
   */
  documentId: string;
  
  /**
   * The ID for the Document Metadata. Required.
   */
  id: string;
  
  /**
   * The new value for the Metadata. Required. Must be between 1 and 255 characters.
   */
  value: string;
}

/**
 * Details of the updated Document Metadata item
 */
export interface UpdateDocumentMetadataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Document Metadata item
   */
  metadata?: Metadata;
}

/**
 * Details about the Draft to update
 */
export interface UpdateDraftInput {
  acceptedChannelPartnerId?: string;
  
  /**
   * Additional supplier detail that should be captured.
   */
  additionalSupplierDetail?: AdditionalSupplierDetailInput;
  
  /**
   * The new monetary value of the Draft. Range 0-999999999.99. Do not provide this if it should not be changed
   */
  amount?: Decimal;
  
  /**
   * For the organisation to opt-into a referral/referee discount (if one is available)
   */
  applyAvailableReferralDiscount?: boolean;
  
  /**
   * The attachments to be created.
   */
  attachmentCreates?: Array<UpdateDraftCreateAttachmentInput>;
  
  /**
   * The attachments to be deleted.
   */
  attachmentDeletes?: Array<UpdateDraftDeleteAttachmentInput>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Comment on the current Draft amendment. Do not provide if no comments
   */
  comment?: string;
  
  /**
   * Updates to the contract details.
   */
  contractUpdates?: UpdateDraftContractDetailInput;
  deliveryDetails?: UpdateDraftDeliveryDetailsInput;
  
  /**
   * The New description (usually the Agreement Content) of the Draft
   * This usually contains details on what the Draft is covering, e.g. Installing new windows at a property
   */
  description?: string;
  
  /**
   * The directors email address, if not the originating user.
   */
  directorEmailAddress?: string;
  
  /**
   * The directors first name, if not the originating user.
   */
  directorFirstName?: string;
  
  /**
   * The directors last name, if not the originating user.
   */
  directorLastName?: string;
  discountPercentage?: Decimal;
  entityWealthAccumulation?: EntityWealthAccumulation;
  establishmentFeeDiscountAmount?: Decimal;
  
  /**
   * The Expected Return Date.
   */
  expectedReturnDate?: Date;
  
  /**
   * The new date the Draft expires.Do not provide this if it should not be changed
   */
  expiresAt?: Date;
  
  /**
   * The facility ID under which a bond/BG should be established.
   */
  facilityId?: string;
  feeSummaryId?: string;
  
  /**
   * The new funding of the Draft. Do not provide this if it should not be changed
   */
  fundingMethod?: FundingMethod;
  
  /**
   * The ID for the Draft. Required.
   */
  id: string;
  industry?: IdentificationIndustry;
  industryAdditionalDetails?: string;
  invoiceRecipientEmailAddresses?: string;
  
  /**
   * Further information on the source of funds for the security of the bank guarantee.
   */
  issuerDetailsOfSourceOfFunds?: string;
  
  /**
   * The source of the issuers funds for the security of the bank guarantee.
   */
  issuerSourceOfFunds?: DraftIssuerSourceOfFunds;
  
  /**
   * The ID of the Organisation that is executing the update. Required.
   */
  organisationId: string;
  
  /**
   * The parties to be created.
   */
  partyCreates?: Array<UpdateDraftCreatePartyInput>;
  
  /**
   * The parties to be deleted.
   */
  partyDeletes?: Array<UpdateDraftDeletePartyInput>;
  
  /**
   * The updated parties for the draft.
   */
  partyUpdates?: Array<UpdateDraftUpdatePartyInput>;
  
  /**
   * To record the user's acceptance of when the product terms e.g. on a product specific modal
   * Only required for some products e.g Prospa
   */
  productTermsAccepted?: boolean;
  
  /**
   * The Project or Property Address. Max length 500. Do not provide this if it should not be changed.
   */
  projectAddress?: string;
  
  /**
   * The new purpose of the Draft. Do not provide this if it should not be changed
   */
  purpose?: DraftPurpose;
  
  /**
   * The Draft's Reference Number, such as a Contract Number. Max length 255. Do not provide this if it should not be changed.
   */
  referenceNumber?: string;
  referralPercentage?: Decimal;
  refundAccountName?: string;
  refundAccountNumber?: string;
  refundBSB?: string;
  
  /**
   * The requested surety documents to be created.
   */
  requestedSuretyDocumentCreates?: Array<UpdateDraftCreateRequestedSuretyDocumentInput>;
  
  /**
   * The requested surety documents to be deleted.
   */
  requestedSuretyDocumentDeletes?: Array<UpdateDraftDeleteRequestedSuretyDocumentInput>;
  
  /**
   * The updated requested surety documents for the draft.
   */
  requestedSuretyDocumentUpdates?: Array<UpdateDraftUpdateRequestedSuretyDocumentInput>;
  
  /**
   * The new other specified purpose. Do not provide this if it should not be changed
   */
  specifiedOtherPurpose?: string;
  stripeSubscriptionId?: string;
  stripeSubscriptionStatus?: string;
}

export interface AdditionalSupplierDetailInput {
  
  /**
   * The account BSB from which the security of a bank guarantee will be taken.
   */
  fundingAccountBsb: string;
  
  /**
   * The account name from which the security of a bank guarantee will be taken.
   */
  fundingAccountNumber: string;
  
  /**
   * Has the client provided authority to take funds from their nominated funding account?
   */
  hasFundingAccountAuthorisation: boolean;
}

/**
 * Details a Draft Attachment to create.
 */
export interface UpdateDraftCreateAttachmentInput {
  
  /**
   * The content length in bytes of the attachment, so file size can be verified before allowing upload. Required. Range 0-30000000.
   */
  contentLength: number;
  
  /**
   * The content checksum in Base64 MD5 of the attachment, so the file can be verified once it is received by S3. Required. Max Length 255. Must be decodable from base64.
   */
  contentMd5Checksum: string;
  
  /**
   * The content type (mime type) of the attachment, so systems can identify how to open the file. Required. Max Length 255. Can only be one of "application/pdf", "image/jpeg", "image/png".
   */
  contentType: string;
  
  /**
   * The filename of the attachment, used to display the file. Required. Max Length 255. Should not contain slashes.
   */
  fileName: string;
  
  /**
   * The variant of the attachment. Eg "Contract Deed".
   */
  variant?: DraftAttachmentVariant;
}

/**
 * Details of Draft Attachment to be deleted.
 */
export interface UpdateDraftDeleteAttachmentInput {
  
  /**
   * The ID for the Attachment. Required.
   */
  id: string;
}

/**
 * Contract details to update on the draft
 */
export interface UpdateDraftContractDetailInput {
  
  /**
   * Bank fronted bonds have been requested.
   */
  bankFrontedBondsRequested?: boolean;
  
  /**
   * Reason Bank Guarantee is required.
   */
  bankFrontedBondsRequestedReason?: string;
  
  /**
   * Were there any defects and faults in materials, workmanship or design
   */
  defectsAndFaults?: UpdateDraftOptionWithDetailInput;
  
  /**
   * Has you Principal extended the defects liability Period?
   */
  defectsLiabilityPeriodExtended?: UpdateDraftOptionWithDetailInput;
  
  /**
   * The date by which any defects found must be fixed by
   */
  finalCompletionDate?: Date;
  
  /**
   * Does the contract identify delay events that give raise to Extension of Time and Cost Recovery?
   */
  hasDelayEvents?: boolean;
  
  /**
   * Does the contract include any "design" obligations and/or liability?
   */
  hasDesignObligationsLiability?: boolean;
  
  /**
   * Has the company undertaken previous contracts for this client?
   */
  hasPreviousContracts?: boolean;
  
  /**
   * Has the company undertaken a contract of this type before?
   */
  hasSimilarContracts?: boolean;
  
  /**
   * Is Existing Project?
   */
  isExistingProject?: boolean;
  
  /**
   * Whether the Issuer is acting as a Subcontractor to the Beneficiary
   */
  isSubcontractor?: boolean;
  
  /**
   * Are there any issues and / or disputes with respect to the underlying contract and for the defects liability period
   */
  issuesAndDisputes?: UpdateDraftOptionWithDetailInput;
  
  /**
   * The date when contracted work should be completed
   */
  practicalCompletionDate?: Date;
  
  /**
   * Has either of the project program or contract sum been exceeded.
   */
  projectNotOnBudget?: boolean;
  
  /**
   * Are we replacing alternative security and if so specify type of security being replaced.
   * This field is required in two cases:
   * 1. A maintenance bond is requested and a performance bond is not being requested.
   * 2. Bond period start date differs to the Contract Start date
   */
  replacingExistingSecurity?: UpdateDraftOptionWithDetailInput;
  
  /**
   * The contracted start date. Required.
   */
  startDate?: Date;
  
  /**
   * The total value of the contract
   */
  totalValue?: Decimal;
}

/**
 * Update a toggleable option and/or its detail
 */
export interface UpdateDraftOptionWithDetailInput {
  
  /**
   * Whether the option is active/selected/checked or not. Do not provide this if it should not be changed
   */
  active?: boolean;
  
  /**
   * User supplied detail of the option. Max length 500. Do not provide this if it should not be changed
   */
  detail?: string;
}

export interface UpdateDraftDeliveryDetailsInput {
  address: string;
  companyName?: string;
  
  /**
   * The selected delivery type
   * NOTE: can only be one of DIGITAL or PHYSICAL
   */
  deliveryType?: DeliveryType;
  phoneNumber: string;
  recipientFamilyName: string;
  recipientGivenName: string;
}

/**
 * Details a Draft Party, such as an Issuer or Beneficiary.
 */
export interface UpdateDraftCreatePartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit).
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 500.
   */
  address?: string;
  addressV2?: AddressInput;
  
  /**
   * The name of Party, most likely the company name. Required. Max length 1000.
   */
  name: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500.
   */
  notes?: string;
  partyEntityType?: PartyEntityType;
  
  /**
   * The type of the Party, e.g. Issuer or Beneficiary. Required.
   */
  partyVariant: DraftPartyVariant;
  
  /**
   * The main contact for the Party.
   */
  primaryContact?: DraftExtendedContactInput;
}

/**
 * Details of Draft Party to be deleted.
 */
export interface UpdateDraftDeletePartyInput {
  
  /**
   * The ID for the Party. Required.
   */
  id: string;
}

/**
 * Details a Draft Party, such as an Issuer or Beneficiary.
 */
export interface UpdateDraftUpdatePartyInput {
  
  /**
   * The ABN of Party. Must be a valid ABN (2 digit checksum of remaining 9 digits) or ACN (9th digit is check digit). Do not provide this if it should not be changed.
   */
  abn?: string;
  
  /**
   * The physical address of the Party, most likely the company address. Max length 500. Do not provide this if it should not be changed.
   */
  address?: string;
  addressV2?: AddressInput;
  
  /**
   * The ID for the Party. Required.
   */
  id: string;
  
  /**
   * The name of Party, most likely the company name. Max length 1000. Do not provide this if it should not be changed.
   */
  name?: string;
  
  /**
   * User entered notes about the party, e.g. contact details. Max length 500. Do not provide this if it should not be changed.
   */
  notes?: string;
  partyEntityType?: PartyEntityType;
  
  /**
   * The main contact for the Party. Do not provide this if it should not be changed.
   */
  primaryContact?: UpdateDraftExtendedContactInput;
}

/**
 * A contact with address and phone number
 */
export interface UpdateDraftExtendedContactInput {
  
  /**
   * The Email Address of the Contact. Max length 250. Do not provide this if it should not be changed
   */
  email?: string;
  
  /**
   * The Family Name of the Contact. Required. Max length 255. Do not provide this if it should not be changed
   */
  familyName?: string;
  
  /**
   * The Given Name of the Contact. Required. Max length 255. Do not provide this if it should not be changed
   */
  givenName?: string;
  
  /**
   * The Primary Phone Number of the Contact. Max length 255. Do not provide this if it should not be changed
   */
  phoneNumber?: string;
}

/**
 * Details a Draft Requested Surety Document.
 */
export interface UpdateDraftCreateRequestedSuretyDocumentInput {
  
  /**
   * The amount the requested document needs to cover. Required. Range 0-999999999.99.
   */
  amount: Decimal;
  
  /**
   * The document wording (legal content) to be used
   */
  documentWording?: string;
  
  /**
   * The template used for the document wording (legal content). Specify "OTHER" if not directly from template.
   */
  documentWordingTemplate?: DraftContractForm;
  
  /**
   * The expiry date for the requested document. Optional.
   */
  expiryDate?: Date;
  
  /**
   * The end of the period the requested document is active. Required.
   */
  periodEndDate: Date;
  
  /**
   * The start of the period the requested document is active. Required.
   */
  periodStartDate: Date;
  
  /**
   * The purpose of the Requested Document. Required.
   */
  purpose: DraftRequestedDocumentPurpose;
}

/**
 * Details of Draft Requested Surety Document to be deleted.
 */
export interface UpdateDraftDeleteRequestedSuretyDocumentInput {
  
  /**
   * The ID for the Requested Surety Document. Required.
   */
  id: string;
}

/**
 * Details a Draft Requested Surety Document.
 */
export interface UpdateDraftUpdateRequestedSuretyDocumentInput {
  
  /**
   * The amount the requested document needs to cover. Range 0-999999999.99. Do not provide this if it should not be changed.
   */
  amount?: Decimal;
  
  /**
   * The document wording (legal content) to be used
   */
  documentWording?: string;
  
  /**
   * The template used for the document wording (legal content). Specify "OTHER" if not directly from template.
   */
  documentWordingTemplate?: DraftContractForm;
  
  /**
   * The expiry date for the requested document. Do not provide this if it should not be changed.
   */
  expiryDate?: Date;
  
  /**
   * The ID for the Requested Document. Required.
   */
  id: string;
  
  /**
   * The end of the period the requested document is active. Do not provide this if it should not be changed.
   */
  periodEndDate?: Date;
  
  /**
   * The start of the period the requested document is active. Do not provide this if it should not be changed.
   */
  periodStartDate?: Date;
}

/**
 * Details of the updated Draft
 */
export interface UpdateDraftPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Draft
   */
  draft?: Draft;
}

/**
 * Details about a BG Switch Draft to create.
 */
export interface UpdateDraftBGSwitchInput {
  affirmationIrrevocability: boolean;
  beneficiaryApproval: boolean;
  
  /**
   * Full name of the bank which issued the current BG.
   */
  currentBankFullName?: string;
  
  /**
   * Expiry date (if any) of the current BG.
   */
  currentExpiryDate?: Date;
  currentGuaranteeNumber?: string;
  
  /**
   * Security type of the current BG.
   */
  currentSecurityType: BGSwitchSecurityType;
  
  /**
   * Value of current BG.
   */
  currentValue: Decimal;
  id: string;
  indemnityAgreement: boolean;
  irrevocableOrder: boolean;
  
  /**
   * If security type cash and cash is in term deposit.
   */
  isCashInTermDeposit?: boolean;
  
  /**
   * The ID of the Organisation that this Draft is for. Required.
   */
  organisationId: string;
  securityInterestDeclaration: boolean;
  status: BGSwitchStatus;
  
  /**
   * The end date of the term deposit if security type is cash and cash is in term deposit.
   */
  termDepositEndDate?: Date;
  transactionUnwindingClause: boolean;
}

/**
 * Details of the updated BG Switch Draft BG
 */
export interface UpdateDraftBGSwitchPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft created
   */
  draftBGSwitch: DraftBGSwitch;
}

/**
 * Details about a Draft Collaborator to create
 */
export interface UpdateDraftCollaboratorInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The ID of the Draft this Collaborator is for.
   */
  draftId: string;
  
  /**
   * The Given Name of the Draft Collaborator.
   */
  inviteAccepted?: boolean;
}

/**
 * Details of the Draft Collaborator created
 */
export interface UpdateDraftCollaboratorPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Draft Collaborator created
   */
  draftCollaborator: DraftCollaborator;
}

export interface UpdateBankDraftInput {
  acceptedChannelPartnerId?: string;
  
  /**
   * Additional supplier detail that should be captured.
   */
  additionalSupplierDetail?: AdditionalSupplierDetailInput;
  
  /**
   * The new monetary value of the Draft. Range 0-999999999.99. Do not provide this if it should not be changed
   */
  amount?: Decimal;
  
  /**
   * For the organisation to opt-into a referral/referee discount (if one is available)
   */
  applyAvailableReferralDiscount?: boolean;
  
  /**
   * The attachments to be created.
   */
  attachmentCreates?: Array<UpdateDraftCreateAttachmentInput>;
  
  /**
   * The attachments to be deleted.
   */
  attachmentDeletes?: Array<UpdateDraftDeleteAttachmentInput>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Comment on the current Draft amendment. Do not provide if no comments
   */
  comment?: string;
  
  /**
   * Updates to the contract details.
   */
  contractUpdates?: UpdateDraftContractDetailInput;
  deliveryDetails?: UpdateDraftDeliveryDetailsInput;
  
  /**
   * The New description (usually the Agreement Content) of the Draft
   * This usually contains details on what the Draft is covering, e.g. Installing new windows at a property
   */
  description?: string;
  
  /**
   * The directors email address, if not the originating user.
   */
  directorEmailAddress?: string;
  
  /**
   * The directors first name, if not the originating user.
   */
  directorFirstName?: string;
  
  /**
   * The directors last name, if not the originating user.
   */
  directorLastName?: string;
  discountPercentage?: Decimal;
  entityWealthAccumulation?: EntityWealthAccumulation;
  establishmentFeeDiscountAmount?: Decimal;
  
  /**
   * The Expected Return Date.
   */
  expectedReturnDate?: Date;
  
  /**
   * The new date the Draft expires.Do not provide this if it should not be changed
   */
  expiresAt?: Date;
  
  /**
   * The facility ID under which a bond/BG should be established.
   */
  facilityId?: string;
  feeSummaryId?: string;
  
  /**
   * The new funding of the Draft. Do not provide this if it should not be changed
   */
  fundingMethod?: FundingMethod;
  
  /**
   * The ID for the Draft. Required.
   */
  id: string;
  industry?: IdentificationIndustry;
  industryAdditionalDetails?: string;
  invoiceRecipientEmailAddresses?: string;
  
  /**
   * Further information on the source of funds for the security of the bank guarantee.
   */
  issuerDetailsOfSourceOfFunds?: string;
  
  /**
   * The source of the issuers funds for the security of the bank guarantee.
   */
  issuerSourceOfFunds?: DraftIssuerSourceOfFunds;
  organisationId?: string;
  
  /**
   * The parties to be created.
   */
  partyCreates?: Array<UpdateDraftCreatePartyInput>;
  
  /**
   * The parties to be deleted.
   */
  partyDeletes?: Array<UpdateDraftDeletePartyInput>;
  
  /**
   * The updated parties for the draft.
   */
  partyUpdates?: Array<UpdateDraftUpdatePartyInput>;
  
  /**
   * To record the user's acceptance of when the product terms e.g. on a product specific modal
   * Only required for some products e.g Prospa
   */
  productTermsAccepted?: boolean;
  
  /**
   * The Project or Property Address. Max length 500. Do not provide this if it should not be changed.
   */
  projectAddress?: string;
  
  /**
   * The new purpose of the Draft. Do not provide this if it should not be changed
   */
  purpose?: DraftPurpose;
  
  /**
   * The Draft's Reference Number, such as a Contract Number. Max length 255. Do not provide this if it should not be changed.
   */
  referenceNumber?: string;
  referralPercentage?: Decimal;
  refundAccountName?: string;
  refundAccountNumber?: string;
  refundBSB?: string;
  
  /**
   * The requested surety documents to be created.
   */
  requestedSuretyDocumentCreates?: Array<UpdateDraftCreateRequestedSuretyDocumentInput>;
  
  /**
   * The requested surety documents to be deleted.
   */
  requestedSuretyDocumentDeletes?: Array<UpdateDraftDeleteRequestedSuretyDocumentInput>;
  
  /**
   * The updated requested surety documents for the draft.
   */
  requestedSuretyDocumentUpdates?: Array<UpdateDraftUpdateRequestedSuretyDocumentInput>;
  
  /**
   * The new other specified purpose. Do not provide this if it should not be changed
   */
  specifiedOtherPurpose?: string;
  status?: DraftStatus;
  stripeSubscriptionId?: string;
  stripeSubscriptionStatus?: string;
}

/**
 * Details of the updated Draft
 */
export interface UpdateBankDraftPayload {
  applicableRequirements: Array<DraftApplicableRequirement>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated Draft
   */
  draft: Draft;
}

export interface UpdateDraftMegDetailsInput {
  draftId: string;
  megAppId?: string;
  megAppNo?: string;
  megDetails: string;
}

/**
 * Details of the updated Draft
 */
export interface UpdateDraftPreviewPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * History records that will be committed with the draft changes
   */
  history: Array<DraftHistory>;
}

/**
 * Details about the Facility Application to Update
 */
export interface UpdateApplicationInput {
  applicant?: UpdateApplicationApplicantInput;
  applicationInformation?: UpdateApplicationInformationInput;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  entities?: Array<UpsertFacilityApplicationEntityInput>;
  facilityApplicationId: string;
  properties?: Array<UpsertFacilityApplicationPropertyInput>;
  sharedFacilityWithOrganisations?: Array<string>;
}

/**
 * Details about the Facility Applicant to update
 */
export interface UpdateApplicationApplicantInput {
  abn: string;
  address: string;
  companyName: string;
  contactName: string;
  contactTitle: string;
  emailAddress: string;
  entityType?: ApplicantEntityType;
  industry?: string;
  phoneNumber: string;
  role?: string;
  website: string;
}

export interface UpdateApplicationInformationInput {
  facilityLimit: Decimal;
}

export interface UpsertFacilityApplicationEntityInput {
  abn: string;
  name: string;
}

export interface UpsertFacilityApplicationPropertyInput {
  address: string;
  estimatedValue: Decimal;
  isMortgaged: boolean;
  isPrimaryPlaceOfResidence?: boolean;
  
  /**
   * Mortgage lender.
   */
  lender?: string;
  
  /**
   * Amount left in mortgage
   */
  outstandingMortgage?: Decimal;
  owners: Array<UpsertFacilityApplicationPropertyOwnerInput>;
  
  /**
   * Type of facility
   */
  propertyType: PropertyType;
}

export interface UpsertFacilityApplicationPropertyOwnerInput {
  applicantRelationship?: string;
  name: string;
}

export interface UpdateFacilityApplicationPaymentStatusInput {
  facilityApplicationId: string;
  invoiceNumber?: string;
}

export interface UpdateGreenIdInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  greenIdVerificationId: string;
  identificationIndividualId: string;
}

export interface UpdateGreenIdPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identificationIndividual?: IdentificationIndividual;
}

export interface UpdateBankGreenIdInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  greenIdVerificationId: string;
  identificationIndividualId: string;
}

export interface UpdateBankGreenIdPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identificationIndividual?: IdentificationIndividual;
}

export interface UpdateIdentificationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  companyDetailsACN?: string;
  companyDetailsHasBeneficialOwners?: boolean;
  companyDetailsIsListed?: boolean;
  companyDetailsIsNormalType?: boolean;
  companyDetailsIsRegulated?: boolean;
  companyDetailsIsSubsidiaryListed?: boolean;
  companyDetailsListedExchangeName?: string;
  companyDetailsName?: string;
  companyDetailsNatureOfBusiness?: string;
  companyDetailsOnlyOperatesInAustralia?: boolean;
  companyDetailsPrincipalPlaceOfBusiness?: string;
  companyDetailsRegisteredAddress?: string;
  companyDetailsRegulatorLicenseNumber?: string;
  companyDetailsRegulatorName?: string;
  companyDetailsSubsidiaryListedCompanyName?: string;
  companyDetailsSubsidiaryListedExchangeName?: string;
  companyDetailsTaxFatcaStatus?: IdentificationCompanyDetailsTaxFatcaStatus;
  companyDetailsTaxFatcaStatusOther?: string;
  companyDetailsTaxForeignResidentCountry?: string;
  companyDetailsTaxGIIN?: string;
  companyDetailsTaxHasBeneficialOwnerForeignResident?: boolean;
  companyDetailsTaxHasGIIN?: boolean;
  companyDetailsTaxIsForeignResident?: boolean;
  companyDetailsTaxType?: IdentificationCompanyDetailsTaxType;
  dataType?: IdentificationDataType;
  entityType?: IdentificationEntityType;
  entityWealthAccumulation?: EntityWealthAccumulation;
  hasDividendsIncome?: boolean;
  hasMacAccount?: boolean;
  id: string;
  identificationIndustry?: IdentificationIndustry;
  individuals?: Array<IdentificationIndividualInput>;
  industryAdditionalDetails?: string;
  macAccountName?: string;
  macAccountNumber?: string;
  postalAddress?: string;
  step?: IdentificationStep;
  taxExemptionDetails?: string;
  taxExemptionType?: IdentificationCompanyDetailsTaxTaxExemptionType;
  taxStatus?: IdentificationCompanyDetailsTaxStatus;
}

export interface IdentificationIndividualInput {
  emailAddress?: string;
  firstName?: string;
  greenIdToken?: string;
  greenIdVerificationId?: string;
  greenIdVerificationStatus?: GreenIdVerificationStatus;
  id?: string;
  identificationId?: string;
  isAccountSignatory?: boolean;
  isApprover?: boolean;
  
  /**
   * An individual who owns 25% or more of the company.
   */
  isBeneficialOwner?: boolean;
  isDirectorOrSecretary?: boolean;
  isForeignResident?: boolean;
  isMacVerified?: boolean;
  isValidated?: boolean;
  macVerifiedNumber?: string;
  middleNames?: string;
  phoneMobile?: string;
  simpleKycDataIndividualId?: string;
  surname?: string;
  taxForeignResidentCountry?: string;
  taxReasonNoTIN?: TaxReasonNoTIN;
  taxReasonUnavailableTIN?: string;
  taxpayerIdentificationNumber?: string;
  title?: string;
  userRole?: IdentificationUserRole;
}

export interface UpdateBankIdentificationInput {
  adminStatus?: IdentificationApprovalStatus;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  comments?: string;
  companyDetailsACN?: string;
  companyDetailsHasBeneficialOwners?: boolean;
  companyDetailsIsListed?: boolean;
  companyDetailsIsNormalType?: boolean;
  companyDetailsIsRegulated?: boolean;
  companyDetailsIsSubsidiaryListed?: boolean;
  companyDetailsListedExchangeName?: string;
  companyDetailsName?: string;
  companyDetailsNatureOfBusiness?: string;
  companyDetailsOnlyOperatesInAustralia?: boolean;
  companyDetailsPrincipalPlaceOfBusiness?: string;
  companyDetailsRegisteredAddress?: string;
  companyDetailsRegulatorLicenseNumber?: string;
  companyDetailsRegulatorName?: string;
  companyDetailsSubsidiaryListedCompanyName?: string;
  companyDetailsSubsidiaryListedExchangeName?: string;
  companyDetailsTaxFatcaStatus?: IdentificationCompanyDetailsTaxFatcaStatus;
  companyDetailsTaxFatcaStatusOther?: string;
  companyDetailsTaxForeignResidentCountry?: string;
  companyDetailsTaxGIIN?: string;
  companyDetailsTaxHasBeneficialOwnerForeignResident?: boolean;
  companyDetailsTaxHasGIIN?: boolean;
  companyDetailsTaxIsForeignResident?: boolean;
  companyDetailsTaxType?: IdentificationCompanyDetailsTaxType;
  dataType?: IdentificationDataType;
  entityType?: IdentificationEntityType;
  entityWealthAccumulation?: EntityWealthAccumulation;
  hasDividendsIncome?: boolean;
  hasMacAccount?: boolean;
  id: string;
  identificationIndustry?: IdentificationIndustry;
  individuals?: Array<IdentificationIndividualInput>;
  industryAdditionalDetails?: string;
  macAccountName?: string;
  macAccountNumber?: string;
  postalAddress?: string;
  step?: IdentificationStep;
  taxExemptionDetails?: string;
  taxExemptionType?: IdentificationCompanyDetailsTaxTaxExemptionType;
  taxStatus?: IdentificationCompanyDetailsTaxStatus;
}

export interface UpdateBankIdentificationPayload {
  applicableRequirements: Array<IdentificationApplicableRequirement>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identification?: BankIdentification;
}

export interface UpdateBankIdentificationRiskDetailsInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identificationId: string;
  riskDetails?: string;
  riskStatus?: RiskStatus;
}

export interface UpdateBankIdentificationRiskDetailsPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identification?: BankIdentification;
}

/**
 * Updates the date in which the user has viewed the lastest platform updates.
 */
export interface UpdateNotifiedAtInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The datetime when the user last viewed the platform updates notification
   */
  updatesNotifiedAt: DateTime;
}

/**
 * The response when the last notification date has been updated successfully.
 */
export interface UpdateNotifiedPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated User Profile record.
   */
  profile?: Profile;
}

/**
 * Details about an Organisation to update
 */
export interface UpdateOrganisationInput {
  
  /**
   * The ABN of the Organisation. ABN format.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   */
  address?: string;
  channelPartnerIds?: Array<string>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Organisation's Fee Discount Percentage.
   */
  discountPercentage?: Decimal;
  entityType?: PartyEntityType;
  feeSummaryIds?: Array<string>;
  
  /**
   * The ID for the Organisation. Required.
   */
  id: string;
  isOngoingClient?: boolean;
  leadSource?: string;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Max length 255.
   */
  name?: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Max length 255.
   */
  nickname?: string;
  
  /**
   * The Organisation Type.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * The Postal Address of the Organisation. Max length 500.
   */
  postalAddress?: string;
  
  /**
   * Whether the Postal Address of the Organisation is the same as the Business Address.
   */
  postalAddressSameAsBusinessAddress?: boolean;
  relationshipManagerId?: string;
  
  /**
   * The Stripe CustomerId of the Organisation. Max length 500.
   */
  stripeCustomerId?: string;
}

/**
 * The result of the Update Organisation operation.
 */
export interface UpdateOrganisationPayload {
  
  /**
   * The ABN of the Organisation. ABN format.
   * @deprecated Please use the organisation property to access this detail.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   * @deprecated Please use the organisation property to access this detail.
   */
  address?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The date stamp the record was created. Required.
   * @deprecated Please use the organisation property to access this detail.
   */
  createdAt: DateTime;
  
  /**
   * The identifier for who or what created this record. Required.
   * @deprecated Please use the organisation property to access this detail.
   */
  createdBy: string;
  
  /**
   * The ID for the Organisation.
   * @deprecated Please use the organisation property to access this detail.
   */
  id: string;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  industryType?: string;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  isOngoingClient?: boolean;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  leadSource?: string;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  name: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  nickname?: string;
  
  /**
   * The Organisation updated
   */
  organisation: Organisation;
  
  /**
   * The Organisation Type.
   * @deprecated Please use the organisation property to access this detail.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  relationshipManagerId?: string;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  stripeCustomerId?: string;
}

/**
 * Details about an Organisation level Alert Configuration to update
 */
export interface UpdateOrganisationAlertConfigurationInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The email addresses that should be notified for an Alert. Min length 1, max length 25. Each element must be in email format.
   */
  emailAddresses: Array<string>;
  
  /**
   * The facility linked to the alert.
   */
  facilityId?: string;
  
  /**
   * The percentage that triggers the facility limit alert
   */
  facilityLimit?: Decimal;
  
  /**
   * Indicates if request facility limit should include projected docs.
   */
  facilityLimitIncludeProjectedDocs?: boolean;
  
  /**
   * The ID for the Alert Configuration. Required.
   */
  id: string;
  
  /**
   * The ID of the Organisation that this Alert Configuration is for. Required.
   */
  organisationId: string;
  
  /**
   * The number of seconds before the event the Alert should be triggered.
   */
  triggerLeadTime?: Seconds;
  
  /**
   * The property that will trigger the Alert. Required.
   */
  triggerProperty?: AlertTriggerProperty;
}

/**
 * Details of the updated Organisation level Alert Configuration
 */
export interface UpdateOrganisationAlertConfigurationPayload {
  
  /**
   * The updated Alert Configuration
   */
  alertConfiguration: AlertConfiguration;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
}

export interface UpdateOrganisationForBankPortalInput {
  
  /**
   * The ABN of the Organisation. ABN format.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   */
  address?: string;
  channelPartnerIds?: Array<string>;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Organisation's Fee Discount Percentage.
   */
  discountPercentage?: Decimal;
  entityType?: PartyEntityType;
  feeSummaryIds?: Array<string>;
  
  /**
   * The ID for the Organisation. Required.
   */
  id: string;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   */
  industryType?: string;
  isOngoingClient?: boolean;
  leadSource?: string;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Max length 255.
   */
  name?: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Max length 255.
   */
  nickname?: string;
  
  /**
   * The Organisation Type.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * The Postal Address of the Organisation. Max length 500.
   */
  postalAddress?: string;
  
  /**
   * Whether the Postal Address of the Organisation is the same as the Business Address.
   */
  postalAddressSameAsBusinessAddress?: boolean;
  relationshipManagerId?: string;
  
  /**
   * The Stripe CustomerId of the Organisation. Max length 500.
   */
  stripeCustomerId?: string;
}

export interface UpdateBankOrganisationPayload {
  
  /**
   * The ABN of the Organisation. ABN format.
   * @deprecated Please use the organisation property to access this detail.
   */
  abn?: string;
  
  /**
   * The Address of the Organisation. Max length 500.
   * @deprecated Please use the organisation property to access this detail.
   */
  address?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The date stamp the record was created. Required.
   * @deprecated Please use the organisation property to access this detail.
   */
  createdAt: DateTime;
  
  /**
   * The identifier for who or what created this record. Required.
   * @deprecated Please use the organisation property to access this detail.
   */
  createdBy: string;
  
  /**
   * The ID for the Organisation.
   * @deprecated Please use the organisation property to access this detail.
   */
  id: string;
  
  /**
   * The Industry Type of the Organisation. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  industryType?: string;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  isOngoingClient?: boolean;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  leadSource?: string;
  
  /**
   * The Name of the Organisation, usually the Company Name. Required. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  name: string;
  
  /**
   * The Nickname of the Organisation, usually the Trading Name. Max length 255.
   * @deprecated Please use the organisation property to access this detail.
   */
  nickname?: string;
  
  /**
   * The Organisation updated
   */
  organisation: Organisation;
  
  /**
   * The Organisation Type.
   * @deprecated Please use the organisation property to access this detail.
   */
  organisationVariant?: OrganisationVariant;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  relationshipManagerId?: string;
  
  /**
   * 
   * @deprecated Please use the organisation property to access this detail.
   */
  stripeCustomerId?: string;
}

/**
 * Updated details for a user profile.
 */
export interface UpdateProfileInput {
  
  /**
   * The physical address of the user. Max Length 255.
   */
  address?: string;
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The Family name (surname) of the user. Required. Max Length 255.
   */
  familyName: string;
  
  /**
   * The Given (First) name of the user. Required. Max Length 255.
   */
  givenName: string;
  
  /**
   * The industry of the user. Max Length 255.
   */
  industry?: string;
  
  /**
   * The job title of the user. Max Length 255.
   */
  jobTitle?: string;
  
  /**
   * The locale (which assists in language detection) of the user. Max Length 255.
   */
  locale?: string;
  
  /**
   * The phone number of the user. Max Length 255.
   */
  phoneNumber?: string;
  
  /**
   * The timezone (which assists in clock/date correction) of the user. Max Length 255.
   */
  timezone?: string;
}

/**
 * The response when a profile has been updated successfully.
 */
export interface UpdateProfilePayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * The updated User Profile record.
   */
  profile?: Profile;
}

export interface UpdateSimpleKycDataInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  simpleKycDataId: string;
}

export interface UpdateSimpleKycDataPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * 
   * @deprecated Please use the SimpleKycData property to access this detail.
   */
  id: string;
  
  /**
   * 
   * @deprecated Please use the SimpleKycData property to access this detail.
   */
  simpleKycApplicationId: string;
  simpleKycData: SimpleKycData;
}

export interface SimpleKycData {
  applicationStatus?: ApplicationStatus;
  businessNames?: string;
  companyABN: string;
  createdAt: DateTime;
  entityClassification?: string;
  id: string;
  individuals?: Array<SimpleKycDataIndividual>;
  legalBusinessName?: string;
  principalPlaceOfBusinessAddress?: string;
  registeredOfficeAddress?: string;
  simpleKycApplicationId: string;
}

export interface SimpleKycDataIndividual {
  address?: SimpleKycDataIndividualAddress;
  dateOfBirth?: Date;
  firstName?: string;
  id: string;
  isBeneficialOwner?: boolean;
  isDirector?: boolean;
  lastName?: string;
  middleNames?: string;
  roles?: string;
  simpleKycDataId: string;
}

export interface SimpleKycDataIndividualAddress {
  country?: string;
  country_name?: string;
  number?: string;
  postalCode?: string;
  state?: string;
  street?: string;
  suburb?: string;
  type?: string;
  unformattedAddress?: string;
  unit?: string;
}

export interface UpdateSimpleKycDataAppInput {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  identificationId: string;
}

export interface UpdateSimpleKycDataAppPayload {
  
  /**
   * A value provided by the client to identify this mutation operation. Recommended to be a GUID. Min Length 5, Max Length 50.
   */
  clientMutationId: string;
  
  /**
   * 
   * @deprecated Please use the SimpleKycData property to access this detail.
   */
  id: string;
  
  /**
   * 
   * @deprecated Please use the SimpleKycData property to access this detail.
   */
  simpleKycApplicationId: string;
  simpleKycData: ISimpleKycData;
}

export interface VoidOrganisationCreditInput {
  comment: string;
  organisationCreditId: string;
}

export interface Subscription {
  
  /**
   * Triggers when the document with the ID provided is updated.
   */
  documentUpdated: Document;
  
  /**
   * Triggers when the draft with the ID provided is updated.
   */
  draftUpdated: Draft;
  
  /**
   * Triggers when the draft with the ID provided is updated.
   */
  draftUpdatedForBankPortal: string;
  
  /**
   * Triggers when the import job is completed
   */
  importJobCompleted: ImportJob;
  
  /**
   * Triggers when the organisations document collection changes. This does not contain information on the document added/changed/removed.
   */
  organisationDocumentsChanged: string;
  
  /**
   * Triggers when the organisation with the ID provided is updated.
   */
  organisationUpdated: Organisation;
  reportUpdated: string;
}

export enum ApplyPolicy {
  BEFORE_RESOLVER = 'BEFORE_RESOLVER',
  AFTER_RESOLVER = 'AFTER_RESOLVER'
}

/**
 * The possible types of Identification.
 */
export enum DraftIdentificationDocumentVariant {
  
  /**
   * Passport
   */
  PASSPORT = 'PASSPORT',
  
  /**
   * Drivers License
   */
  DRIVERS_LICENSE = 'DRIVERS_LICENSE'
}

/*********************************
 *                               *
 *         TYPE RESOLVERS        *
 *                               *
 *********************************/
/**
 * This interface define the shape of your resolver
 * Note that this type is designed to be compatible with graphql-tools resolvers
 * However, you can still use other generated interfaces to make your resolver type-safed
 */
export interface Resolver {
  Query?: QueryTypeResolver;
  ApplicationContactDetails?: ApplicationContactDetailsTypeResolver;
  DateTime?: GraphQLScalarType;
  BankAssetContent?: BankAssetContentTypeResolver;
  DraftBGSwitch?: DraftBGSwitchTypeResolver;
  Decimal?: GraphQLScalarType;
  PaginationAmount?: GraphQLScalarType;
  BgSwitchesByOrganisationIdConnection?: BgSwitchesByOrganisationIdConnectionTypeResolver;
  BgSwitchesByOrganisationIdEdge?: BgSwitchesByOrganisationIdEdgeTypeResolver;
  PageInfo?: PageInfoTypeResolver;
  FinanceRepaymentSummary?: FinanceRepaymentSummaryTypeResolver;
  RepaymentOption?: RepaymentOptionTypeResolver;
  ChannelPartnersConnection?: ChannelPartnersConnectionTypeResolver;
  ChannelPartnersEdge?: ChannelPartnersEdgeTypeResolver;
  ChannelPartners?: ChannelPartnersTypeResolver;
  ChannelPartnersForBankPortalConnection?: ChannelPartnersForBankPortalConnectionTypeResolver;
  ChannelPartnersForBankPortalEdge?: ChannelPartnersForBankPortalEdgeTypeResolver;
  CognitoUser?: CognitoUserTypeResolver;
  CognitoGetBankUsersConnection?: CognitoGetBankUsersConnectionTypeResolver;
  CognitoGetBankUsersEdge?: CognitoGetBankUsersEdgeTypeResolver;
  DocumentAttachmentDownload?: DocumentAttachmentDownloadTypeResolver;
  Document?: DocumentTypeResolver;
  DocumentAttachment?: DocumentAttachmentTypeResolver;
  Bank?: BankTypeResolver;
  DocumentCallerContext?: DocumentCallerContextTypeResolver;
  DocumentOrganisation?: DocumentOrganisationTypeResolver;
  CollaboratorsConnection?: CollaboratorsConnectionTypeResolver;
  CollaboratorsEdge?: CollaboratorsEdgeTypeResolver;
  DocumentCollaborator?: DocumentCollaboratorTypeResolver;
  CommentsConnection?: CommentsConnectionTypeResolver;
  CommentsEdge?: CommentsEdgeTypeResolver;
  Comment?: CommentTypeResolver;
  Author?: AuthorTypeResolver;
  DocumentCosts?: DocumentCostsTypeResolver;
  Custodian?: CustodianTypeResolver;
  Date?: GraphQLScalarType;
  DocumentHandover?: DocumentHandoverTypeResolver;
  HistoryConnection?: HistoryConnectionTypeResolver;
  HistoryEdge?: HistoryEdgeTypeResolver;
  DocumentHistory?: DocumentHistoryTypeResolver;
  DocumentHistoryChange?: DocumentHistoryChangeTypeResolver;
  IInvoice?: IInvoiceTypeResolver;
  IInvoiceLineItem?: {
    __resolveType: IInvoiceLineItemTypeResolver
  };
  
  IInvoicePaymentIntent?: {
    __resolveType: IInvoicePaymentIntentTypeResolver
  };
  
  Long?: GraphQLScalarType;
  MetadataConnection?: MetadataConnectionTypeResolver;
  MetadataEdge?: MetadataEdgeTypeResolver;
  Metadata?: MetadataTypeResolver;
  Party?: PartyTypeResolver;
  Address?: AddressTypeResolver;
  DocumentRequestForReturn?: DocumentRequestForReturnTypeResolver;
  Short?: GraphQLScalarType;
  DocumentNotificationListMember?: DocumentNotificationListMemberTypeResolver;
  DocumentFacilitiesConnection?: DocumentFacilitiesConnectionTypeResolver;
  DocumentFacilitiesEdge?: DocumentFacilitiesEdgeTypeResolver;
  DocumentFacility?: DocumentFacilityTypeResolver;
  FacilityEntity?: FacilityEntityTypeResolver;
  FacilityHistoryConnection?: FacilityHistoryConnectionTypeResolver;
  FacilityHistoryEdge?: FacilityHistoryEdgeTypeResolver;
  FacilityHistory?: FacilityHistoryTypeResolver;
  FacilityHistoryChange?: FacilityHistoryChangeTypeResolver;
  FacilityOrganisation?: FacilityOrganisationTypeResolver;
  FacilityProperty?: FacilityPropertyTypeResolver;
  FacilityPropertyOwner?: FacilityPropertyOwnerTypeResolver;
  FacilitySharedFacilityWithOrganisation?: FacilitySharedFacilityWithOrganisationTypeResolver;
  DocumentReportsConnection?: DocumentReportsConnectionTypeResolver;
  DocumentReportsEdge?: DocumentReportsEdgeTypeResolver;
  Report?: ReportTypeResolver;
  DocumentsConnection?: DocumentsConnectionTypeResolver;
  DocumentsEdge?: DocumentsEdgeTypeResolver;
  DocumentsForBankPortalConnection?: DocumentsForBankPortalConnectionTypeResolver;
  DocumentsForBankPortalEdge?: DocumentsForBankPortalEdgeTypeResolver;
  BankDocument?: BankDocumentTypeResolver;
  DocumentsSharedWithMeConnection?: DocumentsSharedWithMeConnectionTypeResolver;
  DocumentsSharedWithMeEdge?: DocumentsSharedWithMeEdgeTypeResolver;
  DraftApplicableRequirement?: DraftApplicableRequirementTypeResolver;
  DraftAttachmentDownload?: DraftAttachmentDownloadTypeResolver;
  Draft?: DraftTypeResolver;
  AdditionalSupplierDetail?: AdditionalSupplierDetailTypeResolver;
  DraftAttachment?: DraftAttachmentTypeResolver;
  DraftCallerContext?: DraftCallerContextTypeResolver;
  DraftCollaborator?: DraftCollaboratorTypeResolver;
  DraftNotificationListMember?: DraftNotificationListMemberTypeResolver;
  DraftOrganisation?: DraftOrganisationTypeResolver;
  DraftContractDetail?: DraftContractDetailTypeResolver;
  DraftOptionWithDetail?: DraftOptionWithDetailTypeResolver;
  DraftDeliveryDetails?: DraftDeliveryDetailsTypeResolver;
  DraftCollaboratorsConnection?: DraftCollaboratorsConnectionTypeResolver;
  DraftCollaboratorsEdge?: DraftCollaboratorsEdgeTypeResolver;
  DraftCommentsConnection?: DraftCommentsConnectionTypeResolver;
  DraftCommentsEdge?: DraftCommentsEdgeTypeResolver;
  DraftComment?: DraftCommentTypeResolver;
  DraftAuthor?: DraftAuthorTypeResolver;
  DraftHistory?: DraftHistoryTypeResolver;
  DraftHistoryChange?: DraftHistoryChangeTypeResolver;
  DraftHistoryConnection?: DraftHistoryConnectionTypeResolver;
  DraftHistoryEdge?: DraftHistoryEdgeTypeResolver;
  FeeSummary?: FeeSummaryTypeResolver;
  Supplier?: SupplierTypeResolver;
  Identification?: IdentificationTypeResolver;
  IdentificationApplicableRequirement?: IdentificationApplicableRequirementTypeResolver;
  IdentificationIndividual?: IdentificationIndividualTypeResolver;
  GreenIdVerificationResult?: GreenIdVerificationResultTypeResolver;
  GreenIdAddress?: GreenIdAddressTypeResolver;
  GreenIdWatchlistStatus?: GreenIdWatchlistStatusTypeResolver;
  ISimpleKycDataIndividual?: ISimpleKycDataIndividualTypeResolver;
  ISimpleKycAddress?: ISimpleKycAddressTypeResolver;
  IdentificationOrganisation?: IdentificationOrganisationTypeResolver;
  IdentificationOrganisationChannelPartner?: IdentificationOrganisationChannelPartnerTypeResolver;
  ICognitoUser?: ICognitoUserTypeResolver;
  ISimpleKycData?: ISimpleKycDataTypeResolver;
  DraftInvoice?: DraftInvoiceTypeResolver;
  InvoiceLineItem?: InvoiceLineItemTypeResolver;
  InvoicePaymentIntent?: InvoicePaymentIntentTypeResolver;
  DraftParty?: DraftPartyTypeResolver;
  DraftExtendedContact?: DraftExtendedContactTypeResolver;
  DraftRequestedPaymentDetails?: DraftRequestedPaymentDetailsTypeResolver;
  DraftRequestedPaymentLineItemDetails?: DraftRequestedPaymentLineItemDetailsTypeResolver;
  ReferralDiscount?: ReferralDiscountTypeResolver;
  DraftRequestedSuretyDocuments?: DraftRequestedSuretyDocumentsTypeResolver;
  RequiredDocumentViewModel?: RequiredDocumentViewModelTypeResolver;
  RequiredDocumentMessageViewModel?: RequiredDocumentMessageViewModelTypeResolver;
  IUser?: IUserTypeResolver;
  DraftOriginationsForBankPortalConnection?: DraftOriginationsForBankPortalConnectionTypeResolver;
  DraftOriginationsForBankPortalEdge?: DraftOriginationsForBankPortalEdgeTypeResolver;
  ApiDraftOrigination?: ApiDraftOriginationTypeResolver;
  IChannelPartner?: IChannelPartnerTypeResolver;
  ApiDraftOriginationParty?: ApiDraftOriginationPartyTypeResolver;
  ApiDraftOriginationPartRepresentative?: ApiDraftOriginationPartRepresentativeTypeResolver;
  DraftsByOrganisationIdConnection?: DraftsByOrganisationIdConnectionTypeResolver;
  DraftsByOrganisationIdEdge?: DraftsByOrganisationIdEdgeTypeResolver;
  DraftsForBankPortalConnection?: DraftsForBankPortalConnectionTypeResolver;
  DraftsForBankPortalEdge?: DraftsForBankPortalEdgeTypeResolver;
  BankDraft?: BankDraftTypeResolver;
  DraftChannelPartners?: DraftChannelPartnersTypeResolver;
  BankFacility?: BankFacilityTypeResolver;
  Deal?: DealTypeResolver;
  DraftsSharedWithMeConnection?: DraftsSharedWithMeConnectionTypeResolver;
  DraftsSharedWithMeEdge?: DraftsSharedWithMeEdgeTypeResolver;
  FacilitiesForBankPortalConnection?: FacilitiesForBankPortalConnectionTypeResolver;
  FacilitiesForBankPortalEdge?: FacilitiesForBankPortalEdgeTypeResolver;
  FacilityApplication?: FacilityApplicationTypeResolver;
  Applicant?: ApplicantTypeResolver;
  ApplicationInformation?: ApplicationInformationTypeResolver;
  FacilityApplicationAttachment?: FacilityApplicationAttachmentTypeResolver;
  FacilityApplicationEntity?: FacilityApplicationEntityTypeResolver;
  EstablishmentRecord?: EstablishmentRecordTypeResolver;
  FacilityApplicationHistoryConnection?: FacilityApplicationHistoryConnectionTypeResolver;
  FacilityApplicationHistoryEdge?: FacilityApplicationHistoryEdgeTypeResolver;
  FacilityApplicationHistory?: FacilityApplicationHistoryTypeResolver;
  FacilityApplicationHistoryChange?: FacilityApplicationHistoryChangeTypeResolver;
  FacilityApplicationOrganisation?: FacilityApplicationOrganisationTypeResolver;
  FacilityApplicationProperty?: FacilityApplicationPropertyTypeResolver;
  FacilityApplicationPropertyOwner?: FacilityApplicationPropertyOwnerTypeResolver;
  FacilityApplicationSharedFacilityWithOrganisation?: FacilityApplicationSharedFacilityWithOrganisationTypeResolver;
  SubmissionRecord?: SubmissionRecordTypeResolver;
  FacilityApplicationsConnection?: FacilityApplicationsConnectionTypeResolver;
  FacilityApplicationsEdge?: FacilityApplicationsEdgeTypeResolver;
  FacilityApplicationsForBankPortalConnection?: FacilityApplicationsForBankPortalConnectionTypeResolver;
  FacilityApplicationsForBankPortalEdge?: FacilityApplicationsForBankPortalEdgeTypeResolver;
  GatewayFeatures?: GatewayFeaturesTypeResolver;
  FinanceRecordsForBankPortalConnection?: FinanceRecordsForBankPortalConnectionTypeResolver;
  FinanceRecordsForBankPortalEdge?: FinanceRecordsForBankPortalEdgeTypeResolver;
  FinanceRecord?: FinanceRecordTypeResolver;
  ChannelPartnerReportMonth?: ChannelPartnerReportMonthTypeResolver;
  ChartProjectionReportMonth?: ChartProjectionReportMonthTypeResolver;
  ChartReportMonth?: ChartReportMonthTypeResolver;
  GeneratedAttachmentsForOrganisationConnection?: GeneratedAttachmentsForOrganisationConnectionTypeResolver;
  GeneratedAttachmentsForOrganisationEdge?: GeneratedAttachmentsForOrganisationEdgeTypeResolver;
  GetNotificationsForBankPortalConnection?: GetNotificationsForBankPortalConnectionTypeResolver;
  GetNotificationsForBankPortalEdge?: GetNotificationsForBankPortalEdgeTypeResolver;
  Notification?: NotificationTypeResolver;
  GetOrganisationCreditEventsConnection?: GetOrganisationCreditEventsConnectionTypeResolver;
  GetOrganisationCreditEventsEdge?: GetOrganisationCreditEventsEdgeTypeResolver;
  OrganisationCreditEvent?: OrganisationCreditEventTypeResolver;
  GetOrganisationCreditsConnection?: GetOrganisationCreditsConnectionTypeResolver;
  GetOrganisationCreditsEdge?: GetOrganisationCreditsEdgeTypeResolver;
  OrganisationCredit?: OrganisationCreditTypeResolver;
  GetOrganisationsForBankPortalConnection?: GetOrganisationsForBankPortalConnectionTypeResolver;
  GetOrganisationsForBankPortalEdge?: GetOrganisationsForBankPortalEdgeTypeResolver;
  BankOrganisation?: BankOrganisationTypeResolver;
  ChannelPartnerOrganisationsConnection?: ChannelPartnerOrganisationsConnectionTypeResolver;
  ChannelPartnerOrganisationsEdge?: ChannelPartnerOrganisationsEdgeTypeResolver;
  ChannelPartnerOrganisation?: ChannelPartnerOrganisationTypeResolver;
  MemberInvitationsConnection?: MemberInvitationsConnectionTypeResolver;
  MemberInvitationsEdge?: MemberInvitationsEdgeTypeResolver;
  MemberInvitation?: MemberInvitationTypeResolver;
  MembersConnection?: MembersConnectionTypeResolver;
  MembersEdge?: MembersEdgeTypeResolver;
  Member?: MemberTypeResolver;
  User?: UserTypeResolver;
  OrganisationFeeSummary?: OrganisationFeeSummaryTypeResolver;
  Organisation?: OrganisationTypeResolver;
  AlertConfiguration?: AlertConfigurationTypeResolver;
  Seconds?: GraphQLScalarType;
  OrganisationDocumentMetadata?: OrganisationDocumentMetadataTypeResolver;
  OrganisationAssociation?: OrganisationAssociationTypeResolver;
  Entity?: EntityTypeResolver;
  ReferralPortalMember?: ReferralPortalMemberTypeResolver;
  InvoicePaymentIntentSecret?: InvoicePaymentIntentSecretTypeResolver;
  GetSimpleKycDataFlagsByIdentificationIdConnection?: GetSimpleKycDataFlagsByIdentificationIdConnectionTypeResolver;
  GetSimpleKycDataFlagsByIdentificationIdEdge?: GetSimpleKycDataFlagsByIdentificationIdEdgeTypeResolver;
  IFlagsData?: IFlagsDataTypeResolver;
  StripeSubscriptionDetails?: StripeSubscriptionDetailsTypeResolver;
  GetUsersForBankPortalConnection?: GetUsersForBankPortalConnectionTypeResolver;
  GetUsersForBankPortalEdge?: GetUsersForBankPortalEdgeTypeResolver;
  IdentificationsForBankPortalConnection?: IdentificationsForBankPortalConnectionTypeResolver;
  IdentificationsForBankPortalEdge?: IdentificationsForBankPortalEdgeTypeResolver;
  BankIdentification?: BankIdentificationTypeResolver;
  IdentificationHistoryConnection?: IdentificationHistoryConnectionTypeResolver;
  IdentificationHistoryEdge?: IdentificationHistoryEdgeTypeResolver;
  IdentificationHistory?: IdentificationHistoryTypeResolver;
  IdentificationHistoryChange?: IdentificationHistoryChangeTypeResolver;
  IdentificationAuthor?: IdentificationAuthorTypeResolver;
  ImportJobsConnection?: ImportJobsConnectionTypeResolver;
  ImportJobsEdge?: ImportJobsEdgeTypeResolver;
  ImportJob?: ImportJobTypeResolver;
  ImportFile?: ImportFileTypeResolver;
  ImportItem?: ImportItemTypeResolver;
  ImportJobsForBankPortalConnection?: ImportJobsForBankPortalConnectionTypeResolver;
  ImportJobsForBankPortalEdge?: ImportJobsForBankPortalEdgeTypeResolver;
  InvoicesForBankPortalConnection?: InvoicesForBankPortalConnectionTypeResolver;
  InvoicesForBankPortalEdge?: InvoicesForBankPortalEdgeTypeResolver;
  BankInvoice?: BankInvoiceTypeResolver;
  ChartLifetimeProjectedValueDetails?: ChartLifetimeProjectedValueDetailsTypeResolver;
  BankAsset?: BankAssetTypeResolver;
  Profile?: ProfileTypeResolver;
  InvitationsConnection?: InvitationsConnectionTypeResolver;
  InvitationsEdge?: InvitationsEdgeTypeResolver;
  OrganisationInvitation?: OrganisationInvitationTypeResolver;
  OrganisationsConnection?: OrganisationsConnectionTypeResolver;
  OrganisationsEdge?: OrganisationsEdgeTypeResolver;
  ProductSummary?: ProductSummaryTypeResolver;
  ProductDiscount?: ProductDiscountTypeResolver;
  ReferralConfiguration?: ReferralConfigurationTypeResolver;
  ReferralCommissionTier?: ReferralCommissionTierTypeResolver;
  ReferralPortalDealsConnection?: ReferralPortalDealsConnectionTypeResolver;
  ReferralPortalDealsEdge?: ReferralPortalDealsEdgeTypeResolver;
  ReferralPortalEntitiesConnection?: ReferralPortalEntitiesConnectionTypeResolver;
  ReferralPortalEntitiesEdge?: ReferralPortalEntitiesEdgeTypeResolver;
  ReferralPortalEntitiesForClientPortalConnection?: ReferralPortalEntitiesForClientPortalConnectionTypeResolver;
  ReferralPortalEntitiesForClientPortalEdge?: ReferralPortalEntitiesForClientPortalEdgeTypeResolver;
  ReferralPortalMembersConnection?: ReferralPortalMembersConnectionTypeResolver;
  ReferralPortalMembersEdge?: ReferralPortalMembersEdgeTypeResolver;
  SearchOrganisationMembersConnection?: SearchOrganisationMembersConnectionTypeResolver;
  SearchOrganisationMembersEdge?: SearchOrganisationMembersEdgeTypeResolver;
  OrganisationMember?: OrganisationMemberTypeResolver;
  SearchOrganisationsForMembersForBankPortalConnection?: SearchOrganisationsForMembersForBankPortalConnectionTypeResolver;
  SearchOrganisationsForMembersForBankPortalEdge?: SearchOrganisationsForMembersForBankPortalEdgeTypeResolver;
  ReferenceDataType?: ReferenceDataTypeTypeResolver;
  ChartTotalActiveDetails?: ChartTotalActiveDetailsTypeResolver;
  SubmissionValidationResult?: SubmissionValidationResultTypeResolver;
  WebhookResultsForBankPortalConnection?: WebhookResultsForBankPortalConnectionTypeResolver;
  WebhookResultsForBankPortalEdge?: WebhookResultsForBankPortalEdgeTypeResolver;
  ApiWebhookResult?: ApiWebhookResultTypeResolver;
  Mutation?: MutationTypeResolver;
  AcceptInvitationPayload?: AcceptInvitationPayloadTypeResolver;
  RequiredDocumentMessage?: RequiredDocumentMessageTypeResolver;
  RequiredDocument?: RequiredDocumentTypeResolver;
  MutateChannelPartnerPayload?: MutateChannelPartnerPayloadTypeResolver;
  AmendDocumentPayload?: AmendDocumentPayloadTypeResolver;
  BeginDraftSubmissionPayload?: BeginDraftSubmissionPayloadTypeResolver;
  CancelDraftPayload?: CancelDraftPayloadTypeResolver;
  CancelDraftSubmissionPayload?: CancelDraftSubmissionPayloadTypeResolver;
  ChangeFacilityApplicationStatusPayload?: ChangeFacilityApplicationStatusPayloadTypeResolver;
  ChangeMemberRolePayload?: ChangeMemberRolePayloadTypeResolver;
  CognitoPayload?: CognitoPayloadTypeResolver;
  CompleteDraftSubmissionPayload?: CompleteDraftSubmissionPayloadTypeResolver;
  UpdateIdentificationPayload?: UpdateIdentificationPayloadTypeResolver;
  ConfirmDocumentHandoverPayload?: ConfirmDocumentHandoverPayloadTypeResolver;
  ConvertDocumentFacilityForBankPortalPayload?: ConvertDocumentFacilityForBankPortalPayloadTypeResolver;
  CreateCommentPayload?: CreateCommentPayloadTypeResolver;
  CreateDocumentPayload?: CreateDocumentPayloadTypeResolver;
  CreateDocumentAttachmentPayload?: CreateDocumentAttachmentPayloadTypeResolver;
  CreateDocumentCollaboratorPayload?: CreateDocumentCollaboratorPayloadTypeResolver;
  CreateDocumentFacilityPayload?: CreateDocumentFacilityPayloadTypeResolver;
  CreateDocumentHandoverPayload?: CreateDocumentHandoverPayloadTypeResolver;
  CreateDocumentMetadataPayload?: CreateDocumentMetadataPayloadTypeResolver;
  CreateDocumentRequestForReturnPayload?: CreateDocumentRequestForReturnPayloadTypeResolver;
  CreateDraftPayload?: CreateDraftPayloadTypeResolver;
  CreateDraftAttachmentPayload?: CreateDraftAttachmentPayloadTypeResolver;
  CreateDraftBGSwitchPayload?: CreateDraftBGSwitchPayloadTypeResolver;
  CreateDraftCollaboratorPayload?: CreateDraftCollaboratorPayloadTypeResolver;
  CreateDraftCommentPayload?: CreateDraftCommentPayloadTypeResolver;
  CreateDraftFromOriginationPayload?: CreateDraftFromOriginationPayloadTypeResolver;
  CreateFacilityApplicationPayload?: CreateFacilityApplicationPayloadTypeResolver;
  CreateFacilityApplicationAttachmentPayload?: CreateFacilityApplicationAttachmentPayloadTypeResolver;
  FinanceEnquiry?: FinanceEnquiryTypeResolver;
  FinanceEnquiryDetail?: FinanceEnquiryDetailTypeResolver;
  CreateImportJobPayload?: CreateImportJobPayloadTypeResolver;
  CreateOrUpdateFeeSummaryPayload?: CreateOrUpdateFeeSummaryPayloadTypeResolver;
  CreateOrUpdateSupplierPayload?: CreateOrUpdateSupplierPayloadTypeResolver;
  EnrichedSupplier?: EnrichedSupplierTypeResolver;
  CreateOrganisationPayload?: CreateOrganisationPayloadTypeResolver;
  CreateOrganisationAlertConfigurationPayload?: CreateOrganisationAlertConfigurationPayloadTypeResolver;
  CreateOrganisationDocumentMetadataPayload?: CreateOrganisationDocumentMetadataPayloadTypeResolver;
  CreateSimpleKycDataPayload?: CreateSimpleKycDataPayloadTypeResolver;
  DraftEstablishPayload?: DraftEstablishPayloadTypeResolver;
  GenerateNewStripeSubscriptionPayload?: GenerateNewStripeSubscriptionPayloadTypeResolver;
  BankGenerateNewStripeSubscriptionPayload?: BankGenerateNewStripeSubscriptionPayloadTypeResolver;
  ImportExistingSimpleKycDataPayload?: ImportExistingSimpleKycDataPayloadTypeResolver;
  MigrateAllDescriptionsResult?: MigrateAllDescriptionsResultTypeResolver;
  OptInOrganisationToDocumentFacilitiesPayload?: OptInOrganisationToDocumentFacilitiesPayloadTypeResolver;
  PrefillIdentificationPayload?: PrefillIdentificationPayloadTypeResolver;
  ProfileTermsAcceptedPayload?: ProfileTermsAcceptedPayloadTypeResolver;
  BankDocumentUpdatePayload?: BankDocumentUpdatePayloadTypeResolver;
  DraftRejectPayload?: DraftRejectPayloadTypeResolver;
  RemoveDocumentAttachmentPayload?: RemoveDocumentAttachmentPayloadTypeResolver;
  RemoveDocumentCollaboratorPayload?: RemoveDocumentCollaboratorPayloadTypeResolver;
  RemoveDocumentHandoverPayload?: RemoveDocumentHandoverPayloadTypeResolver;
  RemoveDocumentMetadataPayload?: RemoveDocumentMetadataPayloadTypeResolver;
  RemoveDocumentRequestForReturnPayload?: RemoveDocumentRequestForReturnPayloadTypeResolver;
  RemoveDraftAttachmentPayload?: RemoveDraftAttachmentPayloadTypeResolver;
  RemoveDraftCollaboratorPayload?: RemoveDraftCollaboratorPayloadTypeResolver;
  MutateFacilityApplicationPayload?: MutateFacilityApplicationPayloadTypeResolver;
  RemoveInvitationPayload?: RemoveInvitationPayloadTypeResolver;
  RemoveMemberPayload?: RemoveMemberPayloadTypeResolver;
  RemoveOrganisationAlertConfigurationPayload?: RemoveOrganisationAlertConfigurationPayloadTypeResolver;
  RemoveOrganisationDocumentMetadataPayload?: RemoveOrganisationDocumentMetadataPayloadTypeResolver;
  DraftRequestChangePayload?: DraftRequestChangePayloadTypeResolver;
  DraftRequestPaymentPayload?: DraftRequestPaymentPayloadTypeResolver;
  ResendAdditionalInvoicesPayload?: ResendAdditionalInvoicesPayloadTypeResolver;
  SendInvitationPayload?: SendInvitationPayloadTypeResolver;
  SetDocumentNotificationListPayload?: SetDocumentNotificationListPayloadTypeResolver;
  SetDraftApprovalStatusForCollaboratorPayload?: SetDraftApprovalStatusForCollaboratorPayloadTypeResolver;
  SetDraftNotificationListForCollaboratorPayload?: SetDraftNotificationListForCollaboratorPayloadTypeResolver;
  SetDraftRealtimeAuthorStatePayload?: SetDraftRealtimeAuthorStatePayloadTypeResolver;
  DraftRealtimeAuthor?: DraftRealtimeAuthorTypeResolver;
  OrganisationGvpMetadata?: OrganisationGvpMetadataTypeResolver;
  ShareDraftToOrganisationFromCollaboratorPayload?: ShareDraftToOrganisationFromCollaboratorPayloadTypeResolver;
  UpdateDocumentPayload?: UpdateDocumentPayloadTypeResolver;
  UpdateDocumentFacilityPayload?: UpdateDocumentFacilityPayloadTypeResolver;
  UpdateDocumentMetadataPayload?: UpdateDocumentMetadataPayloadTypeResolver;
  UpdateDraftPayload?: UpdateDraftPayloadTypeResolver;
  UpdateDraftBGSwitchPayload?: UpdateDraftBGSwitchPayloadTypeResolver;
  UpdateDraftCollaboratorPayload?: UpdateDraftCollaboratorPayloadTypeResolver;
  UpdateBankDraftPayload?: UpdateBankDraftPayloadTypeResolver;
  UpdateDraftPreviewPayload?: UpdateDraftPreviewPayloadTypeResolver;
  UpdateGreenIdPayload?: UpdateGreenIdPayloadTypeResolver;
  UpdateBankGreenIdPayload?: UpdateBankGreenIdPayloadTypeResolver;
  UpdateBankIdentificationPayload?: UpdateBankIdentificationPayloadTypeResolver;
  UpdateBankIdentificationRiskDetailsPayload?: UpdateBankIdentificationRiskDetailsPayloadTypeResolver;
  UpdateNotifiedPayload?: UpdateNotifiedPayloadTypeResolver;
  UpdateOrganisationPayload?: UpdateOrganisationPayloadTypeResolver;
  UpdateOrganisationAlertConfigurationPayload?: UpdateOrganisationAlertConfigurationPayloadTypeResolver;
  UpdateBankOrganisationPayload?: UpdateBankOrganisationPayloadTypeResolver;
  UpdateProfilePayload?: UpdateProfilePayloadTypeResolver;
  UpdateSimpleKycDataPayload?: UpdateSimpleKycDataPayloadTypeResolver;
  SimpleKycData?: SimpleKycDataTypeResolver;
  SimpleKycDataIndividual?: SimpleKycDataIndividualTypeResolver;
  SimpleKycDataIndividualAddress?: SimpleKycDataIndividualAddressTypeResolver;
  UpdateSimpleKycDataAppPayload?: UpdateSimpleKycDataAppPayloadTypeResolver;
  Subscription?: SubscriptionTypeResolver;
}
export interface QueryTypeResolver<TParent = any> {
  applicationContactDetails?: QueryToApplicationContactDetailsResolver<TParent>;
  applicationContactDetailsForBankPortal?: QueryToApplicationContactDetailsForBankPortalResolver<TParent>;
  bankAssetContent?: QueryToBankAssetContentResolver<TParent>;
  bgSwitchByIdAndOrganisationId?: QueryToBgSwitchByIdAndOrganisationIdResolver<TParent>;
  bgSwitchesByOrganisationId?: QueryToBgSwitchesByOrganisationIdResolver<TParent>;
  calculateAdvertisedFinance?: QueryToCalculateAdvertisedFinanceResolver<TParent>;
  channelPartners?: QueryToChannelPartnersResolver<TParent>;
  channelPartnersForBankPortal?: QueryToChannelPartnersForBankPortalResolver<TParent>;
  cognitoGetAuthenticatedUser?: QueryToCognitoGetAuthenticatedUserResolver<TParent>;
  cognitoGetBankUsers?: QueryToCognitoGetBankUsersResolver<TParent>;
  documentAttachmentDownload?: QueryToDocumentAttachmentDownloadResolver<TParent>;
  documentByDraftId?: QueryToDocumentByDraftIdResolver<TParent>;
  documentById?: QueryToDocumentByIdResolver<TParent>;
  documentFacilities?: QueryToDocumentFacilitiesResolver<TParent>;
  documentFacilityById?: QueryToDocumentFacilityByIdResolver<TParent>;
  documentReportDownloadUrl?: QueryToDocumentReportDownloadUrlResolver<TParent>;
  documentReports?: QueryToDocumentReportsResolver<TParent>;
  documents?: QueryToDocumentsResolver<TParent>;
  documentsForBankPortal?: QueryToDocumentsForBankPortalResolver<TParent>;
  documentsSharedWithMe?: QueryToDocumentsSharedWithMeResolver<TParent>;
  draftApplicableRequirements?: QueryToDraftApplicableRequirementsResolver<TParent>;
  draftAttachmentDownload?: QueryToDraftAttachmentDownloadResolver<TParent>;
  draftAttachmentDownloadForBankPortal?: QueryToDraftAttachmentDownloadForBankPortalResolver<TParent>;
  draftByIdAndOrganisationId?: QueryToDraftByIdAndOrganisationIdResolver<TParent>;
  draftOriginationsForBankPortal?: QueryToDraftOriginationsForBankPortalResolver<TParent>;
  draftsByOrganisationId?: QueryToDraftsByOrganisationIdResolver<TParent>;
  draftsForBankPortal?: QueryToDraftsForBankPortalResolver<TParent>;
  draftsSharedWithMe?: QueryToDraftsSharedWithMeResolver<TParent>;
  fSGHtmlString?: QueryToFSGHtmlStringResolver<TParent>;
  facilitiesForBankPortal?: QueryToFacilitiesForBankPortalResolver<TParent>;
  facilityApplicationById?: QueryToFacilityApplicationByIdResolver<TParent>;
  facilityApplications?: QueryToFacilityApplicationsResolver<TParent>;
  facilityApplicationsForBankPortal?: QueryToFacilityApplicationsForBankPortalResolver<TParent>;
  features?: QueryToFeaturesResolver<TParent>;
  financeRecordsForBankPortal?: QueryToFinanceRecordsForBankPortalResolver<TParent>;
  generateAgencyAgreementHtmlStringForDraft?: QueryToGenerateAgencyAgreementHtmlStringForDraftResolver<TParent>;
  generateAgencyAgreementHtmlStringForDraftForBankPortal?: QueryToGenerateAgencyAgreementHtmlStringForDraftForBankPortalResolver<TParent>;
  generateAgencyAgreementHtmlStringForFacilityApplication?: QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationResolver<TParent>;
  generateAgencyAgreementHtmlStringForFacilityApplicationForBankPortal?: QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationForBankPortalResolver<TParent>;
  generateChannelPartnerReport?: QueryToGenerateChannelPartnerReportResolver<TParent>;
  generateForecastChartReport?: QueryToGenerateForecastChartReportResolver<TParent>;
  generateProductPreviewTemplateHtmlStringForDraft?: QueryToGenerateProductPreviewTemplateHtmlStringForDraftResolver<TParent>;
  generateSummaryChartReport?: QueryToGenerateSummaryChartReportResolver<TParent>;
  generatedAttachmentsForOrganisation?: QueryToGeneratedAttachmentsForOrganisationResolver<TParent>;
  getFeeSummaries?: QueryToGetFeeSummariesResolver<TParent>;
  getNotificationsForBankPortal?: QueryToGetNotificationsForBankPortalResolver<TParent>;
  getOrganisationCreditEvents?: QueryToGetOrganisationCreditEventsResolver<TParent>;
  getOrganisationCredits?: QueryToGetOrganisationCreditsResolver<TParent>;
  getOrganisationsForBankPortal?: QueryToGetOrganisationsForBankPortalResolver<TParent>;
  getPaymentIntentForInvoice?: QueryToGetPaymentIntentForInvoiceResolver<TParent>;
  getSimpleKycDataFlagsByIdentificationId?: QueryToGetSimpleKycDataFlagsByIdentificationIdResolver<TParent>;
  getSimpleKycDataUrlByIdentificationId?: QueryToGetSimpleKycDataUrlByIdentificationIdResolver<TParent>;
  getStripeSubscriptionDetails?: QueryToGetStripeSubscriptionDetailsResolver<TParent>;
  getSuppliersForBankPortal?: QueryToGetSuppliersForBankPortalResolver<TParent>;
  getUsersForBankPortal?: QueryToGetUsersForBankPortalResolver<TParent>;
  identificationsForBankPortal?: QueryToIdentificationsForBankPortalResolver<TParent>;
  importJobs?: QueryToImportJobsResolver<TParent>;
  importJobsForBankPortal?: QueryToImportJobsForBankPortalResolver<TParent>;
  initializeGreenId?: QueryToInitializeGreenIdResolver<TParent>;
  initializeGreenIdBankPortal?: QueryToInitializeGreenIdBankPortalResolver<TParent>;
  invoicesForBankPortal?: QueryToInvoicesForBankPortalResolver<TParent>;
  lifetimeProjectionValue?: QueryToLifetimeProjectionValueResolver<TParent>;
  listBankAssets?: QueryToListBankAssetsResolver<TParent>;
  me?: QueryToMeResolver<TParent>;
  organisations?: QueryToOrganisationsResolver<TParent>;
  productSelectionSummary?: QueryToProductSelectionSummaryResolver<TParent>;
  referralConfiguration?: QueryToReferralConfigurationResolver<TParent>;
  referralPortalCommissionTiers?: QueryToReferralPortalCommissionTiersResolver<TParent>;
  referralPortalDeals?: QueryToReferralPortalDealsResolver<TParent>;
  referralPortalEntities?: QueryToReferralPortalEntitiesResolver<TParent>;
  referralPortalEntitiesForClientPortal?: QueryToReferralPortalEntitiesForClientPortalResolver<TParent>;
  referralPortalMembers?: QueryToReferralPortalMembersResolver<TParent>;
  referralPortalMyMember?: QueryToReferralPortalMyMemberResolver<TParent>;
  searchOrganisationMembers?: QueryToSearchOrganisationMembersResolver<TParent>;
  searchOrganisationsForMembersForBankPortal?: QueryToSearchOrganisationsForMembersForBankPortalResolver<TParent>;
  sourceOfFundsReferenceData_ByDraftId?: QueryToSourceOfFundsReferenceData_ByDraftIdResolver<TParent>;
  sourceOfFundsReferenceData_ForBankPortal?: QueryToSourceOfFundsReferenceData_ForBankPortalResolver<TParent>;
  totalBankGuaranteesSummary?: QueryToTotalBankGuaranteesSummaryResolver<TParent>;
  totalSuretyBondsSummary?: QueryToTotalSuretyBondsSummaryResolver<TParent>;
  totalValueOfSuretyFacilities?: QueryToTotalValueOfSuretyFacilitiesResolver<TParent>;
  validateSubmissionToGvp?: QueryToValidateSubmissionToGvpResolver<TParent>;
  verifyFacilityApplication?: QueryToVerifyFacilityApplicationResolver<TParent>;
  webhookResultsForBankPortal?: QueryToWebhookResultsForBankPortalResolver<TParent>;
}

export interface QueryToApplicationContactDetailsArgs {
  draftId: string;
  organisationId: string;
}
export interface QueryToApplicationContactDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToApplicationContactDetailsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToApplicationContactDetailsForBankPortalArgs {
  draftId: string;
}
export interface QueryToApplicationContactDetailsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToApplicationContactDetailsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToBankAssetContentArgs {
  bankAssetType: BankAssetType;
  name: string;
}
export interface QueryToBankAssetContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToBankAssetContentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToBgSwitchByIdAndOrganisationIdArgs {
  id?: string;
  organisationId?: string;
}
export interface QueryToBgSwitchByIdAndOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToBgSwitchByIdAndOrganisationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToBgSwitchesByOrganisationIdArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftBGSwitchSort;
  organisationId: string;
  search?: string;
  where?: DraftBGSwitchFilter;
}
export interface QueryToBgSwitchesByOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToBgSwitchesByOrganisationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCalculateAdvertisedFinanceArgs {
  draftId: string;
}
export interface QueryToCalculateAdvertisedFinanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCalculateAdvertisedFinanceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToChannelPartnersArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<ChannelPartnerSortInput>;
  where?: ChannelPartnerFilterInput;
}
export interface QueryToChannelPartnersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToChannelPartnersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToChannelPartnersForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<ChannelPartnerSortInput>;
  where?: ChannelPartnerFilterInput;
}
export interface QueryToChannelPartnersForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToChannelPartnersForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCognitoGetAuthenticatedUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCognitoGetBankUsersArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<CognitoUserSortInput>;
  userRoles?: Array<BankUserRole>;
  where?: CognitoUserFilterInput;
}
export interface QueryToCognitoGetBankUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCognitoGetBankUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentAttachmentDownloadArgs {
  documentId: string;
  id: string;
}
export interface QueryToDocumentAttachmentDownloadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentAttachmentDownloadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentByDraftIdArgs {
  id?: string;
}
export interface QueryToDocumentByDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentByDraftIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentByIdArgs {
  id?: string;
}
export interface QueryToDocumentByIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentByIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentFacilitiesArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DocumentFacilitySort;
  organisationId: string;
  where?: DocumentFacilityFilter;
}
export interface QueryToDocumentFacilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentFacilitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentFacilityByIdArgs {
  facilityId: string;
}
export interface QueryToDocumentFacilityByIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentFacilityByIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentReportDownloadUrlArgs {
  reportId: string;
}
export interface QueryToDocumentReportDownloadUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentReportDownloadUrlArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentReportsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<ReportSortInput>;
  where?: ReportFilterInput;
}
export interface QueryToDocumentReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  metadataFilters?: Array<DocumentMetadataFilterInput | null>;
  order_by?: DocumentSort;
  organisationId: string;
  search?: string;
  where?: DocumentFilter;
}
export interface QueryToDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: BankDocumentSort;
  supplierName?: string;
  where?: BankDocumentFilter;
}
export interface QueryToDocumentsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentsSharedWithMeArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DocumentSort;
  search?: string;
  where?: DocumentFilter;
}
export interface QueryToDocumentsSharedWithMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentsSharedWithMeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftApplicableRequirementsArgs {
  input?: GetDraftApplicableRequirementsInput;
}
export interface QueryToDraftApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftApplicableRequirementsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftAttachmentDownloadArgs {
  draftId: string;
  id: string;
  organisationId?: string;
}
export interface QueryToDraftAttachmentDownloadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftAttachmentDownloadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftAttachmentDownloadForBankPortalArgs {
  draftId: string;
  id: string;
}
export interface QueryToDraftAttachmentDownloadForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftAttachmentDownloadForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftByIdAndOrganisationIdArgs {
  id?: string;
  organisationId?: string;
}
export interface QueryToDraftByIdAndOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftByIdAndOrganisationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftOriginationsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: ApiDraftOriginationSort;
  where?: ApiDraftOriginationFilter;
}
export interface QueryToDraftOriginationsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftOriginationsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftsByOrganisationIdArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftSort;
  organisationId: string;
  search?: string;
  where?: DraftFilter;
}
export interface QueryToDraftsByOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftsByOrganisationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: BankDraftSort;
  where?: BankDraftFilter;
}
export interface QueryToDraftsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDraftsSharedWithMeArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftSort;
  search?: string;
  where?: DraftFilter;
}
export interface QueryToDraftsSharedWithMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDraftsSharedWithMeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFSGHtmlStringResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFacilitiesForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DocumentFacilitySort;
  where?: DocumentFacilityFilter;
}
export interface QueryToFacilitiesForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFacilitiesForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFacilityApplicationByIdArgs {
  id?: string;
}
export interface QueryToFacilityApplicationByIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFacilityApplicationByIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFacilityApplicationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: FacilityApplicationSort;
  organisationId: string;
  where?: FacilityApplicationFilter;
}
export interface QueryToFacilityApplicationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFacilityApplicationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFacilityApplicationsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: FacilityApplicationSort;
  where?: FacilityApplicationFilter;
}
export interface QueryToFacilityApplicationsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFacilityApplicationsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFeaturesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFinanceRecordsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<FinanceRecordSortInput>;
  where?: FinanceRecordFilterInput;
}
export interface QueryToFinanceRecordsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFinanceRecordsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateAgencyAgreementHtmlStringForDraftArgs {
  draftId: string;
}
export interface QueryToGenerateAgencyAgreementHtmlStringForDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGenerateAgencyAgreementHtmlStringForDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateAgencyAgreementHtmlStringForDraftForBankPortalArgs {
  draftId: string;
}
export interface QueryToGenerateAgencyAgreementHtmlStringForDraftForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGenerateAgencyAgreementHtmlStringForDraftForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationArgs {
  facilityApplicationId: string;
}
export interface QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationForBankPortalArgs {
  facilityApplicationId: string;
}
export interface QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGenerateAgencyAgreementHtmlStringForFacilityApplicationForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateChannelPartnerReportArgs {
  channelPartnerId: string;
}
export interface QueryToGenerateChannelPartnerReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGenerateChannelPartnerReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateForecastChartReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateProductPreviewTemplateHtmlStringForDraftArgs {
  draftId: string;
  feeSummaryId: string;
}
export interface QueryToGenerateProductPreviewTemplateHtmlStringForDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGenerateProductPreviewTemplateHtmlStringForDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGenerateSummaryChartReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGeneratedAttachmentsForOrganisationArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftAttachmentSort;
  organisationId: string;
  where?: DraftAttachmentFilter;
}
export interface QueryToGeneratedAttachmentsForOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGeneratedAttachmentsForOrganisationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetFeeSummariesArgs {
  organisationId?: string;
  where?: FeeSummaryFilter;
}
export interface QueryToGetFeeSummariesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetFeeSummariesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetNotificationsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<NotificationSortInput>;
  where?: NotificationFilterInput;
}
export interface QueryToGetNotificationsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetNotificationsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetOrganisationCreditEventsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: OrganisationCreditEventSort;
  where?: OrganisationCreditEventFilter;
}
export interface QueryToGetOrganisationCreditEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetOrganisationCreditEventsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetOrganisationCreditsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: OrganisationCreditSort;
  where?: OrganisationCreditFilter;
}
export interface QueryToGetOrganisationCreditsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetOrganisationCreditsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetOrganisationsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: OrganisationSort;
  where?: OrganisationFilter;
}
export interface QueryToGetOrganisationsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetOrganisationsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetPaymentIntentForInvoiceArgs {
  draftId: string;
  organisationId: string;
  paymentIntentId: string;
}
export interface QueryToGetPaymentIntentForInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetPaymentIntentForInvoiceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetSimpleKycDataFlagsByIdentificationIdArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  identificationId: string;
  last?: PaginationAmount;
  order_by?: IFlagsDataSort;
  where?: IFlagsDataFilter;
}
export interface QueryToGetSimpleKycDataFlagsByIdentificationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetSimpleKycDataFlagsByIdentificationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetSimpleKycDataUrlByIdentificationIdArgs {
  identificationId: string;
  urlName: KycUrlType;
}
export interface QueryToGetSimpleKycDataUrlByIdentificationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetSimpleKycDataUrlByIdentificationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetStripeSubscriptionDetailsArgs {
  draftId: string;
}
export interface QueryToGetStripeSubscriptionDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetStripeSubscriptionDetailsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetSuppliersForBankPortalArgs {
  where?: SupplierFilter;
}
export interface QueryToGetSuppliersForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetSuppliersForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGetUsersForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<UserSortInput>;
  where?: UserFilterInput;
}
export interface QueryToGetUsersForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGetUsersForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToIdentificationsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: BankIdentificationSort;
  where?: BankIdentificationFilter;
}
export interface QueryToIdentificationsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToIdentificationsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToImportJobsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: ImportJobSort;
  where?: ImportJobFilter;
}
export interface QueryToImportJobsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToImportJobsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToImportJobsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: ImportJobSort;
  where?: ImportJobFilter;
}
export interface QueryToImportJobsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToImportJobsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInitializeGreenIdArgs {
  identificationIndividualId?: string;
}
export interface QueryToInitializeGreenIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInitializeGreenIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInitializeGreenIdBankPortalArgs {
  identificationIndividualId?: string;
}
export interface QueryToInitializeGreenIdBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInitializeGreenIdBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInvoicesForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: BankInvoiceSort;
  where?: BankInvoiceFilter;
}
export interface QueryToInvoicesForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInvoicesForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToLifetimeProjectionValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToListBankAssetsArgs {
  bankAssetType?: BankAssetType;
}
export interface QueryToListBankAssetsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToListBankAssetsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToOrganisationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: OrganisationSort;
  where?: OrganisationFilter;
}
export interface QueryToOrganisationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToOrganisationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProductSelectionSummaryArgs {
  organisationId: string;
}
export interface QueryToProductSelectionSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProductSelectionSummaryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralPortalCommissionTiersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralPortalDealsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<DealSortInput>;
  where?: DealFilterInput;
}
export interface QueryToReferralPortalDealsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReferralPortalDealsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralPortalEntitiesArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<EntitySortInput>;
  where?: EntityFilterInput;
}
export interface QueryToReferralPortalEntitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReferralPortalEntitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralPortalEntitiesForClientPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<EntitySortInput>;
  where?: EntityFilterInput;
}
export interface QueryToReferralPortalEntitiesForClientPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReferralPortalEntitiesForClientPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralPortalMembersArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<ReferralPortalMemberSortInput>;
  where?: ReferralPortalMemberFilterInput;
}
export interface QueryToReferralPortalMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReferralPortalMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralPortalMyMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSearchOrganisationMembersArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  organisationId: string;
  search: string;
}
export interface QueryToSearchOrganisationMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSearchOrganisationMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSearchOrganisationsForMembersForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: OrganisationSort;
  userId: string;
  where?: OrganisationFilter;
}
export interface QueryToSearchOrganisationsForMembersForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSearchOrganisationsForMembersForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSourceOfFundsReferenceData_ByDraftIdArgs {
  draftId: string;
}
export interface QueryToSourceOfFundsReferenceData_ByDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSourceOfFundsReferenceData_ByDraftIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSourceOfFundsReferenceData_ForBankPortalArgs {
  draftId: string;
}
export interface QueryToSourceOfFundsReferenceData_ForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSourceOfFundsReferenceData_ForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTotalBankGuaranteesSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTotalSuretyBondsSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTotalValueOfSuretyFacilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToValidateSubmissionToGvpArgs {
  draftId: string;
}
export interface QueryToValidateSubmissionToGvpResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToValidateSubmissionToGvpArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToVerifyFacilityApplicationArgs {
  id?: string;
}
export interface QueryToVerifyFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToVerifyFacilityApplicationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToWebhookResultsForBankPortalArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order?: Array<ApiWebhookResultSortInput>;
  where?: ApiWebhookResultFilterInput;
}
export interface QueryToWebhookResultsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToWebhookResultsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsTypeResolver<TParent = any> {
  businessPhone?: ApplicationContactDetailsToBusinessPhoneResolver<TParent>;
  dateLastModified?: ApplicationContactDetailsToDateLastModifiedResolver<TParent>;
  draftId?: ApplicationContactDetailsToDraftIdResolver<TParent>;
  email?: ApplicationContactDetailsToEmailResolver<TParent>;
  firstName?: ApplicationContactDetailsToFirstNameResolver<TParent>;
  id?: ApplicationContactDetailsToIdResolver<TParent>;
  lastName?: ApplicationContactDetailsToLastNameResolver<TParent>;
  mobilePhone?: ApplicationContactDetailsToMobilePhoneResolver<TParent>;
  role?: ApplicationContactDetailsToRoleResolver<TParent>;
}

export interface ApplicationContactDetailsToBusinessPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToDateLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToMobilePhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationContactDetailsToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankAssetContentTypeResolver<TParent = any> {
  content?: BankAssetContentToContentResolver<TParent>;
  contentType?: BankAssetContentToContentTypeResolver<TParent>;
}

export interface BankAssetContentToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankAssetContentToContentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchTypeResolver<TParent = any> {
  affirmationIrrevocability?: DraftBGSwitchToAffirmationIrrevocabilityResolver<TParent>;
  beneficiaryApproval?: DraftBGSwitchToBeneficiaryApprovalResolver<TParent>;
  currentBankFullName?: DraftBGSwitchToCurrentBankFullNameResolver<TParent>;
  currentExpiryDate?: DraftBGSwitchToCurrentExpiryDateResolver<TParent>;
  currentGuaranteeNumber?: DraftBGSwitchToCurrentGuaranteeNumberResolver<TParent>;
  currentSecurityType?: DraftBGSwitchToCurrentSecurityTypeResolver<TParent>;
  currentValue?: DraftBGSwitchToCurrentValueResolver<TParent>;
  id?: DraftBGSwitchToIdResolver<TParent>;
  indemnityAgreement?: DraftBGSwitchToIndemnityAgreementResolver<TParent>;
  irrevocableOrder?: DraftBGSwitchToIrrevocableOrderResolver<TParent>;
  isCashInTermDeposit?: DraftBGSwitchToIsCashInTermDepositResolver<TParent>;
  organisationId?: DraftBGSwitchToOrganisationIdResolver<TParent>;
  securityInterestDeclaration?: DraftBGSwitchToSecurityInterestDeclarationResolver<TParent>;
  status?: DraftBGSwitchToStatusResolver<TParent>;
  termDepositEndDate?: DraftBGSwitchToTermDepositEndDateResolver<TParent>;
  transactionUnwindingClause?: DraftBGSwitchToTransactionUnwindingClauseResolver<TParent>;
}

export interface DraftBGSwitchToAffirmationIrrevocabilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToBeneficiaryApprovalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToCurrentBankFullNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToCurrentExpiryDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToCurrentGuaranteeNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToCurrentSecurityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToCurrentValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToIndemnityAgreementResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToIrrevocableOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToIsCashInTermDepositResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToSecurityInterestDeclarationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToTermDepositEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftBGSwitchToTransactionUnwindingClauseResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BgSwitchesByOrganisationIdConnectionTypeResolver<TParent = any> {
  edges?: BgSwitchesByOrganisationIdConnectionToEdgesResolver<TParent>;
  nodes?: BgSwitchesByOrganisationIdConnectionToNodesResolver<TParent>;
  pageInfo?: BgSwitchesByOrganisationIdConnectionToPageInfoResolver<TParent>;
  totalCount?: BgSwitchesByOrganisationIdConnectionToTotalCountResolver<TParent>;
}

export interface BgSwitchesByOrganisationIdConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BgSwitchesByOrganisationIdConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BgSwitchesByOrganisationIdConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BgSwitchesByOrganisationIdConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BgSwitchesByOrganisationIdEdgeTypeResolver<TParent = any> {
  cursor?: BgSwitchesByOrganisationIdEdgeToCursorResolver<TParent>;
  node?: BgSwitchesByOrganisationIdEdgeToNodeResolver<TParent>;
}

export interface BgSwitchesByOrganisationIdEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BgSwitchesByOrganisationIdEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoTypeResolver<TParent = any> {
  endCursor?: PageInfoToEndCursorResolver<TParent>;
  hasNextPage?: PageInfoToHasNextPageResolver<TParent>;
  hasPreviousPage?: PageInfoToHasPreviousPageResolver<TParent>;
  startCursor?: PageInfoToStartCursorResolver<TParent>;
}

export interface PageInfoToEndCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasNextPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasPreviousPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToStartCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRepaymentSummaryTypeResolver<TParent = any> {
  availabilityPeriodMaxBusinessDays?: FinanceRepaymentSummaryToAvailabilityPeriodMaxBusinessDaysResolver<TParent>;
  availabilityPeriodMinBusinessDays?: FinanceRepaymentSummaryToAvailabilityPeriodMinBusinessDaysResolver<TParent>;
  financeAmount?: FinanceRepaymentSummaryToFinanceAmountResolver<TParent>;
  repaymentOptions?: FinanceRepaymentSummaryToRepaymentOptionsResolver<TParent>;
}

export interface FinanceRepaymentSummaryToAvailabilityPeriodMaxBusinessDaysResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRepaymentSummaryToAvailabilityPeriodMinBusinessDaysResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRepaymentSummaryToFinanceAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRepaymentSummaryToRepaymentOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RepaymentOptionTypeResolver<TParent = any> {
  advertisedFortnightlyRepayments?: RepaymentOptionToAdvertisedFortnightlyRepaymentsResolver<TParent>;
  months?: RepaymentOptionToMonthsResolver<TParent>;
}

export interface RepaymentOptionToAdvertisedFortnightlyRepaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RepaymentOptionToMonthsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersConnectionTypeResolver<TParent = any> {
  edges?: ChannelPartnersConnectionToEdgesResolver<TParent>;
  nodes?: ChannelPartnersConnectionToNodesResolver<TParent>;
  pageInfo?: ChannelPartnersConnectionToPageInfoResolver<TParent>;
  totalCount?: ChannelPartnersConnectionToTotalCountResolver<TParent>;
}

export interface ChannelPartnersConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersEdgeTypeResolver<TParent = any> {
  cursor?: ChannelPartnersEdgeToCursorResolver<TParent>;
  node?: ChannelPartnersEdgeToNodeResolver<TParent>;
}

export interface ChannelPartnersEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersTypeResolver<TParent = any> {
  active?: ChannelPartnersToActiveResolver<TParent>;
  apiKey?: ChannelPartnersToApiKeyResolver<TParent>;
  contactEmail?: ChannelPartnersToContactEmailResolver<TParent>;
  createdAt?: ChannelPartnersToCreatedAtResolver<TParent>;
  discountPercentage?: ChannelPartnersToDiscountPercentageResolver<TParent>;
  establishmentFeeDiscountAmount?: ChannelPartnersToEstablishmentFeeDiscountAmountResolver<TParent>;
  id?: ChannelPartnersToIdResolver<TParent>;
  isPublic?: ChannelPartnersToIsPublicResolver<TParent>;
  name?: ChannelPartnersToNameResolver<TParent>;
  referralPercentage?: ChannelPartnersToReferralPercentageResolver<TParent>;
  webhookUrl?: ChannelPartnersToWebhookUrlResolver<TParent>;
}

export interface ChannelPartnersToActiveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToApiKeyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToContactEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToEstablishmentFeeDiscountAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToIsPublicResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToReferralPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersToWebhookUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: ChannelPartnersForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: ChannelPartnersForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: ChannelPartnersForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: ChannelPartnersForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface ChannelPartnersForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: ChannelPartnersForBankPortalEdgeToCursorResolver<TParent>;
  node?: ChannelPartnersForBankPortalEdgeToNodeResolver<TParent>;
}

export interface ChannelPartnersForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnersForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserTypeResolver<TParent = any> {
  createdOn?: CognitoUserToCreatedOnResolver<TParent>;
  emailAddress?: CognitoUserToEmailAddressResolver<TParent>;
  firstName?: CognitoUserToFirstNameResolver<TParent>;
  id?: CognitoUserToIdResolver<TParent>;
  isEnabled?: CognitoUserToIsEnabledResolver<TParent>;
  isSmsMfaRequired?: CognitoUserToIsSmsMfaRequiredResolver<TParent>;
  lastName?: CognitoUserToLastNameResolver<TParent>;
  lastUpdatedAt?: CognitoUserToLastUpdatedAtResolver<TParent>;
  phoneNumber?: CognitoUserToPhoneNumberResolver<TParent>;
  status?: CognitoUserToStatusResolver<TParent>;
  supplierId?: CognitoUserToSupplierIdResolver<TParent>;
  userName?: CognitoUserToUserNameResolver<TParent>;
  userRoles?: CognitoUserToUserRolesResolver<TParent>;
}

export interface CognitoUserToCreatedOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToIsEnabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToIsSmsMfaRequiredResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToLastUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToUserNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoUserToUserRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoGetBankUsersConnectionTypeResolver<TParent = any> {
  edges?: CognitoGetBankUsersConnectionToEdgesResolver<TParent>;
  nodes?: CognitoGetBankUsersConnectionToNodesResolver<TParent>;
  pageInfo?: CognitoGetBankUsersConnectionToPageInfoResolver<TParent>;
  totalCount?: CognitoGetBankUsersConnectionToTotalCountResolver<TParent>;
}

export interface CognitoGetBankUsersConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoGetBankUsersConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoGetBankUsersConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoGetBankUsersConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoGetBankUsersEdgeTypeResolver<TParent = any> {
  cursor?: CognitoGetBankUsersEdgeToCursorResolver<TParent>;
  node?: CognitoGetBankUsersEdgeToNodeResolver<TParent>;
}

export interface CognitoGetBankUsersEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoGetBankUsersEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentDownloadTypeResolver<TParent = any> {
  downloadPresignedUrl?: DocumentAttachmentDownloadToDownloadPresignedUrlResolver<TParent>;
}

export interface DocumentAttachmentDownloadToDownloadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentTypeResolver<TParent = any> {
  actionDate?: DocumentToActionDateResolver<TParent>;
  amount?: DocumentToAmountResolver<TParent>;
  attachments?: DocumentToAttachmentsResolver<TParent>;
  bank?: DocumentToBankResolver<TParent>;
  callerContext?: DocumentToCallerContextResolver<TParent>;
  capabilities?: DocumentToCapabilitiesResolver<TParent>;
  closedAt?: DocumentToClosedAtResolver<TParent>;
  collaborators?: DocumentToCollaboratorsResolver<TParent>;
  comments?: DocumentToCommentsResolver<TParent>;
  costs?: DocumentToCostsResolver<TParent>;
  createdAt?: DocumentToCreatedAtResolver<TParent>;
  custodian?: DocumentToCustodianResolver<TParent>;
  description?: DocumentToDescriptionResolver<TParent>;
  documentVariant?: DocumentToDocumentVariantResolver<TParent>;
  establishedAt?: DocumentToEstablishedAtResolver<TParent>;
  expectedReturnDate?: DocumentToExpectedReturnDateResolver<TParent>;
  expiresAt?: DocumentToExpiresAtResolver<TParent>;
  facilityId?: DocumentToFacilityIdResolver<TParent>;
  guaranteeNumber?: DocumentToGuaranteeNumberResolver<TParent>;
  handover?: DocumentToHandoverResolver<TParent>;
  history?: DocumentToHistoryResolver<TParent>;
  id?: DocumentToIdResolver<TParent>;
  interestEndDate?: DocumentToInterestEndDateResolver<TParent>;
  interestStartDate?: DocumentToInterestStartDateResolver<TParent>;
  invoices?: DocumentToInvoicesResolver<TParent>;
  isSystemDocument?: DocumentToIsSystemDocumentResolver<TParent>;
  metadata?: DocumentToMetadataResolver<TParent>;
  organisationId?: DocumentToOrganisationIdResolver<TParent>;
  originalDraftId?: DocumentToOriginalDraftIdResolver<TParent>;
  parties?: DocumentToPartiesResolver<TParent>;
  projectAddress?: DocumentToProjectAddressResolver<TParent>;
  purpose?: DocumentToPurposeResolver<TParent>;
  referenceNumber?: DocumentToReferenceNumberResolver<TParent>;
  releventPartyNames?: DocumentToReleventPartyNamesResolver<TParent>;
  requestForReturn?: DocumentToRequestForReturnResolver<TParent>;
  requestedAt?: DocumentToRequestedAtResolver<TParent>;
  retentionType?: DocumentToRetentionTypeResolver<TParent>;
  securityType?: DocumentToSecurityTypeResolver<TParent>;
  specifiedOtherPurpose?: DocumentToSpecifiedOtherPurposeResolver<TParent>;
  status?: DocumentToStatusResolver<TParent>;
  subscribedMembers?: DocumentToSubscribedMembersResolver<TParent>;
  summary?: DocumentToSummaryResolver<TParent>;
  supplierName?: DocumentToSupplierNameResolver<TParent>;
}

export interface DocumentToActionDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToAttachmentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToBankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCallerContextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToClosedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCollaboratorsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
}
export interface DocumentToCollaboratorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DocumentToCollaboratorsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCommentsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: CommentSort;
}
export interface DocumentToCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DocumentToCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCostsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCustodianResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToDocumentVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToEstablishedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToExpectedReturnDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToFacilityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToGuaranteeNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToHandoverResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DocumentHistorySort;
}
export interface DocumentToHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DocumentToHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToInterestEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToInterestStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToIsSystemDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToMetadataArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: MetadataSort;
}
export interface DocumentToMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DocumentToMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToOriginalDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToPartiesArgs {
  where?: PartyFilter;
}
export interface DocumentToPartiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DocumentToPartiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToProjectAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToReleventPartyNamesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToRequestForReturnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToRequestedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToRetentionTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToSecurityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToSpecifiedOtherPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToSubscribedMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToSupplierNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentTypeResolver<TParent = any> {
  contentType?: DocumentAttachmentToContentTypeResolver<TParent>;
  fileName?: DocumentAttachmentToFileNameResolver<TParent>;
  id?: DocumentAttachmentToIdResolver<TParent>;
  infectedFileStatus?: DocumentAttachmentToInfectedFileStatusResolver<TParent>;
  received?: DocumentAttachmentToReceivedResolver<TParent>;
  uploadPresignedUrl?: DocumentAttachmentToUploadPresignedUrlResolver<TParent>;
}

export interface DocumentAttachmentToContentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentToFileNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentToInfectedFileStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentToReceivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentAttachmentToUploadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankTypeResolver<TParent = any> {
  address?: BankToAddressResolver<TParent>;
  bsb?: BankToBsbResolver<TParent>;
  name?: BankToNameResolver<TParent>;
}

export interface BankToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankToBsbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCallerContextTypeResolver<TParent = any> {
  isOrganisationMember?: DocumentCallerContextToIsOrganisationMemberResolver<TParent>;
  organisation?: DocumentCallerContextToOrganisationResolver<TParent>;
}

export interface DocumentCallerContextToIsOrganisationMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCallerContextToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentOrganisationTypeResolver<TParent = any> {
  id?: DocumentOrganisationToIdResolver<TParent>;
  name?: DocumentOrganisationToNameResolver<TParent>;
}

export interface DocumentOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentOrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CollaboratorsConnectionTypeResolver<TParent = any> {
  edges?: CollaboratorsConnectionToEdgesResolver<TParent>;
  nodes?: CollaboratorsConnectionToNodesResolver<TParent>;
  pageInfo?: CollaboratorsConnectionToPageInfoResolver<TParent>;
  totalCount?: CollaboratorsConnectionToTotalCountResolver<TParent>;
}

export interface CollaboratorsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CollaboratorsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CollaboratorsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CollaboratorsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CollaboratorsEdgeTypeResolver<TParent = any> {
  cursor?: CollaboratorsEdgeToCursorResolver<TParent>;
  node?: CollaboratorsEdgeToNodeResolver<TParent>;
}

export interface CollaboratorsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CollaboratorsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCollaboratorTypeResolver<TParent = any> {
  capabilities?: DocumentCollaboratorToCapabilitiesResolver<TParent>;
  emailAddress?: DocumentCollaboratorToEmailAddressResolver<TParent>;
  id?: DocumentCollaboratorToIdResolver<TParent>;
}

export interface DocumentCollaboratorToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCollaboratorToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCollaboratorToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsConnectionTypeResolver<TParent = any> {
  edges?: CommentsConnectionToEdgesResolver<TParent>;
  nodes?: CommentsConnectionToNodesResolver<TParent>;
  pageInfo?: CommentsConnectionToPageInfoResolver<TParent>;
  totalCount?: CommentsConnectionToTotalCountResolver<TParent>;
}

export interface CommentsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsEdgeTypeResolver<TParent = any> {
  cursor?: CommentsEdgeToCursorResolver<TParent>;
  node?: CommentsEdgeToNodeResolver<TParent>;
}

export interface CommentsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentTypeResolver<TParent = any> {
  author?: CommentToAuthorResolver<TParent>;
  content?: CommentToContentResolver<TParent>;
  createdAt?: CommentToCreatedAtResolver<TParent>;
  id?: CommentToIdResolver<TParent>;
}

export interface CommentToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthorTypeResolver<TParent = any> {
  familyName?: AuthorToFamilyNameResolver<TParent>;
  givenName?: AuthorToGivenNameResolver<TParent>;
  isBankAuthor?: AuthorToIsBankAuthorResolver<TParent>;
}

export interface AuthorToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthorToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthorToIsBankAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsTypeResolver<TParent = any> {
  adjustedCost?: DocumentCostsToAdjustedCostResolver<TParent>;
  recurringCostFrequency?: DocumentCostsToRecurringCostFrequencyResolver<TParent>;
  recurringFeeType?: DocumentCostsToRecurringFeeTypeResolver<TParent>;
  recurringFixedCost?: DocumentCostsToRecurringFixedCostResolver<TParent>;
  recurringMinimumAnnualCost?: DocumentCostsToRecurringMinimumAnnualCostResolver<TParent>;
  recurringPercentageCost?: DocumentCostsToRecurringPercentageCostResolver<TParent>;
  setUpCost?: DocumentCostsToSetUpCostResolver<TParent>;
}

export interface DocumentCostsToAdjustedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsToRecurringCostFrequencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsToRecurringFeeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsToRecurringFixedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsToRecurringMinimumAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsToRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentCostsToSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CustodianTypeResolver<TParent = any> {
  dateReceived?: CustodianToDateReceivedResolver<TParent>;
  emailAddress?: CustodianToEmailAddressResolver<TParent>;
  name?: CustodianToNameResolver<TParent>;
  notes?: CustodianToNotesResolver<TParent>;
  storageAddress?: CustodianToStorageAddressResolver<TParent>;
}

export interface CustodianToDateReceivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CustodianToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CustodianToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CustodianToNotesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CustodianToStorageAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHandoverTypeResolver<TParent = any> {
  createdOn?: DocumentHandoverToCreatedOnResolver<TParent>;
  emailAddress?: DocumentHandoverToEmailAddressResolver<TParent>;
  name?: DocumentHandoverToNameResolver<TParent>;
  organisationName?: DocumentHandoverToOrganisationNameResolver<TParent>;
  triggeredBy?: DocumentHandoverToTriggeredByResolver<TParent>;
}

export interface DocumentHandoverToCreatedOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHandoverToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHandoverToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHandoverToOrganisationNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHandoverToTriggeredByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HistoryConnectionTypeResolver<TParent = any> {
  edges?: HistoryConnectionToEdgesResolver<TParent>;
  nodes?: HistoryConnectionToNodesResolver<TParent>;
  pageInfo?: HistoryConnectionToPageInfoResolver<TParent>;
  totalCount?: HistoryConnectionToTotalCountResolver<TParent>;
}

export interface HistoryConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HistoryConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HistoryConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HistoryConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HistoryEdgeTypeResolver<TParent = any> {
  cursor?: HistoryEdgeToCursorResolver<TParent>;
  node?: HistoryEdgeToNodeResolver<TParent>;
}

export interface HistoryEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HistoryEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryTypeResolver<TParent = any> {
  changeSetId?: DocumentHistoryToChangeSetIdResolver<TParent>;
  changeType?: DocumentHistoryToChangeTypeResolver<TParent>;
  changes?: DocumentHistoryToChangesResolver<TParent>;
  id?: DocumentHistoryToIdResolver<TParent>;
  objectType?: DocumentHistoryToObjectTypeResolver<TParent>;
  recordName?: DocumentHistoryToRecordNameResolver<TParent>;
  triggeredAt?: DocumentHistoryToTriggeredAtResolver<TParent>;
  triggeredBy?: DocumentHistoryToTriggeredByResolver<TParent>;
}

export interface DocumentHistoryToChangeSetIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToChangeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToChangesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToObjectTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToRecordNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToTriggeredAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryToTriggeredByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryChangeTypeResolver<TParent = any> {
  field?: DocumentHistoryChangeToFieldResolver<TParent>;
  label?: DocumentHistoryChangeToLabelResolver<TParent>;
  newDisplayValue?: DocumentHistoryChangeToNewDisplayValueResolver<TParent>;
  newValue?: DocumentHistoryChangeToNewValueResolver<TParent>;
  oldDisplayValue?: DocumentHistoryChangeToOldDisplayValueResolver<TParent>;
  oldValue?: DocumentHistoryChangeToOldValueResolver<TParent>;
}

export interface DocumentHistoryChangeToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryChangeToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryChangeToNewDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryChangeToNewValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryChangeToOldDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentHistoryChangeToOldValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceTypeResolver<TParent = any> {
  canGenerateHostedInvoice?: IInvoiceToCanGenerateHostedInvoiceResolver<TParent>;
  createdAt?: IInvoiceToCreatedAtResolver<TParent>;
  createdBy?: IInvoiceToCreatedByResolver<TParent>;
  depositReferenceNumber?: IInvoiceToDepositReferenceNumberResolver<TParent>;
  external_AmountDue?: IInvoiceToExternal_AmountDueResolver<TParent>;
  external_CreatedDate?: IInvoiceToExternal_CreatedDateResolver<TParent>;
  external_DueDate?: IInvoiceToExternal_DueDateResolver<TParent>;
  external_PaidDate?: IInvoiceToExternal_PaidDateResolver<TParent>;
  external_ReceiptNumber?: IInvoiceToExternal_ReceiptNumberResolver<TParent>;
  hostedInvoiceAttachmentId?: IInvoiceToHostedInvoiceAttachmentIdResolver<TParent>;
  hostedReceiptAttachmentId?: IInvoiceToHostedReceiptAttachmentIdResolver<TParent>;
  invoiceLineItems?: IInvoiceToInvoiceLineItemsResolver<TParent>;
  invoicePaymentIntents?: IInvoiceToInvoicePaymentIntentsResolver<TParent>;
  stripeInvoiceHostedUrl?: IInvoiceToStripeInvoiceHostedUrlResolver<TParent>;
  stripeInvoiceId?: IInvoiceToStripeInvoiceIdResolver<TParent>;
  stripeInvoicePdf?: IInvoiceToStripeInvoicePdfResolver<TParent>;
  stripeInvoiceStatus?: IInvoiceToStripeInvoiceStatusResolver<TParent>;
  stripeReceiptUrl?: IInvoiceToStripeReceiptUrlResolver<TParent>;
  taxRate?: IInvoiceToTaxRateResolver<TParent>;
  totalAmount?: IInvoiceToTotalAmountResolver<TParent>;
}

export interface IInvoiceToCanGenerateHostedInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToDepositReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToExternal_AmountDueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToExternal_CreatedDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToExternal_DueDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToExternal_PaidDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToExternal_ReceiptNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToHostedInvoiceAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToHostedReceiptAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToInvoiceLineItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToInvoicePaymentIntentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToStripeInvoiceHostedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToStripeInvoiceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToStripeInvoicePdfResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToStripeInvoiceStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToStripeReceiptUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToTaxRateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceToTotalAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IInvoiceLineItemTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'InvoiceLineItem' | Promise<'InvoiceLineItem'>;
}
export interface IInvoicePaymentIntentTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'InvoicePaymentIntent' | Promise<'InvoicePaymentIntent'>;
}
export interface MetadataConnectionTypeResolver<TParent = any> {
  edges?: MetadataConnectionToEdgesResolver<TParent>;
  nodes?: MetadataConnectionToNodesResolver<TParent>;
  pageInfo?: MetadataConnectionToPageInfoResolver<TParent>;
  totalCount?: MetadataConnectionToTotalCountResolver<TParent>;
}

export interface MetadataConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataEdgeTypeResolver<TParent = any> {
  cursor?: MetadataEdgeToCursorResolver<TParent>;
  node?: MetadataEdgeToNodeResolver<TParent>;
}

export interface MetadataEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataTypeResolver<TParent = any> {
  id?: MetadataToIdResolver<TParent>;
  key?: MetadataToKeyResolver<TParent>;
  value?: MetadataToValueResolver<TParent>;
}

export interface MetadataToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataToKeyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MetadataToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyTypeResolver<TParent = any> {
  abn?: PartyToAbnResolver<TParent>;
  address?: PartyToAddressResolver<TParent>;
  addressV2?: PartyToAddressV2Resolver<TParent>;
  id?: PartyToIdResolver<TParent>;
  name?: PartyToNameResolver<TParent>;
  notes?: PartyToNotesResolver<TParent>;
  partyVariant?: PartyToPartyVariantResolver<TParent>;
}

export interface PartyToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyToAddressV2Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyToNotesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PartyToPartyVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddressTypeResolver<TParent = any> {
  addressLine1?: AddressToAddressLine1Resolver<TParent>;
  addressLine2?: AddressToAddressLine2Resolver<TParent>;
  city?: AddressToCityResolver<TParent>;
  country?: AddressToCountryResolver<TParent>;
  postcode?: AddressToPostcodeResolver<TParent>;
  state?: AddressToStateResolver<TParent>;
}

export interface AddressToAddressLine1Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddressToAddressLine2Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddressToCityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddressToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddressToPostcodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddressToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentRequestForReturnTypeResolver<TParent = any> {
  emailAddress?: DocumentRequestForReturnToEmailAddressResolver<TParent>;
  name?: DocumentRequestForReturnToNameResolver<TParent>;
  recurringFrequency?: DocumentRequestForReturnToRecurringFrequencyResolver<TParent>;
  startedOn?: DocumentRequestForReturnToStartedOnResolver<TParent>;
}

export interface DocumentRequestForReturnToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentRequestForReturnToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentRequestForReturnToRecurringFrequencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentRequestForReturnToStartedOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentNotificationListMemberTypeResolver<TParent = any> {
  familyName?: DocumentNotificationListMemberToFamilyNameResolver<TParent>;
  givenName?: DocumentNotificationListMemberToGivenNameResolver<TParent>;
  memberId?: DocumentNotificationListMemberToMemberIdResolver<TParent>;
}

export interface DocumentNotificationListMemberToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentNotificationListMemberToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentNotificationListMemberToMemberIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilitiesConnectionTypeResolver<TParent = any> {
  edges?: DocumentFacilitiesConnectionToEdgesResolver<TParent>;
  nodes?: DocumentFacilitiesConnectionToNodesResolver<TParent>;
  pageInfo?: DocumentFacilitiesConnectionToPageInfoResolver<TParent>;
  totalCount?: DocumentFacilitiesConnectionToTotalCountResolver<TParent>;
}

export interface DocumentFacilitiesConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilitiesConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilitiesConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilitiesConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilitiesEdgeTypeResolver<TParent = any> {
  cursor?: DocumentFacilitiesEdgeToCursorResolver<TParent>;
  node?: DocumentFacilitiesEdgeToNodeResolver<TParent>;
}

export interface DocumentFacilitiesEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilitiesEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityTypeResolver<TParent = any> {
  annualCost?: DocumentFacilityToAnnualCostResolver<TParent>;
  bankFrontedBondsRecurringPercentageCost?: DocumentFacilityToBankFrontedBondsRecurringPercentageCostResolver<TParent>;
  bankFrontedBondsSetUpCost?: DocumentFacilityToBankFrontedBondsSetUpCostResolver<TParent>;
  capabilities?: DocumentFacilityToCapabilitiesResolver<TParent>;
  documentAdjustedCost?: DocumentFacilityToDocumentAdjustedCostResolver<TParent>;
  documentCount?: DocumentFacilityToDocumentCountResolver<TParent>;
  documentRecurringCostFrequency?: DocumentFacilityToDocumentRecurringCostFrequencyResolver<TParent>;
  documentRecurringFeeType?: DocumentFacilityToDocumentRecurringFeeTypeResolver<TParent>;
  documentRecurringFixedCost?: DocumentFacilityToDocumentRecurringFixedCostResolver<TParent>;
  documentRecurringMinimumAnnualCost?: DocumentFacilityToDocumentRecurringMinimumAnnualCostResolver<TParent>;
  documentRecurringPercentageCost?: DocumentFacilityToDocumentRecurringPercentageCostResolver<TParent>;
  documentSetUpCost?: DocumentFacilityToDocumentSetUpCostResolver<TParent>;
  documentVariant?: DocumentFacilityToDocumentVariantResolver<TParent>;
  endDate?: DocumentFacilityToEndDateResolver<TParent>;
  entities?: DocumentFacilityToEntitiesResolver<TParent>;
  facilityHistory?: DocumentFacilityToFacilityHistoryResolver<TParent>;
  id?: DocumentFacilityToIdResolver<TParent>;
  isAssuroFacility?: DocumentFacilityToIsAssuroFacilityResolver<TParent>;
  limit?: DocumentFacilityToLimitResolver<TParent>;
  name?: DocumentFacilityToNameResolver<TParent>;
  organisation?: DocumentFacilityToOrganisationResolver<TParent>;
  organisationId?: DocumentFacilityToOrganisationIdResolver<TParent>;
  premiumBankFrontedBondsRecurringPercentageCost?: DocumentFacilityToPremiumBankFrontedBondsRecurringPercentageCostResolver<TParent>;
  premiumDocumentRecurringPercentageCost?: DocumentFacilityToPremiumDocumentRecurringPercentageCostResolver<TParent>;
  properties?: DocumentFacilityToPropertiesResolver<TParent>;
  provider?: DocumentFacilityToProviderResolver<TParent>;
  securityType?: DocumentFacilityToSecurityTypeResolver<TParent>;
  setUpCost?: DocumentFacilityToSetUpCostResolver<TParent>;
  sharedFacilityWithOrganisations?: DocumentFacilityToSharedFacilityWithOrganisationsResolver<TParent>;
  startDate?: DocumentFacilityToStartDateResolver<TParent>;
  supplierId?: DocumentFacilityToSupplierIdResolver<TParent>;
  totalEstablished?: DocumentFacilityToTotalEstablishedResolver<TParent>;
  totalProjected?: DocumentFacilityToTotalProjectedResolver<TParent>;
}

export interface DocumentFacilityToAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToBankFrontedBondsRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToBankFrontedBondsSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentAdjustedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentRecurringCostFrequencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentRecurringFeeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentRecurringFixedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentRecurringMinimumAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToDocumentVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToEntitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToFacilityHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: FacilityHistorySort;
}
export interface DocumentFacilityToFacilityHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DocumentFacilityToFacilityHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToIsAssuroFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToPremiumBankFrontedBondsRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToPremiumDocumentRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToPropertiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToProviderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToSecurityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToSharedFacilityWithOrganisationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToTotalEstablishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentFacilityToTotalProjectedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityEntityTypeResolver<TParent = any> {
  abn?: FacilityEntityToAbnResolver<TParent>;
  facility?: FacilityEntityToFacilityResolver<TParent>;
  facilityId?: FacilityEntityToFacilityIdResolver<TParent>;
  id?: FacilityEntityToIdResolver<TParent>;
  name?: FacilityEntityToNameResolver<TParent>;
}

export interface FacilityEntityToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityEntityToFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityEntityToFacilityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityEntityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityEntityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryConnectionTypeResolver<TParent = any> {
  edges?: FacilityHistoryConnectionToEdgesResolver<TParent>;
  nodes?: FacilityHistoryConnectionToNodesResolver<TParent>;
  pageInfo?: FacilityHistoryConnectionToPageInfoResolver<TParent>;
  totalCount?: FacilityHistoryConnectionToTotalCountResolver<TParent>;
}

export interface FacilityHistoryConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryEdgeTypeResolver<TParent = any> {
  cursor?: FacilityHistoryEdgeToCursorResolver<TParent>;
  node?: FacilityHistoryEdgeToNodeResolver<TParent>;
}

export interface FacilityHistoryEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryTypeResolver<TParent = any> {
  changeSetId?: FacilityHistoryToChangeSetIdResolver<TParent>;
  changeType?: FacilityHistoryToChangeTypeResolver<TParent>;
  changes?: FacilityHistoryToChangesResolver<TParent>;
  id?: FacilityHistoryToIdResolver<TParent>;
  objectType?: FacilityHistoryToObjectTypeResolver<TParent>;
  recordName?: FacilityHistoryToRecordNameResolver<TParent>;
  triggeredAt?: FacilityHistoryToTriggeredAtResolver<TParent>;
  triggeredBy?: FacilityHistoryToTriggeredByResolver<TParent>;
}

export interface FacilityHistoryToChangeSetIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToChangeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToChangesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToObjectTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToRecordNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToTriggeredAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryToTriggeredByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryChangeTypeResolver<TParent = any> {
  field?: FacilityHistoryChangeToFieldResolver<TParent>;
  label?: FacilityHistoryChangeToLabelResolver<TParent>;
  newDisplayValue?: FacilityHistoryChangeToNewDisplayValueResolver<TParent>;
  newValue?: FacilityHistoryChangeToNewValueResolver<TParent>;
  oldDisplayValue?: FacilityHistoryChangeToOldDisplayValueResolver<TParent>;
  oldValue?: FacilityHistoryChangeToOldValueResolver<TParent>;
}

export interface FacilityHistoryChangeToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryChangeToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryChangeToNewDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryChangeToNewValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryChangeToOldDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityHistoryChangeToOldValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityOrganisationTypeResolver<TParent = any> {
  id?: FacilityOrganisationToIdResolver<TParent>;
  name?: FacilityOrganisationToNameResolver<TParent>;
}

export interface FacilityOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityOrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyTypeResolver<TParent = any> {
  address?: FacilityPropertyToAddressResolver<TParent>;
  estimatedValue?: FacilityPropertyToEstimatedValueResolver<TParent>;
  facility?: FacilityPropertyToFacilityResolver<TParent>;
  facilityId?: FacilityPropertyToFacilityIdResolver<TParent>;
  id?: FacilityPropertyToIdResolver<TParent>;
  isMortgaged?: FacilityPropertyToIsMortgagedResolver<TParent>;
  isPrimaryPlaceOfResidence?: FacilityPropertyToIsPrimaryPlaceOfResidenceResolver<TParent>;
  lender?: FacilityPropertyToLenderResolver<TParent>;
  outstandingMortgage?: FacilityPropertyToOutstandingMortgageResolver<TParent>;
  owners?: FacilityPropertyToOwnersResolver<TParent>;
  propertyType?: FacilityPropertyToPropertyTypeResolver<TParent>;
}

export interface FacilityPropertyToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToEstimatedValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToFacilityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToIsMortgagedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToIsPrimaryPlaceOfResidenceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToLenderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToOutstandingMortgageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToOwnersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyToPropertyTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyOwnerTypeResolver<TParent = any> {
  applicantRelationship?: FacilityPropertyOwnerToApplicantRelationshipResolver<TParent>;
  facilityPropertyId?: FacilityPropertyOwnerToFacilityPropertyIdResolver<TParent>;
  id?: FacilityPropertyOwnerToIdResolver<TParent>;
  name?: FacilityPropertyOwnerToNameResolver<TParent>;
  property?: FacilityPropertyOwnerToPropertyResolver<TParent>;
}

export interface FacilityPropertyOwnerToApplicantRelationshipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyOwnerToFacilityPropertyIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyOwnerToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyOwnerToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityPropertyOwnerToPropertyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitySharedFacilityWithOrganisationTypeResolver<TParent = any> {
  createdAt?: FacilitySharedFacilityWithOrganisationToCreatedAtResolver<TParent>;
  facilityId?: FacilitySharedFacilityWithOrganisationToFacilityIdResolver<TParent>;
  id?: FacilitySharedFacilityWithOrganisationToIdResolver<TParent>;
  organisationId?: FacilitySharedFacilityWithOrganisationToOrganisationIdResolver<TParent>;
  sharedWithOrganisation?: FacilitySharedFacilityWithOrganisationToSharedWithOrganisationResolver<TParent>;
}

export interface FacilitySharedFacilityWithOrganisationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitySharedFacilityWithOrganisationToFacilityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitySharedFacilityWithOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitySharedFacilityWithOrganisationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitySharedFacilityWithOrganisationToSharedWithOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentReportsConnectionTypeResolver<TParent = any> {
  edges?: DocumentReportsConnectionToEdgesResolver<TParent>;
  nodes?: DocumentReportsConnectionToNodesResolver<TParent>;
  pageInfo?: DocumentReportsConnectionToPageInfoResolver<TParent>;
  totalCount?: DocumentReportsConnectionToTotalCountResolver<TParent>;
}

export interface DocumentReportsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentReportsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentReportsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentReportsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentReportsEdgeTypeResolver<TParent = any> {
  cursor?: DocumentReportsEdgeToCursorResolver<TParent>;
  node?: DocumentReportsEdgeToNodeResolver<TParent>;
}

export interface DocumentReportsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentReportsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportTypeResolver<TParent = any> {
  createdBy?: ReportToCreatedByResolver<TParent>;
  createdOn?: ReportToCreatedOnResolver<TParent>;
  criteria?: ReportToCriteriaResolver<TParent>;
  displayName?: ReportToDisplayNameResolver<TParent>;
  filters?: ReportToFiltersResolver<TParent>;
  id?: ReportToIdResolver<TParent>;
  sortBy?: ReportToSortByResolver<TParent>;
  sortOrder?: ReportToSortOrderResolver<TParent>;
  status?: ReportToStatusResolver<TParent>;
  supplierId?: ReportToSupplierIdResolver<TParent>;
  variant?: ReportToVariantResolver<TParent>;
}

export interface ReportToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToCreatedOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToCriteriaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToDisplayNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToFiltersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToSortByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToSortOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsConnectionTypeResolver<TParent = any> {
  edges?: DocumentsConnectionToEdgesResolver<TParent>;
  nodes?: DocumentsConnectionToNodesResolver<TParent>;
  pageInfo?: DocumentsConnectionToPageInfoResolver<TParent>;
  totalCount?: DocumentsConnectionToTotalCountResolver<TParent>;
}

export interface DocumentsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsEdgeTypeResolver<TParent = any> {
  cursor?: DocumentsEdgeToCursorResolver<TParent>;
  node?: DocumentsEdgeToNodeResolver<TParent>;
}

export interface DocumentsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: DocumentsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: DocumentsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: DocumentsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: DocumentsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface DocumentsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: DocumentsForBankPortalEdgeToCursorResolver<TParent>;
  node?: DocumentsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface DocumentsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentTypeResolver<TParent = any> {
  actionDate?: BankDocumentToActionDateResolver<TParent>;
  adjustedCost?: BankDocumentToAdjustedCostResolver<TParent>;
  amount?: BankDocumentToAmountResolver<TParent>;
  annualCost?: BankDocumentToAnnualCostResolver<TParent>;
  capabilities?: BankDocumentToCapabilitiesResolver<TParent>;
  channelPartnerName?: BankDocumentToChannelPartnerNameResolver<TParent>;
  closedAt?: BankDocumentToClosedAtResolver<TParent>;
  costs?: BankDocumentToCostsResolver<TParent>;
  createdAt?: BankDocumentToCreatedAtResolver<TParent>;
  description?: BankDocumentToDescriptionResolver<TParent>;
  documentVariant?: BankDocumentToDocumentVariantResolver<TParent>;
  establishedAt?: BankDocumentToEstablishedAtResolver<TParent>;
  establishmentFee?: BankDocumentToEstablishmentFeeResolver<TParent>;
  expectedReturnDate?: BankDocumentToExpectedReturnDateResolver<TParent>;
  expiresAt?: BankDocumentToExpiresAtResolver<TParent>;
  guaranteeNumber?: BankDocumentToGuaranteeNumberResolver<TParent>;
  history?: BankDocumentToHistoryResolver<TParent>;
  id?: BankDocumentToIdResolver<TParent>;
  invoices?: BankDocumentToInvoicesResolver<TParent>;
  organisationId?: BankDocumentToOrganisationIdResolver<TParent>;
  originalDraftId?: BankDocumentToOriginalDraftIdResolver<TParent>;
  parties?: BankDocumentToPartiesResolver<TParent>;
  projectAddress?: BankDocumentToProjectAddressResolver<TParent>;
  purpose?: BankDocumentToPurposeResolver<TParent>;
  recurringCostFrequency?: BankDocumentToRecurringCostFrequencyResolver<TParent>;
  recurringFixedCost?: BankDocumentToRecurringFixedCostResolver<TParent>;
  recurringPercentageCost?: BankDocumentToRecurringPercentageCostResolver<TParent>;
  referenceNumber?: BankDocumentToReferenceNumberResolver<TParent>;
  requestedAt?: BankDocumentToRequestedAtResolver<TParent>;
  retentionType?: BankDocumentToRetentionTypeResolver<TParent>;
  securityType?: BankDocumentToSecurityTypeResolver<TParent>;
  setUpCost?: BankDocumentToSetUpCostResolver<TParent>;
  specifiedOtherPurpose?: BankDocumentToSpecifiedOtherPurposeResolver<TParent>;
  status?: BankDocumentToStatusResolver<TParent>;
  supplierName?: BankDocumentToSupplierNameResolver<TParent>;
}

export interface BankDocumentToActionDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToAdjustedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToChannelPartnerNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToClosedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToCostsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToDocumentVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToEstablishedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToEstablishmentFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToExpectedReturnDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToGuaranteeNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DocumentHistorySort;
}
export interface BankDocumentToHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankDocumentToHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToOriginalDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToPartiesArgs {
  where?: PartyFilter;
}
export interface BankDocumentToPartiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankDocumentToPartiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToProjectAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToRecurringCostFrequencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToRecurringFixedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToRequestedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToRetentionTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToSecurityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToSpecifiedOtherPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentToSupplierNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsSharedWithMeConnectionTypeResolver<TParent = any> {
  edges?: DocumentsSharedWithMeConnectionToEdgesResolver<TParent>;
  nodes?: DocumentsSharedWithMeConnectionToNodesResolver<TParent>;
  pageInfo?: DocumentsSharedWithMeConnectionToPageInfoResolver<TParent>;
  totalCount?: DocumentsSharedWithMeConnectionToTotalCountResolver<TParent>;
}

export interface DocumentsSharedWithMeConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsSharedWithMeConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsSharedWithMeConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsSharedWithMeConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsSharedWithMeEdgeTypeResolver<TParent = any> {
  cursor?: DocumentsSharedWithMeEdgeToCursorResolver<TParent>;
  node?: DocumentsSharedWithMeEdgeToNodeResolver<TParent>;
}

export interface DocumentsSharedWithMeEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentsSharedWithMeEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftApplicableRequirementTypeResolver<TParent = any> {
  field?: DraftApplicableRequirementToFieldResolver<TParent>;
  message?: DraftApplicableRequirementToMessageResolver<TParent>;
  requirementMet?: DraftApplicableRequirementToRequirementMetResolver<TParent>;
}

export interface DraftApplicableRequirementToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftApplicableRequirementToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftApplicableRequirementToRequirementMetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentDownloadTypeResolver<TParent = any> {
  downloadPresignedUrl?: DraftAttachmentDownloadToDownloadPresignedUrlResolver<TParent>;
}

export interface DraftAttachmentDownloadToDownloadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftTypeResolver<TParent = any> {
  acceptedChannelPartnerId?: DraftToAcceptedChannelPartnerIdResolver<TParent>;
  additionalSupplierDetail?: DraftToAdditionalSupplierDetailResolver<TParent>;
  amount?: DraftToAmountResolver<TParent>;
  ancestorFeeSummaryIds?: DraftToAncestorFeeSummaryIdsResolver<TParent>;
  applicableRequirements?: DraftToApplicableRequirementsResolver<TParent>;
  attachments?: DraftToAttachmentsResolver<TParent>;
  bGSwitch?: DraftToBGSwitchResolver<TParent>;
  callerContext?: DraftToCallerContextResolver<TParent>;
  capabilities?: DraftToCapabilitiesResolver<TParent>;
  completedFinanceJourney?: DraftToCompletedFinanceJourneyResolver<TParent>;
  contract?: DraftToContractResolver<TParent>;
  createdAt?: DraftToCreatedAtResolver<TParent>;
  currentPeriodEnd?: DraftToCurrentPeriodEndResolver<TParent>;
  deliveryDetails?: DraftToDeliveryDetailsResolver<TParent>;
  deliveryType?: DraftToDeliveryTypeResolver<TParent>;
  description?: DraftToDescriptionResolver<TParent>;
  directorEmailAddress?: DraftToDirectorEmailAddressResolver<TParent>;
  directorFirstName?: DraftToDirectorFirstNameResolver<TParent>;
  directorLastName?: DraftToDirectorLastNameResolver<TParent>;
  discountPercentage?: DraftToDiscountPercentageResolver<TParent>;
  draftCollaborators?: DraftToDraftCollaboratorsResolver<TParent>;
  draftComments?: DraftToDraftCommentsResolver<TParent>;
  draftHistory?: DraftToDraftHistoryResolver<TParent>;
  establishedAt?: DraftToEstablishedAtResolver<TParent>;
  establishmentFeeDiscountAmount?: DraftToEstablishmentFeeDiscountAmountResolver<TParent>;
  expectedReturnDate?: DraftToExpectedReturnDateResolver<TParent>;
  expiresAt?: DraftToExpiresAtResolver<TParent>;
  facilityId?: DraftToFacilityIdResolver<TParent>;
  feeSummary?: DraftToFeeSummaryResolver<TParent>;
  feeSummaryId?: DraftToFeeSummaryIdResolver<TParent>;
  fundingMethod?: DraftToFundingMethodResolver<TParent>;
  id?: DraftToIdResolver<TParent>;
  identification?: DraftToIdentificationResolver<TParent>;
  identificationId?: DraftToIdentificationIdResolver<TParent>;
  identificationSubmitted?: DraftToIdentificationSubmittedResolver<TParent>;
  invoiceRecipientEmailAddresses?: DraftToInvoiceRecipientEmailAddressesResolver<TParent>;
  invoices?: DraftToInvoicesResolver<TParent>;
  isEligibleForFinance?: DraftToIsEligibleForFinanceResolver<TParent>;
  isVisibleToSupplier?: DraftToIsVisibleToSupplierResolver<TParent>;
  issuerDetailsOfSourceOfFunds?: DraftToIssuerDetailsOfSourceOfFundsResolver<TParent>;
  issuerSourceOfFunds?: DraftToIssuerSourceOfFundsResolver<TParent>;
  megDetails?: DraftToMegDetailsResolver<TParent>;
  organisationId?: DraftToOrganisationIdResolver<TParent>;
  parties?: DraftToPartiesResolver<TParent>;
  paymentDetails?: DraftToPaymentDetailsResolver<TParent>;
  processType?: DraftToProcessTypeResolver<TParent>;
  productTermsAcceptedDate?: DraftToProductTermsAcceptedDateResolver<TParent>;
  projectAddress?: DraftToProjectAddressResolver<TParent>;
  purpose?: DraftToPurposeResolver<TParent>;
  referenceNumber?: DraftToReferenceNumberResolver<TParent>;
  referralPercentage?: DraftToReferralPercentageResolver<TParent>;
  referralProgramDiscount?: DraftToReferralProgramDiscountResolver<TParent>;
  refundAccountName?: DraftToRefundAccountNameResolver<TParent>;
  refundAccountNumber?: DraftToRefundAccountNumberResolver<TParent>;
  refundBSB?: DraftToRefundBSBResolver<TParent>;
  rejectionReason?: DraftToRejectionReasonResolver<TParent>;
  requestChangeReason?: DraftToRequestChangeReasonResolver<TParent>;
  requestedSuretyDocuments?: DraftToRequestedSuretyDocumentsResolver<TParent>;
  requiredDocuments?: DraftToRequiredDocumentsResolver<TParent>;
  sourceDraftId?: DraftToSourceDraftIdResolver<TParent>;
  specifiedOtherPurpose?: DraftToSpecifiedOtherPurposeResolver<TParent>;
  status?: DraftToStatusResolver<TParent>;
  stripeSubscriptionId?: DraftToStripeSubscriptionIdResolver<TParent>;
  stripeSubscriptionStatus?: DraftToStripeSubscriptionStatusResolver<TParent>;
  submittedAt?: DraftToSubmittedAtResolver<TParent>;
  totalFees?: DraftToTotalFeesResolver<TParent>;
  visibleToSupplierDate?: DraftToVisibleToSupplierDateResolver<TParent>;
}

export interface DraftToAcceptedChannelPartnerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToAdditionalSupplierDetailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToAncestorFeeSummaryIdsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToAttachmentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToBGSwitchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToCallerContextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToCompletedFinanceJourneyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToContractResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToCurrentPeriodEndResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDeliveryDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDeliveryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDirectorEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDirectorFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDirectorLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDraftCollaboratorsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
}
export interface DraftToDraftCollaboratorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DraftToDraftCollaboratorsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDraftCommentsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftCommentSort;
}
export interface DraftToDraftCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DraftToDraftCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToDraftHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftHistorySort;
}
export interface DraftToDraftHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DraftToDraftHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToEstablishedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToEstablishmentFeeDiscountAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToExpectedReturnDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToFacilityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToFeeSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToFeeSummaryIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToFundingMethodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIdentificationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIdentificationSubmittedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToInvoiceRecipientEmailAddressesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIsEligibleForFinanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIsVisibleToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIssuerDetailsOfSourceOfFundsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToIssuerSourceOfFundsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToMegDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToPartiesArgs {
  where?: DraftPartyFilter;
}
export interface DraftToPartiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DraftToPartiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToPaymentDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToProcessTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToProductTermsAcceptedDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToProjectAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToReferralPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToReferralProgramDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRefundAccountNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRefundAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRefundBSBResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRejectionReasonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRequestChangeReasonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRequestedSuretyDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToRequiredDocumentsArgs {
  order_by?: RequiredDocumentViewModelSort;
}
export interface DraftToRequiredDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DraftToRequiredDocumentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToSourceDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToSpecifiedOtherPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToStripeSubscriptionIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToStripeSubscriptionStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToSubmittedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToTotalFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftToVisibleToSupplierDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdditionalSupplierDetailTypeResolver<TParent = any> {
  fundingAccountBsb?: AdditionalSupplierDetailToFundingAccountBsbResolver<TParent>;
  fundingAccountNumber?: AdditionalSupplierDetailToFundingAccountNumberResolver<TParent>;
  hasFundingAccountAuthorisation?: AdditionalSupplierDetailToHasFundingAccountAuthorisationResolver<TParent>;
  id?: AdditionalSupplierDetailToIdResolver<TParent>;
}

export interface AdditionalSupplierDetailToFundingAccountBsbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdditionalSupplierDetailToFundingAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdditionalSupplierDetailToHasFundingAccountAuthorisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdditionalSupplierDetailToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentTypeResolver<TParent = any> {
  contentMd5Checksum?: DraftAttachmentToContentMd5ChecksumResolver<TParent>;
  contentType?: DraftAttachmentToContentTypeResolver<TParent>;
  createdAt?: DraftAttachmentToCreatedAtResolver<TParent>;
  draftId?: DraftAttachmentToDraftIdResolver<TParent>;
  draftRequestedDocumentId?: DraftAttachmentToDraftRequestedDocumentIdResolver<TParent>;
  fileName?: DraftAttachmentToFileNameResolver<TParent>;
  id?: DraftAttachmentToIdResolver<TParent>;
  infectedFileStatus?: DraftAttachmentToInfectedFileStatusResolver<TParent>;
  received?: DraftAttachmentToReceivedResolver<TParent>;
  uploadPresignedUrl?: DraftAttachmentToUploadPresignedUrlResolver<TParent>;
  variant?: DraftAttachmentToVariantResolver<TParent>;
}

export interface DraftAttachmentToContentMd5ChecksumResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToContentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToDraftRequestedDocumentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToFileNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToInfectedFileStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToReceivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToUploadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAttachmentToVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCallerContextTypeResolver<TParent = any> {
  collaborator?: DraftCallerContextToCollaboratorResolver<TParent>;
  isOrganisationMember?: DraftCallerContextToIsOrganisationMemberResolver<TParent>;
  organisation?: DraftCallerContextToOrganisationResolver<TParent>;
}

export interface DraftCallerContextToCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCallerContextToIsOrganisationMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCallerContextToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorTypeResolver<TParent = any> {
  capabilities?: DraftCollaboratorToCapabilitiesResolver<TParent>;
  emailAddress?: DraftCollaboratorToEmailAddressResolver<TParent>;
  familyName?: DraftCollaboratorToFamilyNameResolver<TParent>;
  givenName?: DraftCollaboratorToGivenNameResolver<TParent>;
  hasApproved?: DraftCollaboratorToHasApprovedResolver<TParent>;
  id?: DraftCollaboratorToIdResolver<TParent>;
  invitationStatus?: DraftCollaboratorToInvitationStatusResolver<TParent>;
  organisationName?: DraftCollaboratorToOrganisationNameResolver<TParent>;
  roles?: DraftCollaboratorToRolesResolver<TParent>;
  subscribedMembers?: DraftCollaboratorToSubscribedMembersResolver<TParent>;
}

export interface DraftCollaboratorToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToHasApprovedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToInvitationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToOrganisationNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorToSubscribedMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftNotificationListMemberTypeResolver<TParent = any> {
  familyName?: DraftNotificationListMemberToFamilyNameResolver<TParent>;
  givenName?: DraftNotificationListMemberToGivenNameResolver<TParent>;
  memberId?: DraftNotificationListMemberToMemberIdResolver<TParent>;
}

export interface DraftNotificationListMemberToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftNotificationListMemberToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftNotificationListMemberToMemberIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOrganisationTypeResolver<TParent = any> {
  discountPercentage?: DraftOrganisationToDiscountPercentageResolver<TParent>;
  id?: DraftOrganisationToIdResolver<TParent>;
  name?: DraftOrganisationToNameResolver<TParent>;
}

export interface DraftOrganisationToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailTypeResolver<TParent = any> {
  bankFrontedBondsRequested?: DraftContractDetailToBankFrontedBondsRequestedResolver<TParent>;
  bankFrontedBondsRequestedReason?: DraftContractDetailToBankFrontedBondsRequestedReasonResolver<TParent>;
  defectsAndFaults?: DraftContractDetailToDefectsAndFaultsResolver<TParent>;
  defectsLiabilityPeriodExtended?: DraftContractDetailToDefectsLiabilityPeriodExtendedResolver<TParent>;
  finalCompletionDate?: DraftContractDetailToFinalCompletionDateResolver<TParent>;
  hasDelayEvents?: DraftContractDetailToHasDelayEventsResolver<TParent>;
  hasDesignObligationsLiability?: DraftContractDetailToHasDesignObligationsLiabilityResolver<TParent>;
  hasPreviousContracts?: DraftContractDetailToHasPreviousContractsResolver<TParent>;
  hasSimilarContracts?: DraftContractDetailToHasSimilarContractsResolver<TParent>;
  isExistingProject?: DraftContractDetailToIsExistingProjectResolver<TParent>;
  isSubcontractor?: DraftContractDetailToIsSubcontractorResolver<TParent>;
  issuesAndDisputes?: DraftContractDetailToIssuesAndDisputesResolver<TParent>;
  practicalCompletionDate?: DraftContractDetailToPracticalCompletionDateResolver<TParent>;
  projectNotOnBudget?: DraftContractDetailToProjectNotOnBudgetResolver<TParent>;
  replacingExistingSecurity?: DraftContractDetailToReplacingExistingSecurityResolver<TParent>;
  startDate?: DraftContractDetailToStartDateResolver<TParent>;
  totalValue?: DraftContractDetailToTotalValueResolver<TParent>;
}

export interface DraftContractDetailToBankFrontedBondsRequestedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToBankFrontedBondsRequestedReasonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToDefectsAndFaultsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToDefectsLiabilityPeriodExtendedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToFinalCompletionDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToHasDelayEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToHasDesignObligationsLiabilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToHasPreviousContractsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToHasSimilarContractsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToIsExistingProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToIsSubcontractorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToIssuesAndDisputesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToPracticalCompletionDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToProjectNotOnBudgetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToReplacingExistingSecurityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftContractDetailToTotalValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOptionWithDetailTypeResolver<TParent = any> {
  active?: DraftOptionWithDetailToActiveResolver<TParent>;
  detail?: DraftOptionWithDetailToDetailResolver<TParent>;
}

export interface DraftOptionWithDetailToActiveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOptionWithDetailToDetailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftDeliveryDetailsTypeResolver<TParent = any> {
  address?: DraftDeliveryDetailsToAddressResolver<TParent>;
  companyName?: DraftDeliveryDetailsToCompanyNameResolver<TParent>;
  phoneNumber?: DraftDeliveryDetailsToPhoneNumberResolver<TParent>;
  recipientFamilyName?: DraftDeliveryDetailsToRecipientFamilyNameResolver<TParent>;
  recipientGivenName?: DraftDeliveryDetailsToRecipientGivenNameResolver<TParent>;
}

export interface DraftDeliveryDetailsToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftDeliveryDetailsToCompanyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftDeliveryDetailsToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftDeliveryDetailsToRecipientFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftDeliveryDetailsToRecipientGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorsConnectionTypeResolver<TParent = any> {
  edges?: DraftCollaboratorsConnectionToEdgesResolver<TParent>;
  nodes?: DraftCollaboratorsConnectionToNodesResolver<TParent>;
  pageInfo?: DraftCollaboratorsConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftCollaboratorsConnectionToTotalCountResolver<TParent>;
}

export interface DraftCollaboratorsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorsEdgeTypeResolver<TParent = any> {
  cursor?: DraftCollaboratorsEdgeToCursorResolver<TParent>;
  node?: DraftCollaboratorsEdgeToNodeResolver<TParent>;
}

export interface DraftCollaboratorsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCollaboratorsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentsConnectionTypeResolver<TParent = any> {
  edges?: DraftCommentsConnectionToEdgesResolver<TParent>;
  nodes?: DraftCommentsConnectionToNodesResolver<TParent>;
  pageInfo?: DraftCommentsConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftCommentsConnectionToTotalCountResolver<TParent>;
}

export interface DraftCommentsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentsEdgeTypeResolver<TParent = any> {
  cursor?: DraftCommentsEdgeToCursorResolver<TParent>;
  node?: DraftCommentsEdgeToNodeResolver<TParent>;
}

export interface DraftCommentsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentTypeResolver<TParent = any> {
  author?: DraftCommentToAuthorResolver<TParent>;
  content?: DraftCommentToContentResolver<TParent>;
  createdAt?: DraftCommentToCreatedAtResolver<TParent>;
  history?: DraftCommentToHistoryResolver<TParent>;
  id?: DraftCommentToIdResolver<TParent>;
}

export interface DraftCommentToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentToHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftCommentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAuthorTypeResolver<TParent = any> {
  familyName?: DraftAuthorToFamilyNameResolver<TParent>;
  givenName?: DraftAuthorToGivenNameResolver<TParent>;
  isBankAuthor?: DraftAuthorToIsBankAuthorResolver<TParent>;
}

export interface DraftAuthorToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAuthorToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftAuthorToIsBankAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryTypeResolver<TParent = any> {
  changeSetId?: DraftHistoryToChangeSetIdResolver<TParent>;
  changeType?: DraftHistoryToChangeTypeResolver<TParent>;
  changes?: DraftHistoryToChangesResolver<TParent>;
  id?: DraftHistoryToIdResolver<TParent>;
  objectType?: DraftHistoryToObjectTypeResolver<TParent>;
  recordName?: DraftHistoryToRecordNameResolver<TParent>;
  triggeredAt?: DraftHistoryToTriggeredAtResolver<TParent>;
  triggeredBy?: DraftHistoryToTriggeredByResolver<TParent>;
}

export interface DraftHistoryToChangeSetIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToChangeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToChangesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToObjectTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToRecordNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToTriggeredAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryToTriggeredByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryChangeTypeResolver<TParent = any> {
  field?: DraftHistoryChangeToFieldResolver<TParent>;
  label?: DraftHistoryChangeToLabelResolver<TParent>;
  newDisplayValue?: DraftHistoryChangeToNewDisplayValueResolver<TParent>;
  newValue?: DraftHistoryChangeToNewValueResolver<TParent>;
  oldDisplayValue?: DraftHistoryChangeToOldDisplayValueResolver<TParent>;
  oldValue?: DraftHistoryChangeToOldValueResolver<TParent>;
}

export interface DraftHistoryChangeToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryChangeToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryChangeToNewDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryChangeToNewValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryChangeToOldDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryChangeToOldValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryConnectionTypeResolver<TParent = any> {
  edges?: DraftHistoryConnectionToEdgesResolver<TParent>;
  nodes?: DraftHistoryConnectionToNodesResolver<TParent>;
  pageInfo?: DraftHistoryConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftHistoryConnectionToTotalCountResolver<TParent>;
}

export interface DraftHistoryConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryEdgeTypeResolver<TParent = any> {
  cursor?: DraftHistoryEdgeToCursorResolver<TParent>;
  node?: DraftHistoryEdgeToNodeResolver<TParent>;
}

export interface DraftHistoryEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftHistoryEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryTypeResolver<TParent = any> {
  assuroAgencyAgreementTemplateName?: FeeSummaryToAssuroAgencyAgreementTemplateNameResolver<TParent>;
  biannualFeeCoefficient?: FeeSummaryToBiannualFeeCoefficientResolver<TParent>;
  createdAt?: FeeSummaryToCreatedAtResolver<TParent>;
  createdBy?: FeeSummaryToCreatedByResolver<TParent>;
  deliveryType?: FeeSummaryToDeliveryTypeResolver<TParent>;
  details?: FeeSummaryToDetailsResolver<TParent>;
  establishmentFee?: FeeSummaryToEstablishmentFeeResolver<TParent>;
  features?: FeeSummaryToFeaturesResolver<TParent>;
  feeSummaryStatus?: FeeSummaryToFeeSummaryStatusResolver<TParent>;
  id?: FeeSummaryToIdResolver<TParent>;
  maxValue?: FeeSummaryToMaxValueResolver<TParent>;
  minValue?: FeeSummaryToMinValueResolver<TParent>;
  name?: FeeSummaryToNameResolver<TParent>;
  productPreviewTemplateName?: FeeSummaryToProductPreviewTemplateNameResolver<TParent>;
  productType?: FeeSummaryToProductTypeResolver<TParent>;
  recurringFeePercentage?: FeeSummaryToRecurringFeePercentageResolver<TParent>;
  securityType?: FeeSummaryToSecurityTypeResolver<TParent>;
  supplier?: FeeSummaryToSupplierResolver<TParent>;
  supplierId?: FeeSummaryToSupplierIdResolver<TParent>;
}

export interface FeeSummaryToAssuroAgencyAgreementTemplateNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToBiannualFeeCoefficientResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToDeliveryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToEstablishmentFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToFeaturesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToFeeSummaryStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToMaxValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToMinValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToProductPreviewTemplateNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToProductTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToRecurringFeePercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToSecurityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeSummaryToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierTypeResolver<TParent = any> {
  createdAt?: SupplierToCreatedAtResolver<TParent>;
  createdBy?: SupplierToCreatedByResolver<TParent>;
  feeSummaries?: SupplierToFeeSummariesResolver<TParent>;
  gvpId?: SupplierToGvpIdResolver<TParent>;
  id?: SupplierToIdResolver<TParent>;
  name?: SupplierToNameResolver<TParent>;
  notificationAddress?: SupplierToNotificationAddressResolver<TParent>;
}

export interface SupplierToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierToFeeSummariesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierToGvpIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupplierToNotificationAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationTypeResolver<TParent = any> {
  adminStatus?: IdentificationToAdminStatusResolver<TParent>;
  applicableRequirements?: IdentificationToApplicableRequirementsResolver<TParent>;
  clientStatus?: IdentificationToClientStatusResolver<TParent>;
  clientVerificationStatus?: IdentificationToClientVerificationStatusResolver<TParent>;
  companyDetailsACN?: IdentificationToCompanyDetailsACNResolver<TParent>;
  companyDetailsHasBeneficialOwners?: IdentificationToCompanyDetailsHasBeneficialOwnersResolver<TParent>;
  companyDetailsIsListed?: IdentificationToCompanyDetailsIsListedResolver<TParent>;
  companyDetailsIsNormalType?: IdentificationToCompanyDetailsIsNormalTypeResolver<TParent>;
  companyDetailsIsRegulated?: IdentificationToCompanyDetailsIsRegulatedResolver<TParent>;
  companyDetailsIsSubsidiaryListed?: IdentificationToCompanyDetailsIsSubsidiaryListedResolver<TParent>;
  companyDetailsListedExchangeName?: IdentificationToCompanyDetailsListedExchangeNameResolver<TParent>;
  companyDetailsName?: IdentificationToCompanyDetailsNameResolver<TParent>;
  companyDetailsNatureOfBusiness?: IdentificationToCompanyDetailsNatureOfBusinessResolver<TParent>;
  companyDetailsOnlyOperatesInAustralia?: IdentificationToCompanyDetailsOnlyOperatesInAustraliaResolver<TParent>;
  companyDetailsPrincipalPlaceOfBusiness?: IdentificationToCompanyDetailsPrincipalPlaceOfBusinessResolver<TParent>;
  companyDetailsRegisteredAddress?: IdentificationToCompanyDetailsRegisteredAddressResolver<TParent>;
  companyDetailsRegulatorLicenseNumber?: IdentificationToCompanyDetailsRegulatorLicenseNumberResolver<TParent>;
  companyDetailsRegulatorName?: IdentificationToCompanyDetailsRegulatorNameResolver<TParent>;
  companyDetailsSubsidiaryListedCompanyName?: IdentificationToCompanyDetailsSubsidiaryListedCompanyNameResolver<TParent>;
  companyDetailsSubsidiaryListedExchangeName?: IdentificationToCompanyDetailsSubsidiaryListedExchangeNameResolver<TParent>;
  companyDetailsTaxFatcaStatus?: IdentificationToCompanyDetailsTaxFatcaStatusResolver<TParent>;
  companyDetailsTaxFatcaStatusOther?: IdentificationToCompanyDetailsTaxFatcaStatusOtherResolver<TParent>;
  companyDetailsTaxForeignResidentCountry?: IdentificationToCompanyDetailsTaxForeignResidentCountryResolver<TParent>;
  companyDetailsTaxGIIN?: IdentificationToCompanyDetailsTaxGIINResolver<TParent>;
  companyDetailsTaxHasBeneficialOwnerForeignResident?: IdentificationToCompanyDetailsTaxHasBeneficialOwnerForeignResidentResolver<TParent>;
  companyDetailsTaxHasGIIN?: IdentificationToCompanyDetailsTaxHasGIINResolver<TParent>;
  companyDetailsTaxIsForeignResident?: IdentificationToCompanyDetailsTaxIsForeignResidentResolver<TParent>;
  companyDetailsTaxType?: IdentificationToCompanyDetailsTaxTypeResolver<TParent>;
  createdAt?: IdentificationToCreatedAtResolver<TParent>;
  dataType?: IdentificationToDataTypeResolver<TParent>;
  entityType?: IdentificationToEntityTypeResolver<TParent>;
  entityWealthAccumulation?: IdentificationToEntityWealthAccumulationResolver<TParent>;
  hasDividendsIncome?: IdentificationToHasDividendsIncomeResolver<TParent>;
  hasMacAccount?: IdentificationToHasMacAccountResolver<TParent>;
  id?: IdentificationToIdResolver<TParent>;
  identificationIndustry?: IdentificationToIdentificationIndustryResolver<TParent>;
  individuals?: IdentificationToIndividualsResolver<TParent>;
  industryAdditionalDetails?: IdentificationToIndustryAdditionalDetailsResolver<TParent>;
  macAccountName?: IdentificationToMacAccountNameResolver<TParent>;
  macAccountNumber?: IdentificationToMacAccountNumberResolver<TParent>;
  organisation?: IdentificationToOrganisationResolver<TParent>;
  organisationId?: IdentificationToOrganisationIdResolver<TParent>;
  postalAddress?: IdentificationToPostalAddressResolver<TParent>;
  simpleKycDataId?: IdentificationToSimpleKycDataIdResolver<TParent>;
  simpleKycDataRecord?: IdentificationToSimpleKycDataRecordResolver<TParent>;
  step?: IdentificationToStepResolver<TParent>;
  taxExemptionDetails?: IdentificationToTaxExemptionDetailsResolver<TParent>;
  taxExemptionType?: IdentificationToTaxExemptionTypeResolver<TParent>;
  taxStatus?: IdentificationToTaxStatusResolver<TParent>;
  userId?: IdentificationToUserIdResolver<TParent>;
}

export interface IdentificationToAdminStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToClientStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToClientVerificationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsACNResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsHasBeneficialOwnersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsIsListedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsIsNormalTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsIsRegulatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsIsSubsidiaryListedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsListedExchangeNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsNatureOfBusinessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsOnlyOperatesInAustraliaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsPrincipalPlaceOfBusinessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsRegisteredAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsRegulatorLicenseNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsRegulatorNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsSubsidiaryListedCompanyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsSubsidiaryListedExchangeNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxFatcaStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxFatcaStatusOtherResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxForeignResidentCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxGIINResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxHasBeneficialOwnerForeignResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxHasGIINResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxIsForeignResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCompanyDetailsTaxTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToDataTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToEntityWealthAccumulationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToHasDividendsIncomeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToHasMacAccountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToIdentificationIndustryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToIndividualsArgs {
  where?: IdentificationIndividualFilter;
}
export interface IdentificationToIndividualsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: IdentificationToIndividualsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToIndustryAdditionalDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToMacAccountNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToMacAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToPostalAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToSimpleKycDataIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToSimpleKycDataRecordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToStepResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToTaxExemptionDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToTaxExemptionTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToTaxStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationApplicableRequirementTypeResolver<TParent = any> {
  field?: IdentificationApplicableRequirementToFieldResolver<TParent>;
  message?: IdentificationApplicableRequirementToMessageResolver<TParent>;
  requirementMet?: IdentificationApplicableRequirementToRequirementMetResolver<TParent>;
}

export interface IdentificationApplicableRequirementToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationApplicableRequirementToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationApplicableRequirementToRequirementMetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualTypeResolver<TParent = any> {
  emailAddress?: IdentificationIndividualToEmailAddressResolver<TParent>;
  firstName?: IdentificationIndividualToFirstNameResolver<TParent>;
  greenIdResult?: IdentificationIndividualToGreenIdResultResolver<TParent>;
  greenIdToken?: IdentificationIndividualToGreenIdTokenResolver<TParent>;
  greenIdVerificationId?: IdentificationIndividualToGreenIdVerificationIdResolver<TParent>;
  greenIdVerificationStatus?: IdentificationIndividualToGreenIdVerificationStatusResolver<TParent>;
  id?: IdentificationIndividualToIdResolver<TParent>;
  identificationId?: IdentificationIndividualToIdentificationIdResolver<TParent>;
  isAccountSignatory?: IdentificationIndividualToIsAccountSignatoryResolver<TParent>;
  isApprover?: IdentificationIndividualToIsApproverResolver<TParent>;
  isBeneficialOwner?: IdentificationIndividualToIsBeneficialOwnerResolver<TParent>;
  isDirectorOrSecretary?: IdentificationIndividualToIsDirectorOrSecretaryResolver<TParent>;
  isForeignResident?: IdentificationIndividualToIsForeignResidentResolver<TParent>;
  isMacVerified?: IdentificationIndividualToIsMacVerifiedResolver<TParent>;
  isValidated?: IdentificationIndividualToIsValidatedResolver<TParent>;
  lastVerificationSmsSentAt?: IdentificationIndividualToLastVerificationSmsSentAtResolver<TParent>;
  macVerifiedNumber?: IdentificationIndividualToMacVerifiedNumberResolver<TParent>;
  middleNames?: IdentificationIndividualToMiddleNamesResolver<TParent>;
  phoneMobile?: IdentificationIndividualToPhoneMobileResolver<TParent>;
  simpleKycDataIndividualId?: IdentificationIndividualToSimpleKycDataIndividualIdResolver<TParent>;
  simpleKycDataIndividualRecord?: IdentificationIndividualToSimpleKycDataIndividualRecordResolver<TParent>;
  surname?: IdentificationIndividualToSurnameResolver<TParent>;
  taxForeignResidentCountry?: IdentificationIndividualToTaxForeignResidentCountryResolver<TParent>;
  taxReasonNoTIN?: IdentificationIndividualToTaxReasonNoTINResolver<TParent>;
  taxReasonUnavailableTIN?: IdentificationIndividualToTaxReasonUnavailableTINResolver<TParent>;
  taxpayerIdentificationNumber?: IdentificationIndividualToTaxpayerIdentificationNumberResolver<TParent>;
  title?: IdentificationIndividualToTitleResolver<TParent>;
  userRole?: IdentificationIndividualToUserRoleResolver<TParent>;
  verificationUrl?: IdentificationIndividualToVerificationUrlResolver<TParent>;
  verificationUrlExpiresAt?: IdentificationIndividualToVerificationUrlExpiresAtResolver<TParent>;
}

export interface IdentificationIndividualToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToGreenIdResultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToGreenIdTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToGreenIdVerificationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToGreenIdVerificationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIdentificationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsAccountSignatoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsApproverResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsBeneficialOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsDirectorOrSecretaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsForeignResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsMacVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToIsValidatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToLastVerificationSmsSentAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToMacVerifiedNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToMiddleNamesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToPhoneMobileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToSimpleKycDataIndividualIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToSimpleKycDataIndividualRecordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToSurnameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToTaxForeignResidentCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToTaxReasonNoTINResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToTaxReasonUnavailableTINResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToTaxpayerIdentificationNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToUserRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToVerificationUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationIndividualToVerificationUrlExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultTypeResolver<TParent = any> {
  address?: GreenIdVerificationResultToAddressResolver<TParent>;
  dateOfBirth?: GreenIdVerificationResultToDateOfBirthResolver<TParent>;
  email?: GreenIdVerificationResultToEmailResolver<TParent>;
  firstName?: GreenIdVerificationResultToFirstNameResolver<TParent>;
  greenIdVerificationStatus?: GreenIdVerificationResultToGreenIdVerificationStatusResolver<TParent>;
  lastName?: GreenIdVerificationResultToLastNameResolver<TParent>;
  middleName?: GreenIdVerificationResultToMiddleNameResolver<TParent>;
  watchlistStatusCollection?: GreenIdVerificationResultToWatchlistStatusCollectionResolver<TParent>;
}

export interface GreenIdVerificationResultToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToDateOfBirthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToGreenIdVerificationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToMiddleNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdVerificationResultToWatchlistStatusCollectionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressTypeResolver<TParent = any> {
  country?: GreenIdAddressToCountryResolver<TParent>;
  number?: GreenIdAddressToNumberResolver<TParent>;
  postalCode?: GreenIdAddressToPostalCodeResolver<TParent>;
  state?: GreenIdAddressToStateResolver<TParent>;
  street?: GreenIdAddressToStreetResolver<TParent>;
  streetType?: GreenIdAddressToStreetTypeResolver<TParent>;
  suburb?: GreenIdAddressToSuburbResolver<TParent>;
  unit?: GreenIdAddressToUnitResolver<TParent>;
}

export interface GreenIdAddressToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToPostalCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToStreetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToStreetTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToSuburbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdAddressToUnitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdWatchlistStatusTypeResolver<TParent = any> {
  result?: GreenIdWatchlistStatusToResultResolver<TParent>;
  resultDescription?: GreenIdWatchlistStatusToResultDescriptionResolver<TParent>;
  resultLabel?: GreenIdWatchlistStatusToResultLabelResolver<TParent>;
  watchlistType?: GreenIdWatchlistStatusToWatchlistTypeResolver<TParent>;
}

export interface GreenIdWatchlistStatusToResultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdWatchlistStatusToResultDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdWatchlistStatusToResultLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GreenIdWatchlistStatusToWatchlistTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualTypeResolver<TParent = any> {
  address?: ISimpleKycDataIndividualToAddressResolver<TParent>;
  dateOfBirth?: ISimpleKycDataIndividualToDateOfBirthResolver<TParent>;
  firstName?: ISimpleKycDataIndividualToFirstNameResolver<TParent>;
  id?: ISimpleKycDataIndividualToIdResolver<TParent>;
  isBeneficialOwner?: ISimpleKycDataIndividualToIsBeneficialOwnerResolver<TParent>;
  isDirector?: ISimpleKycDataIndividualToIsDirectorResolver<TParent>;
  lastName?: ISimpleKycDataIndividualToLastNameResolver<TParent>;
  middleNames?: ISimpleKycDataIndividualToMiddleNamesResolver<TParent>;
  roles?: ISimpleKycDataIndividualToRolesResolver<TParent>;
}

export interface ISimpleKycDataIndividualToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToDateOfBirthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToIsBeneficialOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToIsDirectorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToMiddleNamesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataIndividualToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressTypeResolver<TParent = any> {
  country?: ISimpleKycAddressToCountryResolver<TParent>;
  country_name?: ISimpleKycAddressToCountry_nameResolver<TParent>;
  number?: ISimpleKycAddressToNumberResolver<TParent>;
  postalCode?: ISimpleKycAddressToPostalCodeResolver<TParent>;
  state?: ISimpleKycAddressToStateResolver<TParent>;
  street?: ISimpleKycAddressToStreetResolver<TParent>;
  suburb?: ISimpleKycAddressToSuburbResolver<TParent>;
  type?: ISimpleKycAddressToTypeResolver<TParent>;
  unformattedAddress?: ISimpleKycAddressToUnformattedAddressResolver<TParent>;
  unit?: ISimpleKycAddressToUnitResolver<TParent>;
}

export interface ISimpleKycAddressToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToCountry_nameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToPostalCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToStreetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToSuburbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToUnformattedAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycAddressToUnitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationTypeResolver<TParent = any> {
  abn?: IdentificationOrganisationToAbnResolver<TParent>;
  address?: IdentificationOrganisationToAddressResolver<TParent>;
  channelPartners?: IdentificationOrganisationToChannelPartnersResolver<TParent>;
  discountPercentage?: IdentificationOrganisationToDiscountPercentageResolver<TParent>;
  id?: IdentificationOrganisationToIdResolver<TParent>;
  industryType?: IdentificationOrganisationToIndustryTypeResolver<TParent>;
  isOngoingClient?: IdentificationOrganisationToIsOngoingClientResolver<TParent>;
  leadSource?: IdentificationOrganisationToLeadSourceResolver<TParent>;
  name?: IdentificationOrganisationToNameResolver<TParent>;
  relationshipManager?: IdentificationOrganisationToRelationshipManagerResolver<TParent>;
}

export interface IdentificationOrganisationToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToChannelPartnersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToIndustryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToIsOngoingClientResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToLeadSourceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationToRelationshipManagerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationChannelPartnerTypeResolver<TParent = any> {
  active?: IdentificationOrganisationChannelPartnerToActiveResolver<TParent>;
  id?: IdentificationOrganisationChannelPartnerToIdResolver<TParent>;
  isPublic?: IdentificationOrganisationChannelPartnerToIsPublicResolver<TParent>;
  name?: IdentificationOrganisationChannelPartnerToNameResolver<TParent>;
}

export interface IdentificationOrganisationChannelPartnerToActiveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationChannelPartnerToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationChannelPartnerToIsPublicResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationOrganisationChannelPartnerToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserTypeResolver<TParent = any> {
  emailAddress?: ICognitoUserToEmailAddressResolver<TParent>;
  firstName?: ICognitoUserToFirstNameResolver<TParent>;
  isEnabled?: ICognitoUserToIsEnabledResolver<TParent>;
  isSmsMfaRequired?: ICognitoUserToIsSmsMfaRequiredResolver<TParent>;
  lastName?: ICognitoUserToLastNameResolver<TParent>;
  phoneNumber?: ICognitoUserToPhoneNumberResolver<TParent>;
  roles?: ICognitoUserToRolesResolver<TParent>;
  status?: ICognitoUserToStatusResolver<TParent>;
  supplierId?: ICognitoUserToSupplierIdResolver<TParent>;
  userName?: ICognitoUserToUserNameResolver<TParent>;
  userRoles?: ICognitoUserToUserRolesResolver<TParent>;
}

export interface ICognitoUserToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToIsEnabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToIsSmsMfaRequiredResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToUserNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ICognitoUserToUserRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataTypeResolver<TParent = any> {
  applicationStatus?: ISimpleKycDataToApplicationStatusResolver<TParent>;
  businessNames?: ISimpleKycDataToBusinessNamesResolver<TParent>;
  companyABN?: ISimpleKycDataToCompanyABNResolver<TParent>;
  createdAt?: ISimpleKycDataToCreatedAtResolver<TParent>;
  entityClassification?: ISimpleKycDataToEntityClassificationResolver<TParent>;
  id?: ISimpleKycDataToIdResolver<TParent>;
  legalBusinessName?: ISimpleKycDataToLegalBusinessNameResolver<TParent>;
  principalPlaceOfBusinessAddress?: ISimpleKycDataToPrincipalPlaceOfBusinessAddressResolver<TParent>;
  registeredOfficeAddress?: ISimpleKycDataToRegisteredOfficeAddressResolver<TParent>;
  simpleKycApplicationId?: ISimpleKycDataToSimpleKycApplicationIdResolver<TParent>;
  simpleKycDataIndividualRecord?: ISimpleKycDataToSimpleKycDataIndividualRecordResolver<TParent>;
}

export interface ISimpleKycDataToApplicationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToBusinessNamesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToCompanyABNResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToEntityClassificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToLegalBusinessNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToPrincipalPlaceOfBusinessAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToRegisteredOfficeAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToSimpleKycApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ISimpleKycDataToSimpleKycDataIndividualRecordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceTypeResolver<TParent = any> {
  canGenerateHostedInvoice?: DraftInvoiceToCanGenerateHostedInvoiceResolver<TParent>;
  createdAt?: DraftInvoiceToCreatedAtResolver<TParent>;
  depositReferenceNumber?: DraftInvoiceToDepositReferenceNumberResolver<TParent>;
  hostedInvoiceAttachmentId?: DraftInvoiceToHostedInvoiceAttachmentIdResolver<TParent>;
  hostedReceiptAttachmentId?: DraftInvoiceToHostedReceiptAttachmentIdResolver<TParent>;
  id?: DraftInvoiceToIdResolver<TParent>;
  invoiceLineItems?: DraftInvoiceToInvoiceLineItemsResolver<TParent>;
  invoicePaymentIntents?: DraftInvoiceToInvoicePaymentIntentsResolver<TParent>;
  stripeInvoiceHostedUrl?: DraftInvoiceToStripeInvoiceHostedUrlResolver<TParent>;
  stripeInvoicePdf?: DraftInvoiceToStripeInvoicePdfResolver<TParent>;
  stripeInvoiceStatus?: DraftInvoiceToStripeInvoiceStatusResolver<TParent>;
  stripeReceiptUrl?: DraftInvoiceToStripeReceiptUrlResolver<TParent>;
  sumSubscriptionAmount?: DraftInvoiceToSumSubscriptionAmountResolver<TParent>;
  total?: DraftInvoiceToTotalResolver<TParent>;
}

export interface DraftInvoiceToCanGenerateHostedInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToDepositReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToHostedInvoiceAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToHostedReceiptAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToInvoiceLineItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToInvoicePaymentIntentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToStripeInvoiceHostedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToStripeInvoicePdfResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToStripeInvoiceStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToStripeReceiptUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToSumSubscriptionAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftInvoiceToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemTypeResolver<TParent = any> {
  amount?: InvoiceLineItemToAmountResolver<TParent>;
  description?: InvoiceLineItemToDescriptionResolver<TParent>;
  id?: InvoiceLineItemToIdResolver<TParent>;
  invoice?: InvoiceLineItemToInvoiceResolver<TParent>;
  invoiceId?: InvoiceLineItemToInvoiceIdResolver<TParent>;
  isRecurring?: InvoiceLineItemToIsRecurringResolver<TParent>;
  periodEnd?: InvoiceLineItemToPeriodEndResolver<TParent>;
  periodStart?: InvoiceLineItemToPeriodStartResolver<TParent>;
}

export interface InvoiceLineItemToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToInvoiceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToIsRecurringResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToPeriodEndResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceLineItemToPeriodStartResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentTypeResolver<TParent = any> {
  amount?: InvoicePaymentIntentToAmountResolver<TParent>;
  createdOn?: InvoicePaymentIntentToCreatedOnResolver<TParent>;
  id?: InvoicePaymentIntentToIdResolver<TParent>;
  status?: InvoicePaymentIntentToStatusResolver<TParent>;
  stripeInvoiceId?: InvoicePaymentIntentToStripeInvoiceIdResolver<TParent>;
  stripePaymentIntentId?: InvoicePaymentIntentToStripePaymentIntentIdResolver<TParent>;
}

export interface InvoicePaymentIntentToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentToCreatedOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentToStripeInvoiceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentToStripePaymentIntentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyTypeResolver<TParent = any> {
  abn?: DraftPartyToAbnResolver<TParent>;
  address?: DraftPartyToAddressResolver<TParent>;
  addressV2?: DraftPartyToAddressV2Resolver<TParent>;
  id?: DraftPartyToIdResolver<TParent>;
  name?: DraftPartyToNameResolver<TParent>;
  notes?: DraftPartyToNotesResolver<TParent>;
  partyEntityType?: DraftPartyToPartyEntityTypeResolver<TParent>;
  partyVariant?: DraftPartyToPartyVariantResolver<TParent>;
  primaryContact?: DraftPartyToPrimaryContactResolver<TParent>;
}

export interface DraftPartyToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToAddressV2Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToNotesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToPartyEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToPartyVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftPartyToPrimaryContactResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftExtendedContactTypeResolver<TParent = any> {
  email?: DraftExtendedContactToEmailResolver<TParent>;
  familyName?: DraftExtendedContactToFamilyNameResolver<TParent>;
  givenName?: DraftExtendedContactToGivenNameResolver<TParent>;
  phoneNumber?: DraftExtendedContactToPhoneNumberResolver<TParent>;
}

export interface DraftExtendedContactToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftExtendedContactToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftExtendedContactToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftExtendedContactToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsTypeResolver<TParent = any> {
  bankAccountBsb?: DraftRequestedPaymentDetailsToBankAccountBsbResolver<TParent>;
  bankAccountName?: DraftRequestedPaymentDetailsToBankAccountNameResolver<TParent>;
  bankAccountNumber?: DraftRequestedPaymentDetailsToBankAccountNumberResolver<TParent>;
  establishmentFee?: DraftRequestedPaymentDetailsToEstablishmentFeeResolver<TParent>;
  lineItems?: DraftRequestedPaymentDetailsToLineItemsResolver<TParent>;
  paymentDescription?: DraftRequestedPaymentDetailsToPaymentDescriptionResolver<TParent>;
  requestedAt?: DraftRequestedPaymentDetailsToRequestedAtResolver<TParent>;
  securityAmount?: DraftRequestedPaymentDetailsToSecurityAmountResolver<TParent>;
}

export interface DraftRequestedPaymentDetailsToBankAccountBsbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToBankAccountNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToBankAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToEstablishmentFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToLineItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToPaymentDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToRequestedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentDetailsToSecurityAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentLineItemDetailsTypeResolver<TParent = any> {
  amount?: DraftRequestedPaymentLineItemDetailsToAmountResolver<TParent>;
  description?: DraftRequestedPaymentLineItemDetailsToDescriptionResolver<TParent>;
}

export interface DraftRequestedPaymentLineItemDetailsToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedPaymentLineItemDetailsToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralDiscountTypeResolver<TParent = any> {
  discountAmountInDollars?: ReferralDiscountToDiscountAmountInDollarsResolver<TParent>;
  discountType?: ReferralDiscountToDiscountTypeResolver<TParent>;
  organisationReferralId?: ReferralDiscountToOrganisationReferralIdResolver<TParent>;
}

export interface ReferralDiscountToDiscountAmountInDollarsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralDiscountToDiscountTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralDiscountToOrganisationReferralIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsTypeResolver<TParent = any> {
  amount?: DraftRequestedSuretyDocumentsToAmountResolver<TParent>;
  documentWording?: DraftRequestedSuretyDocumentsToDocumentWordingResolver<TParent>;
  documentWordingTemplate?: DraftRequestedSuretyDocumentsToDocumentWordingTemplateResolver<TParent>;
  expiryDate?: DraftRequestedSuretyDocumentsToExpiryDateResolver<TParent>;
  id?: DraftRequestedSuretyDocumentsToIdResolver<TParent>;
  paymentAnnualCost?: DraftRequestedSuretyDocumentsToPaymentAnnualCostResolver<TParent>;
  paymentEstablishmentFee?: DraftRequestedSuretyDocumentsToPaymentEstablishmentFeeResolver<TParent>;
  periodEndDate?: DraftRequestedSuretyDocumentsToPeriodEndDateResolver<TParent>;
  periodStartDate?: DraftRequestedSuretyDocumentsToPeriodStartDateResolver<TParent>;
  purpose?: DraftRequestedSuretyDocumentsToPurposeResolver<TParent>;
}

export interface DraftRequestedSuretyDocumentsToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToDocumentWordingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToDocumentWordingTemplateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToExpiryDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToPaymentAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToPaymentEstablishmentFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToPeriodEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToPeriodStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestedSuretyDocumentsToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelTypeResolver<TParent = any> {
  createdByAdminUserId?: RequiredDocumentViewModelToCreatedByAdminUserIdResolver<TParent>;
  dateCreated?: RequiredDocumentViewModelToDateCreatedResolver<TParent>;
  draftId?: RequiredDocumentViewModelToDraftIdResolver<TParent>;
  id?: RequiredDocumentViewModelToIdResolver<TParent>;
  overallStatus?: RequiredDocumentViewModelToOverallStatusResolver<TParent>;
  requiredDocumentFlow?: RequiredDocumentViewModelToRequiredDocumentFlowResolver<TParent>;
  requiredDocumentMessages?: RequiredDocumentViewModelToRequiredDocumentMessagesResolver<TParent>;
  requiredDocumentType?: RequiredDocumentViewModelToRequiredDocumentTypeResolver<TParent>;
}

export interface RequiredDocumentViewModelToCreatedByAdminUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToDateCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToOverallStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToRequiredDocumentFlowResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToRequiredDocumentMessagesArgs {
  order_by?: RequiredDocumentMessageViewModelSort;
}
export interface RequiredDocumentViewModelToRequiredDocumentMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RequiredDocumentViewModelToRequiredDocumentMessagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentViewModelToRequiredDocumentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelTypeResolver<TParent = any> {
  attachment?: RequiredDocumentMessageViewModelToAttachmentResolver<TParent>;
  attachmentId?: RequiredDocumentMessageViewModelToAttachmentIdResolver<TParent>;
  canAuthorizedUserAcceptOrReject?: RequiredDocumentMessageViewModelToCanAuthorizedUserAcceptOrRejectResolver<TParent>;
  createdByUser?: RequiredDocumentMessageViewModelToCreatedByUserResolver<TParent>;
  createdByUserId?: RequiredDocumentMessageViewModelToCreatedByUserIdResolver<TParent>;
  dateCreated?: RequiredDocumentMessageViewModelToDateCreatedResolver<TParent>;
  fromParty?: RequiredDocumentMessageViewModelToFromPartyResolver<TParent>;
  hasApproval?: RequiredDocumentMessageViewModelToHasApprovalResolver<TParent>;
  id?: RequiredDocumentMessageViewModelToIdResolver<TParent>;
  isAutomatedMessage?: RequiredDocumentMessageViewModelToIsAutomatedMessageResolver<TParent>;
  message?: RequiredDocumentMessageViewModelToMessageResolver<TParent>;
  messageType?: RequiredDocumentMessageViewModelToMessageTypeResolver<TParent>;
  parentMessageId?: RequiredDocumentMessageViewModelToParentMessageIdResolver<TParent>;
  requiredDocumentId?: RequiredDocumentMessageViewModelToRequiredDocumentIdResolver<TParent>;
}

export interface RequiredDocumentMessageViewModelToAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToCanAuthorizedUserAcceptOrRejectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToCreatedByUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToCreatedByUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToDateCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToFromPartyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToHasApprovalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToIsAutomatedMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToMessageTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToParentMessageIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageViewModelToRequiredDocumentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IUserTypeResolver<TParent = any> {
  email?: IUserToEmailResolver<TParent>;
  familyName?: IUserToFamilyNameResolver<TParent>;
  givenName?: IUserToGivenNameResolver<TParent>;
}

export interface IUserToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IUserToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IUserToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOriginationsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: DraftOriginationsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: DraftOriginationsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: DraftOriginationsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftOriginationsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface DraftOriginationsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOriginationsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOriginationsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOriginationsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOriginationsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: DraftOriginationsForBankPortalEdgeToCursorResolver<TParent>;
  node?: DraftOriginationsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface DraftOriginationsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftOriginationsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationTypeResolver<TParent = any> {
  agreementContent?: ApiDraftOriginationToAgreementContentResolver<TParent>;
  amount?: ApiDraftOriginationToAmountResolver<TParent>;
  channelPartner?: ApiDraftOriginationToChannelPartnerResolver<TParent>;
  channelPartnerId?: ApiDraftOriginationToChannelPartnerIdResolver<TParent>;
  channelPartnerOrganisationAbnOrAcn?: ApiDraftOriginationToChannelPartnerOrganisationAbnOrAcnResolver<TParent>;
  channelPartnerOrganisationBusinessAddress?: ApiDraftOriginationToChannelPartnerOrganisationBusinessAddressResolver<TParent>;
  channelPartnerOrganisationIndustry?: ApiDraftOriginationToChannelPartnerOrganisationIndustryResolver<TParent>;
  channelPartnerOrganisationName?: ApiDraftOriginationToChannelPartnerOrganisationNameResolver<TParent>;
  channelPartnerOrganisationPostalAddress?: ApiDraftOriginationToChannelPartnerOrganisationPostalAddressResolver<TParent>;
  channelPartnerOrganisationReferenceId?: ApiDraftOriginationToChannelPartnerOrganisationReferenceIdResolver<TParent>;
  createdAt?: ApiDraftOriginationToCreatedAtResolver<TParent>;
  draftId?: ApiDraftOriginationToDraftIdResolver<TParent>;
  draftOriginationStatus?: ApiDraftOriginationToDraftOriginationStatusResolver<TParent>;
  draftReferenceId?: ApiDraftOriginationToDraftReferenceIdResolver<TParent>;
  draftType?: ApiDraftOriginationToDraftTypeResolver<TParent>;
  expectedReturnDate?: ApiDraftOriginationToExpectedReturnDateResolver<TParent>;
  expiryDate?: ApiDraftOriginationToExpiryDateResolver<TParent>;
  id?: ApiDraftOriginationToIdResolver<TParent>;
  organisationId?: ApiDraftOriginationToOrganisationIdResolver<TParent>;
  parties?: ApiDraftOriginationToPartiesResolver<TParent>;
  purpose?: ApiDraftOriginationToPurposeResolver<TParent>;
  purposeSpecificOther?: ApiDraftOriginationToPurposeSpecificOtherResolver<TParent>;
  userId?: ApiDraftOriginationToUserIdResolver<TParent>;
}

export interface ApiDraftOriginationToAgreementContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerOrganisationAbnOrAcnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerOrganisationBusinessAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerOrganisationIndustryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerOrganisationNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerOrganisationPostalAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToChannelPartnerOrganisationReferenceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToDraftOriginationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToDraftReferenceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToDraftTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToExpectedReturnDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToExpiryDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToPartiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToPurposeSpecificOtherResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IChannelPartnerTypeResolver<TParent = any> {
  active?: IChannelPartnerToActiveResolver<TParent>;
  createdAt?: IChannelPartnerToCreatedAtResolver<TParent>;
  discountPercentage?: IChannelPartnerToDiscountPercentageResolver<TParent>;
  id?: IChannelPartnerToIdResolver<TParent>;
  name?: IChannelPartnerToNameResolver<TParent>;
}

export interface IChannelPartnerToActiveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IChannelPartnerToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IChannelPartnerToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IChannelPartnerToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IChannelPartnerToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyTypeResolver<TParent = any> {
  abnOrAcn?: ApiDraftOriginationPartyToAbnOrAcnResolver<TParent>;
  address?: ApiDraftOriginationPartyToAddressResolver<TParent>;
  addressV2?: ApiDraftOriginationPartyToAddressV2Resolver<TParent>;
  apiDraftOriginationId?: ApiDraftOriginationPartyToApiDraftOriginationIdResolver<TParent>;
  id?: ApiDraftOriginationPartyToIdResolver<TParent>;
  name?: ApiDraftOriginationPartyToNameResolver<TParent>;
  representatives?: ApiDraftOriginationPartyToRepresentativesResolver<TParent>;
  type?: ApiDraftOriginationPartyToTypeResolver<TParent>;
}

export interface ApiDraftOriginationPartyToAbnOrAcnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToAddressV2Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToApiDraftOriginationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToRepresentativesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartyToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartRepresentativeTypeResolver<TParent = any> {
  apiDraftOriginationPartyId?: ApiDraftOriginationPartRepresentativeToApiDraftOriginationPartyIdResolver<TParent>;
  email?: ApiDraftOriginationPartRepresentativeToEmailResolver<TParent>;
  familyName?: ApiDraftOriginationPartRepresentativeToFamilyNameResolver<TParent>;
  givenName?: ApiDraftOriginationPartRepresentativeToGivenNameResolver<TParent>;
  id?: ApiDraftOriginationPartRepresentativeToIdResolver<TParent>;
  isOwner?: ApiDraftOriginationPartRepresentativeToIsOwnerResolver<TParent>;
}

export interface ApiDraftOriginationPartRepresentativeToApiDraftOriginationPartyIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartRepresentativeToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartRepresentativeToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartRepresentativeToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartRepresentativeToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiDraftOriginationPartRepresentativeToIsOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsByOrganisationIdConnectionTypeResolver<TParent = any> {
  edges?: DraftsByOrganisationIdConnectionToEdgesResolver<TParent>;
  nodes?: DraftsByOrganisationIdConnectionToNodesResolver<TParent>;
  pageInfo?: DraftsByOrganisationIdConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftsByOrganisationIdConnectionToTotalCountResolver<TParent>;
}

export interface DraftsByOrganisationIdConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsByOrganisationIdConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsByOrganisationIdConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsByOrganisationIdConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsByOrganisationIdEdgeTypeResolver<TParent = any> {
  cursor?: DraftsByOrganisationIdEdgeToCursorResolver<TParent>;
  node?: DraftsByOrganisationIdEdgeToNodeResolver<TParent>;
}

export interface DraftsByOrganisationIdEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsByOrganisationIdEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: DraftsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: DraftsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: DraftsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface DraftsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: DraftsForBankPortalEdgeToCursorResolver<TParent>;
  node?: DraftsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface DraftsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftTypeResolver<TParent = any> {
  acceptedChannelPartnerId?: BankDraftToAcceptedChannelPartnerIdResolver<TParent>;
  additionalSupplierDetail?: BankDraftToAdditionalSupplierDetailResolver<TParent>;
  amount?: BankDraftToAmountResolver<TParent>;
  attachments?: BankDraftToAttachmentsResolver<TParent>;
  bGSwitch?: BankDraftToBGSwitchResolver<TParent>;
  canResubmitToGvp?: BankDraftToCanResubmitToGvpResolver<TParent>;
  capabilities?: BankDraftToCapabilitiesResolver<TParent>;
  channelPartner?: BankDraftToChannelPartnerResolver<TParent>;
  contract?: BankDraftToContractResolver<TParent>;
  createdAt?: BankDraftToCreatedAtResolver<TParent>;
  creator?: BankDraftToCreatorResolver<TParent>;
  currentPeriodEnd?: BankDraftToCurrentPeriodEndResolver<TParent>;
  deliveryDetails?: BankDraftToDeliveryDetailsResolver<TParent>;
  deliveryType?: BankDraftToDeliveryTypeResolver<TParent>;
  description?: BankDraftToDescriptionResolver<TParent>;
  directorEmailAddress?: BankDraftToDirectorEmailAddressResolver<TParent>;
  directorFirstName?: BankDraftToDirectorFirstNameResolver<TParent>;
  directorLastName?: BankDraftToDirectorLastNameResolver<TParent>;
  discountPercentage?: BankDraftToDiscountPercentageResolver<TParent>;
  documentId?: BankDraftToDocumentIdResolver<TParent>;
  documentNumber?: BankDraftToDocumentNumberResolver<TParent>;
  draftHistory?: BankDraftToDraftHistoryResolver<TParent>;
  estimatedFees?: BankDraftToEstimatedFeesResolver<TParent>;
  expectedReturnDate?: BankDraftToExpectedReturnDateResolver<TParent>;
  expiresAt?: BankDraftToExpiresAtResolver<TParent>;
  facility?: BankDraftToFacilityResolver<TParent>;
  feeSummary?: BankDraftToFeeSummaryResolver<TParent>;
  feeSummaryId?: BankDraftToFeeSummaryIdResolver<TParent>;
  gvpId?: BankDraftToGvpIdResolver<TParent>;
  id?: BankDraftToIdResolver<TParent>;
  identification?: BankDraftToIdentificationResolver<TParent>;
  identificationSubmitted?: BankDraftToIdentificationSubmittedResolver<TParent>;
  invoiceRecipientEmailAddresses?: BankDraftToInvoiceRecipientEmailAddressesResolver<TParent>;
  invoices?: BankDraftToInvoicesResolver<TParent>;
  isVisibleToSupplier?: BankDraftToIsVisibleToSupplierResolver<TParent>;
  issuerDetailsOfSourceOfFunds?: BankDraftToIssuerDetailsOfSourceOfFundsResolver<TParent>;
  issuerSourceOfFunds?: BankDraftToIssuerSourceOfFundsResolver<TParent>;
  megAppId?: BankDraftToMegAppIdResolver<TParent>;
  megAppNo?: BankDraftToMegAppNoResolver<TParent>;
  megDetails?: BankDraftToMegDetailsResolver<TParent>;
  organisationId?: BankDraftToOrganisationIdResolver<TParent>;
  parties?: BankDraftToPartiesResolver<TParent>;
  paymentDetails?: BankDraftToPaymentDetailsResolver<TParent>;
  processType?: BankDraftToProcessTypeResolver<TParent>;
  productTermsAcceptedDate?: BankDraftToProductTermsAcceptedDateResolver<TParent>;
  projectAddress?: BankDraftToProjectAddressResolver<TParent>;
  purpose?: BankDraftToPurposeResolver<TParent>;
  referenceNumber?: BankDraftToReferenceNumberResolver<TParent>;
  referralPercentage?: BankDraftToReferralPercentageResolver<TParent>;
  referralPortalDeal?: BankDraftToReferralPortalDealResolver<TParent>;
  refundAccountName?: BankDraftToRefundAccountNameResolver<TParent>;
  refundAccountNumber?: BankDraftToRefundAccountNumberResolver<TParent>;
  refundBSB?: BankDraftToRefundBSBResolver<TParent>;
  rejectionReason?: BankDraftToRejectionReasonResolver<TParent>;
  relationshipManager?: BankDraftToRelationshipManagerResolver<TParent>;
  requestChangeReason?: BankDraftToRequestChangeReasonResolver<TParent>;
  requestedSuretyDocuments?: BankDraftToRequestedSuretyDocumentsResolver<TParent>;
  requiredDocuments?: BankDraftToRequiredDocumentsResolver<TParent>;
  sourceDraftId?: BankDraftToSourceDraftIdResolver<TParent>;
  specifiedOtherPurpose?: BankDraftToSpecifiedOtherPurposeResolver<TParent>;
  status?: BankDraftToStatusResolver<TParent>;
  stripeSubscriptionCanceledAt?: BankDraftToStripeSubscriptionCanceledAtResolver<TParent>;
  stripeSubscriptionId?: BankDraftToStripeSubscriptionIdResolver<TParent>;
  stripeSubscriptionStatus?: BankDraftToStripeSubscriptionStatusResolver<TParent>;
  submittedAt?: BankDraftToSubmittedAtResolver<TParent>;
  totalFees?: BankDraftToTotalFeesResolver<TParent>;
  totalOrganisationCreditUsed?: BankDraftToTotalOrganisationCreditUsedResolver<TParent>;
  visibleToSupplierDate?: BankDraftToVisibleToSupplierDateResolver<TParent>;
}

export interface BankDraftToAcceptedChannelPartnerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToAdditionalSupplierDetailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToAttachmentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToBGSwitchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToCanResubmitToGvpResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToChannelPartnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToContractResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToCreatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToCurrentPeriodEndResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDeliveryDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDeliveryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDirectorEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDirectorFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDirectorLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDocumentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDocumentNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToDraftHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: DraftHistorySort;
}
export interface BankDraftToDraftHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankDraftToDraftHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToEstimatedFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToExpectedReturnDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToFeeSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToFeeSummaryIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToGvpIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToIdentificationSubmittedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToInvoiceRecipientEmailAddressesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToIsVisibleToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToIssuerDetailsOfSourceOfFundsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToIssuerSourceOfFundsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToMegAppIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToMegAppNoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToMegDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToPartiesArgs {
  order_by?: BankPartySort;
  where?: DraftPartyFilter;
}
export interface BankDraftToPartiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankDraftToPartiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToPaymentDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToProcessTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToProductTermsAcceptedDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToProjectAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToReferralPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToReferralPortalDealResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRefundAccountNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRefundAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRefundBSBResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRejectionReasonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRelationshipManagerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRequestChangeReasonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRequestedSuretyDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToRequiredDocumentsArgs {
  order_by?: RequiredDocumentViewModelSort;
}
export interface BankDraftToRequiredDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankDraftToRequiredDocumentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToSourceDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToSpecifiedOtherPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToStripeSubscriptionCanceledAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToStripeSubscriptionIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToStripeSubscriptionStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToSubmittedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToTotalFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToTotalOrganisationCreditUsedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDraftToVisibleToSupplierDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftChannelPartnersTypeResolver<TParent = any> {
  id?: DraftChannelPartnersToIdResolver<TParent>;
  name?: DraftChannelPartnersToNameResolver<TParent>;
}

export interface DraftChannelPartnersToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftChannelPartnersToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityTypeResolver<TParent = any> {
  annualCost?: BankFacilityToAnnualCostResolver<TParent>;
  bankFrontedBondsRecurringPercentageCost?: BankFacilityToBankFrontedBondsRecurringPercentageCostResolver<TParent>;
  bankFrontedBondsSetUpCost?: BankFacilityToBankFrontedBondsSetUpCostResolver<TParent>;
  capabilities?: BankFacilityToCapabilitiesResolver<TParent>;
  documentAdjustedCost?: BankFacilityToDocumentAdjustedCostResolver<TParent>;
  documentCount?: BankFacilityToDocumentCountResolver<TParent>;
  documentRecurringCostFrequency?: BankFacilityToDocumentRecurringCostFrequencyResolver<TParent>;
  documentRecurringFeeType?: BankFacilityToDocumentRecurringFeeTypeResolver<TParent>;
  documentRecurringFixedCost?: BankFacilityToDocumentRecurringFixedCostResolver<TParent>;
  documentRecurringMinimumAnnualCost?: BankFacilityToDocumentRecurringMinimumAnnualCostResolver<TParent>;
  documentRecurringPercentageCost?: BankFacilityToDocumentRecurringPercentageCostResolver<TParent>;
  documentSetUpCost?: BankFacilityToDocumentSetUpCostResolver<TParent>;
  documentVariant?: BankFacilityToDocumentVariantResolver<TParent>;
  endDate?: BankFacilityToEndDateResolver<TParent>;
  entities?: BankFacilityToEntitiesResolver<TParent>;
  facilityApplicationId?: BankFacilityToFacilityApplicationIdResolver<TParent>;
  facilityHistory?: BankFacilityToFacilityHistoryResolver<TParent>;
  id?: BankFacilityToIdResolver<TParent>;
  invoiceNumber?: BankFacilityToInvoiceNumberResolver<TParent>;
  isAssuroFacility?: BankFacilityToIsAssuroFacilityResolver<TParent>;
  limit?: BankFacilityToLimitResolver<TParent>;
  name?: BankFacilityToNameResolver<TParent>;
  organisation?: BankFacilityToOrganisationResolver<TParent>;
  organisationId?: BankFacilityToOrganisationIdResolver<TParent>;
  premiumBankFrontedBondsRecurringPercentageCost?: BankFacilityToPremiumBankFrontedBondsRecurringPercentageCostResolver<TParent>;
  premiumDocumentRecurringPercentageCost?: BankFacilityToPremiumDocumentRecurringPercentageCostResolver<TParent>;
  properties?: BankFacilityToPropertiesResolver<TParent>;
  provider?: BankFacilityToProviderResolver<TParent>;
  securityType?: BankFacilityToSecurityTypeResolver<TParent>;
  setUpCost?: BankFacilityToSetUpCostResolver<TParent>;
  sharedFacilityWithOrganisations?: BankFacilityToSharedFacilityWithOrganisationsResolver<TParent>;
  startDate?: BankFacilityToStartDateResolver<TParent>;
  supplierId?: BankFacilityToSupplierIdResolver<TParent>;
  totalEstablished?: BankFacilityToTotalEstablishedResolver<TParent>;
  totalProjected?: BankFacilityToTotalProjectedResolver<TParent>;
}

export interface BankFacilityToAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToBankFrontedBondsRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToBankFrontedBondsSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentAdjustedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentRecurringCostFrequencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentRecurringFeeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentRecurringFixedCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentRecurringMinimumAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToDocumentVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToEntitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToFacilityApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToFacilityHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: FacilityHistorySort;
}
export interface BankFacilityToFacilityHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankFacilityToFacilityHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToInvoiceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToIsAssuroFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToPremiumBankFrontedBondsRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToPremiumDocumentRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToPropertiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToProviderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToSecurityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToSharedFacilityWithOrganisationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToTotalEstablishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankFacilityToTotalProjectedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealTypeResolver<TParent = any> {
  commissionAmount?: DealToCommissionAmountResolver<TParent>;
  createdAt?: DealToCreatedAtResolver<TParent>;
  draftAmount?: DealToDraftAmountResolver<TParent>;
  draftDateEstablished?: DealToDraftDateEstablishedResolver<TParent>;
  draftDateSubmitted?: DealToDraftDateSubmittedResolver<TParent>;
  draftDescription?: DealToDraftDescriptionResolver<TParent>;
  draftId?: DealToDraftIdResolver<TParent>;
  draftIssuer?: DealToDraftIssuerResolver<TParent>;
  draftProduct?: DealToDraftProductResolver<TParent>;
  draftPurpose?: DealToDraftPurposeResolver<TParent>;
  draftStatus?: DealToDraftStatusResolver<TParent>;
  draftSupplier?: DealToDraftSupplierResolver<TParent>;
  entityContactPerson?: DealToEntityContactPersonResolver<TParent>;
  entityEmail?: DealToEntityEmailResolver<TParent>;
  entityId?: DealToEntityIdResolver<TParent>;
  entityName?: DealToEntityNameResolver<TParent>;
  id?: DealToIdResolver<TParent>;
  memberEmail?: DealToMemberEmailResolver<TParent>;
  memberFullName?: DealToMemberFullNameResolver<TParent>;
  memberPhone?: DealToMemberPhoneResolver<TParent>;
  referralPortalMemberId?: DealToReferralPortalMemberIdResolver<TParent>;
}

export interface DealToCommissionAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftDateEstablishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftDateSubmittedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftIssuerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftProductResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToDraftSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToEntityContactPersonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToEntityEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToEntityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToEntityNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToMemberEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToMemberFullNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToMemberPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DealToReferralPortalMemberIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsSharedWithMeConnectionTypeResolver<TParent = any> {
  edges?: DraftsSharedWithMeConnectionToEdgesResolver<TParent>;
  nodes?: DraftsSharedWithMeConnectionToNodesResolver<TParent>;
  pageInfo?: DraftsSharedWithMeConnectionToPageInfoResolver<TParent>;
  totalCount?: DraftsSharedWithMeConnectionToTotalCountResolver<TParent>;
}

export interface DraftsSharedWithMeConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsSharedWithMeConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsSharedWithMeConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsSharedWithMeConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsSharedWithMeEdgeTypeResolver<TParent = any> {
  cursor?: DraftsSharedWithMeEdgeToCursorResolver<TParent>;
  node?: DraftsSharedWithMeEdgeToNodeResolver<TParent>;
}

export interface DraftsSharedWithMeEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftsSharedWithMeEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitiesForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: FacilitiesForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: FacilitiesForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: FacilitiesForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: FacilitiesForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface FacilitiesForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitiesForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitiesForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitiesForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitiesForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: FacilitiesForBankPortalEdgeToCursorResolver<TParent>;
  node?: FacilitiesForBankPortalEdgeToNodeResolver<TParent>;
}

export interface FacilitiesForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilitiesForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationTypeResolver<TParent = any> {
  applicant?: FacilityApplicationToApplicantResolver<TParent>;
  applicationInformation?: FacilityApplicationToApplicationInformationResolver<TParent>;
  attachments?: FacilityApplicationToAttachmentsResolver<TParent>;
  capabilities?: FacilityApplicationToCapabilitiesResolver<TParent>;
  createdAt?: FacilityApplicationToCreatedAtResolver<TParent>;
  entities?: FacilityApplicationToEntitiesResolver<TParent>;
  establishmentRecord?: FacilityApplicationToEstablishmentRecordResolver<TParent>;
  facilityApplicationHistory?: FacilityApplicationToFacilityApplicationHistoryResolver<TParent>;
  facilityType?: FacilityApplicationToFacilityTypeResolver<TParent>;
  feeSummaryId?: FacilityApplicationToFeeSummaryIdResolver<TParent>;
  hasBankApproval?: FacilityApplicationToHasBankApprovalResolver<TParent>;
  id?: FacilityApplicationToIdResolver<TParent>;
  invoiceNumber?: FacilityApplicationToInvoiceNumberResolver<TParent>;
  isInvoicePaid?: FacilityApplicationToIsInvoicePaidResolver<TParent>;
  isVisibleToSupplier?: FacilityApplicationToIsVisibleToSupplierResolver<TParent>;
  lastUpdatedAt?: FacilityApplicationToLastUpdatedAtResolver<TParent>;
  organisation?: FacilityApplicationToOrganisationResolver<TParent>;
  organisationId?: FacilityApplicationToOrganisationIdResolver<TParent>;
  properties?: FacilityApplicationToPropertiesResolver<TParent>;
  sharedFacilityWithOrganisations?: FacilityApplicationToSharedFacilityWithOrganisationsResolver<TParent>;
  status?: FacilityApplicationToStatusResolver<TParent>;
  submission?: FacilityApplicationToSubmissionResolver<TParent>;
  supplierId?: FacilityApplicationToSupplierIdResolver<TParent>;
  totalFees?: FacilityApplicationToTotalFeesResolver<TParent>;
  visibleToSupplierDate?: FacilityApplicationToVisibleToSupplierDateResolver<TParent>;
}

export interface FacilityApplicationToApplicantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToApplicationInformationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToAttachmentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToEntitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToEstablishmentRecordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToFacilityApplicationHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: FacilityApplicationHistorySort;
}
export interface FacilityApplicationToFacilityApplicationHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: FacilityApplicationToFacilityApplicationHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToFacilityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToFeeSummaryIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToHasBankApprovalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToInvoiceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToIsInvoicePaidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToIsVisibleToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToLastUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToPropertiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToSharedFacilityWithOrganisationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToSubmissionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToSupplierIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToTotalFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationToVisibleToSupplierDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantTypeResolver<TParent = any> {
  abn?: ApplicantToAbnResolver<TParent>;
  address?: ApplicantToAddressResolver<TParent>;
  companyName?: ApplicantToCompanyNameResolver<TParent>;
  contactName?: ApplicantToContactNameResolver<TParent>;
  contactTitle?: ApplicantToContactTitleResolver<TParent>;
  emailAddress?: ApplicantToEmailAddressResolver<TParent>;
  entityType?: ApplicantToEntityTypeResolver<TParent>;
  industry?: ApplicantToIndustryResolver<TParent>;
  phoneNumber?: ApplicantToPhoneNumberResolver<TParent>;
  role?: ApplicantToRoleResolver<TParent>;
  website?: ApplicantToWebsiteResolver<TParent>;
}

export interface ApplicantToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToCompanyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToContactNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToContactTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToIndustryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicantToWebsiteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApplicationInformationTypeResolver<TParent = any> {
  facilityLimit?: ApplicationInformationToFacilityLimitResolver<TParent>;
}

export interface ApplicationInformationToFacilityLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentTypeResolver<TParent = any> {
  contentType?: FacilityApplicationAttachmentToContentTypeResolver<TParent>;
  downloadPresignedUrl?: FacilityApplicationAttachmentToDownloadPresignedUrlResolver<TParent>;
  fileName?: FacilityApplicationAttachmentToFileNameResolver<TParent>;
  id?: FacilityApplicationAttachmentToIdResolver<TParent>;
  infectedFileStatus?: FacilityApplicationAttachmentToInfectedFileStatusResolver<TParent>;
  received?: FacilityApplicationAttachmentToReceivedResolver<TParent>;
  uploadPresignedUrl?: FacilityApplicationAttachmentToUploadPresignedUrlResolver<TParent>;
  variant?: FacilityApplicationAttachmentToVariantResolver<TParent>;
}

export interface FacilityApplicationAttachmentToContentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToDownloadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToFileNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToInfectedFileStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToReceivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToUploadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationAttachmentToVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationEntityTypeResolver<TParent = any> {
  abn?: FacilityApplicationEntityToAbnResolver<TParent>;
  facilityApplication?: FacilityApplicationEntityToFacilityApplicationResolver<TParent>;
  facilityApplicationId?: FacilityApplicationEntityToFacilityApplicationIdResolver<TParent>;
  id?: FacilityApplicationEntityToIdResolver<TParent>;
  name?: FacilityApplicationEntityToNameResolver<TParent>;
}

export interface FacilityApplicationEntityToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationEntityToFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationEntityToFacilityApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationEntityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationEntityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordTypeResolver<TParent = any> {
  annualCost?: EstablishmentRecordToAnnualCostResolver<TParent>;
  bankFrontedBondsRecurringPercentageCost?: EstablishmentRecordToBankFrontedBondsRecurringPercentageCostResolver<TParent>;
  bankFrontedBondsSetUpCost?: EstablishmentRecordToBankFrontedBondsSetUpCostResolver<TParent>;
  documentRecurringPercentageCost?: EstablishmentRecordToDocumentRecurringPercentageCostResolver<TParent>;
  documentSetUpCost?: EstablishmentRecordToDocumentSetUpCostResolver<TParent>;
  endDate?: EstablishmentRecordToEndDateResolver<TParent>;
  facilityName?: EstablishmentRecordToFacilityNameResolver<TParent>;
  limit?: EstablishmentRecordToLimitResolver<TParent>;
  premiumBankFrontedBondsRecurringPercentageCost?: EstablishmentRecordToPremiumBankFrontedBondsRecurringPercentageCostResolver<TParent>;
  premiumDocumentRecurringPercentageCost?: EstablishmentRecordToPremiumDocumentRecurringPercentageCostResolver<TParent>;
  setUpCost?: EstablishmentRecordToSetUpCostResolver<TParent>;
  startDate?: EstablishmentRecordToStartDateResolver<TParent>;
}

export interface EstablishmentRecordToAnnualCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToBankFrontedBondsRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToBankFrontedBondsSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToDocumentRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToDocumentSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToFacilityNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToPremiumBankFrontedBondsRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToPremiumDocumentRecurringPercentageCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToSetUpCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EstablishmentRecordToStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryConnectionTypeResolver<TParent = any> {
  edges?: FacilityApplicationHistoryConnectionToEdgesResolver<TParent>;
  nodes?: FacilityApplicationHistoryConnectionToNodesResolver<TParent>;
  pageInfo?: FacilityApplicationHistoryConnectionToPageInfoResolver<TParent>;
  totalCount?: FacilityApplicationHistoryConnectionToTotalCountResolver<TParent>;
}

export interface FacilityApplicationHistoryConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryEdgeTypeResolver<TParent = any> {
  cursor?: FacilityApplicationHistoryEdgeToCursorResolver<TParent>;
  node?: FacilityApplicationHistoryEdgeToNodeResolver<TParent>;
}

export interface FacilityApplicationHistoryEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryTypeResolver<TParent = any> {
  changeSetId?: FacilityApplicationHistoryToChangeSetIdResolver<TParent>;
  changeType?: FacilityApplicationHistoryToChangeTypeResolver<TParent>;
  changes?: FacilityApplicationHistoryToChangesResolver<TParent>;
  id?: FacilityApplicationHistoryToIdResolver<TParent>;
  objectType?: FacilityApplicationHistoryToObjectTypeResolver<TParent>;
  recordName?: FacilityApplicationHistoryToRecordNameResolver<TParent>;
  triggeredAt?: FacilityApplicationHistoryToTriggeredAtResolver<TParent>;
  triggeredBy?: FacilityApplicationHistoryToTriggeredByResolver<TParent>;
}

export interface FacilityApplicationHistoryToChangeSetIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToChangeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToChangesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToObjectTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToRecordNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToTriggeredAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryToTriggeredByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryChangeTypeResolver<TParent = any> {
  field?: FacilityApplicationHistoryChangeToFieldResolver<TParent>;
  label?: FacilityApplicationHistoryChangeToLabelResolver<TParent>;
  newDisplayValue?: FacilityApplicationHistoryChangeToNewDisplayValueResolver<TParent>;
  newValue?: FacilityApplicationHistoryChangeToNewValueResolver<TParent>;
  oldDisplayValue?: FacilityApplicationHistoryChangeToOldDisplayValueResolver<TParent>;
  oldValue?: FacilityApplicationHistoryChangeToOldValueResolver<TParent>;
}

export interface FacilityApplicationHistoryChangeToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryChangeToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryChangeToNewDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryChangeToNewValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryChangeToOldDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationHistoryChangeToOldValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationOrganisationTypeResolver<TParent = any> {
  id?: FacilityApplicationOrganisationToIdResolver<TParent>;
  name?: FacilityApplicationOrganisationToNameResolver<TParent>;
}

export interface FacilityApplicationOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationOrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyTypeResolver<TParent = any> {
  address?: FacilityApplicationPropertyToAddressResolver<TParent>;
  estimatedValue?: FacilityApplicationPropertyToEstimatedValueResolver<TParent>;
  facilityApplication?: FacilityApplicationPropertyToFacilityApplicationResolver<TParent>;
  facilityApplicationId?: FacilityApplicationPropertyToFacilityApplicationIdResolver<TParent>;
  id?: FacilityApplicationPropertyToIdResolver<TParent>;
  isMortgaged?: FacilityApplicationPropertyToIsMortgagedResolver<TParent>;
  isPrimaryPlaceOfResidence?: FacilityApplicationPropertyToIsPrimaryPlaceOfResidenceResolver<TParent>;
  lender?: FacilityApplicationPropertyToLenderResolver<TParent>;
  outstandingMortgage?: FacilityApplicationPropertyToOutstandingMortgageResolver<TParent>;
  owners?: FacilityApplicationPropertyToOwnersResolver<TParent>;
  propertyType?: FacilityApplicationPropertyToPropertyTypeResolver<TParent>;
}

export interface FacilityApplicationPropertyToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToEstimatedValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToFacilityApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToIsMortgagedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToIsPrimaryPlaceOfResidenceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToLenderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToOutstandingMortgageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToOwnersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyToPropertyTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyOwnerTypeResolver<TParent = any> {
  applicantRelationship?: FacilityApplicationPropertyOwnerToApplicantRelationshipResolver<TParent>;
  facilityPropertyId?: FacilityApplicationPropertyOwnerToFacilityPropertyIdResolver<TParent>;
  id?: FacilityApplicationPropertyOwnerToIdResolver<TParent>;
  name?: FacilityApplicationPropertyOwnerToNameResolver<TParent>;
  property?: FacilityApplicationPropertyOwnerToPropertyResolver<TParent>;
}

export interface FacilityApplicationPropertyOwnerToApplicantRelationshipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyOwnerToFacilityPropertyIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyOwnerToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyOwnerToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationPropertyOwnerToPropertyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationSharedFacilityWithOrganisationTypeResolver<TParent = any> {
  createdAt?: FacilityApplicationSharedFacilityWithOrganisationToCreatedAtResolver<TParent>;
  facilityApplicationId?: FacilityApplicationSharedFacilityWithOrganisationToFacilityApplicationIdResolver<TParent>;
  id?: FacilityApplicationSharedFacilityWithOrganisationToIdResolver<TParent>;
  organisationId?: FacilityApplicationSharedFacilityWithOrganisationToOrganisationIdResolver<TParent>;
  sharedWithOrganisation?: FacilityApplicationSharedFacilityWithOrganisationToSharedWithOrganisationResolver<TParent>;
}

export interface FacilityApplicationSharedFacilityWithOrganisationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationSharedFacilityWithOrganisationToFacilityApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationSharedFacilityWithOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationSharedFacilityWithOrganisationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationSharedFacilityWithOrganisationToSharedWithOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubmissionRecordTypeResolver<TParent = any> {
  submittedAt?: SubmissionRecordToSubmittedAtResolver<TParent>;
}

export interface SubmissionRecordToSubmittedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsConnectionTypeResolver<TParent = any> {
  capabilities?: FacilityApplicationsConnectionToCapabilitiesResolver<TParent>;
  edges?: FacilityApplicationsConnectionToEdgesResolver<TParent>;
  nodes?: FacilityApplicationsConnectionToNodesResolver<TParent>;
  pageInfo?: FacilityApplicationsConnectionToPageInfoResolver<TParent>;
  totalCount?: FacilityApplicationsConnectionToTotalCountResolver<TParent>;
}

export interface FacilityApplicationsConnectionToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsEdgeTypeResolver<TParent = any> {
  cursor?: FacilityApplicationsEdgeToCursorResolver<TParent>;
  node?: FacilityApplicationsEdgeToNodeResolver<TParent>;
}

export interface FacilityApplicationsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: FacilityApplicationsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: FacilityApplicationsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: FacilityApplicationsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: FacilityApplicationsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface FacilityApplicationsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: FacilityApplicationsForBankPortalEdgeToCursorResolver<TParent>;
  node?: FacilityApplicationsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface FacilityApplicationsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FacilityApplicationsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesTypeResolver<TParent = any> {
  docuSignIntegration?: GatewayFeaturesToDocuSignIntegrationResolver<TParent>;
  emailAuditing?: GatewayFeaturesToEmailAuditingResolver<TParent>;
  googleAuth?: GatewayFeaturesToGoogleAuthResolver<TParent>;
  gvpIntegration?: GatewayFeaturesToGvpIntegrationResolver<TParent>;
  organisationCredit?: GatewayFeaturesToOrganisationCreditResolver<TParent>;
  referralPortal?: GatewayFeaturesToReferralPortalResolver<TParent>;
  referrals?: GatewayFeaturesToReferralsResolver<TParent>;
  requiredDocuments_BlockCreation_IfSubmittedToGvpAndNotRecalled?: GatewayFeaturesToRequiredDocuments_BlockCreation_IfSubmittedToGvpAndNotRecalledResolver<TParent>;
  suretyBonds?: GatewayFeaturesToSuretyBondsResolver<TParent>;
}

export interface GatewayFeaturesToDocuSignIntegrationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToEmailAuditingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToGoogleAuthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToGvpIntegrationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToOrganisationCreditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToReferralPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToReferralsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToRequiredDocuments_BlockCreation_IfSubmittedToGvpAndNotRecalledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GatewayFeaturesToSuretyBondsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: FinanceRecordsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: FinanceRecordsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: FinanceRecordsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: FinanceRecordsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface FinanceRecordsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: FinanceRecordsForBankPortalEdgeToCursorResolver<TParent>;
  node?: FinanceRecordsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface FinanceRecordsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordTypeResolver<TParent = any> {
  amount?: FinanceRecordToAmountResolver<TParent>;
  dateTime?: FinanceRecordToDateTimeResolver<TParent>;
  financeType?: FinanceRecordToFinanceTypeResolver<TParent>;
  financier?: FinanceRecordToFinancierResolver<TParent>;
  id?: FinanceRecordToIdResolver<TParent>;
  organisationId?: FinanceRecordToOrganisationIdResolver<TParent>;
  performedBy?: FinanceRecordToPerformedByResolver<TParent>;
  performedByUser?: FinanceRecordToPerformedByUserResolver<TParent>;
}

export interface FinanceRecordToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToDateTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToFinanceTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToFinancierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToPerformedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceRecordToPerformedByUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerReportMonthTypeResolver<TParent = any> {
  amount?: ChannelPartnerReportMonthToAmountResolver<TParent>;
  existingClients?: ChannelPartnerReportMonthToExistingClientsResolver<TParent>;
  monthYear?: ChannelPartnerReportMonthToMonthYearResolver<TParent>;
  newClients?: ChannelPartnerReportMonthToNewClientsResolver<TParent>;
  numberOfDocuments?: ChannelPartnerReportMonthToNumberOfDocumentsResolver<TParent>;
  savings?: ChannelPartnerReportMonthToSavingsResolver<TParent>;
}

export interface ChannelPartnerReportMonthToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerReportMonthToExistingClientsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerReportMonthToMonthYearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerReportMonthToNewClientsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerReportMonthToNumberOfDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerReportMonthToSavingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartProjectionReportMonthTypeResolver<TParent = any> {
  monthYear?: ChartProjectionReportMonthToMonthYearResolver<TParent>;
  totalAmount?: ChartProjectionReportMonthToTotalAmountResolver<TParent>;
}

export interface ChartProjectionReportMonthToMonthYearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartProjectionReportMonthToTotalAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthTypeResolver<TParent = any> {
  bankguaranteeAmount?: ChartReportMonthToBankguaranteeAmountResolver<TParent>;
  monthYear?: ChartReportMonthToMonthYearResolver<TParent>;
  numberOfBankguaranteeClients?: ChartReportMonthToNumberOfBankguaranteeClientsResolver<TParent>;
  numberOfBankguaranteeDocuments?: ChartReportMonthToNumberOfBankguaranteeDocumentsResolver<TParent>;
  numberOfClients?: ChartReportMonthToNumberOfClientsResolver<TParent>;
  numberOfDocuments?: ChartReportMonthToNumberOfDocumentsResolver<TParent>;
  numberOfSuretyBondsClients?: ChartReportMonthToNumberOfSuretyBondsClientsResolver<TParent>;
  numberOfSuretyBondsDocuments?: ChartReportMonthToNumberOfSuretyBondsDocumentsResolver<TParent>;
  suretyBondsAmount?: ChartReportMonthToSuretyBondsAmountResolver<TParent>;
  totalAmount?: ChartReportMonthToTotalAmountResolver<TParent>;
}

export interface ChartReportMonthToBankguaranteeAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToMonthYearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToNumberOfBankguaranteeClientsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToNumberOfBankguaranteeDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToNumberOfClientsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToNumberOfDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToNumberOfSuretyBondsClientsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToNumberOfSuretyBondsDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToSuretyBondsAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartReportMonthToTotalAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeneratedAttachmentsForOrganisationConnectionTypeResolver<TParent = any> {
  edges?: GeneratedAttachmentsForOrganisationConnectionToEdgesResolver<TParent>;
  nodes?: GeneratedAttachmentsForOrganisationConnectionToNodesResolver<TParent>;
  pageInfo?: GeneratedAttachmentsForOrganisationConnectionToPageInfoResolver<TParent>;
  totalCount?: GeneratedAttachmentsForOrganisationConnectionToTotalCountResolver<TParent>;
}

export interface GeneratedAttachmentsForOrganisationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeneratedAttachmentsForOrganisationConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeneratedAttachmentsForOrganisationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeneratedAttachmentsForOrganisationConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeneratedAttachmentsForOrganisationEdgeTypeResolver<TParent = any> {
  cursor?: GeneratedAttachmentsForOrganisationEdgeToCursorResolver<TParent>;
  node?: GeneratedAttachmentsForOrganisationEdgeToNodeResolver<TParent>;
}

export interface GeneratedAttachmentsForOrganisationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeneratedAttachmentsForOrganisationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetNotificationsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: GetNotificationsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: GetNotificationsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: GetNotificationsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: GetNotificationsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface GetNotificationsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetNotificationsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetNotificationsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetNotificationsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetNotificationsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: GetNotificationsForBankPortalEdgeToCursorResolver<TParent>;
  node?: GetNotificationsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface GetNotificationsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetNotificationsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationTypeResolver<TParent = any> {
  createdOn?: NotificationToCreatedOnResolver<TParent>;
  emailAddress?: NotificationToEmailAddressResolver<TParent>;
  event?: NotificationToEventResolver<TParent>;
  externalId?: NotificationToExternalIdResolver<TParent>;
  id?: NotificationToIdResolver<TParent>;
  metadata?: NotificationToMetadataResolver<TParent>;
  sentOn?: NotificationToSentOnResolver<TParent>;
  subject?: NotificationToSubjectResolver<TParent>;
  template?: NotificationToTemplateResolver<TParent>;
  userId?: NotificationToUserIdResolver<TParent>;
}

export interface NotificationToCreatedOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToEmailAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToExternalIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToSentOnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToSubjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToTemplateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditEventsConnectionTypeResolver<TParent = any> {
  edges?: GetOrganisationCreditEventsConnectionToEdgesResolver<TParent>;
  nodes?: GetOrganisationCreditEventsConnectionToNodesResolver<TParent>;
  pageInfo?: GetOrganisationCreditEventsConnectionToPageInfoResolver<TParent>;
  totalCount?: GetOrganisationCreditEventsConnectionToTotalCountResolver<TParent>;
}

export interface GetOrganisationCreditEventsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditEventsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditEventsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditEventsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditEventsEdgeTypeResolver<TParent = any> {
  cursor?: GetOrganisationCreditEventsEdgeToCursorResolver<TParent>;
  node?: GetOrganisationCreditEventsEdgeToNodeResolver<TParent>;
}

export interface GetOrganisationCreditEventsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditEventsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventTypeResolver<TParent = any> {
  actionedBy?: OrganisationCreditEventToActionedByResolver<TParent>;
  actionedByName?: OrganisationCreditEventToActionedByNameResolver<TParent>;
  actionedRole?: OrganisationCreditEventToActionedRoleResolver<TParent>;
  amountChanged?: OrganisationCreditEventToAmountChangedResolver<TParent>;
  comment?: OrganisationCreditEventToCommentResolver<TParent>;
  dateCreated?: OrganisationCreditEventToDateCreatedResolver<TParent>;
  eventType?: OrganisationCreditEventToEventTypeResolver<TParent>;
  id?: OrganisationCreditEventToIdResolver<TParent>;
  organisationCreditId?: OrganisationCreditEventToOrganisationCreditIdResolver<TParent>;
  remainingBalance?: OrganisationCreditEventToRemainingBalanceResolver<TParent>;
  usedByDraftId?: OrganisationCreditEventToUsedByDraftIdResolver<TParent>;
}

export interface OrganisationCreditEventToActionedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToActionedByNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToActionedRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToAmountChangedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToDateCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToEventTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToOrganisationCreditIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToRemainingBalanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditEventToUsedByDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditsConnectionTypeResolver<TParent = any> {
  edges?: GetOrganisationCreditsConnectionToEdgesResolver<TParent>;
  nodes?: GetOrganisationCreditsConnectionToNodesResolver<TParent>;
  pageInfo?: GetOrganisationCreditsConnectionToPageInfoResolver<TParent>;
  totalCount?: GetOrganisationCreditsConnectionToTotalCountResolver<TParent>;
}

export interface GetOrganisationCreditsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditsEdgeTypeResolver<TParent = any> {
  cursor?: GetOrganisationCreditsEdgeToCursorResolver<TParent>;
  node?: GetOrganisationCreditsEdgeToNodeResolver<TParent>;
}

export interface GetOrganisationCreditsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationCreditsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditTypeResolver<TParent = any> {
  createdByAdminId?: OrganisationCreditToCreatedByAdminIdResolver<TParent>;
  createdByName?: OrganisationCreditToCreatedByNameResolver<TParent>;
  creditType?: OrganisationCreditToCreditTypeResolver<TParent>;
  dateCreated?: OrganisationCreditToDateCreatedResolver<TParent>;
  draftDescription?: OrganisationCreditToDraftDescriptionResolver<TParent>;
  id?: OrganisationCreditToIdResolver<TParent>;
  issuedAmount?: OrganisationCreditToIssuedAmountResolver<TParent>;
  organisationCreditEvents?: OrganisationCreditToOrganisationCreditEventsResolver<TParent>;
  organisationId?: OrganisationCreditToOrganisationIdResolver<TParent>;
  remainingAmount?: OrganisationCreditToRemainingAmountResolver<TParent>;
  sourceDraftId?: OrganisationCreditToSourceDraftIdResolver<TParent>;
  status?: OrganisationCreditToStatusResolver<TParent>;
}

export interface OrganisationCreditToCreatedByAdminIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToCreatedByNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToCreditTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToDateCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToDraftDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToIssuedAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToOrganisationCreditEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToRemainingAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToSourceDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationCreditToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: GetOrganisationsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: GetOrganisationsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: GetOrganisationsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: GetOrganisationsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface GetOrganisationsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: GetOrganisationsForBankPortalEdgeToCursorResolver<TParent>;
  node?: GetOrganisationsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface GetOrganisationsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetOrganisationsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationTypeResolver<TParent = any> {
  abn?: BankOrganisationToAbnResolver<TParent>;
  address?: BankOrganisationToAddressResolver<TParent>;
  capabilities?: BankOrganisationToCapabilitiesResolver<TParent>;
  channelPartnerOrganisations?: BankOrganisationToChannelPartnerOrganisationsResolver<TParent>;
  connectedGvpGuarantorIds?: BankOrganisationToConnectedGvpGuarantorIdsResolver<TParent>;
  createdAt?: BankOrganisationToCreatedAtResolver<TParent>;
  discountPercentage?: BankOrganisationToDiscountPercentageResolver<TParent>;
  entityType?: BankOrganisationToEntityTypeResolver<TParent>;
  gvpId?: BankOrganisationToGvpIdResolver<TParent>;
  id?: BankOrganisationToIdResolver<TParent>;
  industryType?: BankOrganisationToIndustryTypeResolver<TParent>;
  isOngoingClient?: BankOrganisationToIsOngoingClientResolver<TParent>;
  leadSource?: BankOrganisationToLeadSourceResolver<TParent>;
  memberInvitations?: BankOrganisationToMemberInvitationsResolver<TParent>;
  members?: BankOrganisationToMembersResolver<TParent>;
  name?: BankOrganisationToNameResolver<TParent>;
  nickname?: BankOrganisationToNicknameResolver<TParent>;
  organisationFeeSummaries?: BankOrganisationToOrganisationFeeSummariesResolver<TParent>;
  organisationVariant?: BankOrganisationToOrganisationVariantResolver<TParent>;
  postalAddress?: BankOrganisationToPostalAddressResolver<TParent>;
  postalAddressSameAsBusinessAddress?: BankOrganisationToPostalAddressSameAsBusinessAddressResolver<TParent>;
  referralCode?: BankOrganisationToReferralCodeResolver<TParent>;
  referralPortalAssociation?: BankOrganisationToReferralPortalAssociationResolver<TParent>;
  relationshipManager?: BankOrganisationToRelationshipManagerResolver<TParent>;
  relationshipManagerId?: BankOrganisationToRelationshipManagerIdResolver<TParent>;
  sumAvailableOrganisationCredits?: BankOrganisationToSumAvailableOrganisationCreditsResolver<TParent>;
}

export interface BankOrganisationToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToChannelPartnerOrganisationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
}
export interface BankOrganisationToChannelPartnerOrganisationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankOrganisationToChannelPartnerOrganisationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToConnectedGvpGuarantorIdsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToGvpIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToIndustryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToIsOngoingClientResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToLeadSourceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToMemberInvitationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
}
export interface BankOrganisationToMemberInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankOrganisationToMemberInvitationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToMembersArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  where?: MemberFilter;
}
export interface BankOrganisationToMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankOrganisationToMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToNicknameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToOrganisationFeeSummariesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToOrganisationVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToPostalAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToPostalAddressSameAsBusinessAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToReferralCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToReferralPortalAssociationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToRelationshipManagerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToRelationshipManagerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankOrganisationToSumAvailableOrganisationCreditsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationsConnectionTypeResolver<TParent = any> {
  edges?: ChannelPartnerOrganisationsConnectionToEdgesResolver<TParent>;
  nodes?: ChannelPartnerOrganisationsConnectionToNodesResolver<TParent>;
  pageInfo?: ChannelPartnerOrganisationsConnectionToPageInfoResolver<TParent>;
  totalCount?: ChannelPartnerOrganisationsConnectionToTotalCountResolver<TParent>;
}

export interface ChannelPartnerOrganisationsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationsEdgeTypeResolver<TParent = any> {
  cursor?: ChannelPartnerOrganisationsEdgeToCursorResolver<TParent>;
  node?: ChannelPartnerOrganisationsEdgeToNodeResolver<TParent>;
}

export interface ChannelPartnerOrganisationsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationTypeResolver<TParent = any> {
  channelPartner?: ChannelPartnerOrganisationToChannelPartnerResolver<TParent>;
  id?: ChannelPartnerOrganisationToIdResolver<TParent>;
}

export interface ChannelPartnerOrganisationToChannelPartnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChannelPartnerOrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationsConnectionTypeResolver<TParent = any> {
  edges?: MemberInvitationsConnectionToEdgesResolver<TParent>;
  nodes?: MemberInvitationsConnectionToNodesResolver<TParent>;
  pageInfo?: MemberInvitationsConnectionToPageInfoResolver<TParent>;
  totalCount?: MemberInvitationsConnectionToTotalCountResolver<TParent>;
}

export interface MemberInvitationsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationsEdgeTypeResolver<TParent = any> {
  cursor?: MemberInvitationsEdgeToCursorResolver<TParent>;
  node?: MemberInvitationsEdgeToNodeResolver<TParent>;
}

export interface MemberInvitationsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationTypeResolver<TParent = any> {
  createdAt?: MemberInvitationToCreatedAtResolver<TParent>;
  email?: MemberInvitationToEmailResolver<TParent>;
  id?: MemberInvitationToIdResolver<TParent>;
  isExpired?: MemberInvitationToIsExpiredResolver<TParent>;
  role?: MemberInvitationToRoleResolver<TParent>;
}

export interface MemberInvitationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationToIsExpiredResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberInvitationToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MembersConnectionTypeResolver<TParent = any> {
  edges?: MembersConnectionToEdgesResolver<TParent>;
  nodes?: MembersConnectionToNodesResolver<TParent>;
  pageInfo?: MembersConnectionToPageInfoResolver<TParent>;
  totalCount?: MembersConnectionToTotalCountResolver<TParent>;
}

export interface MembersConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MembersConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MembersConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MembersConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MembersEdgeTypeResolver<TParent = any> {
  cursor?: MembersEdgeToCursorResolver<TParent>;
  node?: MembersEdgeToNodeResolver<TParent>;
}

export interface MembersEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MembersEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberTypeResolver<TParent = any> {
  createdAt?: MemberToCreatedAtResolver<TParent>;
  email?: MemberToEmailResolver<TParent>;
  familyName?: MemberToFamilyNameResolver<TParent>;
  givenName?: MemberToGivenNameResolver<TParent>;
  memberId?: MemberToMemberIdResolver<TParent>;
  role?: MemberToRoleResolver<TParent>;
  user?: MemberToUserResolver<TParent>;
  userId?: MemberToUserIdResolver<TParent>;
}

export interface MemberToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToMemberIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MemberToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserTypeResolver<TParent = any> {
  address?: UserToAddressResolver<TParent>;
  createdAt?: UserToCreatedAtResolver<TParent>;
  email?: UserToEmailResolver<TParent>;
  familyName?: UserToFamilyNameResolver<TParent>;
  givenName?: UserToGivenNameResolver<TParent>;
  id?: UserToIdResolver<TParent>;
  industry?: UserToIndustryResolver<TParent>;
  jobTitle?: UserToJobTitleResolver<TParent>;
  locale?: UserToLocaleResolver<TParent>;
  phoneNumber?: UserToPhoneNumberResolver<TParent>;
}

export interface UserToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIndustryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToJobTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLocaleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationFeeSummaryTypeResolver<TParent = any> {
  feeSummaryId?: OrganisationFeeSummaryToFeeSummaryIdResolver<TParent>;
  id?: OrganisationFeeSummaryToIdResolver<TParent>;
  organisation?: OrganisationFeeSummaryToOrganisationResolver<TParent>;
  organisationId?: OrganisationFeeSummaryToOrganisationIdResolver<TParent>;
}

export interface OrganisationFeeSummaryToFeeSummaryIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationFeeSummaryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationFeeSummaryToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationFeeSummaryToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationTypeResolver<TParent = any> {
  abn?: OrganisationToAbnResolver<TParent>;
  address?: OrganisationToAddressResolver<TParent>;
  alertConfigurations?: OrganisationToAlertConfigurationsResolver<TParent>;
  capabilities?: OrganisationToCapabilitiesResolver<TParent>;
  channelPartnerOrganisations?: OrganisationToChannelPartnerOrganisationsResolver<TParent>;
  createdAt?: OrganisationToCreatedAtResolver<TParent>;
  discountPercentage?: OrganisationToDiscountPercentageResolver<TParent>;
  documentFacilitiesOptIn?: OrganisationToDocumentFacilitiesOptInResolver<TParent>;
  documentMetadata?: OrganisationToDocumentMetadataResolver<TParent>;
  documentsCapabilities?: OrganisationToDocumentsCapabilitiesResolver<TParent>;
  entityType?: OrganisationToEntityTypeResolver<TParent>;
  id?: OrganisationToIdResolver<TParent>;
  industryType?: OrganisationToIndustryTypeResolver<TParent>;
  isOngoingClient?: OrganisationToIsOngoingClientResolver<TParent>;
  leadSource?: OrganisationToLeadSourceResolver<TParent>;
  memberInvitations?: OrganisationToMemberInvitationsResolver<TParent>;
  members?: OrganisationToMembersResolver<TParent>;
  name?: OrganisationToNameResolver<TParent>;
  nickname?: OrganisationToNicknameResolver<TParent>;
  organisationFeeSummaries?: OrganisationToOrganisationFeeSummariesResolver<TParent>;
  organisationVariant?: OrganisationToOrganisationVariantResolver<TParent>;
  postalAddress?: OrganisationToPostalAddressResolver<TParent>;
  postalAddressSameAsBusinessAddress?: OrganisationToPostalAddressSameAsBusinessAddressResolver<TParent>;
  referralCode?: OrganisationToReferralCodeResolver<TParent>;
  referralPortalAssociation?: OrganisationToReferralPortalAssociationResolver<TParent>;
  relationshipManager?: OrganisationToRelationshipManagerResolver<TParent>;
  relationshipManagerId?: OrganisationToRelationshipManagerIdResolver<TParent>;
  sumAvailableOrganisationCredits?: OrganisationToSumAvailableOrganisationCreditsResolver<TParent>;
}

export interface OrganisationToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToAlertConfigurationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToChannelPartnerOrganisationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
}
export interface OrganisationToChannelPartnerOrganisationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: OrganisationToChannelPartnerOrganisationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToDiscountPercentageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToDocumentFacilitiesOptInResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToDocumentMetadataArgs {
  order_by?: OrganisationDocumentMetadataSort;
}
export interface OrganisationToDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: OrganisationToDocumentMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToDocumentsCapabilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToIndustryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToIsOngoingClientResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToLeadSourceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToMemberInvitationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
}
export interface OrganisationToMemberInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: OrganisationToMemberInvitationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToMembersArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  where?: MemberFilter;
}
export interface OrganisationToMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: OrganisationToMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToNicknameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToOrganisationFeeSummariesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToOrganisationVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToPostalAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToPostalAddressSameAsBusinessAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToReferralCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToReferralPortalAssociationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToRelationshipManagerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToRelationshipManagerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationToSumAvailableOrganisationCreditsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationTypeResolver<TParent = any> {
  emailAddresses?: AlertConfigurationToEmailAddressesResolver<TParent>;
  facilityId?: AlertConfigurationToFacilityIdResolver<TParent>;
  facilityLimit?: AlertConfigurationToFacilityLimitResolver<TParent>;
  facilityLimitIncludeProjectedDocs?: AlertConfigurationToFacilityLimitIncludeProjectedDocsResolver<TParent>;
  id?: AlertConfigurationToIdResolver<TParent>;
  triggerLeadTime?: AlertConfigurationToTriggerLeadTimeResolver<TParent>;
  triggerProperty?: AlertConfigurationToTriggerPropertyResolver<TParent>;
}

export interface AlertConfigurationToEmailAddressesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationToFacilityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationToFacilityLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationToFacilityLimitIncludeProjectedDocsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationToTriggerLeadTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AlertConfigurationToTriggerPropertyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationDocumentMetadataTypeResolver<TParent = any> {
  id?: OrganisationDocumentMetadataToIdResolver<TParent>;
  key?: OrganisationDocumentMetadataToKeyResolver<TParent>;
}

export interface OrganisationDocumentMetadataToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationDocumentMetadataToKeyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationTypeResolver<TParent = any> {
  createdAt?: OrganisationAssociationToCreatedAtResolver<TParent>;
  entity?: OrganisationAssociationToEntityResolver<TParent>;
  entityId?: OrganisationAssociationToEntityIdResolver<TParent>;
  id?: OrganisationAssociationToIdResolver<TParent>;
  organisationId?: OrganisationAssociationToOrganisationIdResolver<TParent>;
  referralPortalMember?: OrganisationAssociationToReferralPortalMemberResolver<TParent>;
  referralPortalMemberId?: OrganisationAssociationToReferralPortalMemberIdResolver<TParent>;
}

export interface OrganisationAssociationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationToEntityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationToEntityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationToReferralPortalMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationAssociationToReferralPortalMemberIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityTypeResolver<TParent = any> {
  abn?: EntityToAbnResolver<TParent>;
  addressLine1?: EntityToAddressLine1Resolver<TParent>;
  addressLine2?: EntityToAddressLine2Resolver<TParent>;
  addressPostcode?: EntityToAddressPostcodeResolver<TParent>;
  addressState?: EntityToAddressStateResolver<TParent>;
  addressSuburb?: EntityToAddressSuburbResolver<TParent>;
  bankingAccountNumber?: EntityToBankingAccountNumberResolver<TParent>;
  bankingBsbNumber?: EntityToBankingBsbNumberResolver<TParent>;
  contactPerson?: EntityToContactPersonResolver<TParent>;
  createdAt?: EntityToCreatedAtResolver<TParent>;
  email?: EntityToEmailResolver<TParent>;
  entityType?: EntityToEntityTypeResolver<TParent>;
  id?: EntityToIdResolver<TParent>;
  name?: EntityToNameResolver<TParent>;
  parentEntityId?: EntityToParentEntityIdResolver<TParent>;
  phone?: EntityToPhoneResolver<TParent>;
  relationshipManagerEmail?: EntityToRelationshipManagerEmailResolver<TParent>;
  relationshipManagerFirstName?: EntityToRelationshipManagerFirstNameResolver<TParent>;
  relationshipManagerId?: EntityToRelationshipManagerIdResolver<TParent>;
  relationshipManagerLastName?: EntityToRelationshipManagerLastNameResolver<TParent>;
  relationshipManagerPhone?: EntityToRelationshipManagerPhoneResolver<TParent>;
}

export interface EntityToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToAddressLine1Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToAddressLine2Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToAddressPostcodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToAddressStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToAddressSuburbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToBankingAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToBankingBsbNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToContactPersonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToParentEntityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToRelationshipManagerEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToRelationshipManagerFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToRelationshipManagerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToRelationshipManagerLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EntityToRelationshipManagerPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberTypeResolver<TParent = any> {
  cognitoUser_Username?: ReferralPortalMemberToCognitoUser_UsernameResolver<TParent>;
  email?: ReferralPortalMemberToEmailResolver<TParent>;
  entity?: ReferralPortalMemberToEntityResolver<TParent>;
  entityId?: ReferralPortalMemberToEntityIdResolver<TParent>;
  entityName?: ReferralPortalMemberToEntityNameResolver<TParent>;
  id?: ReferralPortalMemberToIdResolver<TParent>;
  isSmsMfaRequired?: ReferralPortalMemberToIsSmsMfaRequiredResolver<TParent>;
  mobilePhone?: ReferralPortalMemberToMobilePhoneResolver<TParent>;
  name?: ReferralPortalMemberToNameResolver<TParent>;
  position?: ReferralPortalMemberToPositionResolver<TParent>;
  referClientCode?: ReferralPortalMemberToReferClientCodeResolver<TParent>;
  role?: ReferralPortalMemberToRoleResolver<TParent>;
  status?: ReferralPortalMemberToStatusResolver<TParent>;
  surname?: ReferralPortalMemberToSurnameResolver<TParent>;
}

export interface ReferralPortalMemberToCognitoUser_UsernameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToEntityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToEntityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToEntityNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToIsSmsMfaRequiredResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToMobilePhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToPositionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToReferClientCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMemberToSurnameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentSecretTypeResolver<TParent = any> {
  amountInCents?: InvoicePaymentIntentSecretToAmountInCentsResolver<TParent>;
  clientSecret?: InvoicePaymentIntentSecretToClientSecretResolver<TParent>;
  paymentMethodId?: InvoicePaymentIntentSecretToPaymentMethodIdResolver<TParent>;
}

export interface InvoicePaymentIntentSecretToAmountInCentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentSecretToClientSecretResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicePaymentIntentSecretToPaymentMethodIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetSimpleKycDataFlagsByIdentificationIdConnectionTypeResolver<TParent = any> {
  edges?: GetSimpleKycDataFlagsByIdentificationIdConnectionToEdgesResolver<TParent>;
  nodes?: GetSimpleKycDataFlagsByIdentificationIdConnectionToNodesResolver<TParent>;
  pageInfo?: GetSimpleKycDataFlagsByIdentificationIdConnectionToPageInfoResolver<TParent>;
  totalCount?: GetSimpleKycDataFlagsByIdentificationIdConnectionToTotalCountResolver<TParent>;
}

export interface GetSimpleKycDataFlagsByIdentificationIdConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetSimpleKycDataFlagsByIdentificationIdConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetSimpleKycDataFlagsByIdentificationIdConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetSimpleKycDataFlagsByIdentificationIdConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetSimpleKycDataFlagsByIdentificationIdEdgeTypeResolver<TParent = any> {
  cursor?: GetSimpleKycDataFlagsByIdentificationIdEdgeToCursorResolver<TParent>;
  node?: GetSimpleKycDataFlagsByIdentificationIdEdgeToNodeResolver<TParent>;
}

export interface GetSimpleKycDataFlagsByIdentificationIdEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetSimpleKycDataFlagsByIdentificationIdEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IFlagsDataTypeResolver<TParent = any> {
  bo?: IFlagsDataToBoResolver<TParent>;
  descriptor?: IFlagsDataToDescriptorResolver<TParent>;
  flagGrade?: IFlagsDataToFlagGradeResolver<TParent>;
  msg?: IFlagsDataToMsgResolver<TParent>;
  nodeName?: IFlagsDataToNodeNameResolver<TParent>;
  relevance?: IFlagsDataToRelevanceResolver<TParent>;
}

export interface IFlagsDataToBoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IFlagsDataToDescriptorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IFlagsDataToFlagGradeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IFlagsDataToMsgResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IFlagsDataToNodeNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IFlagsDataToRelevanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StripeSubscriptionDetailsTypeResolver<TParent = any> {
  isLastInvoicePaid?: StripeSubscriptionDetailsToIsLastInvoicePaidResolver<TParent>;
  lastInvoiceDueDate?: StripeSubscriptionDetailsToLastInvoiceDueDateResolver<TParent>;
  subscriptionCancelledAt?: StripeSubscriptionDetailsToSubscriptionCancelledAtResolver<TParent>;
  subscriptionEndedAt?: StripeSubscriptionDetailsToSubscriptionEndedAtResolver<TParent>;
}

export interface StripeSubscriptionDetailsToIsLastInvoicePaidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StripeSubscriptionDetailsToLastInvoiceDueDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StripeSubscriptionDetailsToSubscriptionCancelledAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface StripeSubscriptionDetailsToSubscriptionEndedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUsersForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: GetUsersForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: GetUsersForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: GetUsersForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: GetUsersForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface GetUsersForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUsersForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUsersForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUsersForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUsersForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: GetUsersForBankPortalEdgeToCursorResolver<TParent>;
  node?: GetUsersForBankPortalEdgeToNodeResolver<TParent>;
}

export interface GetUsersForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUsersForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: IdentificationsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: IdentificationsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: IdentificationsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: IdentificationsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface IdentificationsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: IdentificationsForBankPortalEdgeToCursorResolver<TParent>;
  node?: IdentificationsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface IdentificationsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationTypeResolver<TParent = any> {
  adminStatus?: BankIdentificationToAdminStatusResolver<TParent>;
  clientStatus?: BankIdentificationToClientStatusResolver<TParent>;
  clientVerificationStatus?: BankIdentificationToClientVerificationStatusResolver<TParent>;
  comments?: BankIdentificationToCommentsResolver<TParent>;
  companyDetailsACN?: BankIdentificationToCompanyDetailsACNResolver<TParent>;
  companyDetailsHasBeneficialOwners?: BankIdentificationToCompanyDetailsHasBeneficialOwnersResolver<TParent>;
  companyDetailsIsListed?: BankIdentificationToCompanyDetailsIsListedResolver<TParent>;
  companyDetailsIsNormalType?: BankIdentificationToCompanyDetailsIsNormalTypeResolver<TParent>;
  companyDetailsIsRegulated?: BankIdentificationToCompanyDetailsIsRegulatedResolver<TParent>;
  companyDetailsIsSubsidiaryListed?: BankIdentificationToCompanyDetailsIsSubsidiaryListedResolver<TParent>;
  companyDetailsListedExchangeName?: BankIdentificationToCompanyDetailsListedExchangeNameResolver<TParent>;
  companyDetailsName?: BankIdentificationToCompanyDetailsNameResolver<TParent>;
  companyDetailsNatureOfBusiness?: BankIdentificationToCompanyDetailsNatureOfBusinessResolver<TParent>;
  companyDetailsOnlyOperatesInAustralia?: BankIdentificationToCompanyDetailsOnlyOperatesInAustraliaResolver<TParent>;
  companyDetailsPrincipalPlaceOfBusiness?: BankIdentificationToCompanyDetailsPrincipalPlaceOfBusinessResolver<TParent>;
  companyDetailsRegisteredAddress?: BankIdentificationToCompanyDetailsRegisteredAddressResolver<TParent>;
  companyDetailsRegulatorLicenseNumber?: BankIdentificationToCompanyDetailsRegulatorLicenseNumberResolver<TParent>;
  companyDetailsRegulatorName?: BankIdentificationToCompanyDetailsRegulatorNameResolver<TParent>;
  companyDetailsSubsidiaryListedCompanyName?: BankIdentificationToCompanyDetailsSubsidiaryListedCompanyNameResolver<TParent>;
  companyDetailsSubsidiaryListedExchangeName?: BankIdentificationToCompanyDetailsSubsidiaryListedExchangeNameResolver<TParent>;
  companyDetailsTaxFatcaStatus?: BankIdentificationToCompanyDetailsTaxFatcaStatusResolver<TParent>;
  companyDetailsTaxFatcaStatusOther?: BankIdentificationToCompanyDetailsTaxFatcaStatusOtherResolver<TParent>;
  companyDetailsTaxForeignResidentCountry?: BankIdentificationToCompanyDetailsTaxForeignResidentCountryResolver<TParent>;
  companyDetailsTaxGIIN?: BankIdentificationToCompanyDetailsTaxGIINResolver<TParent>;
  companyDetailsTaxHasBeneficialOwnerForeignResident?: BankIdentificationToCompanyDetailsTaxHasBeneficialOwnerForeignResidentResolver<TParent>;
  companyDetailsTaxHasGIIN?: BankIdentificationToCompanyDetailsTaxHasGIINResolver<TParent>;
  companyDetailsTaxIsForeignResident?: BankIdentificationToCompanyDetailsTaxIsForeignResidentResolver<TParent>;
  companyDetailsTaxType?: BankIdentificationToCompanyDetailsTaxTypeResolver<TParent>;
  createdAt?: BankIdentificationToCreatedAtResolver<TParent>;
  dataType?: BankIdentificationToDataTypeResolver<TParent>;
  entityType?: BankIdentificationToEntityTypeResolver<TParent>;
  entityWealthAccumulation?: BankIdentificationToEntityWealthAccumulationResolver<TParent>;
  hasDividendsIncome?: BankIdentificationToHasDividendsIncomeResolver<TParent>;
  hasMacAccount?: BankIdentificationToHasMacAccountResolver<TParent>;
  id?: BankIdentificationToIdResolver<TParent>;
  identificationHistory?: BankIdentificationToIdentificationHistoryResolver<TParent>;
  identificationIndustry?: BankIdentificationToIdentificationIndustryResolver<TParent>;
  individuals?: BankIdentificationToIndividualsResolver<TParent>;
  industryAdditionalDetails?: BankIdentificationToIndustryAdditionalDetailsResolver<TParent>;
  macAccountName?: BankIdentificationToMacAccountNameResolver<TParent>;
  macAccountNumber?: BankIdentificationToMacAccountNumberResolver<TParent>;
  organisation?: BankIdentificationToOrganisationResolver<TParent>;
  organisationId?: BankIdentificationToOrganisationIdResolver<TParent>;
  postalAddress?: BankIdentificationToPostalAddressResolver<TParent>;
  riskDetails?: BankIdentificationToRiskDetailsResolver<TParent>;
  riskDetailsCreatedAt?: BankIdentificationToRiskDetailsCreatedAtResolver<TParent>;
  riskDetailsCreatedBy?: BankIdentificationToRiskDetailsCreatedByResolver<TParent>;
  riskStatus?: BankIdentificationToRiskStatusResolver<TParent>;
  simpleKycDataId?: BankIdentificationToSimpleKycDataIdResolver<TParent>;
  simpleKycDataRecord?: BankIdentificationToSimpleKycDataRecordResolver<TParent>;
  step?: BankIdentificationToStepResolver<TParent>;
  taxExemptionDetails?: BankIdentificationToTaxExemptionDetailsResolver<TParent>;
  taxExemptionType?: BankIdentificationToTaxExemptionTypeResolver<TParent>;
  taxStatus?: BankIdentificationToTaxStatusResolver<TParent>;
  userId?: BankIdentificationToUserIdResolver<TParent>;
}

export interface BankIdentificationToAdminStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToClientStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToClientVerificationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsACNResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsHasBeneficialOwnersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsIsListedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsIsNormalTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsIsRegulatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsIsSubsidiaryListedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsListedExchangeNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsNatureOfBusinessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsOnlyOperatesInAustraliaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsPrincipalPlaceOfBusinessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsRegisteredAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsRegulatorLicenseNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsRegulatorNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsSubsidiaryListedCompanyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsSubsidiaryListedExchangeNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxFatcaStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxFatcaStatusOtherResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxForeignResidentCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxGIINResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxHasBeneficialOwnerForeignResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxHasGIINResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxIsForeignResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCompanyDetailsTaxTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToDataTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToEntityTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToEntityWealthAccumulationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToHasDividendsIncomeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToHasMacAccountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToIdentificationHistoryArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  order_by?: IdentificationHistorySort;
}
export interface BankIdentificationToIdentificationHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankIdentificationToIdentificationHistoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToIdentificationIndustryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToIndividualsArgs {
  where?: IdentificationIndividualFilter;
}
export interface BankIdentificationToIndividualsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankIdentificationToIndividualsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToIndustryAdditionalDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToMacAccountNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToMacAccountNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToPostalAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToRiskDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToRiskDetailsCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToRiskDetailsCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToRiskStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToSimpleKycDataIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToSimpleKycDataRecordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToStepResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToTaxExemptionDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToTaxExemptionTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToTaxStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankIdentificationToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryConnectionTypeResolver<TParent = any> {
  edges?: IdentificationHistoryConnectionToEdgesResolver<TParent>;
  nodes?: IdentificationHistoryConnectionToNodesResolver<TParent>;
  pageInfo?: IdentificationHistoryConnectionToPageInfoResolver<TParent>;
  totalCount?: IdentificationHistoryConnectionToTotalCountResolver<TParent>;
}

export interface IdentificationHistoryConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryEdgeTypeResolver<TParent = any> {
  cursor?: IdentificationHistoryEdgeToCursorResolver<TParent>;
  node?: IdentificationHistoryEdgeToNodeResolver<TParent>;
}

export interface IdentificationHistoryEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryTypeResolver<TParent = any> {
  changeSetId?: IdentificationHistoryToChangeSetIdResolver<TParent>;
  changeType?: IdentificationHistoryToChangeTypeResolver<TParent>;
  changes?: IdentificationHistoryToChangesResolver<TParent>;
  id?: IdentificationHistoryToIdResolver<TParent>;
  objectType?: IdentificationHistoryToObjectTypeResolver<TParent>;
  recordName?: IdentificationHistoryToRecordNameResolver<TParent>;
  triggeredAt?: IdentificationHistoryToTriggeredAtResolver<TParent>;
  triggeredBy?: IdentificationHistoryToTriggeredByResolver<TParent>;
}

export interface IdentificationHistoryToChangeSetIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToChangeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToChangesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToObjectTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToRecordNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToTriggeredAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryToTriggeredByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryChangeTypeResolver<TParent = any> {
  field?: IdentificationHistoryChangeToFieldResolver<TParent>;
  label?: IdentificationHistoryChangeToLabelResolver<TParent>;
  newDisplayValue?: IdentificationHistoryChangeToNewDisplayValueResolver<TParent>;
  newValue?: IdentificationHistoryChangeToNewValueResolver<TParent>;
  oldDisplayValue?: IdentificationHistoryChangeToOldDisplayValueResolver<TParent>;
  oldValue?: IdentificationHistoryChangeToOldValueResolver<TParent>;
}

export interface IdentificationHistoryChangeToFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryChangeToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryChangeToNewDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryChangeToNewValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryChangeToOldDisplayValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationHistoryChangeToOldValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationAuthorTypeResolver<TParent = any> {
  familyName?: IdentificationAuthorToFamilyNameResolver<TParent>;
  givenName?: IdentificationAuthorToGivenNameResolver<TParent>;
  isBankAuthor?: IdentificationAuthorToIsBankAuthorResolver<TParent>;
}

export interface IdentificationAuthorToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationAuthorToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface IdentificationAuthorToIsBankAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsConnectionTypeResolver<TParent = any> {
  edges?: ImportJobsConnectionToEdgesResolver<TParent>;
  nodes?: ImportJobsConnectionToNodesResolver<TParent>;
  pageInfo?: ImportJobsConnectionToPageInfoResolver<TParent>;
  totalCount?: ImportJobsConnectionToTotalCountResolver<TParent>;
}

export interface ImportJobsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsEdgeTypeResolver<TParent = any> {
  cursor?: ImportJobsEdgeToCursorResolver<TParent>;
  node?: ImportJobsEdgeToNodeResolver<TParent>;
}

export interface ImportJobsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobTypeResolver<TParent = any> {
  createdAt?: ImportJobToCreatedAtResolver<TParent>;
  errors?: ImportJobToErrorsResolver<TParent>;
  files?: ImportJobToFilesResolver<TParent>;
  id?: ImportJobToIdResolver<TParent>;
  items?: ImportJobToItemsResolver<TParent>;
  recordsFailed?: ImportJobToRecordsFailedResolver<TParent>;
  recordsProcessed?: ImportJobToRecordsProcessedResolver<TParent>;
  status?: ImportJobToStatusResolver<TParent>;
}

export interface ImportJobToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToErrorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToRecordsFailedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToRecordsProcessedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileTypeResolver<TParent = any> {
  contentMd5Checksum?: ImportFileToContentMd5ChecksumResolver<TParent>;
  contentType?: ImportFileToContentTypeResolver<TParent>;
  downloadPresignedUrl?: ImportFileToDownloadPresignedUrlResolver<TParent>;
  fileName?: ImportFileToFileNameResolver<TParent>;
  id?: ImportFileToIdResolver<TParent>;
  received?: ImportFileToReceivedResolver<TParent>;
  uploadPresignedUrl?: ImportFileToUploadPresignedUrlResolver<TParent>;
}

export interface ImportFileToContentMd5ChecksumResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileToContentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileToDownloadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileToFileNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileToReceivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportFileToUploadPresignedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportItemTypeResolver<TParent = any> {
  errors?: ImportItemToErrorsResolver<TParent>;
  rowNumber?: ImportItemToRowNumberResolver<TParent>;
}

export interface ImportItemToErrorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportItemToRowNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: ImportJobsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: ImportJobsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: ImportJobsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: ImportJobsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface ImportJobsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: ImportJobsForBankPortalEdgeToCursorResolver<TParent>;
  node?: ImportJobsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface ImportJobsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportJobsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicesForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: InvoicesForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: InvoicesForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: InvoicesForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: InvoicesForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface InvoicesForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicesForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicesForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicesForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicesForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: InvoicesForBankPortalEdgeToCursorResolver<TParent>;
  node?: InvoicesForBankPortalEdgeToNodeResolver<TParent>;
}

export interface InvoicesForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoicesForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceTypeResolver<TParent = any> {
  canGenerateHostedInvoice?: BankInvoiceToCanGenerateHostedInvoiceResolver<TParent>;
  createdAt?: BankInvoiceToCreatedAtResolver<TParent>;
  depositReferenceNumber?: BankInvoiceToDepositReferenceNumberResolver<TParent>;
  draft?: BankInvoiceToDraftResolver<TParent>;
  draftId?: BankInvoiceToDraftIdResolver<TParent>;
  hostedInvoiceAttachmentId?: BankInvoiceToHostedInvoiceAttachmentIdResolver<TParent>;
  hostedReceiptAttachmentId?: BankInvoiceToHostedReceiptAttachmentIdResolver<TParent>;
  id?: BankInvoiceToIdResolver<TParent>;
  invoicePaymentIntents?: BankInvoiceToInvoicePaymentIntentsResolver<TParent>;
  stripeInvoiceHostedUrl?: BankInvoiceToStripeInvoiceHostedUrlResolver<TParent>;
  stripeInvoiceId?: BankInvoiceToStripeInvoiceIdResolver<TParent>;
  stripeInvoicePdf?: BankInvoiceToStripeInvoicePdfResolver<TParent>;
  stripeInvoiceStatus?: BankInvoiceToStripeInvoiceStatusResolver<TParent>;
  stripeReceiptUrl?: BankInvoiceToStripeReceiptUrlResolver<TParent>;
  sumSubscriptionAmount?: BankInvoiceToSumSubscriptionAmountResolver<TParent>;
  total?: BankInvoiceToTotalResolver<TParent>;
}

export interface BankInvoiceToCanGenerateHostedInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToDepositReferenceNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToDraftArgs {
  where?: BankDraftFilter;
}
export interface BankInvoiceToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BankInvoiceToDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToHostedInvoiceAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToHostedReceiptAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToInvoicePaymentIntentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToStripeInvoiceHostedUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToStripeInvoiceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToStripeInvoicePdfResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToStripeInvoiceStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToStripeReceiptUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToSumSubscriptionAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankInvoiceToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartLifetimeProjectedValueDetailsTypeResolver<TParent = any> {
  lifetimeAmount?: ChartLifetimeProjectedValueDetailsToLifetimeAmountResolver<TParent>;
}

export interface ChartLifetimeProjectedValueDetailsToLifetimeAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankAssetTypeResolver<TParent = any> {
  assetType?: BankAssetToAssetTypeResolver<TParent>;
  name?: BankAssetToNameResolver<TParent>;
}

export interface BankAssetToAssetTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankAssetToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileTypeResolver<TParent = any> {
  address?: ProfileToAddressResolver<TParent>;
  createdAt?: ProfileToCreatedAtResolver<TParent>;
  email?: ProfileToEmailResolver<TParent>;
  familyName?: ProfileToFamilyNameResolver<TParent>;
  givenName?: ProfileToGivenNameResolver<TParent>;
  id?: ProfileToIdResolver<TParent>;
  industry?: ProfileToIndustryResolver<TParent>;
  intercomIdentityEmailHash?: ProfileToIntercomIdentityEmailHashResolver<TParent>;
  invitations?: ProfileToInvitationsResolver<TParent>;
  jobTitle?: ProfileToJobTitleResolver<TParent>;
  locale?: ProfileToLocaleResolver<TParent>;
  phoneNumber?: ProfileToPhoneNumberResolver<TParent>;
  referralPortalReferrerMemberCode?: ProfileToReferralPortalReferrerMemberCodeResolver<TParent>;
  referrerCode?: ProfileToReferrerCodeResolver<TParent>;
  requireTermsAcceptance?: ProfileToRequireTermsAcceptanceResolver<TParent>;
  timezone?: ProfileToTimezoneResolver<TParent>;
  updatesNotifiedAt?: ProfileToUpdatesNotifiedAtResolver<TParent>;
}

export interface ProfileToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToIndustryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToIntercomIdentityEmailHashResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToInvitationsArgs {
  after?: string;
  before?: string;
  first?: PaginationAmount;
  last?: PaginationAmount;
  where?: InvitationFilter;
}
export interface ProfileToInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ProfileToInvitationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToJobTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToLocaleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToReferralPortalReferrerMemberCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToReferrerCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToRequireTermsAcceptanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToTimezoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToUpdatesNotifiedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationsConnectionTypeResolver<TParent = any> {
  edges?: InvitationsConnectionToEdgesResolver<TParent>;
  nodes?: InvitationsConnectionToNodesResolver<TParent>;
  pageInfo?: InvitationsConnectionToPageInfoResolver<TParent>;
  totalCount?: InvitationsConnectionToTotalCountResolver<TParent>;
}

export interface InvitationsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationsEdgeTypeResolver<TParent = any> {
  cursor?: InvitationsEdgeToCursorResolver<TParent>;
  node?: InvitationsEdgeToNodeResolver<TParent>;
}

export interface InvitationsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationInvitationTypeResolver<TParent = any> {
  code?: OrganisationInvitationToCodeResolver<TParent>;
  createdAt?: OrganisationInvitationToCreatedAtResolver<TParent>;
  invitedBy?: OrganisationInvitationToInvitedByResolver<TParent>;
  invitedTo?: OrganisationInvitationToInvitedToResolver<TParent>;
  organisationId?: OrganisationInvitationToOrganisationIdResolver<TParent>;
  role?: OrganisationInvitationToRoleResolver<TParent>;
}

export interface OrganisationInvitationToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationInvitationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationInvitationToInvitedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationInvitationToInvitedToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationInvitationToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationInvitationToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationsConnectionTypeResolver<TParent = any> {
  edges?: OrganisationsConnectionToEdgesResolver<TParent>;
  nodes?: OrganisationsConnectionToNodesResolver<TParent>;
  pageInfo?: OrganisationsConnectionToPageInfoResolver<TParent>;
  totalCount?: OrganisationsConnectionToTotalCountResolver<TParent>;
}

export interface OrganisationsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationsEdgeTypeResolver<TParent = any> {
  cursor?: OrganisationsEdgeToCursorResolver<TParent>;
  node?: OrganisationsEdgeToNodeResolver<TParent>;
}

export interface OrganisationsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductSummaryTypeResolver<TParent = any> {
  feeSummary?: ProductSummaryToFeeSummaryResolver<TParent>;
  productDiscount?: ProductSummaryToProductDiscountResolver<TParent>;
  referralDiscount?: ProductSummaryToReferralDiscountResolver<TParent>;
}

export interface ProductSummaryToFeeSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductSummaryToProductDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductSummaryToReferralDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductDiscountTypeResolver<TParent = any> {
  channelPartnerId?: ProductDiscountToChannelPartnerIdResolver<TParent>;
  discountLabel?: ProductDiscountToDiscountLabelResolver<TParent>;
  discountProviderType?: ProductDiscountToDiscountProviderTypeResolver<TParent>;
  discountType?: ProductDiscountToDiscountTypeResolver<TParent>;
  providerName?: ProductDiscountToProviderNameResolver<TParent>;
  value?: ProductDiscountToValueResolver<TParent>;
}

export interface ProductDiscountToChannelPartnerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductDiscountToDiscountLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductDiscountToDiscountProviderTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductDiscountToDiscountTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductDiscountToProviderNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProductDiscountToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralConfigurationTypeResolver<TParent = any> {
  refereeDiscountAmountInDollars?: ReferralConfigurationToRefereeDiscountAmountInDollarsResolver<TParent>;
  referrerDiscountAmountInDollars?: ReferralConfigurationToReferrerDiscountAmountInDollarsResolver<TParent>;
}

export interface ReferralConfigurationToRefereeDiscountAmountInDollarsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralConfigurationToReferrerDiscountAmountInDollarsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralCommissionTierTypeResolver<TParent = any> {
  commissionAmount?: ReferralCommissionTierToCommissionAmountResolver<TParent>;
  minValue?: ReferralCommissionTierToMinValueResolver<TParent>;
}

export interface ReferralCommissionTierToCommissionAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralCommissionTierToMinValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalDealsConnectionTypeResolver<TParent = any> {
  edges?: ReferralPortalDealsConnectionToEdgesResolver<TParent>;
  nodes?: ReferralPortalDealsConnectionToNodesResolver<TParent>;
  pageInfo?: ReferralPortalDealsConnectionToPageInfoResolver<TParent>;
  totalCount?: ReferralPortalDealsConnectionToTotalCountResolver<TParent>;
}

export interface ReferralPortalDealsConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalDealsConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalDealsConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalDealsConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalDealsEdgeTypeResolver<TParent = any> {
  cursor?: ReferralPortalDealsEdgeToCursorResolver<TParent>;
  node?: ReferralPortalDealsEdgeToNodeResolver<TParent>;
}

export interface ReferralPortalDealsEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalDealsEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesConnectionTypeResolver<TParent = any> {
  edges?: ReferralPortalEntitiesConnectionToEdgesResolver<TParent>;
  nodes?: ReferralPortalEntitiesConnectionToNodesResolver<TParent>;
  pageInfo?: ReferralPortalEntitiesConnectionToPageInfoResolver<TParent>;
  totalCount?: ReferralPortalEntitiesConnectionToTotalCountResolver<TParent>;
}

export interface ReferralPortalEntitiesConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesEdgeTypeResolver<TParent = any> {
  cursor?: ReferralPortalEntitiesEdgeToCursorResolver<TParent>;
  node?: ReferralPortalEntitiesEdgeToNodeResolver<TParent>;
}

export interface ReferralPortalEntitiesEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesForClientPortalConnectionTypeResolver<TParent = any> {
  edges?: ReferralPortalEntitiesForClientPortalConnectionToEdgesResolver<TParent>;
  nodes?: ReferralPortalEntitiesForClientPortalConnectionToNodesResolver<TParent>;
  pageInfo?: ReferralPortalEntitiesForClientPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: ReferralPortalEntitiesForClientPortalConnectionToTotalCountResolver<TParent>;
}

export interface ReferralPortalEntitiesForClientPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesForClientPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesForClientPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesForClientPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesForClientPortalEdgeTypeResolver<TParent = any> {
  cursor?: ReferralPortalEntitiesForClientPortalEdgeToCursorResolver<TParent>;
  node?: ReferralPortalEntitiesForClientPortalEdgeToNodeResolver<TParent>;
}

export interface ReferralPortalEntitiesForClientPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalEntitiesForClientPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMembersConnectionTypeResolver<TParent = any> {
  edges?: ReferralPortalMembersConnectionToEdgesResolver<TParent>;
  nodes?: ReferralPortalMembersConnectionToNodesResolver<TParent>;
  pageInfo?: ReferralPortalMembersConnectionToPageInfoResolver<TParent>;
  totalCount?: ReferralPortalMembersConnectionToTotalCountResolver<TParent>;
}

export interface ReferralPortalMembersConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMembersConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMembersConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMembersConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMembersEdgeTypeResolver<TParent = any> {
  cursor?: ReferralPortalMembersEdgeToCursorResolver<TParent>;
  node?: ReferralPortalMembersEdgeToNodeResolver<TParent>;
}

export interface ReferralPortalMembersEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralPortalMembersEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationMembersConnectionTypeResolver<TParent = any> {
  edges?: SearchOrganisationMembersConnectionToEdgesResolver<TParent>;
  nodes?: SearchOrganisationMembersConnectionToNodesResolver<TParent>;
  pageInfo?: SearchOrganisationMembersConnectionToPageInfoResolver<TParent>;
  totalCount?: SearchOrganisationMembersConnectionToTotalCountResolver<TParent>;
}

export interface SearchOrganisationMembersConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationMembersConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationMembersConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationMembersConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationMembersEdgeTypeResolver<TParent = any> {
  cursor?: SearchOrganisationMembersEdgeToCursorResolver<TParent>;
  node?: SearchOrganisationMembersEdgeToNodeResolver<TParent>;
}

export interface SearchOrganisationMembersEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationMembersEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationMemberTypeResolver<TParent = any> {
  createdAt?: OrganisationMemberToCreatedAtResolver<TParent>;
  familyName?: OrganisationMemberToFamilyNameResolver<TParent>;
  givenName?: OrganisationMemberToGivenNameResolver<TParent>;
  memberId?: OrganisationMemberToMemberIdResolver<TParent>;
  role?: OrganisationMemberToRoleResolver<TParent>;
  userId?: OrganisationMemberToUserIdResolver<TParent>;
}

export interface OrganisationMemberToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationMemberToFamilyNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationMemberToGivenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationMemberToMemberIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationMemberToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationMemberToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationsForMembersForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: SearchOrganisationsForMembersForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: SearchOrganisationsForMembersForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: SearchOrganisationsForMembersForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: SearchOrganisationsForMembersForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface SearchOrganisationsForMembersForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationsForMembersForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationsForMembersForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationsForMembersForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationsForMembersForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: SearchOrganisationsForMembersForBankPortalEdgeToCursorResolver<TParent>;
  node?: SearchOrganisationsForMembersForBankPortalEdgeToNodeResolver<TParent>;
}

export interface SearchOrganisationsForMembersForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchOrganisationsForMembersForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceDataTypeTypeResolver<TParent = any> {
  description?: ReferenceDataTypeToDescriptionResolver<TParent>;
  id?: ReferenceDataTypeToIdResolver<TParent>;
  key?: ReferenceDataTypeToKeyResolver<TParent>;
}

export interface ReferenceDataTypeToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceDataTypeToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceDataTypeToKeyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartTotalActiveDetailsTypeResolver<TParent = any> {
  activeAmount?: ChartTotalActiveDetailsToActiveAmountResolver<TParent>;
  activeClientsNumber?: ChartTotalActiveDetailsToActiveClientsNumberResolver<TParent>;
  activeDocumentsNumber?: ChartTotalActiveDetailsToActiveDocumentsNumberResolver<TParent>;
  totalAmount?: ChartTotalActiveDetailsToTotalAmountResolver<TParent>;
  totalClientsNumber?: ChartTotalActiveDetailsToTotalClientsNumberResolver<TParent>;
  totalDocumentsNumber?: ChartTotalActiveDetailsToTotalDocumentsNumberResolver<TParent>;
}

export interface ChartTotalActiveDetailsToActiveAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartTotalActiveDetailsToActiveClientsNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartTotalActiveDetailsToActiveDocumentsNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartTotalActiveDetailsToTotalAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartTotalActiveDetailsToTotalClientsNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartTotalActiveDetailsToTotalDocumentsNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubmissionValidationResultTypeResolver<TParent = any> {
  errorLevel?: SubmissionValidationResultToErrorLevelResolver<TParent>;
  message?: SubmissionValidationResultToMessageResolver<TParent>;
}

export interface SubmissionValidationResultToErrorLevelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubmissionValidationResultToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookResultsForBankPortalConnectionTypeResolver<TParent = any> {
  edges?: WebhookResultsForBankPortalConnectionToEdgesResolver<TParent>;
  nodes?: WebhookResultsForBankPortalConnectionToNodesResolver<TParent>;
  pageInfo?: WebhookResultsForBankPortalConnectionToPageInfoResolver<TParent>;
  totalCount?: WebhookResultsForBankPortalConnectionToTotalCountResolver<TParent>;
}

export interface WebhookResultsForBankPortalConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookResultsForBankPortalConnectionToNodesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookResultsForBankPortalConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookResultsForBankPortalConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookResultsForBankPortalEdgeTypeResolver<TParent = any> {
  cursor?: WebhookResultsForBankPortalEdgeToCursorResolver<TParent>;
  node?: WebhookResultsForBankPortalEdgeToNodeResolver<TParent>;
}

export interface WebhookResultsForBankPortalEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WebhookResultsForBankPortalEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultTypeResolver<TParent = any> {
  createdAt?: ApiWebhookResultToCreatedAtResolver<TParent>;
  id?: ApiWebhookResultToIdResolver<TParent>;
  originationId?: ApiWebhookResultToOriginationIdResolver<TParent>;
  requestData?: ApiWebhookResultToRequestDataResolver<TParent>;
  requestType?: ApiWebhookResultToRequestTypeResolver<TParent>;
  responseCode?: ApiWebhookResultToResponseCodeResolver<TParent>;
  responseData?: ApiWebhookResultToResponseDataResolver<TParent>;
}

export interface ApiWebhookResultToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultToOriginationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultToRequestDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultToRequestTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultToResponseCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ApiWebhookResultToResponseDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationTypeResolver<TParent = any> {
  acceptInvitation?: MutationToAcceptInvitationResolver<TParent>;
  actionRequiredDocumentMessage?: MutationToActionRequiredDocumentMessageResolver<TParent>;
  actionRequiredDocumentMessageForBankPortal?: MutationToActionRequiredDocumentMessageForBankPortalResolver<TParent>;
  addChannelPartnerForBankPortal?: MutationToAddChannelPartnerForBankPortalResolver<TParent>;
  amendDocument?: MutationToAmendDocumentResolver<TParent>;
  beginDraftSubmission?: MutationToBeginDraftSubmissionResolver<TParent>;
  cancelDraft?: MutationToCancelDraftResolver<TParent>;
  cancelDraftSubmission?: MutationToCancelDraftSubmissionResolver<TParent>;
  changeFacilityApplicationStatus?: MutationToChangeFacilityApplicationStatusResolver<TParent>;
  changeMemberRole?: MutationToChangeMemberRoleResolver<TParent>;
  clientNotInterestedInFinance?: MutationToClientNotInterestedInFinanceResolver<TParent>;
  cognitoAddBankUser?: MutationToCognitoAddBankUserResolver<TParent>;
  cognitoDeleteBankUser?: MutationToCognitoDeleteBankUserResolver<TParent>;
  cognitoResyncBankUser?: MutationToCognitoResyncBankUserResolver<TParent>;
  cognitoUpdateAuthenticatedBankUser?: MutationToCognitoUpdateAuthenticatedBankUserResolver<TParent>;
  cognitoUpdateBankUser?: MutationToCognitoUpdateBankUserResolver<TParent>;
  completeDraftSubmission?: MutationToCompleteDraftSubmissionResolver<TParent>;
  completeIdentification?: MutationToCompleteIdentificationResolver<TParent>;
  completeSuretyBondDraftSubmission?: MutationToCompleteSuretyBondDraftSubmissionResolver<TParent>;
  confirmDocumentHandover?: MutationToConfirmDocumentHandoverResolver<TParent>;
  convertDocumentFacilityForBankPortal?: MutationToConvertDocumentFacilityForBankPortalResolver<TParent>;
  copyDraftForBankPortal?: MutationToCopyDraftForBankPortalResolver<TParent>;
  createComment?: MutationToCreateCommentResolver<TParent>;
  createDocument?: MutationToCreateDocumentResolver<TParent>;
  createDocumentAttachment?: MutationToCreateDocumentAttachmentResolver<TParent>;
  createDocumentCollaborator?: MutationToCreateDocumentCollaboratorResolver<TParent>;
  createDocumentFacility?: MutationToCreateDocumentFacilityResolver<TParent>;
  createDocumentHandover?: MutationToCreateDocumentHandoverResolver<TParent>;
  createDocumentMetadata?: MutationToCreateDocumentMetadataResolver<TParent>;
  createDocumentRequestForReturn?: MutationToCreateDocumentRequestForReturnResolver<TParent>;
  createDraft?: MutationToCreateDraftResolver<TParent>;
  createDraftAttachment?: MutationToCreateDraftAttachmentResolver<TParent>;
  createDraftAttachmentForBankPortal?: MutationToCreateDraftAttachmentForBankPortalResolver<TParent>;
  createDraftBGSwitch?: MutationToCreateDraftBGSwitchResolver<TParent>;
  createDraftCollaborator?: MutationToCreateDraftCollaboratorResolver<TParent>;
  createDraftComment?: MutationToCreateDraftCommentResolver<TParent>;
  createDraftFromOrigination?: MutationToCreateDraftFromOriginationResolver<TParent>;
  createFacilityApplication?: MutationToCreateFacilityApplicationResolver<TParent>;
  createFacilityApplicationAttachment?: MutationToCreateFacilityApplicationAttachmentResolver<TParent>;
  createFinanceEnquiry?: MutationToCreateFinanceEnquiryResolver<TParent>;
  createFinanceRecordForBankPortal?: MutationToCreateFinanceRecordForBankPortalResolver<TParent>;
  createImportJob?: MutationToCreateImportJobResolver<TParent>;
  createOrReplaceBankAsset?: MutationToCreateOrReplaceBankAssetResolver<TParent>;
  createOrUpdateFeeSummary?: MutationToCreateOrUpdateFeeSummaryResolver<TParent>;
  createOrUpdateSupplier?: MutationToCreateOrUpdateSupplierResolver<TParent>;
  createOrganisation?: MutationToCreateOrganisationResolver<TParent>;
  createOrganisationAlertConfiguration?: MutationToCreateOrganisationAlertConfigurationResolver<TParent>;
  createOrganisationDocumentMetadata?: MutationToCreateOrganisationDocumentMetadataResolver<TParent>;
  createRequiredDocumentForBankPortal?: MutationToCreateRequiredDocumentForBankPortalResolver<TParent>;
  createRequiredDocumentMessage?: MutationToCreateRequiredDocumentMessageResolver<TParent>;
  createRequiredDocumentMessageForBankPortal?: MutationToCreateRequiredDocumentMessageForBankPortalResolver<TParent>;
  createSimpleKycDataByIdentificationIdForBankPortal?: MutationToCreateSimpleKycDataByIdentificationIdForBankPortalResolver<TParent>;
  deleteBankAsset?: MutationToDeleteBankAssetResolver<TParent>;
  deleteFinanceRecordFromBankPortal?: MutationToDeleteFinanceRecordFromBankPortalResolver<TParent>;
  editFinanceRecordForBankPortal?: MutationToEditFinanceRecordForBankPortalResolver<TParent>;
  establishDraft?: MutationToEstablishDraftResolver<TParent>;
  establishSuretyBondDraft?: MutationToEstablishSuretyBondDraftResolver<TParent>;
  fixAddressV2?: MutationToFixAddressV2Resolver<TParent>;
  generateDocumentReport?: MutationToGenerateDocumentReportResolver<TParent>;
  generateNewIndividualVerificationUrl?: MutationToGenerateNewIndividualVerificationUrlResolver<TParent>;
  generateNewStripeSubscription?: MutationToGenerateNewStripeSubscriptionResolver<TParent>;
  generateNewStripeSubscriptionForBankPortal?: MutationToGenerateNewStripeSubscriptionForBankPortalResolver<TParent>;
  importAllExistingSimpleKycApplications?: MutationToImportAllExistingSimpleKycApplicationsResolver<TParent>;
  invalidateAssetCache?: MutationToInvalidateAssetCacheResolver<TParent>;
  onceOffDocumentDescriptionMigration?: MutationToOnceOffDocumentDescriptionMigrationResolver<TParent>;
  onceOffDraftDescriptionMigration?: MutationToOnceOffDraftDescriptionMigrationResolver<TParent>;
  optInOrganisationToDocumentFacilities?: MutationToOptInOrganisationToDocumentFacilitiesResolver<TParent>;
  prefillIdentification?: MutationToPrefillIdentificationResolver<TParent>;
  profileTermsAccepted?: MutationToProfileTermsAcceptedResolver<TParent>;
  reactivateSubscription?: MutationToReactivateSubscriptionResolver<TParent>;
  reestablishBankDocument?: MutationToReestablishBankDocumentResolver<TParent>;
  referralPortalCreateEntity?: MutationToReferralPortalCreateEntityResolver<TParent>;
  referralPortalCreateMember?: MutationToReferralPortalCreateMemberResolver<TParent>;
  referralPortalDeleteMember?: MutationToReferralPortalDeleteMemberResolver<TParent>;
  referralPortalResendInvitation?: MutationToReferralPortalResendInvitationResolver<TParent>;
  referralPortalSetOrganisationAssociation?: MutationToReferralPortalSetOrganisationAssociationResolver<TParent>;
  referralPortalUpdateEntity?: MutationToReferralPortalUpdateEntityResolver<TParent>;
  referralPortalUpdateMember?: MutationToReferralPortalUpdateMemberResolver<TParent>;
  rejectDraft?: MutationToRejectDraftResolver<TParent>;
  removeDocumentAttachment?: MutationToRemoveDocumentAttachmentResolver<TParent>;
  removeDocumentCollaborator?: MutationToRemoveDocumentCollaboratorResolver<TParent>;
  removeDocumentHandover?: MutationToRemoveDocumentHandoverResolver<TParent>;
  removeDocumentMetadata?: MutationToRemoveDocumentMetadataResolver<TParent>;
  removeDocumentRequestForReturn?: MutationToRemoveDocumentRequestForReturnResolver<TParent>;
  removeDraftAttachment?: MutationToRemoveDraftAttachmentResolver<TParent>;
  removeDraftAttachmentForBankPortal?: MutationToRemoveDraftAttachmentForBankPortalResolver<TParent>;
  removeDraftCollaborator?: MutationToRemoveDraftCollaboratorResolver<TParent>;
  removeFacilityApplicationAttachment?: MutationToRemoveFacilityApplicationAttachmentResolver<TParent>;
  removeInvitation?: MutationToRemoveInvitationResolver<TParent>;
  removeMember?: MutationToRemoveMemberResolver<TParent>;
  removeMemberForBankPortal?: MutationToRemoveMemberForBankPortalResolver<TParent>;
  removeOrgMemberInvitationForBankPortal?: MutationToRemoveOrgMemberInvitationForBankPortalResolver<TParent>;
  removeOrganisationAlertConfiguration?: MutationToRemoveOrganisationAlertConfigurationResolver<TParent>;
  removeOrganisationDocumentMetadata?: MutationToRemoveOrganisationDocumentMetadataResolver<TParent>;
  requestDraftChanges?: MutationToRequestDraftChangesResolver<TParent>;
  requestDraftPayment?: MutationToRequestDraftPaymentResolver<TParent>;
  resendInvoices?: MutationToResendInvoicesResolver<TParent>;
  resubmitReturnedGvpApplication?: MutationToResubmitReturnedGvpApplicationResolver<TParent>;
  sendOrgMemberInvitation?: MutationToSendOrgMemberInvitationResolver<TParent>;
  sendOrgMemberInvitationForBankPortal?: MutationToSendOrgMemberInvitationForBankPortalResolver<TParent>;
  setApplicationContactDetails?: MutationToSetApplicationContactDetailsResolver<TParent>;
  setApplicationContactDetailsForBankPortal?: MutationToSetApplicationContactDetailsForBankPortalResolver<TParent>;
  setDocumentNotificationList?: MutationToSetDocumentNotificationListResolver<TParent>;
  setDraftApprovalStatusForCollaborator?: MutationToSetDraftApprovalStatusForCollaboratorResolver<TParent>;
  setDraftAvailableToSupplier?: MutationToSetDraftAvailableToSupplierResolver<TParent>;
  setDraftAvailableToSupplier_preValidation?: MutationToSetDraftAvailableToSupplier_preValidationResolver<TParent>;
  setDraftNotificationListForCollaborator?: MutationToSetDraftNotificationListForCollaboratorResolver<TParent>;
  setDraftRealtimeAuthorState?: MutationToSetDraftRealtimeAuthorStateResolver<TParent>;
  setFacilityApplicationAvailableToSupplier?: MutationToSetFacilityApplicationAvailableToSupplierResolver<TParent>;
  setFacilityApplicationBankOutcome?: MutationToSetFacilityApplicationBankOutcomeResolver<TParent>;
  setOrganisationGvpMetadata?: MutationToSetOrganisationGvpMetadataResolver<TParent>;
  shareDraftToOrganisationFromCollaborator?: MutationToShareDraftToOrganisationFromCollaboratorResolver<TParent>;
  submitApplicationToGvp?: MutationToSubmitApplicationToGvpResolver<TParent>;
  submitFacilityApplication?: MutationToSubmitFacilityApplicationResolver<TParent>;
  updateBankDocument?: MutationToUpdateBankDocumentResolver<TParent>;
  updateChannelPartnerForBankPortal?: MutationToUpdateChannelPartnerForBankPortalResolver<TParent>;
  updateDocument?: MutationToUpdateDocumentResolver<TParent>;
  updateDocumentFacility?: MutationToUpdateDocumentFacilityResolver<TParent>;
  updateDocumentFacilityForBankPortal?: MutationToUpdateDocumentFacilityForBankPortalResolver<TParent>;
  updateDocumentMetadata?: MutationToUpdateDocumentMetadataResolver<TParent>;
  updateDraft?: MutationToUpdateDraftResolver<TParent>;
  updateDraftBGSwitch?: MutationToUpdateDraftBGSwitchResolver<TParent>;
  updateDraftBGSwitchForBankPortal?: MutationToUpdateDraftBGSwitchForBankPortalResolver<TParent>;
  updateDraftCollaborator?: MutationToUpdateDraftCollaboratorResolver<TParent>;
  updateDraftForBankPortal?: MutationToUpdateDraftForBankPortalResolver<TParent>;
  updateDraftMegDetails?: MutationToUpdateDraftMegDetailsResolver<TParent>;
  updateDraftPreview?: MutationToUpdateDraftPreviewResolver<TParent>;
  updateFacilityApplication?: MutationToUpdateFacilityApplicationResolver<TParent>;
  updateFacilityApplicationForBankPortal?: MutationToUpdateFacilityApplicationForBankPortalResolver<TParent>;
  updateFacilityApplicationPaymentStatus?: MutationToUpdateFacilityApplicationPaymentStatusResolver<TParent>;
  updateGreenId?: MutationToUpdateGreenIdResolver<TParent>;
  updateGreenIdForBankPortal?: MutationToUpdateGreenIdForBankPortalResolver<TParent>;
  updateIdentification?: MutationToUpdateIdentificationResolver<TParent>;
  updateIdentificationForBankPortal?: MutationToUpdateIdentificationForBankPortalResolver<TParent>;
  updateIdentificationRiskDetailsForBankPortal?: MutationToUpdateIdentificationRiskDetailsForBankPortalResolver<TParent>;
  updateNotifiedAt?: MutationToUpdateNotifiedAtResolver<TParent>;
  updateOrganisation?: MutationToUpdateOrganisationResolver<TParent>;
  updateOrganisationAlertConfiguration?: MutationToUpdateOrganisationAlertConfigurationResolver<TParent>;
  updateOrganisationBankPortal?: MutationToUpdateOrganisationBankPortalResolver<TParent>;
  updateProfile?: MutationToUpdateProfileResolver<TParent>;
  updateSimpleKycDataFromApi?: MutationToUpdateSimpleKycDataFromApiResolver<TParent>;
  updateSimpleKycDataFromApiByIdentificationId?: MutationToUpdateSimpleKycDataFromApiByIdentificationIdResolver<TParent>;
  voidOrganisationCredit?: MutationToVoidOrganisationCreditResolver<TParent>;
}

export interface MutationToAcceptInvitationArgs {
  input: AcceptInvitationInput;
}
export interface MutationToAcceptInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAcceptInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToActionRequiredDocumentMessageArgs {
  input: ActionRequiredDocumentMessageInput;
}
export interface MutationToActionRequiredDocumentMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToActionRequiredDocumentMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToActionRequiredDocumentMessageForBankPortalArgs {
  input: ActionRequiredDocumentMessageInput;
}
export interface MutationToActionRequiredDocumentMessageForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToActionRequiredDocumentMessageForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAddChannelPartnerForBankPortalArgs {
  input: MutateChannelPartnerInput;
}
export interface MutationToAddChannelPartnerForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAddChannelPartnerForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAmendDocumentArgs {
  input: AmendDocumentInput;
}
export interface MutationToAmendDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAmendDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToBeginDraftSubmissionArgs {
  input?: BeginDraftSubmissionInput;
}
export interface MutationToBeginDraftSubmissionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToBeginDraftSubmissionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCancelDraftArgs {
  input?: CancelDraftInput;
}
export interface MutationToCancelDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCancelDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCancelDraftSubmissionArgs {
  input?: CancelDraftSubmissionInput;
}
export interface MutationToCancelDraftSubmissionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCancelDraftSubmissionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToChangeFacilityApplicationStatusArgs {
  input: ChangeFacilityApplicationStatusInput;
}
export interface MutationToChangeFacilityApplicationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToChangeFacilityApplicationStatusArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToChangeMemberRoleArgs {
  input: ChangeMemberRoleInput;
}
export interface MutationToChangeMemberRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToChangeMemberRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToClientNotInterestedInFinanceArgs {
  draftId: string;
}
export interface MutationToClientNotInterestedInFinanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToClientNotInterestedInFinanceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCognitoAddBankUserArgs {
  user: CognitoUserInput;
}
export interface MutationToCognitoAddBankUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCognitoAddBankUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCognitoDeleteBankUserArgs {
  clientMutationId: string;
  userName: string;
}
export interface MutationToCognitoDeleteBankUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCognitoDeleteBankUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCognitoResyncBankUserArgs {
  clientMutationId: string;
}
export interface MutationToCognitoResyncBankUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCognitoResyncBankUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCognitoUpdateAuthenticatedBankUserArgs {
  request: AuthenticatedCognitoUserModificationRequestInput;
}
export interface MutationToCognitoUpdateAuthenticatedBankUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCognitoUpdateAuthenticatedBankUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCognitoUpdateBankUserArgs {
  user: CognitoUserInput;
}
export interface MutationToCognitoUpdateBankUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCognitoUpdateBankUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCompleteDraftSubmissionArgs {
  input?: CompleteDraftSubmissionInput;
}
export interface MutationToCompleteDraftSubmissionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCompleteDraftSubmissionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCompleteIdentificationArgs {
  clientMutationId: string;
  identificationId: string;
}
export interface MutationToCompleteIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCompleteIdentificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCompleteSuretyBondDraftSubmissionArgs {
  input?: CompleteSuretyBondDraftSubmissionInput;
}
export interface MutationToCompleteSuretyBondDraftSubmissionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCompleteSuretyBondDraftSubmissionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToConfirmDocumentHandoverArgs {
  input?: ConfirmDocumentHandoverInput;
}
export interface MutationToConfirmDocumentHandoverResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToConfirmDocumentHandoverArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToConvertDocumentFacilityForBankPortalArgs {
  input: ConvertDocumentFacilityForBankPortalInput;
}
export interface MutationToConvertDocumentFacilityForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToConvertDocumentFacilityForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCopyDraftForBankPortalArgs {
  input?: CopyDraftInput;
}
export interface MutationToCopyDraftForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCopyDraftForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommentArgs {
  input?: CreateCommentInput;
}
export interface MutationToCreateCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentArgs {
  input?: CreateDocumentInput;
}
export interface MutationToCreateDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentAttachmentArgs {
  input?: CreateDocumentAttachmentInput;
}
export interface MutationToCreateDocumentAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentAttachmentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentCollaboratorArgs {
  input?: CreateDocumentCollaboratorInput;
}
export interface MutationToCreateDocumentCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentFacilityArgs {
  input: CreateDocumentFacilityInput;
}
export interface MutationToCreateDocumentFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentFacilityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentHandoverArgs {
  input?: CreateDocumentHandoverInput;
}
export interface MutationToCreateDocumentHandoverResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentHandoverArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentMetadataArgs {
  input?: CreateDocumentMetadataInput;
}
export interface MutationToCreateDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentRequestForReturnArgs {
  input?: CreateDocumentRequestForReturnInput;
}
export interface MutationToCreateDocumentRequestForReturnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentRequestForReturnArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftArgs {
  input?: CreateDraftInput;
}
export interface MutationToCreateDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftAttachmentArgs {
  input?: CreateDraftAttachmentInput;
}
export interface MutationToCreateDraftAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftAttachmentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftAttachmentForBankPortalArgs {
  input?: CreateDraftAttachmentForBankPortalInput;
}
export interface MutationToCreateDraftAttachmentForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftAttachmentForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftBGSwitchArgs {
  input?: CreateDraftBGSwitchInput;
}
export interface MutationToCreateDraftBGSwitchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftBGSwitchArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftCollaboratorArgs {
  input?: CreateDraftCollaboratorInput;
}
export interface MutationToCreateDraftCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftCommentArgs {
  input?: CreateDraftCommentInput;
}
export interface MutationToCreateDraftCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDraftFromOriginationArgs {
  input?: CreateDraftFromOriginationInput;
}
export interface MutationToCreateDraftFromOriginationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDraftFromOriginationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFacilityApplicationArgs {
  input?: CreateFacilityApplicationInput;
}
export interface MutationToCreateFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFacilityApplicationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFacilityApplicationAttachmentArgs {
  input?: CreateFacilityApplicationAttachmentInput;
}
export interface MutationToCreateFacilityApplicationAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFacilityApplicationAttachmentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFinanceEnquiryArgs {
  financeEnquiry: FinanceEnquiryInput;
}
export interface MutationToCreateFinanceEnquiryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFinanceEnquiryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFinanceRecordForBankPortalArgs {
  input: FinanceRecordInput;
}
export interface MutationToCreateFinanceRecordForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFinanceRecordForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateImportJobArgs {
  input?: CreateImportJobInput;
}
export interface MutationToCreateImportJobResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateImportJobArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrReplaceBankAssetArgs {
  input: CreateOrReplaceBankAssetInput;
}
export interface MutationToCreateOrReplaceBankAssetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrReplaceBankAssetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrUpdateFeeSummaryArgs {
  input: CreateOrUpdateFeeSummaryInput;
}
export interface MutationToCreateOrUpdateFeeSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrUpdateFeeSummaryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrUpdateSupplierArgs {
  input: CreateOrUpdateSupplierInput;
}
export interface MutationToCreateOrUpdateSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrUpdateSupplierArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrganisationArgs {
  input: CreateOrganisationInput;
}
export interface MutationToCreateOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrganisationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrganisationAlertConfigurationArgs {
  input?: CreateOrganisationAlertConfigurationInput;
}
export interface MutationToCreateOrganisationAlertConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrganisationAlertConfigurationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrganisationDocumentMetadataArgs {
  input?: CreateOrganisationDocumentMetadataInput;
}
export interface MutationToCreateOrganisationDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrganisationDocumentMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateRequiredDocumentForBankPortalArgs {
  input: CreateRequiredDocumentForBankPortalInput;
}
export interface MutationToCreateRequiredDocumentForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateRequiredDocumentForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateRequiredDocumentMessageArgs {
  input: CreateRequiredDocumentMessageInput;
}
export interface MutationToCreateRequiredDocumentMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateRequiredDocumentMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateRequiredDocumentMessageForBankPortalArgs {
  input: CreateRequiredDocumentMessageInput;
}
export interface MutationToCreateRequiredDocumentMessageForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateRequiredDocumentMessageForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateSimpleKycDataByIdentificationIdForBankPortalArgs {
  input: CreateSimpleKycDataInput;
}
export interface MutationToCreateSimpleKycDataByIdentificationIdForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateSimpleKycDataByIdentificationIdForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteBankAssetArgs {
  input: DeleteBankAssetInput;
}
export interface MutationToDeleteBankAssetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteBankAssetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteFinanceRecordFromBankPortalArgs {
  id: string;
}
export interface MutationToDeleteFinanceRecordFromBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteFinanceRecordFromBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditFinanceRecordForBankPortalArgs {
  input: EditFinanceRecordInput;
}
export interface MutationToEditFinanceRecordForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditFinanceRecordForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEstablishDraftArgs {
  input: DraftEstablishInput;
}
export interface MutationToEstablishDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEstablishDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEstablishSuretyBondDraftArgs {
  input: DraftEstablishSuretyBondInput;
}
export interface MutationToEstablishSuretyBondDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEstablishSuretyBondDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToFixAddressV2Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGenerateDocumentReportArgs {
  input: DocumentReportInput;
}
export interface MutationToGenerateDocumentReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateDocumentReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGenerateNewIndividualVerificationUrlArgs {
  identificationIndividualId?: string;
}
export interface MutationToGenerateNewIndividualVerificationUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateNewIndividualVerificationUrlArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGenerateNewStripeSubscriptionArgs {
  input?: GenerateNewStripeSubscriptionInput;
}
export interface MutationToGenerateNewStripeSubscriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateNewStripeSubscriptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGenerateNewStripeSubscriptionForBankPortalArgs {
  input?: BankPortalGenerateNewStripeSubscriptionInput;
}
export interface MutationToGenerateNewStripeSubscriptionForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateNewStripeSubscriptionForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToImportAllExistingSimpleKycApplicationsArgs {
  input: ImportExistingSimpleKycDataInput;
}
export interface MutationToImportAllExistingSimpleKycApplicationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToImportAllExistingSimpleKycApplicationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToInvalidateAssetCacheResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToOnceOffDocumentDescriptionMigrationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToOnceOffDraftDescriptionMigrationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToOptInOrganisationToDocumentFacilitiesArgs {
  input: OptInOrganisationToDocumentFacilitiesInput;
}
export interface MutationToOptInOrganisationToDocumentFacilitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToOptInOrganisationToDocumentFacilitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPrefillIdentificationArgs {
  input?: PrefillIdentificationInput;
}
export interface MutationToPrefillIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPrefillIdentificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToProfileTermsAcceptedArgs {
  input?: ProfileTermsAcceptedInput;
}
export interface MutationToProfileTermsAcceptedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToProfileTermsAcceptedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReactivateSubscriptionArgs {
  backdateSubscriptionTo: DateTime;
  clientMutationId: string;
  subscriptionId: string;
}
export interface MutationToReactivateSubscriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReactivateSubscriptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReestablishBankDocumentArgs {
  clientMutationId: string;
  documentId: string;
}
export interface MutationToReestablishBankDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReestablishBankDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalCreateEntityArgs {
  input: CreateEntityRequestInput;
}
export interface MutationToReferralPortalCreateEntityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalCreateEntityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalCreateMemberArgs {
  input: ReferralPortalMemberCreateInput;
}
export interface MutationToReferralPortalCreateMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalCreateMemberArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalDeleteMemberArgs {
  referralPortalMemberId: string;
}
export interface MutationToReferralPortalDeleteMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalDeleteMemberArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalResendInvitationArgs {
  input: ResendInvitationRequestInput;
}
export interface MutationToReferralPortalResendInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalResendInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalSetOrganisationAssociationArgs {
  input: SetOrganisationAssociationInput;
}
export interface MutationToReferralPortalSetOrganisationAssociationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalSetOrganisationAssociationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalUpdateEntityArgs {
  input: UpdateEntityRequestInput;
}
export interface MutationToReferralPortalUpdateEntityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalUpdateEntityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReferralPortalUpdateMemberArgs {
  input: ReferralPortalMemberUpdateInput;
}
export interface MutationToReferralPortalUpdateMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReferralPortalUpdateMemberArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRejectDraftArgs {
  input: DraftRejectInput;
}
export interface MutationToRejectDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRejectDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDocumentAttachmentArgs {
  input?: RemoveDocumentAttachmentInput;
}
export interface MutationToRemoveDocumentAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDocumentAttachmentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDocumentCollaboratorArgs {
  input?: RemoveDocumentCollaboratorInput;
}
export interface MutationToRemoveDocumentCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDocumentCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDocumentHandoverArgs {
  input?: RemoveDocumentHandoverInput;
}
export interface MutationToRemoveDocumentHandoverResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDocumentHandoverArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDocumentMetadataArgs {
  input?: RemoveDocumentMetadataInput;
}
export interface MutationToRemoveDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDocumentMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDocumentRequestForReturnArgs {
  input?: RemoveDocumentRequestForReturnInput;
}
export interface MutationToRemoveDocumentRequestForReturnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDocumentRequestForReturnArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDraftAttachmentArgs {
  input?: RemoveDraftAttachmentInput;
}
export interface MutationToRemoveDraftAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDraftAttachmentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDraftAttachmentForBankPortalArgs {
  input?: RemoveDraftAttachmentForBankPortalInput;
}
export interface MutationToRemoveDraftAttachmentForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDraftAttachmentForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveDraftCollaboratorArgs {
  input?: RemoveDraftCollaboratorInput;
}
export interface MutationToRemoveDraftCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveDraftCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveFacilityApplicationAttachmentArgs {
  input?: RemoveFacilityApplicationAttachmentInput;
}
export interface MutationToRemoveFacilityApplicationAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveFacilityApplicationAttachmentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveInvitationArgs {
  input: RemoveInvitationInput;
}
export interface MutationToRemoveInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveMemberArgs {
  input: RemoveMemberInput;
}
export interface MutationToRemoveMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveMemberArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveMemberForBankPortalArgs {
  input: RemoveMemberInput;
}
export interface MutationToRemoveMemberForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveMemberForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveOrgMemberInvitationForBankPortalArgs {
  input: RemoveInvitationInput;
}
export interface MutationToRemoveOrgMemberInvitationForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveOrgMemberInvitationForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveOrganisationAlertConfigurationArgs {
  input?: RemoveOrganisationAlertConfigurationInput;
}
export interface MutationToRemoveOrganisationAlertConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveOrganisationAlertConfigurationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveOrganisationDocumentMetadataArgs {
  input?: RemoveOrganisationDocumentMetadataInput;
}
export interface MutationToRemoveOrganisationDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveOrganisationDocumentMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRequestDraftChangesArgs {
  input: DraftRequestChangeInput;
}
export interface MutationToRequestDraftChangesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRequestDraftChangesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRequestDraftPaymentArgs {
  input: DraftRequestPaymentInput;
}
export interface MutationToRequestDraftPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRequestDraftPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResendInvoicesArgs {
  clientMutationId?: string;
  input?: string;
  referenceNumber?: string;
}
export interface MutationToResendInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResendInvoicesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResubmitReturnedGvpApplicationArgs {
  draftId: string;
}
export interface MutationToResubmitReturnedGvpApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResubmitReturnedGvpApplicationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSendOrgMemberInvitationArgs {
  input: SendInvitationInput;
}
export interface MutationToSendOrgMemberInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSendOrgMemberInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSendOrgMemberInvitationForBankPortalArgs {
  input: SendInvitationInput;
}
export interface MutationToSendOrgMemberInvitationForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSendOrgMemberInvitationForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetApplicationContactDetailsArgs {
  input: ClientPortalApplicationContactDetailsInput;
}
export interface MutationToSetApplicationContactDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetApplicationContactDetailsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetApplicationContactDetailsForBankPortalArgs {
  input: ApplicationContactDetailsInput;
}
export interface MutationToSetApplicationContactDetailsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetApplicationContactDetailsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDocumentNotificationListArgs {
  input?: SetDocumentNotificationListInput;
}
export interface MutationToSetDocumentNotificationListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDocumentNotificationListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDraftApprovalStatusForCollaboratorArgs {
  input?: SetDraftApprovalStatusForCollaboratorInput;
}
export interface MutationToSetDraftApprovalStatusForCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDraftApprovalStatusForCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDraftAvailableToSupplierArgs {
  clientMutationId?: string;
  draftId?: string;
}
export interface MutationToSetDraftAvailableToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDraftAvailableToSupplierArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDraftAvailableToSupplier_preValidationArgs {
  draftId?: string;
}
export interface MutationToSetDraftAvailableToSupplier_preValidationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDraftAvailableToSupplier_preValidationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDraftNotificationListForCollaboratorArgs {
  input?: SetDraftNotificationListForCollaboratorInput;
}
export interface MutationToSetDraftNotificationListForCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDraftNotificationListForCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDraftRealtimeAuthorStateArgs {
  input?: SetDraftRealtimeAuthorStateInput;
}
export interface MutationToSetDraftRealtimeAuthorStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDraftRealtimeAuthorStateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetFacilityApplicationAvailableToSupplierArgs {
  facilityApplicationId: string;
}
export interface MutationToSetFacilityApplicationAvailableToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetFacilityApplicationAvailableToSupplierArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetFacilityApplicationBankOutcomeArgs {
  input: SetFacilityApplicationBankOutcomeInput;
}
export interface MutationToSetFacilityApplicationBankOutcomeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetFacilityApplicationBankOutcomeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetOrganisationGvpMetadataArgs {
  input: OrganisationGvpMetadataInput;
}
export interface MutationToSetOrganisationGvpMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetOrganisationGvpMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToShareDraftToOrganisationFromCollaboratorArgs {
  input?: ShareDraftToOrganisationFromCollaboratorInput;
}
export interface MutationToShareDraftToOrganisationFromCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToShareDraftToOrganisationFromCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSubmitApplicationToGvpArgs {
  draftId: string;
}
export interface MutationToSubmitApplicationToGvpResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSubmitApplicationToGvpArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSubmitFacilityApplicationArgs {
  input?: SubmitApplicationInput;
}
export interface MutationToSubmitFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSubmitFacilityApplicationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateBankDocumentArgs {
  input: BankDocumentUpdateInput;
}
export interface MutationToUpdateBankDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateBankDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateChannelPartnerForBankPortalArgs {
  id: string;
  input: MutateChannelPartnerInput;
}
export interface MutationToUpdateChannelPartnerForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateChannelPartnerForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDocumentArgs {
  input?: UpdateDocumentInput;
}
export interface MutationToUpdateDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDocumentFacilityArgs {
  input: UpdateDocumentFacilityInput;
}
export interface MutationToUpdateDocumentFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDocumentFacilityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDocumentFacilityForBankPortalArgs {
  input: UpdateDocumentFacilityInput;
}
export interface MutationToUpdateDocumentFacilityForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDocumentFacilityForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDocumentMetadataArgs {
  input?: UpdateDocumentMetadataInput;
}
export interface MutationToUpdateDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDocumentMetadataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftArgs {
  input?: UpdateDraftInput;
}
export interface MutationToUpdateDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftBGSwitchArgs {
  input?: UpdateDraftBGSwitchInput;
}
export interface MutationToUpdateDraftBGSwitchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftBGSwitchArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftBGSwitchForBankPortalArgs {
  input?: UpdateDraftBGSwitchInput;
}
export interface MutationToUpdateDraftBGSwitchForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftBGSwitchForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftCollaboratorArgs {
  input?: UpdateDraftCollaboratorInput;
}
export interface MutationToUpdateDraftCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftCollaboratorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftForBankPortalArgs {
  input?: UpdateBankDraftInput;
}
export interface MutationToUpdateDraftForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftMegDetailsArgs {
  input?: UpdateDraftMegDetailsInput;
}
export interface MutationToUpdateDraftMegDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftMegDetailsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDraftPreviewArgs {
  input?: UpdateDraftInput;
}
export interface MutationToUpdateDraftPreviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDraftPreviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateFacilityApplicationArgs {
  input?: UpdateApplicationInput;
}
export interface MutationToUpdateFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateFacilityApplicationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateFacilityApplicationForBankPortalArgs {
  input?: UpdateApplicationInput;
}
export interface MutationToUpdateFacilityApplicationForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateFacilityApplicationForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateFacilityApplicationPaymentStatusArgs {
  input?: UpdateFacilityApplicationPaymentStatusInput;
}
export interface MutationToUpdateFacilityApplicationPaymentStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateFacilityApplicationPaymentStatusArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateGreenIdArgs {
  input?: UpdateGreenIdInput;
}
export interface MutationToUpdateGreenIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateGreenIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateGreenIdForBankPortalArgs {
  input?: UpdateBankGreenIdInput;
}
export interface MutationToUpdateGreenIdForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateGreenIdForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateIdentificationArgs {
  input?: UpdateIdentificationInput;
}
export interface MutationToUpdateIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateIdentificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateIdentificationForBankPortalArgs {
  input?: UpdateBankIdentificationInput;
}
export interface MutationToUpdateIdentificationForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateIdentificationForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateIdentificationRiskDetailsForBankPortalArgs {
  input?: UpdateBankIdentificationRiskDetailsInput;
}
export interface MutationToUpdateIdentificationRiskDetailsForBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateIdentificationRiskDetailsForBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateNotifiedAtArgs {
  input?: UpdateNotifiedAtInput;
}
export interface MutationToUpdateNotifiedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateNotifiedAtArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateOrganisationArgs {
  input: UpdateOrganisationInput;
}
export interface MutationToUpdateOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateOrganisationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateOrganisationAlertConfigurationArgs {
  input?: UpdateOrganisationAlertConfigurationInput;
}
export interface MutationToUpdateOrganisationAlertConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateOrganisationAlertConfigurationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateOrganisationBankPortalArgs {
  input: UpdateOrganisationForBankPortalInput;
}
export interface MutationToUpdateOrganisationBankPortalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateOrganisationBankPortalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateProfileArgs {
  input?: UpdateProfileInput;
}
export interface MutationToUpdateProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateProfileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSimpleKycDataFromApiArgs {
  input: UpdateSimpleKycDataInput;
}
export interface MutationToUpdateSimpleKycDataFromApiResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateSimpleKycDataFromApiArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSimpleKycDataFromApiByIdentificationIdArgs {
  input: UpdateSimpleKycDataAppInput;
}
export interface MutationToUpdateSimpleKycDataFromApiByIdentificationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateSimpleKycDataFromApiByIdentificationIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToVoidOrganisationCreditArgs {
  input: VoidOrganisationCreditInput;
}
export interface MutationToVoidOrganisationCreditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToVoidOrganisationCreditArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AcceptInvitationPayloadTypeResolver<TParent = any> {
  clientMutationId?: AcceptInvitationPayloadToClientMutationIdResolver<TParent>;
}

export interface AcceptInvitationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageTypeResolver<TParent = any> {
  attachment?: RequiredDocumentMessageToAttachmentResolver<TParent>;
  attachmentId?: RequiredDocumentMessageToAttachmentIdResolver<TParent>;
  createdByUserId?: RequiredDocumentMessageToCreatedByUserIdResolver<TParent>;
  dateCreated?: RequiredDocumentMessageToDateCreatedResolver<TParent>;
  fromParty?: RequiredDocumentMessageToFromPartyResolver<TParent>;
  hasApproval?: RequiredDocumentMessageToHasApprovalResolver<TParent>;
  id?: RequiredDocumentMessageToIdResolver<TParent>;
  isAutomatedMessage?: RequiredDocumentMessageToIsAutomatedMessageResolver<TParent>;
  message?: RequiredDocumentMessageToMessageResolver<TParent>;
  messageType?: RequiredDocumentMessageToMessageTypeResolver<TParent>;
  parentMessageId?: RequiredDocumentMessageToParentMessageIdResolver<TParent>;
  requiredDocument?: RequiredDocumentMessageToRequiredDocumentResolver<TParent>;
  requiredDocumentId?: RequiredDocumentMessageToRequiredDocumentIdResolver<TParent>;
}

export interface RequiredDocumentMessageToAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToAttachmentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToCreatedByUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToDateCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToFromPartyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToHasApprovalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToIsAutomatedMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToMessageTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToParentMessageIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToRequiredDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentMessageToRequiredDocumentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentTypeResolver<TParent = any> {
  createdByAdminUserId?: RequiredDocumentToCreatedByAdminUserIdResolver<TParent>;
  dateCreated?: RequiredDocumentToDateCreatedResolver<TParent>;
  draft?: RequiredDocumentToDraftResolver<TParent>;
  draftId?: RequiredDocumentToDraftIdResolver<TParent>;
  id?: RequiredDocumentToIdResolver<TParent>;
  requiredDocumentMessages?: RequiredDocumentToRequiredDocumentMessagesResolver<TParent>;
  requiredDocumentType?: RequiredDocumentToRequiredDocumentTypeResolver<TParent>;
}

export interface RequiredDocumentToCreatedByAdminUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentToDateCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentToRequiredDocumentMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RequiredDocumentToRequiredDocumentTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutateChannelPartnerPayloadTypeResolver<TParent = any> {
  channelPartner?: MutateChannelPartnerPayloadToChannelPartnerResolver<TParent>;
  clientMutationId?: MutateChannelPartnerPayloadToClientMutationIdResolver<TParent>;
}

export interface MutateChannelPartnerPayloadToChannelPartnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutateChannelPartnerPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmendDocumentPayloadTypeResolver<TParent = any> {
  clientMutationId?: AmendDocumentPayloadToClientMutationIdResolver<TParent>;
  document?: AmendDocumentPayloadToDocumentResolver<TParent>;
}

export interface AmendDocumentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmendDocumentPayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeginDraftSubmissionPayloadTypeResolver<TParent = any> {
  clientMutationId?: BeginDraftSubmissionPayloadToClientMutationIdResolver<TParent>;
  draft?: BeginDraftSubmissionPayloadToDraftResolver<TParent>;
}

export interface BeginDraftSubmissionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeginDraftSubmissionPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CancelDraftPayloadTypeResolver<TParent = any> {
  clientMutationId?: CancelDraftPayloadToClientMutationIdResolver<TParent>;
  draft?: CancelDraftPayloadToDraftResolver<TParent>;
}

export interface CancelDraftPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CancelDraftPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CancelDraftSubmissionPayloadTypeResolver<TParent = any> {
  clientMutationId?: CancelDraftSubmissionPayloadToClientMutationIdResolver<TParent>;
}

export interface CancelDraftSubmissionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChangeFacilityApplicationStatusPayloadTypeResolver<TParent = any> {
  clientMutationId?: ChangeFacilityApplicationStatusPayloadToClientMutationIdResolver<TParent>;
  facilityApplication?: ChangeFacilityApplicationStatusPayloadToFacilityApplicationResolver<TParent>;
}

export interface ChangeFacilityApplicationStatusPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChangeFacilityApplicationStatusPayloadToFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChangeMemberRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: ChangeMemberRolePayloadToClientMutationIdResolver<TParent>;
  member?: ChangeMemberRolePayloadToMemberResolver<TParent>;
}

export interface ChangeMemberRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChangeMemberRolePayloadToMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoPayloadTypeResolver<TParent = any> {
  clientMutationId?: CognitoPayloadToClientMutationIdResolver<TParent>;
  user?: CognitoPayloadToUserResolver<TParent>;
}

export interface CognitoPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CognitoPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompleteDraftSubmissionPayloadTypeResolver<TParent = any> {
  applicableRequirements?: CompleteDraftSubmissionPayloadToApplicableRequirementsResolver<TParent>;
  clientMutationId?: CompleteDraftSubmissionPayloadToClientMutationIdResolver<TParent>;
}

export interface CompleteDraftSubmissionPayloadToApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompleteDraftSubmissionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateIdentificationPayloadTypeResolver<TParent = any> {
  applicableRequirements?: UpdateIdentificationPayloadToApplicableRequirementsResolver<TParent>;
  clientMutationId?: UpdateIdentificationPayloadToClientMutationIdResolver<TParent>;
  identification?: UpdateIdentificationPayloadToIdentificationResolver<TParent>;
}

export interface UpdateIdentificationPayloadToApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateIdentificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateIdentificationPayloadToIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ConfirmDocumentHandoverPayloadTypeResolver<TParent = any> {
  clientMutationId?: ConfirmDocumentHandoverPayloadToClientMutationIdResolver<TParent>;
}

export interface ConfirmDocumentHandoverPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ConvertDocumentFacilityForBankPortalPayloadTypeResolver<TParent = any> {
  clientMutationId?: ConvertDocumentFacilityForBankPortalPayloadToClientMutationIdResolver<TParent>;
  documentFacility?: ConvertDocumentFacilityForBankPortalPayloadToDocumentFacilityResolver<TParent>;
}

export interface ConvertDocumentFacilityForBankPortalPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ConvertDocumentFacilityForBankPortalPayloadToDocumentFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateCommentPayloadToClientMutationIdResolver<TParent>;
  comment?: CreateCommentPayloadToCommentResolver<TParent>;
}

export interface CreateCommentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommentPayloadToCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentPayloadToClientMutationIdResolver<TParent>;
  document?: CreateDocumentPayloadToDocumentResolver<TParent>;
}

export interface CreateDocumentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentPayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentAttachmentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentAttachmentPayloadToClientMutationIdResolver<TParent>;
  documentAttachment?: CreateDocumentAttachmentPayloadToDocumentAttachmentResolver<TParent>;
}

export interface CreateDocumentAttachmentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentAttachmentPayloadToDocumentAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentCollaboratorPayloadToClientMutationIdResolver<TParent>;
  documentCollaborator?: CreateDocumentCollaboratorPayloadToDocumentCollaboratorResolver<TParent>;
}

export interface CreateDocumentCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentCollaboratorPayloadToDocumentCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentFacilityPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentFacilityPayloadToClientMutationIdResolver<TParent>;
  documentFacility?: CreateDocumentFacilityPayloadToDocumentFacilityResolver<TParent>;
}

export interface CreateDocumentFacilityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentFacilityPayloadToDocumentFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentHandoverPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentHandoverPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateDocumentHandoverPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentMetadataPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentMetadataPayloadToClientMutationIdResolver<TParent>;
  metadata?: CreateDocumentMetadataPayloadToMetadataResolver<TParent>;
}

export interface CreateDocumentMetadataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentMetadataPayloadToMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentRequestForReturnPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentRequestForReturnPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateDocumentRequestForReturnPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDraftPayloadToClientMutationIdResolver<TParent>;
  draft?: CreateDraftPayloadToDraftResolver<TParent>;
}

export interface CreateDraftPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftAttachmentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDraftAttachmentPayloadToClientMutationIdResolver<TParent>;
  draftAttachment?: CreateDraftAttachmentPayloadToDraftAttachmentResolver<TParent>;
}

export interface CreateDraftAttachmentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftAttachmentPayloadToDraftAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftBGSwitchPayloadTypeResolver<TParent = any> {
  draftBGSwitch?: CreateDraftBGSwitchPayloadToDraftBGSwitchResolver<TParent>;
}

export interface CreateDraftBGSwitchPayloadToDraftBGSwitchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDraftCollaboratorPayloadToClientMutationIdResolver<TParent>;
  draftCollaborator?: CreateDraftCollaboratorPayloadToDraftCollaboratorResolver<TParent>;
}

export interface CreateDraftCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftCollaboratorPayloadToDraftCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftCommentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDraftCommentPayloadToClientMutationIdResolver<TParent>;
  comment?: CreateDraftCommentPayloadToCommentResolver<TParent>;
}

export interface CreateDraftCommentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftCommentPayloadToCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftFromOriginationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDraftFromOriginationPayloadToClientMutationIdResolver<TParent>;
  draftId?: CreateDraftFromOriginationPayloadToDraftIdResolver<TParent>;
  organisationId?: CreateDraftFromOriginationPayloadToOrganisationIdResolver<TParent>;
}

export interface CreateDraftFromOriginationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftFromOriginationPayloadToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDraftFromOriginationPayloadToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateFacilityApplicationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateFacilityApplicationPayloadToClientMutationIdResolver<TParent>;
  facilityApplication?: CreateFacilityApplicationPayloadToFacilityApplicationResolver<TParent>;
}

export interface CreateFacilityApplicationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateFacilityApplicationPayloadToFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateFacilityApplicationAttachmentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateFacilityApplicationAttachmentPayloadToClientMutationIdResolver<TParent>;
  facilityApplicationAttachment?: CreateFacilityApplicationAttachmentPayloadToFacilityApplicationAttachmentResolver<TParent>;
}

export interface CreateFacilityApplicationAttachmentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateFacilityApplicationAttachmentPayloadToFacilityApplicationAttachmentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryTypeResolver<TParent = any> {
  contactEmail?: FinanceEnquiryToContactEmailResolver<TParent>;
  contactFirstName?: FinanceEnquiryToContactFirstNameResolver<TParent>;
  contactLastName?: FinanceEnquiryToContactLastNameResolver<TParent>;
  contactPhoneNumber?: FinanceEnquiryToContactPhoneNumberResolver<TParent>;
  dateTimeEnquired?: FinanceEnquiryToDateTimeEnquiredResolver<TParent>;
  draftId?: FinanceEnquiryToDraftIdResolver<TParent>;
  financeEnquiryDetail?: FinanceEnquiryToFinanceEnquiryDetailResolver<TParent>;
  id?: FinanceEnquiryToIdResolver<TParent>;
  organisationId?: FinanceEnquiryToOrganisationIdResolver<TParent>;
  reasonForFinance?: FinanceEnquiryToReasonForFinanceResolver<TParent>;
}

export interface FinanceEnquiryToContactEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToContactFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToContactLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToContactPhoneNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToDateTimeEnquiredResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToDraftIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToFinanceEnquiryDetailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryToReasonForFinanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailTypeResolver<TParent = any> {
  averageMonthlySales?: FinanceEnquiryDetailToAverageMonthlySalesResolver<TParent>;
  creditStatus?: FinanceEnquiryDetailToCreditStatusResolver<TParent>;
  financeEnquiry?: FinanceEnquiryDetailToFinanceEnquiryResolver<TParent>;
  financeEnquiryId?: FinanceEnquiryDetailToFinanceEnquiryIdResolver<TParent>;
  id?: FinanceEnquiryDetailToIdResolver<TParent>;
  loanAmount?: FinanceEnquiryDetailToLoanAmountResolver<TParent>;
  monthsTrading?: FinanceEnquiryDetailToMonthsTradingResolver<TParent>;
  recentPerformance?: FinanceEnquiryDetailToRecentPerformanceResolver<TParent>;
  requestedLoanTermInMonths?: FinanceEnquiryDetailToRequestedLoanTermInMonthsResolver<TParent>;
  residencyStatus?: FinanceEnquiryDetailToResidencyStatusResolver<TParent>;
  yearsTrading?: FinanceEnquiryDetailToYearsTradingResolver<TParent>;
}

export interface FinanceEnquiryDetailToAverageMonthlySalesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToCreditStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToFinanceEnquiryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToFinanceEnquiryIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToLoanAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToMonthsTradingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToRecentPerformanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToRequestedLoanTermInMonthsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToResidencyStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FinanceEnquiryDetailToYearsTradingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateImportJobPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateImportJobPayloadToClientMutationIdResolver<TParent>;
  importJob?: CreateImportJobPayloadToImportJobResolver<TParent>;
}

export interface CreateImportJobPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateImportJobPayloadToImportJobResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrUpdateFeeSummaryPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateOrUpdateFeeSummaryPayloadToClientMutationIdResolver<TParent>;
  feeSummary?: CreateOrUpdateFeeSummaryPayloadToFeeSummaryResolver<TParent>;
}

export interface CreateOrUpdateFeeSummaryPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrUpdateFeeSummaryPayloadToFeeSummaryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrUpdateSupplierPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateOrUpdateSupplierPayloadToClientMutationIdResolver<TParent>;
  supplier?: CreateOrUpdateSupplierPayloadToSupplierResolver<TParent>;
}

export interface CreateOrUpdateSupplierPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrUpdateSupplierPayloadToSupplierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierTypeResolver<TParent = any> {
  createdAt?: EnrichedSupplierToCreatedAtResolver<TParent>;
  createdBy?: EnrichedSupplierToCreatedByResolver<TParent>;
  feeSummaries?: EnrichedSupplierToFeeSummariesResolver<TParent>;
  gvpId?: EnrichedSupplierToGvpIdResolver<TParent>;
  id?: EnrichedSupplierToIdResolver<TParent>;
  name?: EnrichedSupplierToNameResolver<TParent>;
  notificationAddress?: EnrichedSupplierToNotificationAddressResolver<TParent>;
}

export interface EnrichedSupplierToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierToFeeSummariesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierToGvpIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EnrichedSupplierToNotificationAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadTypeResolver<TParent = any> {
  abn?: CreateOrganisationPayloadToAbnResolver<TParent>;
  address?: CreateOrganisationPayloadToAddressResolver<TParent>;
  clientMutationId?: CreateOrganisationPayloadToClientMutationIdResolver<TParent>;
  createdAt?: CreateOrganisationPayloadToCreatedAtResolver<TParent>;
  createdBy?: CreateOrganisationPayloadToCreatedByResolver<TParent>;
  id?: CreateOrganisationPayloadToIdResolver<TParent>;
  industryType?: CreateOrganisationPayloadToIndustryTypeResolver<TParent>;
  name?: CreateOrganisationPayloadToNameResolver<TParent>;
  nickname?: CreateOrganisationPayloadToNicknameResolver<TParent>;
  organisation?: CreateOrganisationPayloadToOrganisationResolver<TParent>;
  organisationVariant?: CreateOrganisationPayloadToOrganisationVariantResolver<TParent>;
  stripeCustomerId?: CreateOrganisationPayloadToStripeCustomerIdResolver<TParent>;
}

export interface CreateOrganisationPayloadToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToIndustryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToNicknameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToOrganisationVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationPayloadToStripeCustomerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationAlertConfigurationPayloadTypeResolver<TParent = any> {
  alertConfiguration?: CreateOrganisationAlertConfigurationPayloadToAlertConfigurationResolver<TParent>;
  clientMutationId?: CreateOrganisationAlertConfigurationPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateOrganisationAlertConfigurationPayloadToAlertConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationAlertConfigurationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationDocumentMetadataPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateOrganisationDocumentMetadataPayloadToClientMutationIdResolver<TParent>;
  organisationDocumentMetadata?: CreateOrganisationDocumentMetadataPayloadToOrganisationDocumentMetadataResolver<TParent>;
}

export interface CreateOrganisationDocumentMetadataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrganisationDocumentMetadataPayloadToOrganisationDocumentMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateSimpleKycDataPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateSimpleKycDataPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateSimpleKycDataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftEstablishPayloadTypeResolver<TParent = any> {
  clientMutationId?: DraftEstablishPayloadToClientMutationIdResolver<TParent>;
  draft?: DraftEstablishPayloadToDraftResolver<TParent>;
}

export interface DraftEstablishPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftEstablishPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GenerateNewStripeSubscriptionPayloadTypeResolver<TParent = any> {
  clientMutationId?: GenerateNewStripeSubscriptionPayloadToClientMutationIdResolver<TParent>;
  draft?: GenerateNewStripeSubscriptionPayloadToDraftResolver<TParent>;
}

export interface GenerateNewStripeSubscriptionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GenerateNewStripeSubscriptionPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankGenerateNewStripeSubscriptionPayloadTypeResolver<TParent = any> {
  clientMutationId?: BankGenerateNewStripeSubscriptionPayloadToClientMutationIdResolver<TParent>;
  draft?: BankGenerateNewStripeSubscriptionPayloadToDraftResolver<TParent>;
}

export interface BankGenerateNewStripeSubscriptionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankGenerateNewStripeSubscriptionPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImportExistingSimpleKycDataPayloadTypeResolver<TParent = any> {
  clientMutationId?: ImportExistingSimpleKycDataPayloadToClientMutationIdResolver<TParent>;
}

export interface ImportExistingSimpleKycDataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultTypeResolver<TParent = any> {
  defaultedReason?: MigrateAllDescriptionsResultToDefaultedReasonResolver<TParent>;
  entityId?: MigrateAllDescriptionsResultToEntityIdResolver<TParent>;
  exception?: MigrateAllDescriptionsResultToExceptionResolver<TParent>;
  generatedDescription?: MigrateAllDescriptionsResultToGeneratedDescriptionResolver<TParent>;
  originalAgreementContent?: MigrateAllDescriptionsResultToOriginalAgreementContentResolver<TParent>;
  purpose?: MigrateAllDescriptionsResultToPurposeResolver<TParent>;
  successful?: MigrateAllDescriptionsResultToSuccessfulResolver<TParent>;
  variant?: MigrateAllDescriptionsResultToVariantResolver<TParent>;
}

export interface MigrateAllDescriptionsResultToDefaultedReasonResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToEntityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToExceptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToGeneratedDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToOriginalAgreementContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToPurposeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToSuccessfulResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MigrateAllDescriptionsResultToVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OptInOrganisationToDocumentFacilitiesPayloadTypeResolver<TParent = any> {
  clientMutationId?: OptInOrganisationToDocumentFacilitiesPayloadToClientMutationIdResolver<TParent>;
}

export interface OptInOrganisationToDocumentFacilitiesPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PrefillIdentificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: PrefillIdentificationPayloadToClientMutationIdResolver<TParent>;
  identification?: PrefillIdentificationPayloadToIdentificationResolver<TParent>;
}

export interface PrefillIdentificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PrefillIdentificationPayloadToIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileTermsAcceptedPayloadTypeResolver<TParent = any> {
  clientMutationId?: ProfileTermsAcceptedPayloadToClientMutationIdResolver<TParent>;
  profile?: ProfileTermsAcceptedPayloadToProfileResolver<TParent>;
}

export interface ProfileTermsAcceptedPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileTermsAcceptedPayloadToProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentUpdatePayloadTypeResolver<TParent = any> {
  clientMutationId?: BankDocumentUpdatePayloadToClientMutationIdResolver<TParent>;
  document?: BankDocumentUpdatePayloadToDocumentResolver<TParent>;
}

export interface BankDocumentUpdatePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BankDocumentUpdatePayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRejectPayloadTypeResolver<TParent = any> {
  clientMutationId?: DraftRejectPayloadToClientMutationIdResolver<TParent>;
  draft?: DraftRejectPayloadToDraftResolver<TParent>;
}

export interface DraftRejectPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRejectPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDocumentAttachmentPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDocumentAttachmentPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDocumentAttachmentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDocumentCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDocumentCollaboratorPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDocumentCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDocumentHandoverPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDocumentHandoverPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDocumentHandoverPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDocumentMetadataPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDocumentMetadataPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDocumentMetadataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDocumentRequestForReturnPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDocumentRequestForReturnPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDocumentRequestForReturnPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDraftAttachmentPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDraftAttachmentPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDraftAttachmentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveDraftCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveDraftCollaboratorPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveDraftCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutateFacilityApplicationPayloadTypeResolver<TParent = any> {
  clientMutationId?: MutateFacilityApplicationPayloadToClientMutationIdResolver<TParent>;
  facilityApplication?: MutateFacilityApplicationPayloadToFacilityApplicationResolver<TParent>;
}

export interface MutateFacilityApplicationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutateFacilityApplicationPayloadToFacilityApplicationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveInvitationPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveInvitationPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveInvitationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveMemberPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveMemberPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveMemberPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveOrganisationAlertConfigurationPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveOrganisationAlertConfigurationPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveOrganisationAlertConfigurationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemoveOrganisationDocumentMetadataPayloadTypeResolver<TParent = any> {
  clientMutationId?: RemoveOrganisationDocumentMetadataPayloadToClientMutationIdResolver<TParent>;
}

export interface RemoveOrganisationDocumentMetadataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestChangePayloadTypeResolver<TParent = any> {
  clientMutationId?: DraftRequestChangePayloadToClientMutationIdResolver<TParent>;
  draft?: DraftRequestChangePayloadToDraftResolver<TParent>;
}

export interface DraftRequestChangePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestChangePayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: DraftRequestPaymentPayloadToClientMutationIdResolver<TParent>;
  draft?: DraftRequestPaymentPayloadToDraftResolver<TParent>;
}

export interface DraftRequestPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRequestPaymentPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResendAdditionalInvoicesPayloadTypeResolver<TParent = any> {
  allRecipients?: ResendAdditionalInvoicesPayloadToAllRecipientsResolver<TParent>;
  clientMutationId?: ResendAdditionalInvoicesPayloadToClientMutationIdResolver<TParent>;
}

export interface ResendAdditionalInvoicesPayloadToAllRecipientsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResendAdditionalInvoicesPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SendInvitationPayloadTypeResolver<TParent = any> {
  clientMutationId?: SendInvitationPayloadToClientMutationIdResolver<TParent>;
  invitation?: SendInvitationPayloadToInvitationResolver<TParent>;
}

export interface SendInvitationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SendInvitationPayloadToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetDocumentNotificationListPayloadTypeResolver<TParent = any> {
  clientMutationId?: SetDocumentNotificationListPayloadToClientMutationIdResolver<TParent>;
}

export interface SetDocumentNotificationListPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetDraftApprovalStatusForCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: SetDraftApprovalStatusForCollaboratorPayloadToClientMutationIdResolver<TParent>;
}

export interface SetDraftApprovalStatusForCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetDraftNotificationListForCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: SetDraftNotificationListForCollaboratorPayloadToClientMutationIdResolver<TParent>;
}

export interface SetDraftNotificationListForCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetDraftRealtimeAuthorStatePayloadTypeResolver<TParent = any> {
  authors?: SetDraftRealtimeAuthorStatePayloadToAuthorsResolver<TParent>;
  clientMutationId?: SetDraftRealtimeAuthorStatePayloadToClientMutationIdResolver<TParent>;
}

export interface SetDraftRealtimeAuthorStatePayloadToAuthorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SetDraftRealtimeAuthorStatePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRealtimeAuthorTypeResolver<TParent = any> {
  author?: DraftRealtimeAuthorToAuthorResolver<TParent>;
  isCurrentUser?: DraftRealtimeAuthorToIsCurrentUserResolver<TParent>;
  status?: DraftRealtimeAuthorToStatusResolver<TParent>;
}

export interface DraftRealtimeAuthorToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRealtimeAuthorToIsCurrentUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DraftRealtimeAuthorToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationGvpMetadataTypeResolver<TParent = any> {
  gvpGuarantorIds?: OrganisationGvpMetadataToGvpGuarantorIdsResolver<TParent>;
  gvpId?: OrganisationGvpMetadataToGvpIdResolver<TParent>;
  organisationId?: OrganisationGvpMetadataToOrganisationIdResolver<TParent>;
}

export interface OrganisationGvpMetadataToGvpGuarantorIdsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationGvpMetadataToGvpIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrganisationGvpMetadataToOrganisationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ShareDraftToOrganisationFromCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: ShareDraftToOrganisationFromCollaboratorPayloadToClientMutationIdResolver<TParent>;
  draftCollaborator?: ShareDraftToOrganisationFromCollaboratorPayloadToDraftCollaboratorResolver<TParent>;
}

export interface ShareDraftToOrganisationFromCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ShareDraftToOrganisationFromCollaboratorPayloadToDraftCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDocumentPayloadToClientMutationIdResolver<TParent>;
  document?: UpdateDocumentPayloadToDocumentResolver<TParent>;
}

export interface UpdateDocumentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentPayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentFacilityPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDocumentFacilityPayloadToClientMutationIdResolver<TParent>;
  documentFacility?: UpdateDocumentFacilityPayloadToDocumentFacilityResolver<TParent>;
}

export interface UpdateDocumentFacilityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentFacilityPayloadToDocumentFacilityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentMetadataPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDocumentMetadataPayloadToClientMutationIdResolver<TParent>;
  metadata?: UpdateDocumentMetadataPayloadToMetadataResolver<TParent>;
}

export interface UpdateDocumentMetadataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentMetadataPayloadToMetadataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDraftPayloadToClientMutationIdResolver<TParent>;
  draft?: UpdateDraftPayloadToDraftResolver<TParent>;
}

export interface UpdateDraftPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftBGSwitchPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDraftBGSwitchPayloadToClientMutationIdResolver<TParent>;
  draftBGSwitch?: UpdateDraftBGSwitchPayloadToDraftBGSwitchResolver<TParent>;
}

export interface UpdateDraftBGSwitchPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftBGSwitchPayloadToDraftBGSwitchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftCollaboratorPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDraftCollaboratorPayloadToClientMutationIdResolver<TParent>;
  draftCollaborator?: UpdateDraftCollaboratorPayloadToDraftCollaboratorResolver<TParent>;
}

export interface UpdateDraftCollaboratorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftCollaboratorPayloadToDraftCollaboratorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankDraftPayloadTypeResolver<TParent = any> {
  applicableRequirements?: UpdateBankDraftPayloadToApplicableRequirementsResolver<TParent>;
  clientMutationId?: UpdateBankDraftPayloadToClientMutationIdResolver<TParent>;
  draft?: UpdateBankDraftPayloadToDraftResolver<TParent>;
}

export interface UpdateBankDraftPayloadToApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankDraftPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankDraftPayloadToDraftResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftPreviewPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDraftPreviewPayloadToClientMutationIdResolver<TParent>;
  history?: UpdateDraftPreviewPayloadToHistoryResolver<TParent>;
}

export interface UpdateDraftPreviewPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDraftPreviewPayloadToHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateGreenIdPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateGreenIdPayloadToClientMutationIdResolver<TParent>;
  identificationIndividual?: UpdateGreenIdPayloadToIdentificationIndividualResolver<TParent>;
}

export interface UpdateGreenIdPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateGreenIdPayloadToIdentificationIndividualResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankGreenIdPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateBankGreenIdPayloadToClientMutationIdResolver<TParent>;
  identificationIndividual?: UpdateBankGreenIdPayloadToIdentificationIndividualResolver<TParent>;
}

export interface UpdateBankGreenIdPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankGreenIdPayloadToIdentificationIndividualResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankIdentificationPayloadTypeResolver<TParent = any> {
  applicableRequirements?: UpdateBankIdentificationPayloadToApplicableRequirementsResolver<TParent>;
  clientMutationId?: UpdateBankIdentificationPayloadToClientMutationIdResolver<TParent>;
  identification?: UpdateBankIdentificationPayloadToIdentificationResolver<TParent>;
}

export interface UpdateBankIdentificationPayloadToApplicableRequirementsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankIdentificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankIdentificationPayloadToIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankIdentificationRiskDetailsPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateBankIdentificationRiskDetailsPayloadToClientMutationIdResolver<TParent>;
  identification?: UpdateBankIdentificationRiskDetailsPayloadToIdentificationResolver<TParent>;
}

export interface UpdateBankIdentificationRiskDetailsPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankIdentificationRiskDetailsPayloadToIdentificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateNotifiedPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateNotifiedPayloadToClientMutationIdResolver<TParent>;
  profile?: UpdateNotifiedPayloadToProfileResolver<TParent>;
}

export interface UpdateNotifiedPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateNotifiedPayloadToProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadTypeResolver<TParent = any> {
  abn?: UpdateOrganisationPayloadToAbnResolver<TParent>;
  address?: UpdateOrganisationPayloadToAddressResolver<TParent>;
  clientMutationId?: UpdateOrganisationPayloadToClientMutationIdResolver<TParent>;
  createdAt?: UpdateOrganisationPayloadToCreatedAtResolver<TParent>;
  createdBy?: UpdateOrganisationPayloadToCreatedByResolver<TParent>;
  id?: UpdateOrganisationPayloadToIdResolver<TParent>;
  industryType?: UpdateOrganisationPayloadToIndustryTypeResolver<TParent>;
  isOngoingClient?: UpdateOrganisationPayloadToIsOngoingClientResolver<TParent>;
  leadSource?: UpdateOrganisationPayloadToLeadSourceResolver<TParent>;
  name?: UpdateOrganisationPayloadToNameResolver<TParent>;
  nickname?: UpdateOrganisationPayloadToNicknameResolver<TParent>;
  organisation?: UpdateOrganisationPayloadToOrganisationResolver<TParent>;
  organisationVariant?: UpdateOrganisationPayloadToOrganisationVariantResolver<TParent>;
  relationshipManagerId?: UpdateOrganisationPayloadToRelationshipManagerIdResolver<TParent>;
  stripeCustomerId?: UpdateOrganisationPayloadToStripeCustomerIdResolver<TParent>;
}

export interface UpdateOrganisationPayloadToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToIndustryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToIsOngoingClientResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToLeadSourceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToNicknameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToOrganisationVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToRelationshipManagerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationPayloadToStripeCustomerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationAlertConfigurationPayloadTypeResolver<TParent = any> {
  alertConfiguration?: UpdateOrganisationAlertConfigurationPayloadToAlertConfigurationResolver<TParent>;
  clientMutationId?: UpdateOrganisationAlertConfigurationPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateOrganisationAlertConfigurationPayloadToAlertConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrganisationAlertConfigurationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadTypeResolver<TParent = any> {
  abn?: UpdateBankOrganisationPayloadToAbnResolver<TParent>;
  address?: UpdateBankOrganisationPayloadToAddressResolver<TParent>;
  clientMutationId?: UpdateBankOrganisationPayloadToClientMutationIdResolver<TParent>;
  createdAt?: UpdateBankOrganisationPayloadToCreatedAtResolver<TParent>;
  createdBy?: UpdateBankOrganisationPayloadToCreatedByResolver<TParent>;
  id?: UpdateBankOrganisationPayloadToIdResolver<TParent>;
  industryType?: UpdateBankOrganisationPayloadToIndustryTypeResolver<TParent>;
  isOngoingClient?: UpdateBankOrganisationPayloadToIsOngoingClientResolver<TParent>;
  leadSource?: UpdateBankOrganisationPayloadToLeadSourceResolver<TParent>;
  name?: UpdateBankOrganisationPayloadToNameResolver<TParent>;
  nickname?: UpdateBankOrganisationPayloadToNicknameResolver<TParent>;
  organisation?: UpdateBankOrganisationPayloadToOrganisationResolver<TParent>;
  organisationVariant?: UpdateBankOrganisationPayloadToOrganisationVariantResolver<TParent>;
  relationshipManagerId?: UpdateBankOrganisationPayloadToRelationshipManagerIdResolver<TParent>;
  stripeCustomerId?: UpdateBankOrganisationPayloadToStripeCustomerIdResolver<TParent>;
}

export interface UpdateBankOrganisationPayloadToAbnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToCreatedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToIndustryTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToIsOngoingClientResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToLeadSourceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToNicknameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToOrganisationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToOrganisationVariantResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToRelationshipManagerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateBankOrganisationPayloadToStripeCustomerIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateProfilePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateProfilePayloadToClientMutationIdResolver<TParent>;
  profile?: UpdateProfilePayloadToProfileResolver<TParent>;
}

export interface UpdateProfilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateProfilePayloadToProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateSimpleKycDataPayloadToClientMutationIdResolver<TParent>;
  id?: UpdateSimpleKycDataPayloadToIdResolver<TParent>;
  simpleKycApplicationId?: UpdateSimpleKycDataPayloadToSimpleKycApplicationIdResolver<TParent>;
  simpleKycData?: UpdateSimpleKycDataPayloadToSimpleKycDataResolver<TParent>;
}

export interface UpdateSimpleKycDataPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataPayloadToSimpleKycApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataPayloadToSimpleKycDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataTypeResolver<TParent = any> {
  applicationStatus?: SimpleKycDataToApplicationStatusResolver<TParent>;
  businessNames?: SimpleKycDataToBusinessNamesResolver<TParent>;
  companyABN?: SimpleKycDataToCompanyABNResolver<TParent>;
  createdAt?: SimpleKycDataToCreatedAtResolver<TParent>;
  entityClassification?: SimpleKycDataToEntityClassificationResolver<TParent>;
  id?: SimpleKycDataToIdResolver<TParent>;
  individuals?: SimpleKycDataToIndividualsResolver<TParent>;
  legalBusinessName?: SimpleKycDataToLegalBusinessNameResolver<TParent>;
  principalPlaceOfBusinessAddress?: SimpleKycDataToPrincipalPlaceOfBusinessAddressResolver<TParent>;
  registeredOfficeAddress?: SimpleKycDataToRegisteredOfficeAddressResolver<TParent>;
  simpleKycApplicationId?: SimpleKycDataToSimpleKycApplicationIdResolver<TParent>;
}

export interface SimpleKycDataToApplicationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToBusinessNamesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToCompanyABNResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToEntityClassificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToIndividualsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToLegalBusinessNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToPrincipalPlaceOfBusinessAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToRegisteredOfficeAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataToSimpleKycApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualTypeResolver<TParent = any> {
  address?: SimpleKycDataIndividualToAddressResolver<TParent>;
  dateOfBirth?: SimpleKycDataIndividualToDateOfBirthResolver<TParent>;
  firstName?: SimpleKycDataIndividualToFirstNameResolver<TParent>;
  id?: SimpleKycDataIndividualToIdResolver<TParent>;
  isBeneficialOwner?: SimpleKycDataIndividualToIsBeneficialOwnerResolver<TParent>;
  isDirector?: SimpleKycDataIndividualToIsDirectorResolver<TParent>;
  lastName?: SimpleKycDataIndividualToLastNameResolver<TParent>;
  middleNames?: SimpleKycDataIndividualToMiddleNamesResolver<TParent>;
  roles?: SimpleKycDataIndividualToRolesResolver<TParent>;
  simpleKycDataId?: SimpleKycDataIndividualToSimpleKycDataIdResolver<TParent>;
}

export interface SimpleKycDataIndividualToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToDateOfBirthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToIsBeneficialOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToIsDirectorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToMiddleNamesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualToSimpleKycDataIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressTypeResolver<TParent = any> {
  country?: SimpleKycDataIndividualAddressToCountryResolver<TParent>;
  country_name?: SimpleKycDataIndividualAddressToCountry_nameResolver<TParent>;
  number?: SimpleKycDataIndividualAddressToNumberResolver<TParent>;
  postalCode?: SimpleKycDataIndividualAddressToPostalCodeResolver<TParent>;
  state?: SimpleKycDataIndividualAddressToStateResolver<TParent>;
  street?: SimpleKycDataIndividualAddressToStreetResolver<TParent>;
  suburb?: SimpleKycDataIndividualAddressToSuburbResolver<TParent>;
  type?: SimpleKycDataIndividualAddressToTypeResolver<TParent>;
  unformattedAddress?: SimpleKycDataIndividualAddressToUnformattedAddressResolver<TParent>;
  unit?: SimpleKycDataIndividualAddressToUnitResolver<TParent>;
}

export interface SimpleKycDataIndividualAddressToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToCountry_nameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToPostalCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToStreetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToSuburbResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToUnformattedAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SimpleKycDataIndividualAddressToUnitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataAppPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateSimpleKycDataAppPayloadToClientMutationIdResolver<TParent>;
  id?: UpdateSimpleKycDataAppPayloadToIdResolver<TParent>;
  simpleKycApplicationId?: UpdateSimpleKycDataAppPayloadToSimpleKycApplicationIdResolver<TParent>;
  simpleKycData?: UpdateSimpleKycDataAppPayloadToSimpleKycDataResolver<TParent>;
}

export interface UpdateSimpleKycDataAppPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataAppPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataAppPayloadToSimpleKycApplicationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSimpleKycDataAppPayloadToSimpleKycDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscriptionTypeResolver<TParent = any> {
  documentUpdated?: SubscriptionToDocumentUpdatedResolver<TParent>;
  draftUpdated?: SubscriptionToDraftUpdatedResolver<TParent>;
  draftUpdatedForBankPortal?: SubscriptionToDraftUpdatedForBankPortalResolver<TParent>;
  importJobCompleted?: SubscriptionToImportJobCompletedResolver<TParent>;
  organisationDocumentsChanged?: SubscriptionToOrganisationDocumentsChangedResolver<TParent>;
  organisationUpdated?: SubscriptionToOrganisationUpdatedResolver<TParent>;
  reportUpdated?: SubscriptionToReportUpdatedResolver<TParent>;
}

export interface SubscriptionToDocumentUpdatedArgs {
  documentId: string;
}
export interface SubscriptionToDocumentUpdatedResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToDocumentUpdatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToDocumentUpdatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToDraftUpdatedArgs {
  draftId: string;
  organisationId: string;
}
export interface SubscriptionToDraftUpdatedResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToDraftUpdatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToDraftUpdatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToDraftUpdatedForBankPortalArgs {
  draftId: string;
}
export interface SubscriptionToDraftUpdatedForBankPortalResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToDraftUpdatedForBankPortalArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToDraftUpdatedForBankPortalArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToImportJobCompletedArgs {
  importJobId: string;
}
export interface SubscriptionToImportJobCompletedResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToImportJobCompletedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToImportJobCompletedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToOrganisationDocumentsChangedArgs {
  organisationId: string;
}
export interface SubscriptionToOrganisationDocumentsChangedResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToOrganisationDocumentsChangedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToOrganisationDocumentsChangedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToOrganisationUpdatedArgs {
  organisationId: string;
}
export interface SubscriptionToOrganisationUpdatedResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToOrganisationUpdatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToOrganisationUpdatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}

export interface SubscriptionToReportUpdatedArgs {
  userId: string;
}
export interface SubscriptionToReportUpdatedResolver<TParent = any, TResult = any> {
  resolve?: (parent: TParent, args: SubscriptionToReportUpdatedArgs, context: any, info: GraphQLResolveInfo) => TResult;
  subscribe: (parent: TParent, args: SubscriptionToReportUpdatedArgs, context: any, info: GraphQLResolveInfo) => AsyncIterator<TResult>;
}
